webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isLoaded: false,
  developMode: localStorage.getItem('developMode') === 'true' ? true : false,
  language: !localStorage.getItem('lang') ? 'ru' : localStorage.getItem('lang'),
  enterRouter: null,

  countries: null,
  offers: null,
  goods: null,
  operators: null,
  couriers: null,
  lastUpdate: null,
  lastVersion: null,
  dashboardStatistic: null,
  selectedDateFrom: null,
  selectedDateTo: null,
  selectedDateFromFirst: null,
  selectedDateToFirst: null,
  selectedDateFromSecond: null,
  selectedDateToSecond: null,
  selectedDateCreatedTo: null,
  selectedDateCreatedFrom: null,
  selectedDateReceiptFrom: null,
  selectedDateReceiptTo: null,
  selectedMonthFrom: null,
  selectedMonthTo: null,

  selectedCountry: [],

  selectedOffer: null,

  selectedOperator: null,
  selectedCouriers: null,
  selectedWebmaster: null,
  webmasters: [],
  byWmFilter: true,
  byManualFilter: '',
  OldbyWmFilter: true,
  webFilter: null,
  webSelectedFilter: null,
  webNewFilter: [],
  webNewManualFilter: null,
  webNewSelectedFilter: [],
  webNewManualSelectedFilter: null,
  webAddTagFilter: null
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  getCountries: function getCountries() {
    return _vue2.default.http.get('data/countries');
  },
  getOffers: function getOffers(countryId) {
    return _vue2.default.http.get('data/offers?country_id=' + countryId);
  },
  getWebmastersNoGrid: function getWebmastersNoGrid(countryId) {
    return _vue2.default.http.get('data/external-webmasters?country_id=' + countryId);
  },
  getGoods: function getGoods(countryId) {
    return _vue2.default.http.get('data/goods?country_id=' + countryId);
  },
  postChooseMainGood: function postChooseMainGood(country, product) {
    return _vue2.default.http.post('statistic/operator-cross-sell/choose-main-good?country_id=' + country, product);
  },
  postCancelMainGood: function postCancelMainGood(country, product) {
    return _vue2.default.http.post('statistic/operator-cross-sell/cancel-main-good?country_id=' + country, product);
  },
  getCrossSell: function getCrossSell() {
    return _vue2.default.http.get('statistic/operator-cross-sell?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&operator_id=' + _Helper2.default.getOperatorsList() + '&' + _Helper2.default.getDateRange());
  },
  getGoodsMain: function getGoodsMain() {
    return _vue2.default.http.get('data/goods/goods-with-id?country_id=' + _Helper2.default.getCountryList());
  },
  getWebmasters: function getWebmasters(countryId) {
    return _vue2.default.http.get('data/webmasters?country_id=' + countryId);
  },
  getWebmastersAll: function getWebmastersAll(countryId) {
    return _vue2.default.http.get('data/webmasters/get-all?country_id=' + countryId);
  },
  getWebmastersGraphs: function getWebmastersGraphs(webmaster) {
    return _vue2.default.http.get('statistic/webmasters/graph?country_id=' + _Helper2.default.getCountryList() + '&by_wm=' + webmaster + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getSourcesGraps: function getSourcesGraps(sources) {
    return _vue2.default.http.get('statistic/webmasters/source-graph?country_id=' + _Helper2.default.getCountryList() + '&source=' + sources + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange() + '&external_wm=' + _Helper2.default.getWebsTags());
  },
  getGrid: function getGrid() {
    return _vue2.default.http.get('statistic/webmasters/cpa?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange() + '&manual=&by_wm=' + _Helper2.default.getWebsList());
  },
  getArrivalNewLeads: function getArrivalNewLeads(isParse) {
    return _vue2.default.http.get('statistic/order-forecasting?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange() + '&manual=&by_wm=' + _Helper2.default.getWebsList() + '&roll_up_level=' + isParse);
  },
  getOperators: function getOperators(countryId) {
    var offerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return _vue2.default.http.get('data/operators?country_id=' + countryId + '&offer_id=' + offerId);
  },
  getCurrencyHistory: function getCurrencyHistory(currency) {
    if (currency instanceof Array) {
      var setParams = function setParams(arr) {
        return arr.map(function (x) {
          return 'currency[]=' + x;
        }).join('&');
      };
      return _vue2.default.http.get('data/currency-history?' + setParams(currency) + _Helper2.default.getDateRange());
    } else {
      return _vue2.default.http.get('data/currency-history?currency=' + currency + '&' + _Helper2.default.getDateRange());
    }
  },
  getDashboardStatistic: function getDashboardStatistic() {
    return _vue2.default.http.get('statistic/dash');
  },
  getLastUpdateTime: function getLastUpdateTime() {
    return _vue2.default.http.get('data/last-update');
  },
  getOfferRentabilityСhangeStatistic: function getOfferRentabilityHangeStatistic(offerId, vat, out, packaging) {
    return _vue2.default.http.get('statistic/offer-rentability/change-expenses?country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + offerId + '&vat=' + vat + '&out=' + out + '&packaging=' + packaging);
  },
  getOfferRentabilityСhangeStatisticVAT: function getOfferRentabilityHangeStatisticVAT(offerId, vat) {
    return _vue2.default.http.get('statistic/offer-rentability/change-expenses?country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + offerId + '&vat=' + vat);
  },
  getOfferRentabilityСhangeStatisticOUT: function getOfferRentabilityHangeStatisticOUT(offerId, out) {
    return _vue2.default.http.get('statistic/offer-rentability/change-expenses?country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + offerId + '&out=' + out);
  },
  getOfferRentabilityСhangeStatisticPACK: function getOfferRentabilityHangeStatisticPACK(offerId, packaging) {
    return _vue2.default.http.get('statistic/offer-rentability/change-expenses?country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + offerId + '&packaging=' + packaging);
  },
  getOfferRentabilityAverage: function getOfferRentabilityAverage() {
    return _vue2.default.http.get('statistic/offer-rentability/averages?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getOfferRentabilityCountryStatistic: function getOfferRentabilityCountryStatistic() {
    return _vue2.default.http.get('statistic/offer-rentability/country-expenses?country_id=' + _Storage2.default.selectedCountry.id + '&' + _Helper2.default.getDateRange());
  },
  getOfferRentabilityStatistic: function getOfferRentabilityStatistic() {
    return _vue2.default.http.get('statistic/offer-rentability?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList(false) + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getRentabilityExpenseExpection: function getRentabilityExpenseExpection() {
    return _vue2.default.http.get('statistic/expense-expection?country_id=' + _Helper2.default.getCountryList() + '&' + _Helper2.default.getMonthRange() + '&by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter);
  },
  postRentabilityExpenseExpection: function postRentabilityExpenseExpection(obj) {
    return _vue2.default.http.post('statistic/expense-expection/change-call-center-expenses?country_id=' + _Storage2.default.selectedCountry.id, obj);
  },
  postEditOfferRentability: function postEditOfferRentability(post) {
    return _vue2.default.http.post('statistic/offer-rentability/change-expenses?country_id=' + _Storage2.default.selectedCountry.id, _extends({}, post));
  },
  getConversionsCountryStatistic: function getConversionsCountryStatistic() {
    return _vue2.default.http.get('statistic/conversions/country?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getConversionsCouriersStatistic: function getConversionsCouriersStatistic() {
    return _vue2.default.http.get('statistic/conversions/couriers?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&' + _Helper2.default.getDateRange());
  },
  getConversionsOffersStatistic: function getConversionsOffersStatistic() {
    return _vue2.default.http.get('statistic/conversions/offers?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getConversionsPeriodStatistic: function getConversionsPeriodStatistic() {
    return _vue2.default.http.get('statistic/conversions/period?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getConversionsBuyoutStatistic: function getConversionsBuyoutStatistic() {
    return _vue2.default.http.get('statistic/conversions/quantity?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getConversionsFlypost: function getConversionsFlypost() {
    return _vue2.default.http.get('statistic/conversions/flypost?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  postConversionsFlypost: function postConversionsFlypost(obj) {
    return _vue2.default.http.post('statistic/conversions/change-delivery-cost?country_id=' + _Storage2.default.selectedCountry.id, obj);
  },
  getWebmasterStatistic: function getWebmasterStatistic() {
    return _vue2.default.http.get('statistic/webmasters?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getWebmasterSourceStatistic: function getWebmasterSourceStatistic() {
    return _vue2.default.http.get('statistic/webmasters/source?by_wm=' + _Helper2.default.getWebsList() + '&webmaster_id=' + _Helper2.default.getWebmasterId() + '&country_id=' + _Helper2.default.getCountryList(false) + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange() + '&external_wm=' + _Helper2.default.getWebsTags());
  },
  getWebmasterLandStatistic: function getWebmasterLandStatistic() {
    return _vue2.default.http.get('statistic/webmasters/landing?by_wm=' + _Helper2.default.getWebsList() + '&webmaster_id=' + _Helper2.default.getWebmasterId() + '&country_id=' + _Helper2.default.getCountryList(false) + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange() + '&external_wm=' + _Helper2.default.getWebsTags());
  },
  getLandGraps: function getLandGraps(sources) {
    return _vue2.default.http.get('statistic/webmasters/landing-graph?country_id=' + _Storage2.default.selectedCountry.id + '&source=' + sources + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange() + '&external_wm=' + _Helper2.default.getWebsTags());
  },
  getWebmasterPayments: function getWebmasterPayments() {
    return _vue2.default.http.get('statistic/webmasters-payments?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getWebmasterPaymentChange: function getWebmasterPaymentChange(wmid, fixto, fixfrom) {
    return _vue2.default.http.get('statistic/webmasters-fixes/change-fix?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&wm_id=' + wmid + '&fix_to=' + fixto + '&fix_from=' + fixfrom);
  },
  getWebmasterPaymentHistory: function getWebmasterPaymentHistory() {
    return _vue2.default.http.get('statistic/webmasters-fixes?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList());
  },
  getReturnReasonStatistic: function getReturnReasonStatistic() {
    return _vue2.default.http.get('statistic/return-reason?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getOperatorStatistic: function getOperatorStatistic() {
    return _vue2.default.http.get('statistic/operator-statistic?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&operator_id=' + _Helper2.default.getOperatorsList() + '&' + _Helper2.default.getDateRange());
  },
  getOperatorActivity: function getOperatorActivity() {
    return _vue2.default.http.get('statistic/operator-queries?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&operator_id=' + _Helper2.default.getOperatorsList() + '&' + _Helper2.default.getDateRange());
  },
  getOperatorOrder: function getOperatorOrder() {
    return _vue2.default.http.get('statistic/order-processing?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&operator_id=' + _Helper2.default.getOperatorsList() + '&' + _Helper2.default.getDateRange());
  },
  getOperatorConversion: function getOperatorConversion() {
    return _vue2.default.http.get('statistic/operators-summary?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&operator_id=' + _Helper2.default.getOperatorsList() + '&' + _Helper2.default.getDateRange());
  },
  getCouriers: function getCouriers() {
    return _vue2.default.http.get('data/couriers');
  },
  getRefundsStatistic: function getRefundsStatistic(reasonType) {
    return _vue2.default.http.get('statistic/return-reason?by_wm=' + _Helper2.default.getWebsList() + '&reason_type_id=' + reasonType + '&country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&' + _Helper2.default.getDateRange());
  },
  getRefundsCancelOperators: function getRefundsCancelOperators() {
    return _vue2.default.http.get('statistic/operator-cancels?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&manual=' + _Storage2.default.byManualFilter + '&' + _Helper2.default.getDateRange());
  },
  getReasons: function getReasons() {
    return _vue2.default.http.get('statistic/return-reason/reason-types?country_id=' + 1534 + '&' + _Helper2.default.getDateRange());
  },
  getReturnReasonStatisticByMonth: function getReturnReasonStatisticByMonth(reasonType) {
    return _vue2.default.http.get('statistic/return-reason/summary-by-month?by_wm=' + _Helper2.default.getWebsList() + '&webmaster_id=' + _Helper2.default.getWebmasterId() + '&reason_type_id=' + reasonType + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&' + _Helper2.default.getDateRange());
  },
  getReturnReasonStatisticByDay: function getReturnReasonStatisticByDay(reasonType, date) {
    return _vue2.default.http.get('statistic/return-reason/summary-by-month?by_wm=' + _Helper2.default.getWebsTags() + '&reason_type_id=' + reasonType + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&date_from=' + date + '&date_to=' + date);
  },
  getBuyoutStatistic: function getBuyoutStatistic() {
    return _vue2.default.http.get('statistic/buyout-statistic?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&' + _Helper2.default.getDateRange());
  },
  getBuyoutStatisticByWeeks: function getBuyoutStatisticByWeeks() {
    return _vue2.default.http.get('statistic/buyout-statistic/by-weeks?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&' + _Helper2.default.getDateRange());
  },
  getBuyoutStatisticByDays: function getBuyoutStatisticByDays() {
    return _vue2.default.http.get('statistic/buyout-statistic/by-days?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&' + _Helper2.default.getDateRange());
  },
  getBuyoutStatisticMonth: function getBuyoutStatisticMonth() {
    return _vue2.default.http.get('statistic/buyout-statistic/by-months?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&courier_id=' + _Helper2.default.getCouriersList() + '&' + _Helper2.default.getDateRange());
  },
  getRemnantsOrdersReceipt: function getRemnantsOrdersReceipt() {
    return _vue2.default.http.get('statistic/remnants-orders-receipt/get-orders-receipt?country_id=' + _Helper2.default.getCountryList() + '&' + _Helper2.default.getDateCreatedRange() + '&' + _Helper2.default.getDateReceiptRange(), {});
  },
  getRemnantsBalance: function getRemnantsBalance() {
    return _vue2.default.http.get('statistic/remnants-orders-receipt/remnants-balance?country_id=-1' + _Helper2.default.getDateRangeFrom());
  },
  postRemnantsBalance: function postRemnantsBalance(obj) {
    return _vue2.default.http.post('statistic/remnants-orders-receipt/change-product-price?country_id=-1', obj);
  },
  getProductTags: function getProductTags() {
    return _vue2.default.http.get('statistic/remnants-orders-receipt/offer-tags?country_id=1547');
  },
  getRemnantsCountry: function getRemnantsCountry() {
    return _vue2.default.http.get('statistic/remnants-orders-receipt/loads?country_id=' + _Helper2.default.getCountryList() + _Helper2.default.getDateRange());
  },
  getRemnantsCountryById: function getRemnantsCountryById() {
    return _vue2.default.http.get('data/goods/goods-with-id?country_id=' + _Helper2.default.getCountryList());
  },
  getRemnandsChanges: function getRemnandsChanges() {
    return _vue2.default.http.get('statistic/remnants-orders-receipt/remnants-changes?country_id=' + _Helper2.default.getCountryList());
  },
  getRemnands: function getRemnands() {
    return _vue2.default.http.get('statistic/remnants-orders-receipt/get-remnants?country_id=' + _Helper2.default.getCountryList());
  },
  getGraphConversion: function getGraphConversion() {
    return _vue2.default.http.get('statistic/conversion-graphic?by_wm=' + _Helper2.default.getWebsListNew() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getMonthRange());
  },
  putEditOrder: function putEditOrder(obj) {
    return _vue2.default.http.post('statistic/remnants-orders-receipt/edit-order?country_id=' + _Storage2.default.selectedCountry.id + '&id=' + obj.id, _defineProperty({}, obj.title, obj.value));
  },
  putEditRemains: function putEditRemains(obj) {
    return _vue2.default.http.post('statistic/remnants-orders-receipt/change-remains?country_id=' + _Storage2.default.selectedCountry.id, _defineProperty({
      country_id: _Storage2.default.selectedCountry.id,
      product_id: obj.id
    }, obj.title, obj.value));
  },
  deleteOrder: function deleteOrder(offerid) {
    return _vue2.default.http.get('statistic/remnants-orders-receipt/delete-order?country_id=' + _Storage2.default.selectedCountry.id + '&id=' + offerid);
  },
  postEditOrder: function postEditOrder(offerid, obj) {
    return _vue2.default.http.post('statistic/remnants-orders-receipt/edit-order?country_id=' + _Storage2.default.selectedCountry.id + '&id=' + offerid, obj);
  },
  postRemnandsNew: function postRemnandsNew(formData) {
    return _vue2.default.http.post('statistic/remnants-orders-receipt/new-order?country_id=' + _Storage2.default.selectedCountry.id, formData);
  },
  profileChangePassword: function profileChangePassword(oldPassword, newPassword, newPasswordRepeat) {
    return _vue2.default.http.post('user/update-password', {
      old_password: oldPassword,
      password: newPassword,
      password_repeat: newPasswordRepeat
    });
  },
  profileUpdate: function profileUpdate(email, firstName, lastName) {
    return _vue2.default.http.post('user/update-profile', {
      email: email,
      first_name: firstName,
      last_name: lastName
    });
  },
  profileChangeLanguage: function profileChangeLanguage(lang) {
    return _vue2.default.http.post('user/update-lang', {
      lang: lang
    });
  },
  disabledDasbourdCountry: function disabledDasbourdCountry(id) {
    return _vue2.default.http.post('statistic/dash/disable-country', {
      country_id: id
    });
  },
  enabledDashboardCountry: function enabledDashboardCountry(id) {
    return _vue2.default.http.post('statistic/dash/turn-on-country', {
      country_id: id
    });
  },
  saveOperatorStatisticExportHistory: function saveOperatorStatisticExportHistory(systemBonus, paidBonus, bonusType) {
    return _vue2.default.http.post('statistic/operator-statistic/save-export-history/?country_id=' + _Storage2.default.selectedCountry.id, {
      system_bonus: systemBonus,
      paid_bonus: paidBonus,
      bonus_type: bonusType,
      date_from: _Storage2.default.selectedDateFrom,
      date_to: _Storage2.default.selectedDateTo,
      offer_id: _Helper2.default.getOffersList()
    });
  },
  getOperatorStatisticExportHistory: function getOperatorStatisticExportHistory() {
    return _vue2.default.http.get('statistic/operator-statistic/export-history/?country_id=' + _Storage2.default.selectedCountry.id);
  },
  getOperatorApprovedDuringDay: function getOperatorApprovedDuringDay() {
    return _vue2.default.http.get('statistic/offer-activity?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange());
  },
  getChengeLog: function getChengeLog(type, page, perpage) {
    return _vue2.default.http.get('data/change-log?type=' + type + '&page=' + page + '&per_page=' + perpage + '&sort_id=1');
  },
  getLastVersion: function getLastVersion() {
    return _vue2.default.http.get('data/last-version');
  },
  getChangeVersion: function getChangeVersion(page, perpage) {
    return _vue2.default.http.get('data/versions?page=' + page + '&per_page=' + perpage + '&sort_id=1');
  },
  getWebAnalysis: function getWebAnalysis() {
    return _vue2.default.http.get('statistic/webmasters/analysis?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&by_wm=' + _Helper2.default.getWebsList() + '&' + _Helper2.default.getDateRangeAnalytics() + '&' + _Helper2.default.getDateRangeAnalyticsSecond());
  },
  getDisabledCountry: function getDisabledCountry() {
    return _vue2.default.http.get('statistic/dash/get-disabled-countries');
  },
  getAveragesGraphic: function getAveragesGraphic(id) {
    return _vue2.default.http.get('statistic/dash/averages-graphic?country_id=' + id);
  },
  getAveragesGraphicAllCountry: function getAveragesGraphicAllCountry() {
    return _vue2.default.http.get('statistic/dash/averages-graphic?country_id=' + -1);
  },
  getBranch: function getBranch(filial, indexCourier, month) {
    return _vue2.default.http.get('statistic/conversions/cities-flypost?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + indexCourier + '&' + _Helper2.default.getDataRangeSearch(month) + '&filial=' + filial);
  },
  getBranchSum: function getBranchSum(filial, month) {
    return _vue2.default.http.get('statistic/conversions/cities-flypost?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Storage2.default.selectedCountry.id + '&' + _Helper2.default.getDataRangeSearch2(month) + '&filial=' + filial);
  },
  getRingingSms: function getRingingSms() {
    return _vue2.default.http.get('statistic/sms-robocall-statistic?by_wm=' + _Helper2.default.getWebsListNew() + '&country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + _Helper2.default.getOffersList() + '&' + _Helper2.default.getDateRange() + '&courier_id=' + _Helper2.default.getCouriersList());
  },
  getRingingRates: function getRingingRates() {
    return _vue2.default.http.get('statistic/sms-robocall-statistic/get-costs?country_id=' + _Helper2.default.getCountryList());
  },
  postRingingRates: function postRingingRates(rate) {
    return _vue2.default.http.post('statistic/sms-robocall-statistic/change-costs?country_id=' + _Helper2.default.getCountryList(), rate);
  },
  getTemplateSms: function getTemplateSms() {
    return _vue2.default.http.get('data/sms-template?country_id=' + _Helper2.default.getCountryList());
  },
  getSentSmsTemplate: function getSentSmsTemplate() {
    return _vue2.default.http.get('statistic/sms-template?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + _Helper2.default.getDateRange() + '&operator_id=' + _Helper2.default.getOperatorsList());
  },
  getWebPopup: function getWebPopup(wm) {
    return _vue2.default.http.get('data/webmaster-countries?by_wm=' + wm + '&' + _Helper2.default.getDateRange());
  },
  getCallStatistics: function getCallStatistics(isWorkShift) {
    return _vue2.default.http.get('statistic/calls?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + _Helper2.default.getDateRange() + '&is_work_shift=' + isWorkShift);
  },
  getOperatorsAnalysis: function getOperatorsAnalysis() {
    return _vue2.default.http.get('statistic/operator-analysis/analysis?country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + '&by_wm=' + _Helper2.default.getWebsListNew() + '&' + _Helper2.default.getDateRangeAnalytics() + '&' + _Helper2.default.getDateRangeAnalyticsSecond());
  },
  getWorkTimingKC: function getWorkTimingKC() {
    return _vue2.default.http.get('statistic/call-center-timings?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + _Helper2.default.getDateRange());
  },
  getCallStatisticsHourly: function getCallStatisticsHourly() {
    return _vue2.default.http.get('statistic/calls/work-shift?by_wm=' + _Helper2.default.getWebsList() + '&manual=' + _Storage2.default.byManualFilter + '&country_id=' + _Storage2.default.selectedCountry.id + '&offer_id=' + _Helper2.default.getOffersList() + _Helper2.default.getDateRange());
  },
  webmasterStatus: function webmasterStatus(wmId, countryId, offerId, status) {
    return _vue2.default.http.post('data/webmaster-status/assign?webmaster_id=' + wmId + '&country_id=' + countryId + '&offer_id=' + offerId + '&status=' + status);
  },
  historyWebmasterStatus: function historyWebmasterStatus() {
    return _vue2.default.http.get('data/webmaster-status/history?&country_id=' + (_Storage2.default.selectedCountry.id || _Storage2.default.selectedCountry[0].id) + '&offer_id=' + _Helper2.default.getOffersList());
  },
  getRingingHolds: function getRingingHolds() {
    return _vue2.default.http.get('statistic/hold-calls?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + _Helper2.default.getDateRange());
  },
  getNewOrders: function getNewOrders() {
    return _vue2.default.http.get('statistic/new-orders-statistic?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + _Helper2.default.getDateRange() + '&operator_id=' + _Helper2.default.getOperatorsList());
  },
  getNewOrdersWeek: function getNewOrdersWeek() {
    return _vue2.default.http.get('statistic/new-orders-statistic/weekly?by_wm=' + _Helper2.default.getWebsList() + '&country_id=' + _Helper2.default.getCountryList() + '&offer_id=' + _Helper2.default.getOffersList() + _Helper2.default.getDateRange() + '&operator_id=' + _Helper2.default.getOperatorsList());
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(5);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  areByWm: function areByWm() {
    return _Storage2.default.OldbyWmFilter ? 'by_wm=web1&' : '';
  },
  getExportedOffers: function getExportedOffers(dOffers) {
    var selectedOffers = this.findSelectedOffers(dOffers);
    var offers = [];
    if (selectedOffers.length === 0) {
      return 'All';
    } else {
      selectedOffers.map(function (d) {
        offers.push(d.name);
      });
      return offers.join(', ');
    }
  },
  getWebsList: function getWebsList() {
    var ids = [];
    (0, _lodash.map)(_Storage2.default.webSelectedFilter, function (d) {
      ids.push(d.login);
    });
    return ids.join(',');
  },
  getWebmasterId: function getWebmasterId() {
    var ids = [];
    (0, _lodash.map)(_Storage2.default.selectedWebmaster, function (d) {
      ids.push(d.id);
    });
    return ids.join(',');
  },
  getWebsListNew: function getWebsListNew() {
    var ids = [];
    (0, _lodash.map)(_Storage2.default.webNewSelectedFilter, function (d) {
      ids.push(d.name);
    });
    return ids.join(',');
  },
  getWebsTags: function getWebsTags() {
    var ids = [];
    (0, _lodash.map)(_Storage2.default.webAddTagFilter, function (d) {
      ids.push(d.name);
    });
    return ids.join(',');
  },
  getOffersList: function getOffersList() {
    var ids = [];
    (0, _lodash.map)(_Storage2.default.selectedOffer, function (d) {
      ids.push(d.id);
    });
    return ids.join(',');
  },
  getCountryList: function getCountryList() {
    var isAllowedFilteringByAllCountries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var ids = [];

    if (_Storage2.default.selectedCountry.length) {
      var allCountriesObj = _Storage2.default.selectedCountry.find(function (country) {
        return country.id === -1;
      });

      if (allCountriesObj) {
        if (!isAllowedFilteringByAllCountries) return '-1';

        _Storage2.default.countries.map(function (country) {
          ids.push(country.id);
        });
      } else {
        (0, _lodash.map)(_Storage2.default.selectedCountry, function (d) {
          ids.push(d.id);
        });
      }

      return ids.join(',');
    } else {
      return _Storage2.default.selectedCountry.id;
    }
  },
  getCouriersList: function getCouriersList() {
    var ids = [];
    (0, _lodash.map)(_Storage2.default.selectedCouriers, function (d) {
      ids.push(d.id);
    });
    return ids.join(',');
  },
  getxstart: function getxstart(all, start) {
    if (start && all) {
      return parseFloat(parseFloat(all) / parseFloat(start)).toFixed(2);
    } else {
      return 1;
    }
  },
  getSumCount: function getSumCount(sum, count) {
    if (sum && count) {
      return (parseFloat(sum) / parseFloat(count)).toFixed(1);
    } else {
      return 0;
    }
  },
  getOperatorsList: function getOperatorsList() {
    var ids = [];
    (0, _lodash.map)(_Storage2.default.selectedOperator, function (d) {
      ids.push(d.id);
    });
    return ids.join(',');
  },
  getDataRangeSearch: function getDataRangeSearch(month) {
    var month1 = (0, _moment2.default)(_Storage2.default.selectedDateFrom).format('MM').replace('0', '');
    var month2 = (0, _moment2.default)(_Storage2.default.selectedDateTo).format('MM').replace('0', '');
    var selectedDateFrom = (0, _moment2.default)(_Storage2.default.selectedDateFrom).format('YYYY-MM-DD');
    var selectedDateTo = (0, _moment2.default)(_Storage2.default.selectedDateTo).format('YYYY-MM-DD');
    var lastDay = (0, _moment2.default)(_Storage2.default.selectedDateFrom).endOf('month').format('YYYY-MM-DD');
    var firstDay = (0, _moment2.default)(_Storage2.default.selectedDateTo).startOf('month').format('YYYY-MM-DD');
    if (month1 !== month2 && month === month1) {
      return '&date_from=' + selectedDateFrom + '&date_to=' + lastDay;
    }
    if (month1 !== month2 && month === month2) {
      return '&date_from=' + firstDay + '&date_to=' + selectedDateTo;
    }
    if (month1 === month2) {
      return '&date_from=' + selectedDateFrom + '&date_to=' + selectedDateTo;
    }
  },
  getDataRangeSearch2: function getDataRangeSearch2(month) {
    var month1 = (0, _moment2.default)(_Storage2.default.selectedDateFrom).format('MM').replace('0', '');
    var month2 = (0, _moment2.default)(_Storage2.default.selectedDateTo).format('MM').replace('0', '');
    var selectedDateFrom = (0, _moment2.default)(_Storage2.default.selectedDateFrom).format('YYYY-MM-DD');
    var selectedDateTo = (0, _moment2.default)(_Storage2.default.selectedDateTo).format('YYYY-MM-DD');
    var lastDay = (0, _moment2.default)(_Storage2.default.selectedDateFrom).endOf('month').format('YYYY-MM-DD');
    var firstDay = (0, _moment2.default)(_Storage2.default.selectedDateTo).startOf('month').format('YYYY-MM-DD');
    if (month === month1) {
      return '&date_from=' + selectedDateFrom + '&date_to=' + lastDay;
    }
    if (month === month2 && month === month2) {
      return '&date_from=' + firstDay + '&date_to=' + selectedDateTo;
    }
  },
  getDateRangeFrom: function getDateRangeFrom() {
    return '&date_from=' + (0, _moment2.default)(_Storage2.default.selectedMonthFrom).format('YYYY-MM');
  },
  getDateRange: function getDateRange() {
    return '&date_from=' + (0, _moment2.default)(_Storage2.default.selectedDateFrom).format('YYYY-MM-DD') + '&date_to=' + (0, _moment2.default)(_Storage2.default.selectedDateTo).format('YYYY-MM-DD');
  },
  getDateRangeAnalyticsSecond: function getDateRangeAnalyticsSecond() {
    return '&second_date_from=' + (0, _moment2.default)(_Storage2.default.selectedDateFromSecond).format('YYYY-MM-DD') + '&second_date_to=' + (0, _moment2.default)(_Storage2.default.selectedDateToSecond).format('YYYY-MM-DD');
  },
  getDateRangeAnalytics: function getDateRangeAnalytics() {
    return '&first_date_from=' + (0, _moment2.default)(_Storage2.default.selectedDateFrom).format('YYYY-MM-DD') + '&first_date_to=' + (0, _moment2.default)(_Storage2.default.selectedDateTo).format('YYYY-MM-DD');
  },
  getDateCreatedRange: function getDateCreatedRange() {
    if (!_Storage2.default.selectedDateCreatedFrom && !_Storage2.default.selectedDateCreatedTo) {
      return '&date_from=&date_to=';
    } else {
      return '&date_from=' + (0, _moment2.default)(_Storage2.default.selectedDateCreatedFrom).format('YYYY-MM-DD') + '&date_to=' + (0, _moment2.default)(_Storage2.default.selectedDateCreatedTo).format('YYYY-MM-DD');
    }
  },
  getDateReceiptRange: function getDateReceiptRange() {
    if (!_Storage2.default.selectedDateReceiptFrom && !_Storage2.default.selectedDateReceiptTo) {
      return '&receipt_date_from=&receipt_date_to=';
    } else {
      return '&receipt_date_from=' + (0, _moment2.default)(_Storage2.default.selectedDateReceiptFrom).format('YYYY-MM-DD') + '&receipt_date_to=' + (0, _moment2.default)(_Storage2.default.selectedDateReceiptTo).format('YYYY-MM-DD');
    }
  },
  getMonthRange: function getMonthRange() {
    return '&date_from=' + (0, _moment2.default)(_Storage2.default.selectedMonthFrom).format('YYYY-MM') + '&date_to=' + (0, _moment2.default)(_Storage2.default.selectedMonthTo).format('YYYY-MM');
  },
  percents: function percents(total, count) {
    if (total === 0 || count === 0) {
      return '0%';
    }
    return (parseFloat(parseFloat(count) / parseFloat(total) * 100).toFixed(1) + '%').replace('.', ',');
  },
  percentsC: function percentsC(total, count) {
    if (total === 0 || count === 0) {
      return 0;
    }
    return parseInt(parseFloat(count) / parseFloat(total) * 100);
  },
  percentsF: function percentsF(total, count) {
    if (total === 0 || count === 0) {
      return 0;
    }
    return parseFloat((parseFloat(count) / parseFloat(total) * 100).toFixed(1));
  },
  averageDbt: function averageDbt(sum, countryId) {
    return parseFloat(parseFloat(sum) / this.findCountry(countryId).rate).toFixed(2);
  },
  leadIncrease: function leadIncrease(price, approved, total, date, daysTotal) {
    var approvedPercent = (parseInt(approved) / parseInt(total)).toFixed(2);
    var expensesKC = Number(price) * parseInt(approved);
    if (!price) {
      return '' + 0 * parseInt(approved) / (parseInt(total) / date * daysTotal) * parseInt(approved) / parseInt(total);
    } else {
      return '' + (expensesKC / (parseInt(total) / date * daysTotal * approvedPercent)).toFixed(2);
    }
  },
  averageBill: function averageBill(_averageBill, count, clean) {
    if (!count) {
      if (!clean) {
        return ('$ ' + parseFloat(parseFloat(_averageBill) / parseFloat(_Storage2.default.selectedCountry.rate)).toFixed(2)).replace('.', ',');
      } else {
        return parseFloat((parseFloat(_averageBill) / parseFloat(_Storage2.default.selectedCountry.rate)).toFixed(2));
      }
    } else {
      return ('$ ' + parseFloat(parseFloat(_averageBill) / parseFloat(_Storage2.default.selectedCountry.rate) / parseFloat(count)).toFixed(2)).replace('.', ',');
    }
  },
  averageBillDay: function averageBillDay(averageBill, rate, clean) {
    if (!clean) {
      return ('$ ' + parseFloat(parseFloat(averageBill) / parseFloat(rate)).toFixed(2)).replace('.', ',');
    } else {
      return parseFloat(parseFloat(averageBill) / parseFloat(rate)).toFixed(2);
    }
  },
  averageBillDayCount: function averageBillDayCount(averageBillSum, count) {
    if (averageBillSum === 0) {
      return '$ 0,00';
    }
    return ('$ ' + parseFloat(parseFloat(averageBillSum).toFixed(0) / count).toFixed(2)).replace('.', ',');
  },
  localAverageBill: function localAverageBill(averageBill, count) {
    if (!count) {
      return (parseFloat(averageBill).toFixed(0) + ' ' + _Storage2.default.selectedCountry.currency_symbol).replace('.', ',');
    } else {
      return (parseFloat(parseFloat(averageBill).toFixed(0) / count).toFixed(0) + ' ' + _Storage2.default.selectedCountry.currency_symbol).replace('.', ',');
    }
  },
  renderGist: function renderGist(total, percents, color) {
    return '<td class="double" style="position: relative">\n                <div style="position: absolute; width: ' + percents + '; height: 50px; background-color: ' + color + ';"></div>\n                <span>' + total + '</span> <span>' + percents + '</span>\n            </td>';
  },
  average: function average(sum, count) {
    if (sum === 0 || count === 0) {
      return 0;
    }
    var average = parseInt(parseFloat(sum) / parseFloat(count), 10);
    return isNaN(average) ? 0 : average;
  },
  averageFloat: function averageFloat(sum, count) {
    if (sum === 0 || count === 0) {
      return 0;
    }
    var average = parseFloat(parseFloat(sum) / parseFloat(count)).toFixed(2);
    return isNaN(average) ? 0 : average;
  },
  renderSingleGist: function renderSingleGist(total, count) {
    if (total === 0 || count === 0) {
      return 0;
    }
    return parseFloat(count) / parseFloat(total) * 100;
  },
  renderSingleGistMin: function renderSingleGistMin(total, count) {
    if (total === 0 || count >= 0) {
      return 0;
    }
    return parseFloat(count) / parseFloat(total) * 100;
  },
  renderGistPart: function renderGistPart(total, count, secondPart) {
    if (total === 0 || count === 0) {
      return 0;
    }
    var percents = parseFloat(count) / parseFloat(total) * 100;
    var first = 0;
    var second = 0;
    if (percents > 50) {
      first = 100;
      second = (percents - 50) / 50 * 100;
    } else {
      first = percents * 2;
    }
    if (secondPart) {
      return second;
    } else {
      return first;
    }
  },
  getRawNumber: function getRawNumber(value) {
    return parseFloat(('' + value).replace(',', '.').replace('$ ', ''));
  },
  getOfferTitle: function getOfferTitle(offers, id) {
    var offer = (0, _lodash.find)(offers, { id: parseInt(id, 10) });
    if (!offer) {
      return false;
    } else {
      return offer.title;
    }
  },
  getGoodNameById: function getGoodNameById(goods, id) {
    var good = (0, _lodash.find)(goods, { id: parseInt(id) });
    if (!good) {
      return 404;
    } else {
      return good.name;
    }
  },
  getGoodName: function getGoodName(goods, id) {
    var good = (0, _lodash.find)(goods, { alias: '' + id });
    if (!good) {
      return false;
    } else {
      return good.name;
    }
  },
  getOperatorLogin: function getOperatorLogin(operators, id) {
    if (parseInt(id) === 0) {
      return 'Administrator';
    }
    var operator = (0, _lodash.find)(operators, { id: '' + id });
    if (!operator) {
      return 404;
    } else {
      return operator.login;
    }
  },
  getOperatorLoginEmpty: function getOperatorLoginEmpty(operators, id) {
    var operator = (0, _lodash.find)(operators, { id: '' + id });
    if (!operator) {
      return '';
    } else {
      return operator.login;
    }
  },
  getWebLogin: function getWebLogin(web, id) {
    var webName = (0, _lodash.find)(web, { personal_id: parseInt(id) });
    if (!webName) {
      return 404;
    } else {
      return webName.login;
    }
  },
  getWebLoginCountry: function getWebLoginCountry(web, id, country) {
    var webNameCountry = web.filter(function (w) {
      return w.country_id === country;
    });
    var nameweb = (0, _lodash.find)(webNameCountry, { personal_id: parseInt(id) });
    if (nameweb) {
      return nameweb.login;
    } else {
      return 404;
    }
  },
  getCancelName: function getCancelName(cancels, id) {
    var cancel = (0, _lodash.find)(cancels, { id: parseInt(id) });
    if (!cancel) {
      return 4004;
    } else {
      return cancel.text;
    }
  },
  getCourierTitle: function getCourierTitle(couriers, id) {
    var courier = (0, _lodash.find)(couriers, { id: parseInt(id) });
    if (!courier) {
      return 404;
    } else {
      return courier.title;
    }
  },
  getSmsText: function getSmsText(templates, id) {
    var sms = (0, _lodash.find)(templates, { id: parseInt(id) });
    if (!sms) {
      return 'СМС не найдено';
    } else {
      return sms.text;
    }
  },
  getCourierTitleWithUndefinedCourier: function getCourierTitleWithUndefinedCourier(couriers, id) {
    var courier = (0, _lodash.find)(couriers, { id: parseInt(id) });
    if (!courier) {
      return 'Undefined';
    } else {
      return courier.title;
    }
  },
  findCountry: function findCountry(id) {
    var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(id, 10) });
    if (!country) {
      return _Storage2.default.countries[Object.keys(_Storage2.default.countries)[0]];
    } else {
      return country;
    }
  },
  findCountryName: function findCountryName(id) {
    var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(id, 10) });
    if (!country) {
      return _Storage2.default.countries[Object.keys(_Storage2.default.countries)[0]];
    } else {
      return country.name;
    }
  },
  getCountryTitle: function getCountryTitle(country, id) {
    var countryTitle = (0, _lodash.find)(country, { id: parseInt(id) });
    if (!countryTitle) {
      return 404;
    } else {
      return countryTitle.name;
    }
  },
  findSelectedOffers: function findSelectedOffers(idsLine) {
    if (idsLine) {
      var ids = idsLine.split(',');
      var offers = [];
      ids.map(function (id) {
        var offer = (0, _lodash.find)(_Storage2.default.offers, { id: parseInt(id, 10) });
        if (offer) {
          offers.push(offer);
        }
      });
      return offers;
    } else {
      return [];
    }
  },
  findSelectedOperators: function findSelectedOperators(idsLine) {
    if (idsLine) {
      var ids = idsLine.split(',');
      var operators = [];
      ids.map(function (id) {
        var operator = (0, _lodash.find)(_Storage2.default.operators, { id: '' + id });
        if (operator) {
          operators.push(operator);
        }
      });
      return operators;
    } else {
      return [];
    }
  },
  findSelectedCouriers: function findSelectedCouriers(idsLine) {
    if (idsLine) {
      var ids = idsLine.split(',');
      var couriers = [];
      ids.map(function (id) {
        var courier = (0, _lodash.find)(_Storage2.default.couriers, { id: '' + id });
        if (courier) {
          couriers.push(courier);
        }
      });
      return couriers;
    } else {
      return [];
    }
  },
  findSelectedWebs: function findSelectedWebs(idsLine) {
    if (idsLine) {
      var ids = idsLine.split(',');
      var webFilter = [];
      ids.map(function (id) {
        var webFilter = (0, _lodash.find)(_Storage2.default.webFilter, { id: '' + id });
        if (webFilter) {
          webFilter.push(webFilter);
        }
      });
      return webFilter;
    } else {
      return [];
    }
  },
  s2ab: function s2ab(s) {
    if (typeof ArrayBuffer !== 'undefined') {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }return buf;
    } else {
      var _buf = new Array(s.length);
      for (var _i = 0; _i !== s.length; ++_i) {
        _buf[_i] = s.charCodeAt(_i) & 0xFF;
      }return _buf;
    }
  },
  checkLang: function checkLang() {
    if (_Auth2.default.user.profile && _Auth2.default.user.profile.lang !== _Storage2.default.language) {
      localStorage.setItem('lang', _Auth2.default.user.profile.lang);
      if (_Storage2.default.enterRouter.fullPath) {
        window.location = _Storage2.default.enterRouter.fullPath;
      } else {
        window.location.reload();
      }
    }
  },
  isInt: function isInt(n) {
    return Number(n) === n && n % 1 === 0;
  },
  isFloat: function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  },
  getDateOfISOWeek: function getDateOfISOWeek(w, y) {
    var simple = new Date(y, 0, 1 + (w - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4) {
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    } else {
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    }
    return ISOweekStart;
  },
  hourAndMin: function hourAndMin(data) {
    var hourse = Math.floor(data / 60 / 60);
    var minutes = Math.floor(data / 60) - hourse * 60;
    var seconds = Math.floor(data % 60);
    return hourse + ' \u0447. ' + minutes + ' \u043C. ' + seconds + ' \u0441.';
  },
  newLocalAverageBill: function newLocalAverageBill(averageBill, count, currency) {
    if (!count) {
      return (parseFloat(averageBill).toFixed(0) + ' ' + currency).replace('.', ',');
    } else {
      return Math.round(parseFloat(Math.round(Number(averageBill)) / count)) + ' ' + currency;
    }
  },
  newAverageBillDay: function newAverageBillDay(averageBill, count, currency) {
    if (!currency) {
      return '' + (averageBill * count).toFixed(0);
    } else {
      return (averageBill * count).toFixed(0) + ' ' + currency;
    }
  },
  percentHungry: function percentHungry(value, count) {
    if (!count) {
      return '0 %';
    } else {
      return (value / count * 100).toFixed(2) + ' %';
    }
  },
  approvedFromValid: function approvedFromValid(approved, total, spam) {
    return (approved / (total - spam) * 100).toFixed(1) + '%';
  }
};

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-425dea9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-529ae098",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  total: '#e0e0e0',
  processed: '#fff9c4',
  processedPercents: '#fff9c4',
  accepted: '#c8e6c9',
  acceptedPercents: '#c8e6c9',
  acceptedSum: '#c8e6c9',
  canceled: '#ef9a9a',
  ProcessCancel: '#ef9a9a',
  canceledPercents: '#ef9a9a',
  error: '#f48fb1',
  ProcessSpam: '#f48fb1',
  errorPercents: '#f48fb1',
  return: '#ce93d8',
  returnPercents: '#ce93d8',
  paid: '#b9f6ca',
  cost_price: 'rgba(156,255,112,0.56)',
  paidPercents: '#b9f6ca',
  paidSum: '#b9f6ca',
  averageBill: '#90caf9',
  average_bill: '#90caf9',
  averageBillLocal: '#90caf9',
  averageBuyback: '#bae0ff',
  averageBuybackLocal: '#bae0ff',
  averageBillPopup: '#bae0ff',
  average_x_price: '#c8e6c9',
  payment_fix: '#e0e0e0',
  last_payment: '#90caf9',
  average_payment: '#fff9c4',
  proportion: '#fff9c4',
  approve: '#81c784',
  ProcessAccept: '#81c784',
  approved: '#81c784',
  orders_accepted: '#81c784',
  approvedFromValid: '#8fbc8f',
  points: '#e0e0e0',
  shipped: '#fff9c4',
  CancelAccept: '#fff9c4',
  SpamAccept: '#FFC107',
  transit: '#FFC107',
  transitPercents: '#FFC107',
  delivered: '#90caf9',
  buyout: '#b9f6ca',
  buyoutPercents: '#b9f6ca',
  additionalSale: '#dcedc8',
  oldBonus: '#e0e0e0',
  newBonus: '#e0e0e0',
  oldBonusHistory: '#f48fb1',
  newBonusHistory: '#c8e6c9',
  manager: '#FEE2D5',
  buyoutDelivered: '#b9f6ca',
  buyoutPaid: '#b9f6ca',
  AcceptCancel: '#90caf9',
  profit_for_oneminus: '#ef9a9a',
  profit_for_oneplus: '#c8e6c9',
  profit_for_periodminus: '#ef9a9a',
  profit_for_periodplus: '#c8e6c9',
  time_recall: '#fae5a4',
  time_success_call: '#c8cce6',
  count: '#90caf9',
  countPercents: '#90caf9',
  cancel_count: '#90caf9',
  month1: '#e0e0e0',
  month_persent_m1: '#e0e0e0',
  month2: '#c8e6c9',
  month_persent_m2: '#c8e6c9',
  month3: '#ef9a9a',
  month_persent_m3: '#ef9a9a',
  month4: '#f48fb1',
  month_persent_m4: '#f48fb1',
  month5: '#ce93d8',
  month_persent_m5: '#ce93d8',
  month6: '#b9f6ca',
  month_persent_m6: '#b9f6ca',
  month7: '#90caf9',
  month_persent_m7: '#90caf9',
  month8: '#FFC107',
  month_persent_m8: '#FFC107',
  month9: '#e0e0e0',
  month_persent_m9: '#FFC107',
  month10: '#b9f6ca',
  month_persent_m10: '#b9f6ca',
  month11: '#fff9c4',
  month_persent_m11: '#fff9c4',
  month12: '#ce93d8',
  month_persent_m12: '#ce93d8',
  adult: '#e0e0e0',
  slimming: '#fff9c4',
  beauty: '#c8e6c9',
  health: '#ef9a9a',
  economizers: '#ce93d8',
  lowPrice: '#b9f6ca',
  hair: '#90caf9',
  sport: '#fff9c4',
  other: '#FEE2D5',
  revenue_lead: '#fae5a4',
  deviation_mean: '#ef9a9a',
  dialer: '#ce93d8',
  average_first_call_time: '#ffd96a',
  average_number_touches: '#ffe083',
  average_calls: '#ffe69b',
  new_orders: '#e0e0e0',
  buyoutSum: '#b9f6ca',
  spam: '#f48fb1',
  call_duration: '#ffd96a',
  time_processing: '#ffe083',
  time_out_calls: '#ffe69b',
  holds: '#e0e0e0',
  active_operators: '#b9f6ca',
  expensive: '#ef9a9a',
  no_payment_method: '#ef9a9a',
  form_release: '#ef9a9a',
  want_guarantees: '#ef9a9a',
  not_processed: '#ef9a9a',
  expensive_delivery: '#ef9a9a',
  no_pay_tax: '#ef9a9a',
  changed_mind: '#ef9a9a',
  medical_contraindications: '#ef9a9a',
  not_allowed: '#ef9a9a',
  bad_reputation: '#ef9a9a',
  not_order: '#e0e0e0',
  not_delivery_time: '#e0e0e0',
  already_bought: '#e0e0e0',
  suite_different_price: '#e0e0e0',
  made_request: '#ef9a9a',
  no_nearby: '#e0e0e0',
  other_information: '#e0e0e0',
  won_gift: '#e0e0e0',
  language_barrier: '#e0e0e0',
  wrong_data: '#e0e0e0',
  drop_calls: '#e0e0e0',
  silent: '#e0e0e0',
  under_18: '#e0e0e0',
  not_ringing_long_time: '#e0e0e0',
  not_make_contact: '#e0e0e0',
  no_coverage: '#e0e0e0',
  blacklisted_customer: '#e0e0e0',
  minor: '#e0e0e0',
  another: '#e0e0e0',
  processed_all: '#fff9c4',
  total_cancel: '#ef9a9a',
  consultation: '#ef9a9a',
  any_reasons: '#e0e0e0',
  call_duration_approve: '#81c784',
  call_duration_cancel: '#ef9a9a',
  total_revenue: '#60b3f6',
  cross_sell_cost: '#60b3f6',
  cross_sell_local: '#60b3f6',
  operator: '#e0e0e0',
  parts_sms: '#e0e0e0',
  approvals: '#81c784',
  sent_sms: '#ffe69b',
  total_amount: '#90caf9',
  approve_percent: '#81c784',
  total_sms_sent: '#fff9c4',
  total_all: '#e0e0e0',
  total_lead_sms_sent: '#ffe69b',
  total_sms: '#ffe083',
  total_minutes: '#ffd96a',
  total_all_minutes: '#e0e0e0',
  total_minutes_lead: '#ffe69b',
  total_lead: '#ffe083',
  total_seconds_call: '#ffd96a'
};

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _Config = __webpack_require__(26);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  user: {
    authenticated: false,
    profile: null
  },
  haveAccess: function haveAccess(statisticName) {
    return this.user.profile.allowed_statistics[_Config2.default.STATISTICS[statisticName]];
  },
  check: function check(context, routerPatch) {
    var _this = this;

    var token = this.getAuthData();

    if (token !== null) {
      _vue2.default.console.log('Check session');
      _vue2.default.http.headers.common['Authorization'] = 'Bearer ' + token.access_token;
      _vue2.default.http.get('user').then(function (response) {
        _this.user.authenticated = true;
        _this.user.profile = response.data;
        _vue2.default.console.log('Restored');
        context.$router.push('/loading');
      }, function (response) {
        _vue2.default.console.log('Try to refresh session');
        _vue2.default.http.post('oauth2/token', {
          refresh_token: token.refresh_token,
          client_id: _Config2.default.CLIENT_ID,
          client_secret: _Config2.default.CLIENT_SECRET,
          grant_type: _Config2.default.GRANT_TYPE_REFRESH_TOKEN
        }).then(function (response) {
          _this.setAuthData(response.data);
          _vue2.default.http.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
          _vue2.default.http.get('user').then(function (response) {
            _this.user.authenticated = true;
            _this.user.profile = response.data;
            _vue2.default.console.log('Refreshed');
            context.$router.push('/loading');
          });
        }, function (response) {
          _this.logout(context);
        });
      });
    } else {
      context.$router.push('/login');
    }
  },
  login: function login(context) {
    var _this2 = this;

    _vue2.default.http.post('oauth2/token', {
      username: context.credentials.username,
      password: context.credentials.password,
      client_id: _Config2.default.CLIENT_ID,
      client_secret: _Config2.default.CLIENT_SECRET,
      grant_type: _Config2.default.GRANT_TYPE_PASSWORD
    }).then(function (response) {
      context.error = false;
      _this2.setAuthData(response.data);
      _vue2.default.http.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
      _vue2.default.http.get('user').then(function (response) {
        _this2.user.profile = response.data;
        _this2.user.authenticated = true;
        context.$router.push('/loading');
        context.authLoading = false;
      }, function (response) {
        _vue2.default.console.log('Response');
        _this2.clean();
        context.authLoading = false;
        context.error = 'Try again';
      });
    }, function (response) {
      context.authLoading = false;
      context.error = response.data.message;
    });
  },
  logout: function logout(context) {
    _vue2.default.console.log('Logout');
    this.clean();
    this.user.authenticated = false;
    this.user.profile = null;
    context.$router.push('/login');
  },
  loginImpersonate: function loginImpersonate(context) {
    var _this3 = this;

    _vue2.default.http.post('oauth2/token', {
      username: context.routese.username,
      password: context.routese.password,
      client_id: _Config2.default.CLIENT_ID,
      client_secret: _Config2.default.CLIENT_SECRET,
      grant_type: _Config2.default.GRANT_TYPE_PASSWORD,
      code: context.credentials.code,
      user_from: context.routese.user_from
    }).then(function (response) {
      context.error = false;
      _this3.setAuthData(response.data);
      _vue2.default.http.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
      _vue2.default.http.get('user').then(function (response) {
        _this3.user.profile = response.data;
        _this3.user.authenticated = true;
        context.$router.push('/loading');
        context.authLoading = false;
      }, function (response) {
        _vue2.default.console.log('Response');
        _this3.clean();
        context.authLoading = false;
        context.error = 'Try again';
      });
    }, function (response) {
      context.authLoading = false;
      context.error = response.data.message;
    });
  },
  logoutImpersonate: function logoutImpersonate() {
    this.clean();
    this.user.authenticated = false;
    this.user.profile = null;
  },
  getAuthData: function getAuthData() {
    return JSON.parse(localStorage.getItem('auth'));
  },
  setAuthData: function setAuthData(data) {
    localStorage.setItem('auth', JSON.stringify(data));
  },
  clean: function clean() {
    localStorage.removeItem('auth');
  }
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(565),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(550),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  API_HOST: 'https://api.analytics.leadgroup.su',
  CLIENT_ID: 'testclient',
  CLIENT_SECRET: 'testpass',
  GRANT_TYPE_PASSWORD: 'password',
  GRANT_TYPE_REFRESH_TOKEN: 'refresh_token',
  STATISTICS: {
    CONVERSIONS: 'CONVERSIONS',
    WEBMASTERS: 'WEBMASTERS',
    BUYOUT: 'BUYOUT',
    ORDER_PROCESSING: 'ORDER_PROCESSING',
    OPERATORS_SUMMARY: 'OPERATORS_SUMMARY',
    OPERATORS_EFFICIENCY: 'OPERATORS_EFFICIENCY',
    OPERATORS_ACTIVITY: 'OPERATORS_ACTIVITY',
    OFFER_ACTIVITY_STATISTIC: 'OFFER_ACTIVITY_STATISTIC',
    EXPENSE_EXPECTION: 'EXPENSE_EXPECTION',
    RETURN_REASON: 'RETURN_REASON',
    DASH_ADVERTISE_DEBIT: 'DASH_ADVERTISE_DEBIT',
    REFUNDS: 'REFUNDS',
    PRODUCT: 'PRODUCT',
    OFFER_RENTABILITY: 'OFFER_RENTABILITY',
    WEBMASTERS_PAYMENTS: 'WEBMASTERS_PAYMENTS',
    CALL_STATISTICS: 'CALL_STATISTICS',
    OPERATORS_ANALYSIS: 'OPERATORS_ANALYSIS',
    CALL_CENTER_TIMINGS: 'CALL_CENTER_TIMINGS',
    HOLD_CALLS: 'HOLD_CALLS'
  }
};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57054616",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__(178);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Language = __webpack_require__(197);

var _Language2 = _interopRequireDefault(_Language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);

var i18n = new _vueI18n2.default({
  locale: _Storage2.default.language,
  fallbackLocale: 'en',
  messages: _Language2.default
});

exports.default = i18n;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  1528: '#80cbc4',
  1534: '#20a8d8',
  1522: '#b39ddb',
  1536: '#bcaaa4',
  1529: '#a5d6a7',
  1527: '#80dee9',
  1525: '#90caf8',
  1537: '#b0bec5',
  1531: '#76fe03',
  1535: '#feab91',
  77: '#ce93d8',
  1532: '#e5ed9c',
  1526: '#81d4f9',
  1530: '#c5e1a5',
  1533: '#008000',
  1524: '#9fa8da',
  1538: '#b263aa',
  1539: '#da9d89',
  1540: '#bac9f0',
  1542: '#6498b7',
  1543: '#f0e2a5',
  1544: '#5ca2aa',
  1545: '#94cf62',
  1546: '#eaa1e3',
  1547: '#feab91'
};

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(523),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65da3394",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1da9c8f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(561),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */,
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(604);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueI18n = __webpack_require__(178);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _i18n = __webpack_require__(34);

var _i18n2 = _interopRequireDefault(_i18n);

var _Full = __webpack_require__(443);

var _Full2 = _interopRequireDefault(_Full);

var _Dashboard = __webpack_require__(444);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Page = __webpack_require__(451);

var _Page2 = _interopRequireDefault(_Page);

var _Login = __webpack_require__(447);

var _Login2 = _interopRequireDefault(_Login);

var _Profile = __webpack_require__(448);

var _Profile2 = _interopRequireDefault(_Profile);

var _Loading = __webpack_require__(446);

var _Loading2 = _interopRequireDefault(_Loading);

var _Impersonate = __webpack_require__(445);

var _Impersonate2 = _interopRequireDefault(_Impersonate);

var _Country = __webpack_require__(460);

var _Country2 = _interopRequireDefault(_Country);

var _Offer = __webpack_require__(464);

var _Offer2 = _interopRequireDefault(_Offer);

var _Period = __webpack_require__(465);

var _Period2 = _interopRequireDefault(_Period);

var _Courier = __webpack_require__(461);

var _Courier2 = _interopRequireDefault(_Courier);

var _Graph = __webpack_require__(463);

var _Graph2 = _interopRequireDefault(_Graph);

var _Buyout = __webpack_require__(459);

var _Buyout2 = _interopRequireDefault(_Buyout);

var _Flypost = __webpack_require__(462);

var _Flypost2 = _interopRequireDefault(_Flypost);

var _Webmasters = __webpack_require__(452);

var _Webmasters2 = _interopRequireDefault(_Webmasters);

var _Payments = __webpack_require__(496);

var _Payments2 = _interopRequireDefault(_Payments);

var _Source = __webpack_require__(497);

var _Source2 = _interopRequireDefault(_Source);

var _Landing = __webpack_require__(495);

var _Landing2 = _interopRequireDefault(_Landing);

var _Grid = __webpack_require__(494);

var _Grid2 = _interopRequireDefault(_Grid);

var _ArrivalNewLeads = __webpack_require__(493);

var _ArrivalNewLeads2 = _interopRequireDefault(_ArrivalNewLeads);

var _WebAnalysis = __webpack_require__(498);

var _WebAnalysis2 = _interopRequireDefault(_WebAnalysis);

var _Efficiency = __webpack_require__(470);

var _Efficiency2 = _interopRequireDefault(_Efficiency);

var _Activity = __webpack_require__(467);

var _Activity2 = _interopRequireDefault(_Activity);

var _Order = __webpack_require__(474);

var _Order2 = _interopRequireDefault(_Order);

var _Conversion = __webpack_require__(477);

var _Conversion2 = _interopRequireDefault(_Conversion);

var _NewOrders = __webpack_require__(478);

var _NewOrders2 = _interopRequireDefault(_NewOrders);

var _NewOrdersWeek = __webpack_require__(479);

var _NewOrdersWeek2 = _interopRequireDefault(_NewOrdersWeek);

var _OperatorSchedule = __webpack_require__(472);

var _OperatorSchedule2 = _interopRequireDefault(_OperatorSchedule);

var _ExpectedExpensesKC = __webpack_require__(471);

var _ExpectedExpensesKC2 = _interopRequireDefault(_ExpectedExpensesKC);

var _CallStatistics = __webpack_require__(468);

var _CallStatistics2 = _interopRequireDefault(_CallStatistics);

var _OperatorsAnalysis = __webpack_require__(473);

var _OperatorsAnalysis2 = _interopRequireDefault(_OperatorsAnalysis);

var _RingingSms = __webpack_require__(480);

var _RingingSms2 = _interopRequireDefault(_RingingSms);

var _WorkTimingKC = __webpack_require__(476);

var _WorkTimingKC2 = _interopRequireDefault(_WorkTimingKC);

var _RingingHolds = __webpack_require__(475);

var _RingingHolds2 = _interopRequireDefault(_RingingHolds);

var _SentSmsTemplate = __webpack_require__(481);

var _SentSmsTemplate2 = _interopRequireDefault(_SentSmsTemplate);

var _CrossSell = __webpack_require__(469);

var _CrossSell2 = _interopRequireDefault(_CrossSell);

var _Rentability = __webpack_require__(466);

var _Rentability2 = _interopRequireDefault(_Rentability);

var _Cancel = __webpack_require__(488);

var _Cancel2 = _interopRequireDefault(_Cancel);

var _Return = __webpack_require__(491);

var _Return2 = _interopRequireDefault(_Return);

var _CancelByMonth = __webpack_require__(489);

var _CancelByMonth2 = _interopRequireDefault(_CancelByMonth);

var _ReturnByMonth = __webpack_require__(492);

var _ReturnByMonth2 = _interopRequireDefault(_ReturnByMonth);

var _CancelOperators = __webpack_require__(490);

var _CancelOperators2 = _interopRequireDefault(_CancelOperators);

var _Product = __webpack_require__(483);

var _Product2 = _interopRequireDefault(_Product);

var _ProductCountry = __webpack_require__(485);

var _ProductCountry2 = _interopRequireDefault(_ProductCountry);

var _ProductTag = __webpack_require__(486);

var _ProductTag2 = _interopRequireDefault(_ProductTag);

var _ProductBalance = __webpack_require__(484);

var _ProductBalance2 = _interopRequireDefault(_ProductBalance);

var _OrdersReceipt = __webpack_require__(482);

var _OrdersReceipt2 = _interopRequireDefault(_OrdersReceipt);

var _Country3 = __webpack_require__(453);

var _Country4 = _interopRequireDefault(_Country3);

var _Offer3 = __webpack_require__(457);

var _Offer4 = _interopRequireDefault(_Offer3);

var _Couriers = __webpack_require__(454);

var _Couriers2 = _interopRequireDefault(_Couriers);

var _Week = __webpack_require__(458);

var _Week2 = _interopRequireDefault(_Week);

var _Days = __webpack_require__(455);

var _Days2 = _interopRequireDefault(_Days);

var _Month = __webpack_require__(456);

var _Month2 = _interopRequireDefault(_Month);

var _ChangeLog = __webpack_require__(449);

var _ChangeLog2 = _interopRequireDefault(_ChangeLog);

var _ChangeVersion = __webpack_require__(450);

var _ChangeVersion2 = _interopRequireDefault(_ChangeVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var vm = new _vue2.default({
  i18n: _i18n2.default
});

exports.default = new _vueRouter2.default({
  mode: 'hash',
  linkActiveClass: 'open active',
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: vm.$t('pages.analytics'),
    component: _Full2.default,
    children: [{
      path: 'dashboard',
      name: vm.$t('pages.dashboard'),
      component: _Dashboard2.default
    }, {
      path: '/pages/changelog',
      name: vm.$t('pages.changelog'),
      component: _ChangeLog2.default
    }, {
      path: '/pages/versions',
      name: vm.$t('pages.changeversion'),
      component: _ChangeVersion2.default
    }, {
      path: '/statistic/conversions',
      redirect: '/statistic/conversions/country',
      name: vm.$t('pages.conversions'),
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/statistic/conversions/country',
        name: vm.$t('pages.by_country'),
        component: _Country2.default
      }, {
        path: '/statistic/conversions/offers',
        name: vm.$t('pages.by_offers'),
        component: _Offer2.default
      }, {
        path: '/statistic/conversions/period',
        name: vm.$t('pages.by_period'),
        component: _Period2.default
      }, {
        path: '/statistic/conversions/courier',
        name: vm.$t('pages.by_couriers'),
        component: _Courier2.default
      }, {
        path: '/statistic/conversions/graph',
        name: vm.$t('pages.by_graph'),
        component: _Graph2.default
      }, {
        path: '/statistic/conversions/buyout',
        name: vm.$t('pages.by_pieces'),
        component: _Buyout2.default
      }, {
        path: '/statistic/conversions/flypost',
        name: vm.$t('pages.buyouts_flypost'),
        component: _Flypost2.default
      }]
    }, {
      path: '/statistic/webmasters',
      name: vm.$t('pages.webmasters'),
      component: _Webmasters2.default
    }, {
      path: '/statistic/webmasters/payments',
      name: vm.$t('pages.webmaster_individual_rates'),
      component: _Payments2.default
    }, {
      path: '/statistic/webmasters/source',
      name: vm.$t('pages.source_statistic'),
      component: _Source2.default
    }, {
      path: '/statistic/webmasters/landing',
      name: vm.$t('pages.landing_statistic'),
      component: _Landing2.default
    }, {
      path: '/statistic/webmasters/grid',
      name: vm.$t('pages.grid_statistic'),
      component: _Grid2.default
    }, {
      path: '/statistic/webmasters/arrival_new_leads',
      name: vm.$t('pages.arrival_new_leads'),
      component: _ArrivalNewLeads2.default
    }, {
      path: '/statistic/webmasters/analysis',
      name: vm.$t('pages.web_analysis'),
      component: _WebAnalysis2.default
    }, {
      path: '/statistic/refunds',
      redirect: '/statistic/refunds/return_by_month',
      name: vm.$t('pages.refunds'),
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/statistic/refunds/return',
        name: vm.$t('pages.ref_return'),
        component: _Return2.default
      }, {
        path: '/statistic/refunds/cancel',
        name: vm.$t('pages.ref_cancel'),
        component: _Cancel2.default
      }, {
        path: '/statistic/refunds/cancel_by_month',
        name: vm.$t('pages.ref_cancel_by_month'),
        component: _CancelByMonth2.default
      }, {
        path: '/statistic/refunds/return_by_month',
        name: vm.$t('pages.ref_return_by_month'),
        component: _ReturnByMonth2.default
      }, {
        path: '/statistic/refunds/cancel_operators',
        name: vm.$t('pages.ref_cancel_operators'),
        component: _CancelOperators2.default
      }]
    }, {
      path: '/statistic/buyout',
      redirect: '/statistic/buyout/country',
      name: vm.$t('pages.buyout'),
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/statistic/buyout/country',
        name: 'by_country',
        component: _Country4.default
      }, {
        path: '/statistic/buyout/offers',
        name: 'by_offers',
        component: _Offer4.default
      }, {
        path: '/statistic/buyout/couriers',
        name: 'by_couriers',
        component: _Couriers2.default
      }, {
        path: '/statistic/buyout/weeks',
        name: vm.$t('pages.by_weeks'),
        component: _Week2.default
      }, {
        path: '/statistic/buyout/days',
        name: vm.$t('pages.by_days'),
        component: _Days2.default
      }, {
        path: '/statistic/buyout/month',
        name: vm.$t('pages.by_month'),
        component: _Month2.default
      }]
    }, {
      path: '/statistic/offer',
      redirect: '/statistic/offer',
      name: vm.$t('pages.offer'),
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/statistic/offer',
        name: vm.$t('pages.offer_rent'),
        component: _Rentability2.default
      }]
    }, {
      path: '/statistic/operators',
      redirect: '/statistic/operators/efficiency',
      name: vm.$t('pages.operators'),
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/statistic/operators/efficiency',
        name: vm.$t('pages.efficiency'),
        component: _Efficiency2.default
      }, {
        path: '/statistic/operators/activity',
        name: vm.$t('pages.activity'),
        component: _Activity2.default
      }, {
        path: '/statistic/operators/order',
        name: vm.$t('pages.order'),
        component: _Order2.default
      }, {
        path: '/statistic/operators/conversions/conversion',
        name: 'order',
        component: _Conversion2.default
      }, {
        path: '/statistic/operators/conversions/new_orders',
        name: vm.$t('pages.new_orders'),
        component: _NewOrders2.default
      }, {
        path: '/statistic/operators/conversions/new_orders_week',
        name: vm.$t('pages.new_orders_week'),
        component: _NewOrdersWeek2.default
      }, {
        path: '/statistic/operators/schedule',
        name: vm.$t('pages.approved_during_the_day'),
        component: _OperatorSchedule2.default
      }, {
        path: '/statistic/operators/expenses_kc',
        name: vm.$t('pages.expenses_by_kc'),
        component: _ExpectedExpensesKC2.default
      }, {
        path: '/statistic/operators/timing_kc',
        name: vm.$t('pages.timing_kc'),
        component: _WorkTimingKC2.default
      }, {
        path: '/statistic/operators/ringing_sms',
        name: vm.$t('pages.ringing_sms'),
        component: _RingingSms2.default
      }, {
        path: '/statistic/operators/sent_sms_template',
        name: vm.$t('pages.sent_sms_template'),
        component: _SentSmsTemplate2.default
      }, {
        path: '/statistic/operators/call_statistics',
        name: vm.$t('pages.call_statistics'),
        component: _CallStatistics2.default
      }, {
        path: '/statistic/operators/operators_analysis',
        name: vm.$t('pages.operators_analysis'),
        component: _OperatorsAnalysis2.default
      }, {
        path: '/statistic/operators/ringing_holds',
        name: vm.$t('pages.ringing_holds'),
        component: _RingingHolds2.default
      }, {
        path: '/statistic/operators/cross_sell',
        name: vm.$t('pages.cross_sell'),
        component: _CrossSell2.default
      }]
    }, {
      path: '/statistic/product',
      redirect: '/statistic/product/offer',
      name: vm.$t('pages.product'),
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/statistic/product/offer',
        name: vm.$t('pages.by_offers'),
        component: _Product2.default
      }, {
        path: '/statistic/product/country',
        name: vm.$t('pages.by_country'),
        component: _ProductCountry2.default
      }, {
        path: '/statistic/product/tag',
        name: vm.$t('pages.by_category_product'),
        component: _ProductTag2.default
      }, {
        path: '/statistic/product/balance',
        name: vm.$t('pages.by_balance_currency'),
        component: _ProductBalance2.default
      }, {
        path: '/statistic/product/orders_receipt',
        name: vm.$t('pages.orders_receipt'),
        component: _OrdersReceipt2.default
      }]
    }]
  }, {
    path: '/404',
    name: '404 Error',
    component: _Page2.default
  }, {
    path: '/impersonate',
    name: 'Impersonate',
    component: _Impersonate2.default
  }, {
    path: '/login',
    name: 'Login',
    component: _Login2.default
  }, {
    path: '/loading',
    name: 'Loading',
    component: _Loading2.default
  }, {
    path: '/account/',
    redirect: '/account/profile',
    name: vm.$t('auth.account'),
    component: _Full2.default,
    children: [{
      path: 'profile',
      name: vm.$t('auth.profile'),
      component: _Profile2.default
    }]
  }, {
    path: '*',
    name: '404',
    component: _Page2.default
  }]
});

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ru = __webpack_require__(199);

var _ru2 = _interopRequireDefault(_ru);

var _en = __webpack_require__(198);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { ru: _ru2.default, en: _en2.default };

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  message: {
    loading: 'Loading'
  },
  verbs: {
    url_copied: 'URL copied',
    save: 'Save',
    close: 'Close',
    error: 'Error',
    try_again: 'Try again',
    download: 'Download',
    history: 'History',
    apply: 'Apply',
    invalid_parameters: 'Invalid parameters',
    manager: 'Manager',
    loading_error: 'Error while loading data. Try again.',
    edit: 'Make changes?',
    total: 'The number of orders',
    without: 'No courier',
    unsent: 'Unsent',
    statusFilter: 'Filter',
    statusStop: 'Stop'
  },
  auth: {
    login_action: 'Login',
    login: 'Login',
    password: 'Password',
    password_repeat: 'Password repeat',
    account: 'Account',
    profile: 'Profile',
    logout: 'Logout',
    old_password: 'Old password',
    key: 'Enter a code'
  },
  filter: {
    webmaster_grid: 'Webmaster (on grids)',
    webmaster: 'Webmaster'
  },
  statistic: {
    ad_approved: 'Advertising',
    ad_pre_approved: 'Pre-approval advertising',
    ad_difference: 'Difference of advertisements',
    ad_approve_percent: '% approval',
    averageBuyback: 'Average Buyback',
    revenue_lead: 'Revenue Lead',
    total_revenue: 'Total revenue',
    deviation_mean: 'Deviation Mean',
    day: 'Day',
    traffic: 'Traffic',
    last_update: 'Last update',
    last_version: 'Current version',
    averageBill: 'Average bill',
    averageBillLocal: 'Average bill (local)',
    average_x_price: 'Average x start price',
    approve: 'Approve',
    approve_percent: 'Approve total',
    approved: 'Approved',
    approvedFromValid: 'Approved from valid',
    leads: 'Leads',
    quantity: 'Quantity',
    offers: 'Offers',
    offer: 'Offer',
    filters: 'Filters',
    adult: 'Adult',
    slimming: 'Slimming',
    beauty: 'Beauty',
    health: 'Health',
    economizers: 'Economizers',
    lowPrice: 'Low Price',
    hair: 'Hair',
    sport: 'Sport',
    other: 'Other',
    date: 'Date',
    total: 'Total',
    processed: 'Processed',
    accepted: 'Accepted',
    canceled: 'Canceled',
    canceled_by_reason: 'Сanceled by reason',
    canceledPercents: 'Canceled %',
    error: 'Error',
    errorPercents: 'Error %',
    return: 'Return',
    returnPercents: 'Return %',
    paid: 'Paid',
    paidPercents: 'Paid %',
    in_total: 'In total',
    webmaster: 'Webmaster',
    proportion: 'Proportion',
    buyoutSum: 'Buyout sum',
    acceptedSum: 'Accepted sum',
    operator: 'Operator',
    processed_leads: 'Processed leads',
    points: 'Points',
    operators: 'Operators',
    actions: 'Actions',
    courier: 'Courier',
    shipped: 'Shipped',
    couriers: 'Couriers',
    transit: 'Transit',
    delivered: 'Delivered',
    buyout: 'Buyout',
    additional_sale: 'Add. sale',
    old_bonus: 'Bonus',
    new_bonus: 'New bonus',
    bonus_system: 'Bonus system',
    exporting_history: 'Exporting history',
    paid_bonus: 'Paid bonus',
    system_bonus: 'System bonus',
    reason: 'Reason',
    month: 'Month',
    week: 'Week',
    debt: 'Advertise debit',
    country: 'Country',
    to_pay_for_today: 'To pay for today',
    payout_for_the_week: 'Payout for the week',
    last_payout: 'Last payout',
    cancel_title: 'Reason for cancel',
    cancel_count: 'Cancellations',
    return_title: 'Reason for return',
    return_count: 'Returns',
    refundsId: 'ID',
    AcceptCancel: 'Accept Cancel',
    CancelAccept: 'Cancel Accept',
    ProcessAccept: 'Process Accept',
    ProcessCancel: 'Process Cancel',
    ProcessSpam: 'Process Spam',
    SpamAccept: 'Spam Accept',
    spam: 'Spam',
    average_payment: 'Average payment for the period',
    last_payment: 'Actual payment',
    payment_fix: 'Settlement payment',
    fix_to: 'Became',
    fix_from: 'It was',
    payment_history: 'History of changes',
    vat: 'VAT',
    out: 'OUT',
    profitlid: 'PROFIT from 1 lead',
    profitperiod: 'PROFIT for the period',
    packaging: 'Packaging',
    shippeds: 'Ship',
    average_payments: 'Average Payments',
    user: 'User',
    product: 'Product',
    products: 'Products',
    balance: 'Balance',
    unloaded_leads: 'Unloaded leads',
    unloaded_product: 'Unloaded product',
    delays_leads: 'Delays leads',
    delays_product: 'Delays product',
    stock_product: 'Stock product',
    order_product: 'Order product',
    comment: 'Comment',
    price: 'Price',
    project: 'Project',
    price_for_one: 'Unit price',
    balance_on_the_first_day_of_the_month: 'Balance on the first day of the month',
    total_money: 'Total',
    provider: 'Provider',
    logistic: 'Logistics',
    customs: 'Customs',
    time: 'Time',
    times: 'Date',
    status: 'Status',
    ordered: 'Ordered',
    credit: 'Credit',
    shift: 'Changes',
    by_graph: 'By graph',
    time_success_call: 'Average time to a successful call',
    time_recall: 'Average time to chime',
    expenses_by_lead: 'Expenses by lead',
    expected_lead_increase: 'Expected lead increase',
    cost_change: 'Cost change',
    sets: 'Sets',
    city: 'City',
    cost_price: 'Cost price',
    dialer: '% Dialer',
    average_first_call_time: 'Average First Call Time',
    average_number_touches: 'Average Number Touches',
    average_calls: 'Average Number Calls',
    active_operators: 'Active operators',
    ringing_holds: 'Holds ringing',
    cross_sell: 'Cross sell',
    worked: 'Worked',
    one_day_dialer: 'One day dialer',
    sending_check: 'Sending check',
    foreclosure_check: 'Foreclosure Check',
    call_duration: 'Call Duration',
    time_processing: 'Time Processing',
    time_out_calls: 'Time out of calls',
    call_duration_approve: 'Call duration approve',
    call_duration_cancel: 'Call duration cancel',
    total_cancel: 'Total cancellations',
    processed_all: 'Processed all',
    another: 'Other',
    expensive: 'Expensive',
    not_order: 'Not order',
    changed_mind: 'Changed mind',
    bad_reputation: 'Bad reputation',
    consultation: 'Consultation',
    not_allowed: 'Not allowed',
    medical_contraindications: 'Medical contraindications',
    not_ringing_long_time: 'Not ringing long time',
    not_make_contact: 'Not make contact',
    no_coverage: 'No coverage',
    blacklisted_customer: 'Blacklisted customer',
    not_delivery_time: 'Not delivery time',
    already_bought: 'Already bought',
    suite_different_price: 'Suite different price',
    any_reasons: 'Any reasons',
    template_sms: 'SMS template',
    parts_sms: 'Number of SMS parts',
    sent_sms: 'Sent SMS',
    total_amount: 'Total amount',
    approvals: 'Approvals',
    cross_sell_cost: 'Cross sell cost',
    orders_accepted: 'Orders accepted',
    no_payment_method: 'Not satisfied with the payment method (card / cash)',
    form_release: "I don't like the form of release of the product",
    want_guarantees: 'Guarantees and refunds',
    not_processed: 'Orders cannot be processed at this time',
    expensive_delivery: 'Expensive delivery',
    no_pay_tax: "Doesn't want to pay tax",
    no_nearby: 'There is no client nearby',
    other_information: 'The site has other information about the product',
    won_gift: 'The client thought he had won a gift',
    language_barrier: 'Language barrier',
    wrong_data: 'Wrong number, wrong place',
    drop_calls: 'The client drops the call / cannot be confirmed',
    silent: 'Clients are silent and do not talk',
    under_18: 'Client under 18 years of age'
  },
  filters: {
    clean: 'Clean',
    select_all: 'Select all',
    reset: 'Reset',
    more_pre: 'and ',
    more_post: ' more',
    apply: 'Apply',
    reset_all: 'Reset all',
    yesterday: 'Yesterday',
    week: 'Week',
    this_month: 'This month',
    last_month: 'Last month',
    copy_filter: 'Copy filter',
    filter_copied: 'Filter copied',
    filter_copied_error: 'Copy error',
    period: 'Period',
    by_wm: 'By web1',
    by_manual: 'By manual'
  },
  country: {
    '1528': 'Vietnam',
    '1534': 'Egypt',
    '1522': 'India',
    '1536': 'Iran',
    '1529': 'Indonesia',
    '1527': 'Morocco',
    '1525': 'Malaysia',
    '1537': 'Nigeria',
    '1531': 'Pakistan',
    '1535': 'Russia 2',
    '77': 'Russia',
    '1532': 'Thailand 4',
    '1526': 'Turkey 2',
    '1530': 'Thailand 3',
    '1533': 'Philippines 2',
    '1524': 'Philippines',
    '1538': 'Tunis',
    '1539': 'Indonesia 2',
    '1540': 'Europe',
    '1541': 'Test',
    '1542': 'Colombia',
    '1543': 'Algeria',
    '1544': 'Myanmar',
    '1545': 'UAE',
    '1546': 'Singapore',
    '1547': 'Russia 3',
    '1548': 'GreenGo',
    '1549': 'India 2',
    '1550': 'Peru',
    '1551': 'PRO India',
    '1552': 'PRO Indonesia',
    '1553': 'PRO Malaysia',
    '1554': 'PRO Philippines',
    '1555': 'PRO Vietnam',
    '1556': 'PRO Tunis',
    '1557': 'PRO Colombia',
    '1558': 'PRO Russia',
    '1559': 'PRO Ukraine',
    '1560': 'PRO Kazakhstan',
    '1561': 'PRO Nigeria',
    '1562': 'Test',
    '1563': 'PRO Thailand',
    '1564': 'PRO Iraq',
    '1565': 'PRO South Africa',
    '1566': 'PRO Venezuela',
    '1567': 'PRO Argentine',
    '1568': 'PRO Chile',
    '1569': 'PRO Uruguay',
    '1570': 'PRO Ecuador',
    '1571': 'PRO Peru',
    '1573': 'PRO Morocco',
    '1574': 'PRO Mexico',
    '1576': 'PRO Bangladesh',
    '1580': 'PRO Sri Lanka',
    '1581': 'PRO Laos',
    '1582': 'PRO Europe',
    '1583': 'PRO Uzbekistan',
    '1584': 'PRO Nepal',
    '1585': 'PRO Kenya',
    '1588': 'Test 2',
    '1589': 'Myanmar 2',
    '1572': 'PRO Myanmar',
    '1591': 'PRO Myanmar 2',
    '1592': 'PRO Indonesia 2',
    '1593': 'PRO India 2',
    '1594': 'Colombia 2',
    '1595': 'PRO Mexico 2',
    '1596': 'PRO Colombia 2',
    '1597': 'GGTeam',
    '1598': 'PRO Kazakhstan 2',
    '1599': 'PRO Guatemala',
    '1600': 'PRO Singapore',
    '1601': 'Chile',
    '1602': 'Pakistan',
    '1603': 'Ethiopia',
    '1604': 'Ecuador',
    '1605': 'USA',
    '1606': 'Iran 1',
    '1608': 'For tests',
    '1609': 'PRO Algeria',
    '1610': 'Sri-Lanka',
    '1611': 'PRO Costa-Rica',
    '1612': 'PRO Dominican Republic',
    '1613': 'PRO Egypt 2',
    '1614': 'PRO Honduras',
    '1615': 'PRO Ivory Coast',
    '1616': 'PRO Jordan',
    '1617': 'PRO Nigeria 2',
    '1618': 'PRO South Africa 2',
    '1619': 'PRO Bolivia',
    '1620': 'PRO Kenya 2',
    '-1': 'All'
  },
  return_reason: {
    1: 'VERY_EXPENSIVE',
    2: 'CHANGED_ONES_MIND',
    3: 'DELIVERY_TOOK_TO_LONG',
    4: 'BAD_QUALITY_OF_PACKAGE',
    5: 'COURIER_INCREASED_AMOUNT',
    6: 'NO_NOTIFICATION_FROM_COURIER',
    7: 'RUDE_COURIER',
    8: 'NO_DELIVERED_AFTER_FIRST_ATTEMPT',
    9: 'CUSTOMER_OUTSIDE_OF_CITY',
    10: 'DELIVERED_BOY_DID_NOT_CAME',
    11: 'PIN_CODE_MISTAKE',
    12: 'CUSTOMER_IS_NOT_AVAILABLE',
    13: 'BOUGHT_ANOTHER_PRODUCT',
    14: 'MONEY_PROBLEM',
    15: 'CAN_NOT_OPEN_PARCEL',
    16: 'CAN_NOT_PAY_VIA_CREDIT_CARD'
  },
  pages: {
    web_analysis: 'Web analysis',
    statistic: 'Statistic',
    refunds: 'Returns',
    ref_cancel: 'Statistics on cancellations',
    ref_return: 'Statistics on returns',
    ref_cancel_by_month: 'Statistics on cancellations by month',
    ref_return_by_month: 'Statistics on returns by month',
    ref_cancel_operators: 'Operator cancellation statistics',
    webmasters: 'Webmasters',
    dashboard: 'Main',
    analytics: 'Analytics',
    conversions: 'Statistic',
    by_country: 'Country',
    by_offers: 'Offers',
    by_category_product: 'Category Product',
    by_balance_currency: 'Balance Currency',
    by_period: 'Period',
    operators: 'Operators',
    efficiency: 'Efficiency',
    activity: 'Activity',
    buyout: 'Buyout',
    return_reason: 'Return reason',
    by_couriers: 'By couriers',
    by_weeks: 'By weeks',
    by_days: 'By days',
    by_month: 'By month',
    by_graph: 'By graph',
    by_pieces: 'By pieces',
    changelog: 'Change Log',
    changeversion: 'Versions',
    order: 'Processing orders',
    conversion: 'Сonversion',
    new_orders: 'New Orders',
    new_orders_week: 'By weeks',
    operator_conversions: 'Conversion statistics for operators',
    individual_rates: 'Individual rates',
    webmaster_statistic: 'Statistics for webmasters',
    webmaster_individual_rates: 'Statistics on individual rewards of webmasters',
    orders: 'Orders',
    receipt: 'Receipt',
    remnants: 'Remnants',
    product: 'Product',
    offer: 'Offer',
    offer_rent: 'Profitability offers',
    rentability: 'Rentability',
    expenses_by_kc: 'Expenses by KC',
    timing_kc: 'Work timing KC',
    call_statistics: 'Call Statistics',
    operators_analysis: 'Operators',
    source_statistic: 'Statistics for source',
    sources: 'Sources',
    landing: 'Landing',
    landing_statistic: 'Statistics for landing',
    arrival_new_leads: 'Arrival of new leads',
    grid_statistic: 'Statistics for grid',
    approved_during_the_day: 'Approved during the day',
    orders_receipt: 'Orders/Receipt',
    buyouts_flypost: 'Buyouts Flypost',
    sent_sms_template: 'Sent sms template',
    webmasters_notify: 'Webmasters successfully copied'
  },
  profile: {
    gravatar_change_avatar: 'You may change your avatar at ',
    avatar: 'Avatar',
    security: 'Security',
    change_password: 'Change password',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    personal_information: 'Personal Information',
    password_error_9: 'Password length must be 6 or more symbols',
    password_error_8: 'Passwords did not match',
    password_error_10: 'Old password is invalid',
    password_changed: 'Password changed',
    need_all: 'Please fill all fields',
    updated: 'Profile updated',
    language: 'Language',
    language_changed: 'Language changed',
    for_developer: 'For developers',
    developer_mode: 'Developer mode'
  },
  month: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  }
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  message: {
    loading: 'Загрузка'
  },
  verbs: {
    url_copied: 'Ссылка скопирована',
    save: 'Сохранить',
    close: 'Закрыть',
    error: 'Ошибка',
    try_again: 'Попробуйте еще раз',
    download: 'Скачать',
    history: 'История',
    apply: 'Применить',
    invalid_parameters: 'Неверные параметры',
    manager: 'Менеджер',
    edit: 'Внести изменения?',
    add_product: 'Добавить заказ',
    total: 'Количество заказов',
    without: 'Без курьерки',
    unsent: 'Неотправленные',
    statusFilter: 'Фильтр',
    statusStop: 'Стоп'
  },
  auth: {
    login_action: 'Войти',
    login: 'Авторизация',
    password: 'Пароль',
    password_repeat: 'Пароль еще раз',
    account: 'Аккаунт',
    profile: 'Профиль',
    logout: 'Выход',
    old_password: 'Старый пароль',
    key: 'Введите код'
  },
  filter: {
    webmaster_grid: 'Веб-мастер (по сеткам)',
    webmaster: 'Веб-мастер'
  },
  statistic: {
    traffic: 'Трафик',
    ad_approved: 'Реклама',
    ad_pre_approved: 'Реклама предапрува',
    ad_difference: 'Разница реклам',
    ad_approve_percent: '% апрува',
    day: 'День',
    last_update: 'Последнее обновление',
    last_version: 'Текущая версия',
    averageBill: 'Средний чек',
    averageBillLocal: 'Средний чек (местный)',
    averageBuyback: 'Средний чек выкупа',
    averageBuybackLocal: 'Средний выкуп (местный)',
    average_x_price: 'x от нач.цены',
    approve: 'Апрув',
    approvedFromValid: 'Арув от валида',
    approved: 'Подтверждено',
    leads: 'Лиды',
    quantity: 'Количество',
    holds: 'Холды',
    offers: 'Офферы',
    offer: 'Оффер',
    filters: 'Фильтры',
    adult: 'Адалт',
    slimming: 'Похудение',
    beauty: 'Красота',
    health: 'Здоровье',
    economizers: 'Экономайзеры',
    lowPrice: 'Лоу Прайс',
    hair: 'Волосы',
    sport: 'Спорт',
    other: 'Прочее',
    date: 'Дата',
    total: 'Всего',
    processed: 'В обработке',
    accepted: 'Одобрено',
    canceled: 'Отменено',
    canceled_by_reason: 'Отменено по причине',
    canceledPercents: 'Отменено %',
    error: 'Ошибки',
    errorPercents: 'Ошибки %',
    return: 'Возвраты',
    returnPercents: 'Возвраты %',
    paid: 'Оплачено',
    paidPercents: 'Оплачено %',
    in_total: 'Итого',
    webmaster: 'Веб-мастер',
    proportion: 'Доля',
    buyoutSum: 'Выкуплено',
    acceptedSum: 'Одобрено',
    worked: 'Отработано',
    operator: 'Оператор',
    processed_leads: 'Обработано лидов',
    points: 'Баллы',
    operators: 'Операторы',
    actions: 'Действия',
    courier: 'Курьер',
    shipped: 'Отправлено',
    couriers: 'Курьеры',
    transit: 'В пути',
    delivered: 'Доставлено',
    averageBillPopup: 'Средний чек',
    buyout: 'Выкуп',
    additional_sale: 'Доп. продаж',
    old_bonus: 'Бонус',
    revenue_lead: 'Выручка на лид',
    total_revenue: 'Выручка всего',
    deviation_mean: 'Отклонение от среднего',
    new_bonus: 'Новый бонус',
    bonus_system: 'Система бонусов',
    exporting_history: 'История экспорта',
    period: 'Период',
    paid_bonus: 'Выплаченный бонус',
    system_bonus: 'Бонус по системе',
    loading_error: 'Ошибка при загрузке данных. Попробуйте еще раз.',
    reason: 'Причина',
    week: 'Неделя',
    difference: 'Разница',
    debt: 'Рекламный долг',
    delay_debt: 'Просрочка по рекламному долгу',
    country: 'Страна',
    to_pay_for_today: 'К выплате за сегодня',
    payout_for_the_week: 'К выплате за неделю',
    last_payout: 'Последняя выплата',
    cancel_title: 'Причина отмены',
    cancel_count: 'Отмены',
    return_title: 'Причина возврата',
    return_count: 'Возвраты',
    refundsId: 'ID',
    AcceptCancel: 'Принят ⇒ Отменен',
    CancelAccept: 'Отменен ⇒ Принят',
    ProcessAccept: 'Обработка ⇒ Принят',
    ProcessCancel: 'Обработка ⇒ Отменен',
    ProcessSpam: 'Обработка ⇒ Спам',
    SpamAccept: 'Спам ⇒ Принят',
    spam: 'Спам',
    average_payment: 'Средняя выплата за период',
    last_payment: 'Фактическая выплата',
    payment_fix: 'Установленная выплата',
    fix_to: 'Стало',
    fix_from: 'Было',
    payment_history: 'История изменений',
    vat: 'VAT',
    out: 'Вывод',
    profitlid: 'ПРОФИТ с 1 лида',
    profitperiod: 'ПРОФИТ за период',
    packaging: 'Упаковка',
    shippeds: 'В доставке',
    average_payments: 'Выплата вебу',
    user: 'Пользователь',
    product: 'Товар',
    products: 'Товары',
    balance: 'Остаток на складе',
    unloaded_leads: 'Выгружено лидов за месяц',
    unloaded_product: 'Выгружено товаров за месяц',
    delays_leads: 'Задержки Лидов',
    delays_product: 'Задержки Товаров',
    stock_product: 'Запас Дней',
    order_product: 'Заказ Товара',
    comment: 'Комментарий',
    price: 'Цена',
    project: 'Проект',
    balance_on_the_first_day_of_the_month: 'Остаток на 1-е число',
    total_money: 'Сумма',
    logistic: 'Логистика',
    customs: 'Растаможка',
    price_for_one: 'Цена за единицу',
    provider: 'Поставщик',
    time: 'Срок поставки',
    times: 'Дата поставки',
    status: 'Статус',
    ordered: 'Заказано',
    credit: 'Долг',
    shift: 'Изменения',
    by_graph: 'График динамики ключевых показателей',
    manager: 'Менеджер',
    expiration_date: 'Cрок годности',
    stagnation_date: 'Cколько дней задержка',
    time_success_call: 'Cреднее время до успешного звонка',
    time_recall: 'Cреднее время до перезвона',
    approve_percent: 'Количество апрувов',
    expenses_by_lead: 'Расход на лид',
    expected_lead_increase: 'Ожидаемое увеличения расхода на лид',
    cost_change: 'Изменение расхода',
    month: 'Месяц',
    sets: 'Сеты',
    city: 'Город',
    cost_price: 'Себестоимость',
    total_all: 'Сумма всего',
    total_sms_sent: 'Всего отправленных смс',
    total_lead_sms_sent: 'Отправленные смс на 1 лид',
    total_sms: 'Сумма на 1 смс',
    total_minutes: 'Сумма минут звонков',
    total_all_minutes: 'Сумма всего',
    total_minutes_lead: 'Минут на 1 лид',
    total_lead: 'Сумма на 1 лид',
    total_seconds_call: 'Сумма СМС и звонков на 1 лид',
    country_id_web: 'Страны вебмастера',
    offer_id_web: 'Проекты вебмастера',
    dialer: '% Дозвона',
    average_first_call_time: 'Среднее время первого звонка',
    average_number_touches: 'Среднее количество касаний',
    average_calls: 'Среднее количество звонков',
    active_operators: 'Количество активных операторов',
    one_day_dialer: 'Дозвон на 1 день',
    new_orders: 'Новых заказов',
    sending_check: 'Чек отправки',
    foreclosure_check: 'Чек выкупа',
    call_duration: 'Длительность разговора',
    call_duration_approve: 'Длительность разговора апрувов',
    call_duration_cancel: 'Длительность разговора отмен',
    time_processing: 'Время обработки',
    time_out_calls: 'Время вне звонков',
    total_cancel: 'Всего отмен',
    processed_all: 'Обработано всего',
    another: 'Другое',
    expensive: 'Дорого',
    not_order: 'Не заказывал',
    changed_mind: 'Передумал',
    bad_reputation: 'Плохая репутация продукта/компании',
    consultation: 'Сделал заявку, чтобы получить консультацию',
    not_allowed: 'Муж, жена, родственники не разрешают',
    medical_contraindications: 'Медицинские противопоказания',
    not_ringing_long_time: 'Недозвон в течении долгого времени',
    not_make_contact: 'Не идёт на контакт бросает трубку агрессивно реагирует',
    no_coverage: 'Нет покрытия',
    blacklisted_customer: 'Клиент в черном списке',
    not_delivery_time: 'Не успеваем доставить вовремя',
    already_bought: 'Уже купил',
    suite_different_price: 'На сайте другая цена',
    any_reasons: 'Без причины',
    template_sms: 'Шаблон СМС',
    parts_sms: 'Кол-во частей СМС',
    sent_sms: 'Кол-во отправленных СМС',
    total_amount: 'Итоговая сумма',
    approvals: 'Кол-во апрувов',
    cross_sell_cost: 'Стоимость кроссейла',
    orders_accepted: 'Принятые заказы',

    no_payment_method: 'Не устраивает способ оплаты (карта/наличные)',
    form_release: 'Не нравится форма выпуска продукта (клиент выслушал оператора и ему не нравится форма выпуска)',
    want_guarantees: 'Клиент хочет получить информацию о гарантиях и возврате денег',
    not_processed: 'Заказы не могут быть обработаны в данный момент. (зп в след месяце, клиент в другом городе)',
    expensive_delivery: 'Дорогая доставка',
    no_pay_tax: 'Не хочет платить налог',
    no_nearby: 'Отвечает третье лицо, нет заказчика рядом',
    other_information: 'На сайте другая информация',
    won_gift: 'Клиент думал что выиграл подарок (или бесплатную упаковку)',
    language_barrier: 'Языковой барьер',
    wrong_data: 'Не верный номер, не туда попали',
    drop_calls: 'Клиент скидывает звонок / не может быть подтвержден',
    silent: 'Клиенты молчат и не разговаривают',
    under_18: 'Клиент младше 18 лет'
  },
  filters: {
    clean: 'Очистить',
    select_all: 'Выбрать все',
    reset: 'Сбросить',
    more_pre: 'еще ',
    more_post: '',
    apply: 'Применить',
    reset_all: 'Сбросить все',
    yesterday: 'Вчера',
    week: 'Неделя',
    this_month: 'Этот месяц',
    last_month: 'Прошлый месяц',
    copy_filter: 'Скопировать фильтр',
    filter_copied: 'Фильтр скопирован',
    filter_copied_error: 'Ошибка копирования',
    period: 'Период',
    by_wm: 'По web1',
    by_manual: 'По manual'
  },
  country: {
    '1528': 'Вьетнам',
    '1534': 'Египет',
    '1522': 'Индия',
    '1536': 'Иран',
    '1529': 'Индонезия',
    '1527': 'Марокко',
    '1525': 'Малайзия',
    '1537': 'Нигерия',
    '1531': 'PRO Пакистан',
    '1535': 'Россия 2',
    '77': 'Россия',
    '1532': 'Таиланд 4',
    '1526': 'Турция 2',
    '1530': 'Таиланд 3',
    '1533': 'Филиппины 2',
    '1524': 'Филиппины',
    '1538': 'Тунис',
    '1539': 'Индонезия 2',
    '1540': 'Европа',
    '1541': 'Тест',
    '1542': 'Колумбия',
    '1543': 'Алжир',
    '1544': 'Мьянма',
    '1545': 'ОАЭ',
    '1546': 'Сингапур',
    '1547': 'Россия 3',
    '1548': 'GreenGo',
    '1549': 'Индия 2',
    '1550': 'Перу',
    '1551': 'PRO Индия',
    '1552': 'PRO Индонезия',
    '1553': 'PRO Малайзия',
    '1554': 'PRO Филиппины',
    '1555': 'PRO Вьетнам',
    '1556': 'PRO Тунис',
    '1557': 'PRO Колумбия',
    '1558': 'PRO Россия',
    '1559': 'PRO Украина',
    '1560': 'PRO Казахстан',
    '1561': 'PRO Нигерия',
    '1562': 'Тестовый',
    '1563': 'PRO Тайланд',
    '1564': 'PRO Ирак',
    '1565': 'PRO ЮАР',
    '1566': 'PRO Венесуэла',
    '1567': 'PRO Аргентина',
    '1568': 'PRO Чили',
    '1569': 'PRO Уругвай',
    '1570': 'PRO Эквадор',
    '1573': 'PRO Марокко',
    '1571': 'PRO Перу',
    '1572': 'PRO Мьянма',
    '1575': 'Камбоджа',
    '1574': 'PRO Мексика',
    '1576': 'PRO Бангладеш',
    '1577': 'PRO Россия Мск',
    '1579': 'PRO Россия Рязань',
    '1578': 'Конго',
    '1581': 'PRO Лаос',
    '1582': 'PRO Европа',
    '1585': 'PRO Кения',
    '1580': 'PRO Шри-Ланка',
    '1583': 'PRO Узбекистан',
    '1584': 'PRO Непал',
    '1586': 'PRO Танзания',
    '1587': 'PRO Австралия',
    '1588': 'Тест 2',
    '1589': 'Мьянма 2',
    '1590': 'Pro Египет',
    '1591': 'PRO Мьянма 2',
    '1592': 'PRO Индонезия 2',
    '1593': 'PRO Индия 2',
    '1594': 'Колумбия 2',
    '1595': 'PRO Мексика 2',
    '1596': 'PRO Колумбия 2',
    '1597': 'GGTeam',
    '1598': 'PRO Казахстан 2',
    '1599': 'PRO Гватемала',
    '1600': 'PRO Сингапур',
    '1601': 'Чили',
    '1602': 'Пакистан',
    '1603': 'Эфиопия',
    '1604': 'Эквадор',
    '1605': 'США',
    '1606': 'Иран 1',
    '1608': 'For tests',
    '1609': 'PRO Алжир',
    '1610': 'Шри-Ланка',
    '1611': 'PRO Коста-Рика',
    '1612': 'PRO Доминикана',
    '1613': 'PRO Египет 2',
    '1614': 'PRO Гондурас',
    '1615': "PRO Кот-д'Ивуар",
    '1616': 'PRO Иордания',
    '1617': 'PRO Нигерия 2',
    '1618': 'PRO ЮАР 2',
    '1619': 'PRO Боливия',
    '1620': 'PRO Кения 2',
    '-1': 'Все страны'
  },
  return_reason: {
    1: 'VERY_EXPENSIVE',
    2: 'CHANGED_ONES_MIND',
    3: 'DELIVERY_TOOK_TO_LONG',
    4: 'BAD_QUALITY_OF_PACKAGE',
    5: 'COURIER_INCREASED_AMOUNT',
    6: 'NO_NOTIFICATION_FROM_COURIER',
    7: 'RUDE_COURIER',
    8: 'NO_DELIVERED_AFTER_FIRST_ATTEMPT',
    9: 'CUSTOMER_OUTSIDE_OF_CITY',
    10: 'DELIVERED_BOY_DID_NOT_CAME',
    11: 'PIN_CODE_MISTAKE',
    12: 'CUSTOMER_IS_NOT_AVAILABLE',
    13: 'BOUGHT_ANOTHER_PRODUCT',
    14: 'MONEY_PROBLEM',
    15: 'CAN_NOT_OPEN_PARCEL',
    16: 'CAN_NOT_PAY_VIA_CREDIT_CARD'
  },
  pages: {
    statistic: 'Статистика',
    refunds: 'Возвраты',
    ref_cancel: 'Статистика по отменам',
    ref_return: 'Статистика по возвратам',
    ref_cancel_by_month: 'Статистика по отменам по месяцам',
    ref_return_by_month: 'Статистика по возвратам по месяцам',
    ref_cancel_operators: 'Статистика по отменам операторов',
    webmasters: 'Источники',
    dashboard: 'Главная',
    analytics: 'Аналитика',
    conversions: 'Статистика',
    by_country: 'По стране',
    by_offers: 'По офферам',
    by_category_product: 'По категориям товаров',
    by_balance_currency: 'Валюта баланс',
    by_period: 'За период',
    operators: 'ЦОК',
    efficiency: 'Эффективность',
    activity: 'Активность',
    buyout: 'Выкупаемость',
    return_reason: 'Причины возврата',
    by_couriers: 'По курьеркам',
    by_graph: 'По ключевым показателям',
    by_weeks: 'По неделям',
    by_days: 'По дням',
    by_month: 'По месяцам',
    by_pieces: 'По штукам',
    changelog: 'История версий',
    changeversion: 'Версии',
    order: 'Обработка заказов',
    conversion: 'Конверсии',
    new_orders: 'Новые заказы',
    operator_conversions: 'Статистика конверсии у операторов',
    individual_rates: 'Индивидуальные рейты',
    webmaster_statistic: 'Cтатистика по вебам',
    webmaster_individual_rates: 'Статистика по индивидуальным рейтам вебмастеров',
    offer: 'Оффер',
    offer_rent: 'Рентабельность офферов',
    orders: 'Заказы',
    receipt: 'Приходы',
    remnants: 'Остатки',
    product: 'Товары',
    source_statistic: 'Статистика по сорсам',
    sources: 'Sources',
    rentability: 'Рентабельность',
    expenses_by_kc: 'Расходы по КЦ',
    timing_kc: 'Тайминг работы КЦ',
    call_statistics: 'Статистика по звонкам',
    operators_analysis: 'Операторы',
    ringing_sms: 'СМС и Робопрозвон',
    sent_sms_template: 'Отправленные СМС шаблоны',
    ringing_holds: 'Прозвон холдов',
    cross_sell: 'Кроссейл',
    landing: 'Landing',
    landing_statistic: 'Статистика по лендам',
    arrival_new_leads: 'Поступление новых лидов',
    grid_statistic: 'Статистика по сеткам',
    web_analysis: 'Анализ',
    approved_during_the_day: 'Апрув в течение дня',
    orders_receipt: 'Заказы/Приходы',
    buyouts_flypost: 'Выкупы флайпост',
    new_orders_week: 'За неделю',
    webmasters_notify: 'Вебмастеры успешно скопированы'
  },
  profile: {
    gravatar_change_avatar: 'Вы можете сменить свой аватар на сайте ',
    avatar: 'Аватар',
    security: 'Безопасность',
    change_password: 'Сменить пароль',
    first_name: 'Имя',
    last_name: 'Фамилия',
    email: 'Email',
    personal_information: 'Персональная информация',
    password_error_9: 'Длина пароля должна быть не менее 6 символов',
    password_error_8: 'Пароли не совпадают',
    password_error_10: 'Неверный пароль',
    password_changed: 'Пароль сменен',
    need_all: 'Пожалуйста,',
    updated: 'Профиль обновлен',
    language: 'Язык',
    language_changed: 'Язык сменен',
    for_developer: 'Для разработчиков',
    developer_mode: 'Режим разработчика'
  },
  month: {
    1: 'Январь',
    2: 'Февраль',
    3: 'Март',
    4: 'Апрель',
    5: 'Май',
    6: 'Июнь',
    7: 'Июль',
    8: 'Август',
    9: 'Сентябрь',
    10: 'Октябрь',
    11: 'Ноябрь',
    12: 'Декабрь'
  }
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(192);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(186);

var _router2 = _interopRequireDefault(_router);

var _i18n = __webpack_require__(34);

var _i18n2 = _interopRequireDefault(_i18n);

var _vueResource = __webpack_require__(188);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueLogger = __webpack_require__(187);

var _vueLogger2 = _interopRequireDefault(_vueLogger);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueClipboard = __webpack_require__(191);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

var _vueNotification = __webpack_require__(194);

var _vueNotification2 = _interopRequireDefault(_vueNotification);

var _vue2Scrollspy = __webpack_require__(196);

var _vue2Scrollspy2 = _interopRequireDefault(_vue2Scrollspy);

var _vueMoment = __webpack_require__(193);

var _vueMoment2 = _interopRequireDefault(_vueMoment);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _mobileDetect = __webpack_require__(189);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _vueCarousel = __webpack_require__(190);

var _vueCarousel2 = _interopRequireDefault(_vueCarousel);

var _vue2Hammer = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vue2Hammer.VueHammer);
_vue2.default.use(_vueCarousel2.default);
_vue2.default.use(_vueMoment2.default);

_vue2.default.use(_vue2Scrollspy2.default);
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default },
  i18n: _i18n2.default,
  moment: _moment2.default.locale(_Storage2.default.language),
  data: function data() {
    return {
      MobileDetect: new _mobileDetect2.default(window.navigator.userAgent)
    };
  }
});

_vue2.default.use(_vueLogger2.default, {
  prefix: 'ANALYTICS',
  dev: true,
  shortName: true,
  levels: ['log', 'warn', 'debug', 'error', 'dir']
});

_vue2.default.use(_vueResource2.default);
_vue2.default.http.options.root = 'https://api.analytics.leadgroup.su';
_vue2.default.use(_vueClipboard2.default);
_vue2.default.use(_vueNotification2.default);

_vue2.default.console.log('App init');

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  data: function data() {
    return {
      Auth: _Auth2.default,
      Storage: _Storage2.default,
      api: _API2.default
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      _Helper2.default.checkLang();
      if (this.$route.fullPath !== '/loading' && this.$route.fullPath !== '/login') {
        _Storage2.default.enterRouter = this.$route;
      } else {
        _Storage2.default.enterRouter = { fullPath: '/', query: {} };
      }
      if (this.$route.path !== '/impersonate') {
        _Auth2.default.check(this);
      } else {
        _Storage2.default.enterRouter = { fullPath: '/', query: {} };
      }
    });
  }
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'AlphabetScroll',
  props: {
    alphabet: {
      type: Array,
      required: true
    },
    scrollPos: {
      type: Number,
      required: true
    },
    context: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      total: 0
    };
  },

  watch: {
    alphabet: function alphabet(val) {
      var total = 0;
      val.map(function (d) {
        total += d.count;
      });
      this.total = total;
    }
  },
  methods: {
    margin: function margin(letter, i) {
      if (i === 0 || this.alphabet.length - 1 === i) {
        return 'none';
      } else {
        return 'calc((100vh - 55px) * ' + letter.count / this.total * 0.68 + ')';
      }
    }
  }
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      required: true,
      type: [String, Number]
    },
    label: {
      required: true,
      type: String
    },
    icon: {
      required: false,
      default: null
    },
    bg: {
      required: false,
      default: 'info'
    }
  },
  name: 'DashCard'
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(5);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    color: {
      type: String,
      default: 'info',
      required: false
    },
    icon: {
      type: String,
      default: 'line-chart',
      required: false
    },
    title: {
      type: String,
      required: true
    },
    tableData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      preparedData: null,
      average: 0,
      Storage: _Storage2.default,
      find: _lodash.find,
      max: 0,
      totalBalance: 0.0,
      totalDelayDebt: 0.0,
      totalTodaySum: 0.0,
      totalWeekSum: 0.0,
      totalLastPaymentSum: 0.0,
      sortingField: 'balance',
      sortingType: 'desc'
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.preparedData = this.calculateData();
    });
  },

  methods: {
    sortData: function sortData(field, cb) {
      this.sortingField = field;
      if (this.sortingType === 'asc') {
        this.sortingType = 'desc';
      } else {
        this.sortingType = 'asc';
      }
      this.preparedData = this.calculateData(cb);
    },
    calculateData: function calculateData(sortingCb) {
      var _this = this;

      var data = (0, _lodash.cloneDeep)(this.tableData);
      var count = 0;
      var statistic = [];
      var total = 0.00;
      var totalDelay = 0.00;
      var totalWeekSum = 0.00;
      var totalTodaySum = 0.00;
      var totalLastPaymentSum = 0.00;

      (0, _lodash.map)(data, function (d) {
        total += parseFloat(d.balance);
        totalDelay += parseFloat(d.delay_debt);
        totalTodaySum += parseFloat(d.today_sum);
        totalWeekSum += parseFloat(d.week_sum);
        totalLastPaymentSum += parseFloat(d.last_payment_sum);
      });

      (0, _lodash.map)(data, function (d) {
        var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(d.country_id, 10) });
        statistic.push({
          countryId: d.country_id,
          balance: parseFloat(d.balance).toFixed(2),
          delay_debt: parseFloat(d.delay_debt).toFixed(2),
          todaySum: parseFloat(d.today_sum).toFixed(2),
          weekSum: parseFloat(d.week_sum).toFixed(2),
          lastPaymentSum: parseFloat(d.last_payment_sum).toFixed(2),
          lastPaymentDate: new Date(d.last_payment_date.split(' ')[0]),
          code: country.code.toLowerCase(),
          average: parseFloat(parseFloat(d.balance) / parseFloat(d.month_average)).toFixed(2)
        });
        if (d.balance > 0) {
          count++;
        }
      });

      this.totalTodaySum = parseFloat(totalTodaySum).toFixed(2);
      this.totalWeekSum = parseFloat(totalWeekSum).toFixed(2);
      this.totalBalance = parseFloat(total).toFixed(2);
      this.totalDelayDebt = parseFloat(totalDelay).toFixed(2);
      this.totalLastPaymentSum = parseFloat(totalLastPaymentSum).toFixed(2);
      this.average = parseFloat(total / parseFloat(count)).toFixed(2);
      return (0, _lodash.orderBy)(statistic, [function (e) {
        if (!sortingCb) {
          return parseFloat(e[_this.sortingField]);
        } else {
          return sortingCb(e[_this.sortingField]);
        }
      }], [this.sortingType]);
    }
  },
  name: 'DebitTable'
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(5);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _CountryColor = __webpack_require__(35);

var _CountryColor2 = _interopRequireDefault(_CountryColor);

var _vueStrap = __webpack_require__(9);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _exporting = __webpack_require__(40);

var _exporting2 = _interopRequireDefault(_exporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _exporting2.default)(_highcharts2.default);
var chartOptionsDif = {
  isHidden: false,
  title: {
    text: null
  },
  subtitle: {
    text: null
  },
  yAxis: [{
    title: {
      text: '\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u0447\u0435\u043A $'
    },
    min: 0,
    tickInterval: 10
  }],
  xAxis: {
    categories: []
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false
  },
  exporting: {
    enabled: false
  },
  series: [{
    data: []
  }],
  tooltip: {
    formatter: function formatter() {
      return '$ ' + this.y;
    }
  }
};
exports.default = {
  props: {
    symbol: {
      type: String,
      default: null,
      required: false
    },
    isLeads: Boolean,
    color: {
      type: String,
      default: 'info',
      required: false
    },
    icon: {
      type: String,
      default: 'line-chart',
      required: false
    },
    title: {
      type: String,
      required: true
    },
    tableData: {
      type: Object,
      required: true
    },
    calculate: {
      type: Boolean,
      default: false
    },
    withAverage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      chartOptionsDif: chartOptionsDif,
      average: 0,
      Storage: _Storage2.default,
      find: _lodash.find,
      order: 'asc',
      tableDataBySort: null,
      max: 0,
      tableDataWithDifference: [],
      chartModalDif: false,
      titleAverage: '',
      chartSeries: [],
      countryCurrencySymbol: ''
    };
  },

  computed: {
    preparedData: function preparedData() {
      var _this = this;

      var data = void 0;
      if (!this.tableDataBySort) {
        data = (0, _lodash.cloneDeep)(this.tableData);
      } else {
        data = (0, _lodash.cloneDeep)(this.tableDataBySort);
      }
      var total = 0;
      var count = 0;
      var diff = 0.00001;
      (0, _lodash.map)(data, function (d, i) {
        var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(d.country_id, 10) });
        data[i].country_code = country.code.toLowerCase();
        if (_this.isLeads) {
          data[i].difference = data[i].weekAverage - data[i].limit;
        }
        if (d.total > 0) {
          if (_this.symbol === '$') {
            data[i].total = parseFloat(parseFloat(parseFloat(d.total)) / parseFloat(country.rate)).toFixed(0);
          } else {
            data[i].total = parseInt(d.total, 10);
          }

          if (_this.symbol !== null) {
            data[i].diff = parseFloat(d.diff).toFixed(1);
            diff = parseFloat(diff) + parseFloat(d.diff);
          } else {
            data[i].diff = parseFloat(d.diff).toFixed(0);
            diff = parseInt(diff, 10) + parseInt(d.diff, 10);
          }

          _this.max = data[i].total > _this.max ? data[i].total : _this.max;
          total += parseFloat(data[i].total);
          count++;
        }
      });
      if (!this.calculate) {
        this.average = parseFloat(total / count).toFixed(0);
      } else {
        if (!this.withAverage) {
          this.average = diff;
        } else {
          this.average = parseFloat(parseFloat(diff) / parseFloat(count)).toFixed(1);
        }
      }
      if (!this.tableDataBySort) {
        return (0, _lodash.orderBy)(data, [function (e) {
          return parseInt(e.total, 10);
        }], ['desc']);
      } else {
        return data;
      }
    }
  },
  methods: {
    diffStyle: function diffStyle(diff) {
      return diff > 0 ? 'color: green' : 'color: red';
    },
    diffSymbol: function diffSymbol(diff) {
      return diff === 0 ? '' : diff > 0 ? '\u25B2' : '\u25BC';
    },
    renderGist: function renderGist(line) {
      if (this.symbol !== null) {
        return 'background: linear-gradient(to right, ' + _CountryColor2.default[line.country_id] + ' ' + line.total + '%, transparent 0%)';
      } else {
        return 'background: linear-gradient(to right, ' + _CountryColor2.default[line.country_id] + ' ' + parseFloat(line.total / this.max * 100).toFixed(0) + '%, transparent 0%)';
      }
    },
    sort: function sort(field) {
      this.order = this.order === 'asc' ? 'desc' : 'asc';
      this.tableDataBySort = (0, _lodash.orderBy)(this.tableData, [function (item) {
        if (field === 'difference') {
          return item[field];
        } else {
          return !item[field].ocb ? item[field] : item[field].ocb(item[field]);
        }
      }], [this.order]);
    },
    isPopup: function isPopup(id) {
      var _this2 = this;

      var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(id, 10) });
      this.countryCurrencySymbol = country.currency_symbol;
      this.titleAverage = '\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u0447\u0435\u043A: ($)';
      var chartSeries = new Promise(function (resolve, reject) {
        _API2.default.getAveragesGraphic(id).then(function (response) {
          resolve(response.body);
          return response.body;
        }).catch(function (err) {
          return console.log(err);
        });
      });
      chartSeries.then(function (response) {
        var array = [];
        for (var i in response) {
          array.push(parseFloat(response[i].toFixed(2)));
          chartOptionsDif.xAxis.categories.push(i);
          chartOptionsDif.series[0] = {
            data: [].concat(array)
          };
        }
        _this2.chartModalDif = true;
        _highcharts2.default.chart('dash-chart-traffic-dif', chartOptionsDif);
        _this2.chart = _highcharts2.default.chart('dash-chart-traffic-dif', chartOptionsDif);
      });
    },
    idPopupAllCountry: function idPopupAllCountry() {
      var _this3 = this;

      this.chartSeries = [];
      this.titleAverage = 'Средний чек по всем странам ($)';
      var chartSeries = new Promise(function (resolve) {
        _API2.default.getAveragesGraphicAllCountry().then(function (response) {
          resolve(response.body);
          return response.body;
        });
      });
      chartSeries.then(function (response) {
        var array = [];
        for (var i in response) {
          array.push(parseFloat(response[i].toFixed(2)));
          chartOptionsDif.xAxis.categories.push(i);
          chartOptionsDif.series[0] = {
            data: [].concat(array)
          };
        }
        _this3.chartModalDif = true;
        _highcharts2.default.chart('dash-chart-traffic-dif', chartOptionsDif);
        _this3.chart = _highcharts2.default.chart('dash-chart-traffic-dif', chartOptionsDif);
      });
    }
  },
  name: 'DifferencyTable',
  components: {
    modal: _vueStrap.modal,
    StatisticTable: _StatisticTable2.default
  }
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DateFilter = __webpack_require__(430);

var _DateFilter2 = _interopRequireDefault(_DateFilter);

var _DateFilterSecond = __webpack_require__(431);

var _DateFilterSecond2 = _interopRequireDefault(_DateFilterSecond);

var _MonthFromFilter = __webpack_require__(434);

var _MonthFromFilter2 = _interopRequireDefault(_MonthFromFilter);

var _DateReceipt = __webpack_require__(432);

var _DateReceipt2 = _interopRequireDefault(_DateReceipt);

var _MonthFilter = __webpack_require__(433);

var _MonthFilter2 = _interopRequireDefault(_MonthFilter);

var _CountryFilter = __webpack_require__(427);

var _CountryFilter2 = _interopRequireDefault(_CountryFilter);

var _OfferFilter = __webpack_require__(436);

var _OfferFilter2 = _interopRequireDefault(_OfferFilter);

var _OperatorFilter = __webpack_require__(439);

var _OperatorFilter2 = _interopRequireDefault(_OperatorFilter);

var _CopyButton = __webpack_require__(426);

var _CopyButton2 = _interopRequireDefault(_CopyButton);

var _CourierFilter = __webpack_require__(428);

var _CourierFilter2 = _interopRequireDefault(_CourierFilter);

var _ByWmFilter = __webpack_require__(424);

var _ByWmFilter2 = _interopRequireDefault(_ByWmFilter);

var _WebmasterFilter = __webpack_require__(441);

var _WebmasterFilter2 = _interopRequireDefault(_WebmasterFilter);

var _OldWmFilter = __webpack_require__(437);

var _OldWmFilter2 = _interopRequireDefault(_OldWmFilter);

var _NewWmFilter = __webpack_require__(435);

var _NewWmFilter2 = _interopRequireDefault(_NewWmFilter);

var _ByManualFilter = __webpack_require__(422);

var _ByManualFilter2 = _interopRequireDefault(_ByManualFilter);

var _ByWmFilterAll = __webpack_require__(425);

var _ByWmFilterAll2 = _interopRequireDefault(_ByWmFilterAll);

var _DateCreated = __webpack_require__(429);

var _DateCreated2 = _interopRequireDefault(_DateCreated);

var _Switch = __webpack_require__(20);

var _Switch2 = _interopRequireDefault(_Switch);

var _WorkShifts = __webpack_require__(442);

var _WorkShifts2 = _interopRequireDefault(_WorkShifts);

var _OneCountryFilter = __webpack_require__(438);

var _OneCountryFilter2 = _interopRequireDefault(_OneCountryFilter);

var _ParsePeriod = __webpack_require__(440);

var _ParsePeriod2 = _interopRequireDefault(_ParsePeriod);

var _ByWebmasterFilter = __webpack_require__(423);

var _ByWebmasterFilter2 = _interopRequireDefault(_ByWebmasterFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    scope: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      isLoading: false,
      isMounted: false,
      checked: false
    };
  },

  name: 'Filters',
  components: {
    OneCountryFilter: _OneCountryFilter2.default,
    WorkShifts: _WorkShifts2.default,
    ParsePeriod: _ParsePeriod2.default,
    cSwitch: _Switch2.default,
    DateReceipt: _DateReceipt2.default,
    DateFilter: _DateFilter2.default,
    DateFilterSecond: _DateFilterSecond2.default,
    MonthFilter: _MonthFilter2.default,
    CountryFilter: _CountryFilter2.default,
    OfferFilter: _OfferFilter2.default,
    OperatorFilter: _OperatorFilter2.default,
    CopyButton: _CopyButton2.default,
    CourierFilter: _CourierFilter2.default,
    ByWmFilter: _ByWmFilter2.default,
    WebmasterFilter: _WebmasterFilter2.default,
    OldWmFilter: _OldWmFilter2.default,
    NewWmFilter: _NewWmFilter2.default,
    ByManualFilter: _ByManualFilter2.default,
    DateCreated: _DateCreated2.default,
    ByWmFilterAll: _ByWmFilterAll2.default,
    MonthFromFilter: _MonthFromFilter2.default,
    ByWebmasterFilter: _ByWebmasterFilter2.default
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('data_loading', function () {
      _this.isLoading = true;
    });
    this.$root.$on('data_loaded', function () {
      _this.isLoading = false;
    });
    this.$root.$on('filters_load_new_data', function () {
      _this.checked = false;
    });
  },

  methods: {
    filterSwitch: function filterSwitch() {
      this.$root.$emit('filter_switch', this.checked);
    },
    resetAll: function resetAll() {
      this.$root.$emit('filters_reset_all');
    },
    load: function load() {
      this.$root.$emit('filters_load_new_data');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('filters_load_new_data');
  }
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Config = __webpack_require__(26);

var _Config2 = _interopRequireDefault(_Config);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'footer',
  data: function data() {
    return {
      Config: _Config2.default,
      Storage: _Storage2.default,
      lastUpdate: _Storage2.default.lastUpdate,
      lastVersion: _Storage2.default.lastVersion,
      date: new Date().getFullYear()
    };
  }
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = __webpack_require__(417);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _vueStrap = __webpack_require__(9);

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'header',
  components: {
    navbar: _Navbar2.default,
    dropdown: _vueStrap.dropdown
  },
  data: function data() {
    return {
      Auth: _Auth2.default
    };
  },

  methods: {
    logout: function logout() {
      _Auth2.default.logout(this);
    },
    click: function click() {},
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    }
  }
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'navbar',
  created: function created() {
    this._navbar = true;
  }
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _map = __webpack_require__(404);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _map2.default)(_highcharts2.default);

exports.default = {
  props: {
    statistic: {
      required: true
    },
    title: {
      required: true
    },
    id: {
      required: true
    }
  },
  name: 'OperatorActivityChart',
  mounted: function mounted() {
    _highcharts2.default.chart('chart-container-' + this.id, this.chartConfig);
  },

  computed: {
    chartConfig: function chartConfig() {
      return {
        chart: {
          type: 'heatmap',
          inverted: true
        },
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m-%d}'
          },
          tickWidth: 1,
          tickPixelInterval: 30,
          gridLineWidth: 15,
          breakSize: 0
        },
        yAxis: {
          title: {
            text: null
          },
          labels: {
            format: '{value}:00'
          },
          minPadding: 0,
          maxPadding: 0,
          startOnTick: false,
          endOnTick: false,
          tickPositions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
          tickWidth: 1,
          min: 0,
          max: 23
        },
        colorAxis: {
          stops: [[0, '#78c439'], [0.5, '#FFFF00'], [1, '#c4463a']],
          min: 0
        },
        series: [{
          borderWidth: 1,
          borderColor: 'white',
          colsize: 16 * 36e5,
          tooltip: {
            headerFormat: this.$t('statistic.actions') + '<br/>',
            pointFormat: '{point.x:%Y-%m-%d} {point.y}:00: <b>{point.value}</b>'
          },
          data: this.statistic
        }]
      };
    }
  }
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fileSaver = __webpack_require__(17);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OrderTable',
  components: {
    DatePicker: _vuejsDatepicker2.default
  },
  props: {
    title: {
      type: String,
      required: false
    },
    disableActionBTN: Boolean,
    isActiveBtn: Boolean,
    headColumns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    idElem: {
      type: String,
      required: false
    },
    footColumns: {
      type: Object,
      required: true
    },
    columns: {
      type: Object,
      required: false
    },
    preheatColumns: {
      type: Array,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      id: null,
      Storage: _Storage2.default,
      order: 'asc',
      Helper: _Helper2.default
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8);
    this.$root.$on('data_loading', function () {
      _this.isLoading = true;
    });
    this.$root.$on('data_loaded', function () {
      _this.isLoading = false;
    });
  },

  methods: {
    showClick: function showClick(row) {
      row.showInput = true;
    },
    getOfferName: function getOfferName(id) {
      var offer = _Helper2.default.getGoodName(_Storage2.default.goods, id);
      return offer || 'Не найдено';
    },
    sort: function sort(field, index) {
      this.order = this.order === 'asc' ? 'desc' : 'asc';
      this.rows = (0, _lodash.orderBy)(this.rows, [function (o) {
        return o.value[index].value;
      }], [this.order]);
    },
    saveChange: function saveChange(offerId) {
      this.$emit('addReceipt', offerId);
    },
    deleteChange: function deleteChange(offerId) {
      this.$emit('deleteChange', offerId);
    },
    downloadAll: function downloadAll() {
      this.$emit('downloadAll', { rows: this.rows });
    },
    downloadAllReceipt: function downloadAllReceipt() {
      this.$emit('downloadAllReceipt', { rows: this.rows });
    },
    download: function download(offerId) {
      this.$emit('download', offerId);
    },
    downloadPdfReceipt: function downloadPdfReceipt(offerId) {
      this.$emit('downloadPdfReceipt', offerId);
    },
    uploadImage: function uploadImage(offerId, files, name) {
      this.$emit('uploadImage', offerId, files, name);
    },
    uploadImageReceipt: function uploadImageReceipt(offerId, files, name) {
      this.$emit('uploadImageReceipt', offerId, files, name);
    },
    changeTableVal: function changeTableVal(offerId, cell) {
      var rowsEdit = (0, _lodash.find)(this.rows, { key: offerId });
      this.$emit('changeVal', rowsEdit.key, cell);
    },
    exporting: function exporting(evt) {
      var doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + this.title + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
      doc += document.getElementById(this.id).innerHTML;
      doc += '</body></html>';
      _fileSaver2.default.saveAs(new Blob([doc], {
        encoding: 'UTF-8',
        type: 'application/octet-stream'
      }), 'analytics-' + this.title + '-' + new Date().toLocaleString() + '.xls');
    },
    renderBackground: function renderBackground(cell) {
      var style = !cell.style ? {} : cell.style;
      if (cell.color) {
        var elseObj = (0, _lodash.filter)(cell.color, function (obj) {
          return obj.value === 'else';
        });
        var bigObj = (0, _lodash.filter)(cell.color, function (obj) {
          return obj.value === '>0';
        });
        var colorObj = (0, _lodash.filter)(cell.color, function (obj) {
          return obj.value === Number(cell.value);
        });
        if ((0, _lodash.size)(colorObj) > 0) {
          style.backgroundColor = colorObj[0].bg;
        } else if ((0, _lodash.size)(elseObj) > 0) {
          style.backgroundColor = elseObj[0].bg;
        } else if ((0, _lodash.size)(bigObj) > 0) {
          if (cell.value > 0) {
            style.backgroundColor = bigObj[0].bg;
          }
        }
      }
      if (cell.bg) {
        var procent = cell.value / cell.bg.maxday * 100;
        style.background = 'linear-gradient(to right, ' + cell.bg.colorBg + ' ' + procent + '%, transparent 0%)';
      }
      return style;
    }
  }
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Config = __webpack_require__(26);

var _Config2 = _interopRequireDefault(_Config);

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sidebar',
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    haveAccess: function haveAccess(statisticName) {
      return _Auth2.default.user.profile.allowed_statistics[_Config2.default.STATISTICS[statisticName]];
    }
  },
  data: function data() {
    return {
      Config: _Config2.default,
      Storage: _Storage2.default
    };
  }
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(5);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _fileSaver = __webpack_require__(17);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vueStrap = __webpack_require__(9);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    modal: _vueStrap.modal,
    MultiSelect: _vueMultiselect2.default,
    dropdown: _vueStrap.dropdown
  },
  props: {
    isActive: {
      type: Boolean,
      required: false
    },
    isExelAll: {
      type: Boolean,
      required: false
    },
    isFlypostModal: {
      type: Boolean,
      required: false
    },
    isFlypost: {
      type: Boolean,
      required: false
    },
    isFixed: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    checkbox: false,
    checked: {},
    className: {
      type: String,
      required: false
    },
    classes: {
      type: String,
      required: false
    },
    headColumns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    footColumns: {
      type: Object,
      required: true
    },
    columns: {
      type: Object,
      required: false
    },
    preheatColumns: {
      type: Array,
      required: false
    },
    totalColumnsDd: {
      type: Object,
      required: false
    },
    copyIcon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      id: null,
      isLoading: false,
      chartModal: false,
      order: 'asc',
      totalCells: {},
      status: {},
      TypeColor: _TypeColor2.default,
      Storage: _Storage2.default,
      chart: {
        isBuilded: false,
        isHidden: false,
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          title: {
            text: null
          },
          tickInterval: 1
        }],
        tooltip: {
          valueSuffix: null
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m-%d}'
          }
        },
        series: []
      }
    };
  },

  name: 'StatisticTable',
  mounted: function mounted() {
    var _this = this;

    this.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8);
    this.$root.$on('data_loading', function () {
      _this.isLoading = true;
    });
    this.$root.$on('data_loaded', function () {
      _this.isLoading = false;
    });
  },

  computed: {
    computedHeadColumns: function computedHeadColumns() {
      var _this2 = this;

      if (!this.columns) {
        return this.headColumns;
      } else {
        var headColumns = [];
        this.headColumns.map(function (d) {
          if (_this2.columns[d.field]) {
            headColumns.push(d);
          }
        });
        return headColumns;
      }
    },
    computedFootColumns: function computedFootColumns() {
      var _this3 = this;

      if (!this.columns) {
        return this.footColumns;
      } else {
        var footColumns = {};
        (0, _lodash.map)(this.footColumns, function (d, i) {
          if (_this3.columns[i] || i === 'label' || _this3.columns[i.replace('Percents', '')]) {
            footColumns[i] = d;
          }
        });
        return footColumns;
      }
    },
    computedFootCourier: function computedFootCourier() {
      var _this4 = this;

      if (!this.columns) {
        return this.totalColumnsDd;
      } else {
        var totalColumnsDd = {};
        (0, _lodash.map)(this.totalColumnsDd, function (d, i) {
          if (_this4.columns[i] || i === 'label' || _this4.columns[i.replace('Percents', '')]) {
            totalColumnsDd[i] = d;
          }
        });
        return totalColumnsDd;
      }
    },
    computedRows: function computedRows() {
      var _this5 = this;

      if (!this.columns) {
        this.createCheckbox();
        return this.rows;
      } else {
        var rows = [];
        this.rows.map(function (row) {
          var tmpRow = {};
          (0, _lodash.map)(row, function (d, i) {
            if (_this5.columns[i] || _this5.columns[i.replace('Percents', '')]) {
              tmpRow[i] = d;
            }
          });
          rows.push(tmpRow);
        });
        this.createCheckbox();
        return rows;
      }
    }
  },
  methods: {
    getCellClasses: function getCellClasses(cell) {
      var classes = [];
      classes.push(cell.isCollspaned ? 'no-border' : null);
      classes.push(cell.is_new === 1 ? 'web' : null);
      classes.push(cell.isActive ? 'noActive' : null);
      classes.push(cell.percentBg ? 'percentBg' : null);
      classes.push(cell.minusBg ? 'minusBg' : null);
      classes.push(cell.plusBg ? 'plusBg' : null);
      if (parseInt(cell.statusStop) > 0 && parseInt(cell.statusFilter) === 0) {
        classes.push('statusRed');
      }
      if (parseInt(cell.statusStop) === 0 && parseInt(cell.statusFilter) > 0) {
        classes.push('statusYellow');
      }
      if (parseInt(cell.statusStop) > 0 && parseInt(cell.statusFilter) > 0) {
        classes.push('statusBlue');
      }
      if (cell.colouredDayOff) {
        var day = new Date(cell.value).getDay();
        classes.push(day === 0 || day === 6 ? 'coloured_day_off' : null);
      }
      return classes.join(' ');
    },
    exporting: function exporting(evt) {
      if (this.classes) {
        var classes = document.getElementsByClassName(this.classes);
        var doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + this.title + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
        doc += '<div>' + (0, _moment2.default)(this.classes).format('MMMM YYYY') + '</div><br/>';
        (0, _lodash.map)(classes, function (cl, i) {
          doc += cl.innerHTML + '<br/>';
        });
        doc += '</body></html>';
        _fileSaver2.default.saveAs(new Blob([doc], {
          encoding: 'UTF-8',
          type: 'application/octet-stream'
        }), 'analytics-' + this.classes + '.xls');
      } else {
        var _doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + this.title + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
        _doc += document.getElementById(this.id).innerHTML;
        _doc += '</body></html>';
        _fileSaver2.default.saveAs(new Blob([_doc], {
          encoding: 'UTF-8',
          type: 'application/octet-stream'
        }), 'analytics-' + this.title + '-' + new Date().toLocaleString() + '.xls');
      }
    },
    exportingAll: function exportingAll() {
      this.$emit('exportingAll');
    },
    sort: function sort(col) {
      var isLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.order = this.order === 'asc' ? 'desc' : 'asc';
      var that = this;

      this.rows = (0, _lodash.orderBy)(this.rows, [function (item) {
        if (col.splitter && !isLeft) {
          return !item[col.field].ocb ? item[col.field].bgg : item[col.field].ocb(item[col.field].bgg);
        }

        if (item[col.field].orderData !== undefined) {
          return !item[col.field].ocb ? item[col.field].orderData : item[col.field].ocb(item[col.field].orderData);
        } else {
          return !item[col.field].ocb ? item[col.field].value : item[col.field].ocb(item[col.field].value);
        }
      }], [this.order]);
    },
    renderBackground: function renderBackground(cell, i, bc) {
      var style = !cell.style ? {} : cell.style;
      if (!cell || cell.bgg === undefined && !cell.dbgg) {
        style.backgroundColor = !cell.bgc ? this.TypeColor[i] : cell.bgc;
      } else {
        if (!cell.dbgg) {
          if (!cell.bgl) {
            style.background = 'linear-gradient(to right, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
          } else {
            style.background = 'linear-gradient(to left, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
            style.position = 'relative';
          }
        } else {
          style.background = 'linear-gradient(to right, ' + this.TypeColor[cell.dbgg[0].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + (cell.dbgg[0].width + cell.dbgg[1].width) + '%, transparent 0%)';
        }
      }
      if (bc.bc) {
        style.backgroundColor = '' + bc.bc;
        style.color = bc.c;
      }
      if (cell.bgColorTwo) {
        var summ = Math.abs(cell.bgColorTwo.max.value) + Math.abs(cell.bgColorTwo.min.value);
        var minPercent = (Math.abs(cell.bgColorTwo.min.value) / summ * 100).toFixed(0);
        var maxPercent = (Math.abs(cell.bgColorTwo.max.value) / summ * 100).toFixed(0);
        var percent = void 0;
        if (cell.bgColorTwo.value < 0) {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.min.value) * minPercent + parseInt(maxPercent);
          style.background = 'linear-gradient(to left, transparent 0%, transparent ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        } else {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.max.value) * maxPercent + parseInt(minPercent);
          style.background = 'linear-gradient(to right, transparent 0%, transparent ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        }
        style.position = 'relative';
      }
      return style;
    },
    renderChart: function renderChart(cell, i) {
      if (!cell.graph) {
        return false;
      }
      var rows = (0, _lodash.orderBy)(this.rows, [function (item) {
        return item.date.value;
      }], ['asc']);
      var series = [];
      (0, _lodash.map)(rows, function (row) {
        if (!cell.graph.cb) {
          series.push([Date.parse(row[Object.keys(row)[0]].value), row[i].value]);
        } else {
          series.push([Date.parse(row[Object.keys(row)[0]].value), cell.graph.cb(row[i].value)]);
        }
      });
      if (cell.graph.symbol) {
        this.chart.tooltip.valueSuffix = cell.graph.symbol;
      } else {
        this.chart.tooltip.valueSuffix = null;
      }
      this.chart.title = this.$root.$t('statistic.' + i);
      this.chart.series[0] = {
        data: series,
        color: _TypeColor2.default[i],
        name: this.$root.$t('statistic.' + i)
      };
      this.chart.yAxis[0].min = 0;
      this.chart.yAxis[0].title.text = cell.symbol ? cell.symbol : this.$root.$t('statistic.' + i);
      _highcharts2.default.chart('chart-container-' + this.id, this.chart);
      this.toggleModal();
    },
    toggleModal: function toggleModal() {
      this.chartModal = !this.chartModal;
    },
    createCheckbox: function createCheckbox() {
      var _this6 = this;

      if (this.checkbox) {
        this.rows.map(function (val, key) {
          _this6.$set(_this6.status, key, true);
        });
        this.$set(this.status, 'all', true);
      }
    },
    check: function check(poles) {
      var _this7 = this;

      if (poles === 'all') {
        this.rows.map(function (val, key) {
          _this7.$set(_this7.status, key, _this7.status.all);
        });
        this.chekeds();
      } else {
        this.chekeds();
      }
    },
    chekeds: function chekeds() {
      var _this8 = this;

      var checka = true;
      var summ = {};
      this.rows.map(function (val, key) {
        (0, _lodash.map)(_this8.checked[key].total, function (val1, key1) {
          if (key === 0) {
            summ[key1] = 0;
          }
          if (_this8.status[key] === false) {
            checka = false;
          } else {
            summ[key1] += _this8.checked[key].total[key1].count;
          }
        });
      });
      (0, _lodash.map)(summ, function (val, key) {
        _this8.footColumns[key].value = summ[key];
      });
      this.$set(this.status, 'all', checka);
    },
    updates: function updates(cell, cvalue) {
      this.$emit('changeElem', cell, cvalue);
      return false;
    },
    webGraph: function webGraph(cell, i) {
      if (!cell.webGraph) {
        return false;
      }
      this.$emit('webGraph', cell, i);
    },
    copyIconClick: function copyIconClick(e) {
      e.stopPropagation();
      this.$emit('copy');
    },
    isPopup: function isPopup(cell, i) {
      if (!cell.popup) {
        return false;
      }
      this.$emit('isPopup', cell, i);
    },
    isPopupFlyPost: function isPopupFlyPost(cell) {
      this.$emit('isPopupFlyPost', cell);
    }
  }
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: ''
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(5);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _fileSaver = __webpack_require__(17);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vueStrap = __webpack_require__(9);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    modal: _vueStrap.modal,
    MultiSelect: _vueMultiselect2.default,
    dropdown: _vueStrap.dropdown
  },
  props: {
    isActive: {
      type: Boolean,
      required: false
    },
    isExelAll: {
      type: Boolean,
      required: false
    },
    isFlypostModal: {
      type: Boolean,
      required: false
    },
    isFlypost: {
      type: Boolean,
      required: false
    },
    isFixed: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    checkbox: false,
    checked: {},
    className: {
      type: String,
      required: false
    },
    classes: {
      type: String,
      required: false
    },
    headColumns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    footColumns: {
      type: Object,
      required: true
    },
    columns: {
      type: Object,
      required: false
    },
    preheatColumns: {
      type: Array,
      required: false
    },
    totalColumnsDd: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      id: null,
      isLoading: false,
      chartModal: false,
      order: 'asc',
      totalCells: {},
      status: {},
      TypeColor: _TypeColor2.default,
      Storage: _Storage2.default,
      chart: {
        isBuilded: false,
        isHidden: false,
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          title: {
            text: null
          },
          tickInterval: 1
        }],
        tooltip: {
          valueSuffix: null
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m-%d}'
          }
        },
        series: []
      }
    };
  },

  name: 'StatisticTable',
  mounted: function mounted() {
    var _this = this;

    this.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8);
    this.$root.$on('data_loading', function () {
      _this.isLoading = true;
    });
    this.$root.$on('data_loaded', function () {
      _this.isLoading = false;
    });
  },

  computed: {
    computedHeadColumns: function computedHeadColumns() {
      var _this2 = this;

      if (!this.columns) {
        return this.headColumns;
      } else {
        var headColumns = [];
        this.headColumns.map(function (d) {
          if (_this2.columns[d.field]) {
            headColumns.push(d);
          }
        });
        return headColumns;
      }
    },
    computedFootColumns: function computedFootColumns() {
      var _this3 = this;

      if (!this.columns) {
        return this.footColumns;
      } else {
        var footColumns = {};
        (0, _lodash.map)(this.footColumns, function (d, i) {
          if (_this3.columns[i] || i === 'label' || _this3.columns[i.replace('Percents', '')]) {
            footColumns[i] = d;
          }
        });
        return footColumns;
      }
    },
    computedFootCourier: function computedFootCourier() {
      var _this4 = this;

      if (!this.columns) {
        return this.totalColumnsDd;
      } else {
        var totalColumnsDd = {};
        (0, _lodash.map)(this.totalColumnsDd, function (d, i) {
          if (_this4.columns[i] || i === 'label' || _this4.columns[i.replace('Percents', '')]) {
            totalColumnsDd[i] = d;
          }
        });
        return totalColumnsDd;
      }
    },
    computedRows: function computedRows() {
      var _this5 = this;

      if (!this.columns) {
        this.createCheckbox();
        return this.rows;
      } else {
        var rows = [];
        this.rows.map(function (row) {
          var tmpRow = {};
          (0, _lodash.map)(row, function (d, i) {
            if (_this5.columns[i] || _this5.columns[i.replace('Percents', '')]) {
              tmpRow[i] = d;
            }
          });
          rows.push(tmpRow);
        });
        this.createCheckbox();
        return rows;
      }
    }
  },
  methods: {
    getCellClasses: function getCellClasses(cell) {
      var classes = [];
      classes.push(cell.isCollspaned ? 'no-border' : null);
      classes.push(cell.is_new === 1 ? 'web' : null);
      classes.push(cell.isActive ? 'noActive' : null);
      classes.push(cell.percentBg ? 'percentBg' : null);
      classes.push(cell.minusBg ? 'minusBg' : null);
      classes.push(cell.plusBg ? 'plusBg' : null);
      if (parseInt(cell.statusStop) > 0 && parseInt(cell.statusFilter) === 0) {
        classes.push('statusRed');
      }
      if (parseInt(cell.statusStop) === 0 && parseInt(cell.statusFilter) > 0) {
        classes.push('statusYellow');
      }
      if (parseInt(cell.statusStop) > 0 && parseInt(cell.statusFilter) > 0) {
        classes.push('statusBlue');
      }
      if (cell.colouredDayOff) {
        var day = new Date(cell.value).getDay();
        classes.push(day === 0 || day === 6 ? 'coloured_day_off' : null);
      }
      return classes.join(' ');
    },
    exporting: function exporting(evt) {
      if (this.classes) {
        var classes = document.getElementsByClassName(this.classes);
        var doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + this.title + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
        doc += '<div>' + (0, _moment2.default)(this.classes).format('MMMM YYYY') + '</div><br/>';
        (0, _lodash.map)(classes, function (cl, i) {
          doc += cl.innerHTML + '<br/>';
        });
        doc += '</body></html>';
        _fileSaver2.default.saveAs(new Blob([doc], {
          encoding: 'UTF-8',
          type: 'application/octet-stream'
        }), 'analytics-' + this.classes + '.xls');
      } else {
        var _doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + this.title + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
        _doc += document.getElementById(this.id).innerHTML;
        _doc += '</body></html>';
        _fileSaver2.default.saveAs(new Blob([_doc], {
          encoding: 'UTF-8',
          type: 'application/octet-stream'
        }), 'analytics-' + this.title + '-' + new Date().toLocaleString() + '.xls');
      }
    },
    exportingAll: function exportingAll() {
      this.$emit('exportingAll');
    },
    sort: function sort(field) {
      this.order = this.order === 'asc' ? 'desc' : 'asc';
      this.rows = (0, _lodash.orderBy)(this.rows, [function (item) {
        if (item[field].orderData !== undefined) {
          return !item[field].ocb ? item[field].orderData : item[field].ocb(item[field].orderData);
        } else {
          return !item[field].ocb ? item[field].value : item[field].ocb(item[field].value);
        }
      }], [this.order]);
    },
    renderBackground: function renderBackground(cell, i, bc) {
      var style = !cell.style ? {} : cell.style;
      if (!cell || cell.bgg === undefined && !cell.dbgg) {
        style.backgroundColor = !cell.bgc ? this.TypeColor[i] : cell.bgc;
      } else {
        if (!cell.dbgg) {
          if (!cell.bgl) {
            style.background = 'linear-gradient(to right, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
          } else {
            style.background = 'linear-gradient(to left, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
            style.position = 'relative';
          }
        } else {
          style.background = 'linear-gradient(to right, ' + this.TypeColor[cell.dbgg[0].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + (cell.dbgg[0].width + cell.dbgg[1].width) + '%, transparent 0%)';
        }
      }
      if (bc.bc) {
        style.backgroundColor = '' + bc.bc;
        style.color = bc.c;
      }
      if (cell.bgColorTwo) {
        var summ = Math.abs(cell.bgColorTwo.max.value) + Math.abs(cell.bgColorTwo.min.value);
        var minPercent = (Math.abs(cell.bgColorTwo.min.value) / summ * 100).toFixed(0);
        var maxPercent = (Math.abs(cell.bgColorTwo.max.value) / summ * 100).toFixed(0);
        var percent = void 0;
        if (cell.bgColorTwo.value < 0) {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.min.value) * minPercent + parseInt(maxPercent);
          style.background = 'linear-gradient(to left, transparent 0%, transparent ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        } else {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.max.value) * maxPercent + parseInt(minPercent);
          style.background = 'linear-gradient(to right, transparent 0%, transparent ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        }
        style.position = 'relative';
      }
      return style;
    },
    renderChart: function renderChart(cell, i) {
      if (!cell.graph) {
        return false;
      }
      var rows = (0, _lodash.orderBy)(this.rows, [function (item) {
        return item.date.value;
      }], ['asc']);
      var series = [];
      (0, _lodash.map)(rows, function (row) {
        if (!cell.graph.cb) {
          series.push([Date.parse(row[Object.keys(row)[0]].value), row[i].value]);
        } else {
          series.push([Date.parse(row[Object.keys(row)[0]].value), cell.graph.cb(row[i].value)]);
        }
      });
      if (cell.graph.symbol) {
        this.chart.tooltip.valueSuffix = cell.graph.symbol;
      } else {
        this.chart.tooltip.valueSuffix = null;
      }
      this.chart.title = this.$t('statistic.' + i);
      this.chart.series[0] = {
        data: series,
        color: _TypeColor2.default[i],
        name: this.$t('statistic.' + i)
      };
      this.chart.yAxis[0].min = 0;
      this.chart.yAxis[0].title.text = cell.symbol ? cell.symbol : this.$t('statistic.' + i);
      _highcharts2.default.chart('chart-container-' + this.id, this.chart);
      this.toggleModal();
    },
    toggleModal: function toggleModal() {
      this.chartModal = !this.chartModal;
    },
    createCheckbox: function createCheckbox() {
      var _this6 = this;

      if (this.checkbox) {
        this.rows.map(function (val, key) {
          _this6.$set(_this6.status, key, true);
        });
        this.$set(this.status, 'all', true);
      }
    },
    check: function check(poles) {
      var _this7 = this;

      if (poles === 'all') {
        this.rows.map(function (val, key) {
          _this7.$set(_this7.status, key, _this7.status.all);
        });
        this.chekeds();
      } else {
        this.chekeds();
      }
    },
    chekeds: function chekeds() {
      var _this8 = this;

      var checka = true;
      var summ = {};
      this.rows.map(function (val, key) {
        (0, _lodash.map)(_this8.checked[key].total, function (val1, key1) {
          if (key === 0) {
            summ[key1] = 0;
          }
          if (_this8.status[key] === false) {
            checka = false;
          } else {
            summ[key1] += _this8.checked[key].total[key1].count;
          }
        });
      });
      (0, _lodash.map)(summ, function (val, key) {
        _this8.footColumns[key].value = summ[key];
      });
      this.$set(this.status, 'all', checka);
    },
    updates: function updates(cell, cvalue) {
      this.$emit('changeElem', cell, cvalue);
      return false;
    },
    webGraph: function webGraph(cell, i) {
      if (!cell.webGraph) {
        return false;
      }
      this.$emit('webGraph', cell, i);
    },
    isPopup: function isPopup(cell, i) {
      if (!cell.popup) {
        return false;
      }
      this.$emit('isPopup', cell, i);
    },
    isPopupFlyPost: function isPopupFlyPost(cell) {
      this.$emit('isPopupFlyPost', cell);
    }
  }
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _lodash = __webpack_require__(5);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _CountryColor = __webpack_require__(35);

var _CountryColor2 = _interopRequireDefault(_CountryColor);

var _exporting = __webpack_require__(40);

var _exporting2 = _interopRequireDefault(_exporting);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _exporting2.default)(_highcharts2.default);

var chartOptions = {
  isBuilded: false,
  isHidden: false,
  title: {
    text: null
  },
  subtitle: {
    text: null
  },
  credits: {
    enabled: false
  },
  legend: {
    align: 'right',
    verticalAlign: 'top',
    layout: 'vertical',
    x: 0,
    y: 30
  },
  plotOptions: {
    line: {
      events: {
        legendItemClick: function legendItemClick() {
          if (this.userOptions.visible) {
            _API2.default.disabledDasbourdCountry(this.userOptions.id);
          } else {
            _API2.default.enabledDashboardCountry(this.userOptions.id);
          }
        }
      }
    }
  },
  yAxis: [{
    title: {
      text: null
    }
  }],
  xAxis: {
    categories: []
  },
  exporting: {
    allowHTML: true,
    buttons: {
      contextButton: {
        enabled: false
      },
      hideButton: {
        text: '<span style="font-family: FontAwesome; font-size: 14px">\uF070</span>',
        x: -80,
        onclick: function onclick(e) {
          var _this = this;

          if (typeof this.isHidden !== 'undefined') {
            this.isHidden = !this.isHidden;
          } else {
            this.isHidden = false;
          }
          this.series.map(function (v, i) {
            _this.isHidden ? _this.series[i].show() : _this.series[i].hide();
          });
        }
      }
    }
  },
  series: []
};
exports.default = {
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!chartOptions.isBuilded) {
      chartOptions.yAxis[0].title.text = this.$t('statistic.traffic');
      chartOptions.xAxis.categories = this.chartData.dates ? this.chartData.dates : [];
      (0, _lodash.map)(this.chartData.values, function (dataItem, dataIndex) {
        var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(dataIndex, 10) });
        chartOptions.series.push({
          id: country.id,
          name: _this2.$t('country.' + country.id),
          color: _CountryColor2.default[country.id],
          data: (0, _lodash.cloneDeep)(dataItem),
          visible: true
        });
      });
      chartOptions.isBuilded = true;
    } else {
      this.chart = _highcharts2.default.chart('dash-chart-traffic', chartOptions);
    }
    _API2.default.getDisabledCountry().then(function (response) {
      response.body.forEach(function (item) {
        for (var i in chartOptions.series) {
          if (chartOptions.series[i].id === item && item) {
            chartOptions.series[i].visible = false;
          }
        }
      });
      _this2.chart = _highcharts2.default.chart('dash-chart-traffic', chartOptions);
    });
  },
  data: function data() {
    return {
      chartOptions: chartOptions,
      chart: null
    };
  },

  name: 'TrafficChart'
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Switch = __webpack_require__(20);

var _Switch2 = _interopRequireDefault(_Switch);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ByManualFilter',
  components: {
    cSwitch: _Switch2.default,
    MultiSelect: _vueMultiselect2.default
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('country_selected', function () {
      _API2.default.getWebmasters(_Helper2.default.getCountryList()).then(function (response) {
        _Storage2.default.webFilter = response.data;
      });
    });

    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
    this.$refs.multiselect.$on('select', function () {
      this.search = '';
    });
    this.manual_filter = _Auth2.default.user.profile.manual_filter;
  },
  data: function data() {
    return {
      Storage: _Storage2.default,
      manual_filter: 0
    };
  },

  methods: {
    dispatchInputAction: function dispatchInputAction() {
      this.$root.$emit('country_selected');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('country_selected');
  }
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  mounted: function mounted() {
    _API2.default.getWebmastersNoGrid(_Helper2.default.getCountryList()).then(function (response) {
      _Storage2.default.webmasters = response.data;
    });
    this.$root.$on('country_selected', function () {
      _API2.default.getWebmastersNoGrid(_Helper2.default.getCountryList()).then(function (response) {
        _Storage2.default.webmasters = response.data;
      });
    });
    this.$refs.multiselect.$on('select', function () {
      this.search = '';
    });
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  methods: {
    dispatchInputAction: function dispatchInputAction() {
      this.$root.$emit('webmaster_selected');
    },
    reset: function reset() {
      _Storage2.default.selectedWebmaster = _Storage2.default.webmasters;
      this.dispatchInputAction();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('country_selected');
  }
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Switch = __webpack_require__(20);

var _Switch2 = _interopRequireDefault(_Switch);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ByWmFilter',
  components: {
    cSwitch: _Switch2.default,
    MultiSelect: _vueMultiselect2.default
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('country_selected', function () {
      _API2.default.getWebmasters(_Helper2.default.getCountryList()).then(function (response) {
        _Storage2.default.webFilter = response.data;
      });
    });
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
    this.$refs.multiselect.$on('select', function () {
      this.search = '';
    });
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  methods: {
    dispatchInputAction: function dispatchInputAction() {
      this.$root.$emit('country_selected');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('country_selected');
  }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Switch = __webpack_require__(20);

var _Switch2 = _interopRequireDefault(_Switch);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ByWmFilterAll',
  components: {
    cSwitch: _Switch2.default,
    MultiSelect: _vueMultiselect2.default
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
    this.$refs.multiselect.$on('select', function () {
      this.search = '';
    });
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  methods: {
    dispatchInputAction: function dispatchInputAction() {
      this.$root.$emit('country_selected');
    }
  }
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CopyButton',
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    showCopySuccess: function showCopySuccess() {
      this.$notify({
        type: 'success',
        text: this.$t('filters.filter_copied'),
        animationType: 'velocity'
      });
    },
    filterURL: function filterURL() {
      if (!_Storage2.default.selectedCountry) {
        return null;
      }
      var location = window.location.href.replace('/?.+/');
      var offerId = _Helper2.default.getOffersList();
      var operatorsList = _Helper2.default.getOperatorsList();
      var dateRange = _Helper2.default.getDateRange();
      var courierId = _Helper2.default.getCouriersList();
      return location + '?country_id=' + _Helper2.default.getCountryList() + (offerId ? '&offer_id=' + offerId : '') + (operatorsList ? '&operator_id=' + operatorsList : '') + dateRange + (courierId ? '&courier_id=' + courierId : '');
    }
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CountryFilter',
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  computed: {
    isRuLang: function isRuLang() {
      return localStorage.getItem('lang') === 'ru';
    }
  },
  methods: {
    customLabel: function customLabel(item) {
      return this.$root.$t('country.' + item.id);
    },
    dispatchInputActionCountry: function dispatchInputActionCountry() {
      this.$root.$emit('country_selected');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('country_selected');
  }
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'CourierFilter',
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      Storage: _Storage2.default,
      vm: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
    this.$refs.multiselect.$on('select', function () {
      this.search = '';
    });
  },

  methods: {
    limitTextMessage: function limitTextMessage(count) {
      return this.$root.$t('filters.more_pre') + count + this.$root.$t('filters.more_post');
    },
    selectAll: function selectAll() {
      _Storage2.default.selectedCouriers = _Storage2.default.couriers;
      this.dispatchInputAction();
    },
    reset: function reset() {
      _Storage2.default.selectedCouriers = [];
    }
  }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'DateCreated',
  components: {
    DatePicker: _vuejsDatepicker2.default,
    dropdown: _vueStrap.dropdown
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  methods: {
    yesterday: function yesterday() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      _Storage2.default.selectedDateCreatedTo = _Storage2.default.selectedDateCreatedFrom = date;
    },
    getMaxDate: function getMaxDate(y, m) {
      if (m === 1) {
        return y % 4 || !(y % 100) && y % 400 ? 28 : 29;
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31;
    },
    week: function week() {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      _Storage2.default.selectedDateCreatedFrom = null;
      _Storage2.default.selectedDateCreatedTo = null;
    },
    thisMonth: function thisMonth() {
      var date = new Date();
      date.setDate(1);
      _Storage2.default.selectedDateCreatedFrom = date;
      _Storage2.default.selectedDateCreatedTo = new Date();
    },
    lastMonth: function lastMonth() {
      var date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(1);
      _Storage2.default.selectedDateCreatedFrom = date;

      date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()));
      _Storage2.default.selectedDateCreatedTo = date;
    },
    reset: function reset() {
      this.week();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (_Storage2.default.selectedDateCreatedFrom === null) {
      this.reset();
    }
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
  }
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'DateFilter',
  components: {
    DatePicker: _vuejsDatepicker2.default,
    dropdown: _vueStrap.dropdown
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  methods: {
    yesterday: function yesterday() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      _Storage2.default.selectedDateTo = _Storage2.default.selectedDateFrom = date;
    },
    getMaxDate: function getMaxDate(y, m) {
      if (m === 1) {
        return y % 4 || !(y % 100) && y % 400 ? 28 : 29;
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31;
    },
    week: function week() {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      _Storage2.default.selectedDateFrom = date;
      _Storage2.default.selectedDateTo = new Date();
    },
    thisMonth: function thisMonth() {
      var date = new Date();
      date.setDate(1);
      _Storage2.default.selectedDateFrom = date;
      _Storage2.default.selectedDateTo = new Date();
    },
    lastMonth: function lastMonth() {
      var date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(1);
      _Storage2.default.selectedDateFrom = date;

      date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()));
      _Storage2.default.selectedDateTo = date;
    },
    reset: function reset() {
      this.week();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (_Storage2.default.selectedDateFrom === null) {
      this.reset();
    }
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'DateFilterSecond',
  components: {
    DatePicker: _vuejsDatepicker2.default,
    dropdown: _vueStrap.dropdown
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  methods: {
    yesterday: function yesterday() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      _Storage2.default.selectedDateToSecond = _Storage2.default.selectedDateFromSecond = date;
    },
    getMaxDate: function getMaxDate(y, m) {
      if (m === 1) {
        return y % 4 || !(y % 100) && y % 400 ? 28 : 29;
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31;
    },
    week: function week() {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      _Storage2.default.selectedDateFromSecond = date;
      _Storage2.default.selectedDateToSecond = new Date();
    },
    thisMonth: function thisMonth() {
      var date = new Date();
      date.setDate(1);
      _Storage2.default.selectedDateFromSecond = date;
      _Storage2.default.selectedDateToSecond = new Date();
    },
    lastMonth: function lastMonth() {
      var date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(1);
      _Storage2.default.selectedDateFromSecond = date;

      date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()));
      _Storage2.default.selectedDateToSecond = date;
    },
    reset: function reset() {
      this.week();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (_Storage2.default.selectedDateFromSecond === null) {
      this.reset();
    }
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'DateReceipt',
  components: {
    DatePicker: _vuejsDatepicker2.default,
    dropdown: _vueStrap.dropdown
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },

  methods: {
    yesterday: function yesterday() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      _Storage2.default.selectedDateReceiptTo = _Storage2.default.selectedDateReceiptFrom = date;
    },
    getMaxDate: function getMaxDate(y, m) {
      if (m === 1) {
        return y % 4 || !(y % 100) && y % 400 ? 28 : 29;
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31;
    },
    week: function week() {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      _Storage2.default.selectedDateReceiptFrom = null;
      _Storage2.default.selectedDateReceiptTo = null;
    },
    thisMonth: function thisMonth() {
      var date = new Date();
      date.setDate(1);
      _Storage2.default.selectedDateReceiptFrom = date;
      _Storage2.default.selectedDateReceiptTo = new Date();
    },
    lastMonth: function lastMonth() {
      var date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(1);
      _Storage2.default.selectedDateReceiptFrom = date;

      date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()));
      _Storage2.default.selectedDateReceiptTo = date;
    },
    reset: function reset() {
      this.week();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (_Storage2.default.selectedDateReceiptFrom === null) {
      this.reset();
    }
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
  }
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'MonthFilter',
  components: {
    DatePicker: _vuejsDatepicker2.default,
    dropdown: _vueStrap.dropdown
  },
  data: function data() {
    return {
      Storage: _Storage2.default,
      DatePickerFormat: 'yyyy-MM',
      disabledDates: {
        to: new Date(2017, 7, 31)
      }
    };
  },

  methods: {
    yesterday: function yesterday() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      _Storage2.default.selectedMonthTo = _Storage2.default.selectedMonthFrom = date;
    },
    getMaxDate: function getMaxDate(y, m) {
      if (m === 1) {
        return y % 4 || !(y % 100) && y % 400 ? 28 : 29;
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31;
    },
    week: function week() {
      var date = new Date();
      date.setDate(date.getMonth() - 1);
      _Storage2.default.selectedMonthFrom = date;
      _Storage2.default.selectedMonthTo = new Date();
    },
    month: function month() {
      var date = new Date();
      date.setMonth(date.getMonth() - 12);
      date.setDate(1);
      _Storage2.default.selectedMonthFrom = date;

      date = new Date();
      date.setDate(1);
      _Storage2.default.selectedMonthTo = date;
    },
    thisMonth: function thisMonth() {
      var date = new Date();
      date.setDate(1);
      _Storage2.default.selectedDateFrom = date;
      _Storage2.default.selectedDateTo = new Date();
    },
    lastMonth: function lastMonth() {
      var date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(1);
      _Storage2.default.selectedDateFrom = date;

      date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()));
      _Storage2.default.selectedDateTo = date;
    },
    reset: function reset() {
      this.month();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (_Storage2.default.selectedMonthFrom === null) {
      this.reset();
    }
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
  }
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'MonthFromFilter',
  components: {
    DatePicker: _vuejsDatepicker2.default,
    dropdown: _vueStrap.dropdown
  },
  data: function data() {
    return {
      Storage: _Storage2.default,
      DatePickerFormat: 'yyyy-MM',
      disabledDates: {
        to: new Date(2017, 7, 31)
      }
    };
  },

  methods: {
    yesterday: function yesterday() {
      _Storage2.default.selectedMonthFrom = new Date();
    },
    getMaxDate: function getMaxDate(y, m) {
      if (m === 1) {
        return y % 4 || !(y % 100) && y % 400 ? 28 : 29;
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31;
    },
    week: function week() {
      _Storage2.default.selectedMonthFrom = new Date();
    },
    month: function month() {
      var date = new Date();
      date.setDate(1);
      _Storage2.default.selectedMonthFrom = date;
    },
    thisMonth: function thisMonth() {
      _Storage2.default.selectedMonthFrom = new Date();
    },
    lastMonth: function lastMonth() {
      var date = new Date();

      date = new Date();
      date.setMonth(date.getMonth() - 1);
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()));
      _Storage2.default.selectedMonthFrom = date;
    },
    reset: function reset() {
      this.month();
    }
  },
  mounted: function mounted() {
    var _this = this;

    _Storage2.default.selectedMonthFrom = new Date();
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
  }
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'NewWmFilter',
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  mounted: function mounted() {
    _Storage2.default.webNewFilter = [{ name: 'web1' }];
    _Storage2.default.webNewSelectedFilter = [{ name: 'web1' }];
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  }
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'OfferFilter',
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('country_selected', function () {
      _API2.default.getOffers(_Helper2.default.getCountryList()).then(function (response) {
        _Storage2.default.offers = response.data;
      });
    });
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
    this.$refs.multiselect.$on('select', function () {
      this.search = '';
    });
  },
  data: function data() {
    return {
      Storage: _Storage2.default,
      vm: null
    };
  },

  methods: {
    dispatchInputAction: function dispatchInputAction() {
      this.$root.$emit('offer_selected');
    },
    limitTextMessage: function limitTextMessage(count) {
      return this.$t('filters.more_pre') + count + this.$t('filters.more_post');
    },
    selectAll: function selectAll() {
      _Storage2.default.selectedOffer = _Storage2.default.offers;
      this.dispatchInputAction();
    },
    reset: function reset() {
      _Storage2.default.selectedOffer = [];
      this.dispatchInputAction();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('country_selected');
  }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Switch = __webpack_require__(20);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OldWmFilter',
  components: {
    cSwitch: _Switch2.default
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  }
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'oneCountryFilter',
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      Storage: _Storage2.default,
      countryCode: ''
    };
  },

  methods: {
    customLabel: function customLabel(item) {
      return this.$root.$t('country.' + item.id);
    },
    dispatchInputAction: function dispatchInputAction() {
      this.$root.$emit('country_selected');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('country_selected');
  }
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'OperatorFilter',
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      Storage: _Storage2.default
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('country_selected', function () {
      _API2.default.getOperators(_Helper2.default.getCountryList(), _Helper2.default.getOffersList()).then(function (response) {
        _Storage2.default.operators = Object.keys(response.data).map(function (key) {
          return response.data[key];
        });
        _this.reset();
      });
    });
    this.$root.$on('filters_reset_all', function () {
      _this.reset();
    });
    this.$refs.multiselect.$on('select', function () {
      this.search = '';
    });
  },

  methods: {
    limitTextMessage: function limitTextMessage(count) {
      return this.$root.$t('filters.more_pre') + count + this.$root.$t('filters.more_post');
    },
    selectAll: function selectAll() {
      _Storage2.default.selectedOperator = _Storage2.default.operators;
    },
    reset: function reset() {
      _Storage2.default.selectedOperator = [];
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('country_selected');
  }
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      value: { title: 'День', value: 'day' },
      options: [{ title: 'День', value: 'day' }, { title: 'Неделя', value: 'week' }, { title: 'Месяц', value: 'month' }]
    };
  },
  mounted: function mounted() {},

  methods: {
    handleChangeParse: function handleChangeParse(event) {
      this.$root.$emit('handleChangeParse', event.value);
    }
  }
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'WebmasterFilter',
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      Storage: _Storage2.default,
      options: []
    };
  },

  methods: {
    addTag: function addTag(newTag) {
      if (_Storage2.default.webAddTagFilter == null) {
        _Storage2.default.webAddTagFilter = [];
      }
      var tag = {
        name: newTag
      };
      this.options.push(tag);
      _Storage2.default.webAddTagFilter.push(tag);
    }
  }
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MultiSelect: _vueMultiselect2.default
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      value: { title: 'Обе смены', value: null },
      options: [{ title: 'Обе смены', value: null }, { title: 'Рабочая смена', value: true }, { title: 'Нерабочая смена', value: false }]
    };
  },

  methods: {
    handleChangeClose: function handleChangeClose(event) {
      this.$root.$emit('handleChangeClose', event.value);
    }
  }
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(416);

var _Header2 = _interopRequireDefault(_Header);

var _Sidebar = __webpack_require__(419);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Footer = __webpack_require__(415);

var _Footer2 = _interopRequireDefault(_Footer);

var _Breadcrumb = __webpack_require__(411);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'full',
  components: {
    AppHeader: _Header2.default,
    Sidebar: _Sidebar2.default,
    AppFooter: _Footer2.default,
    Breadcrumb: _Breadcrumb2.default
  },
  data: function data() {
    return {
      authenticated: _Auth2.default.user.authenticated
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'language',
  methods: {
    chooseLanguage: function chooseLanguage(lang) {
      localStorage.setItem('lang', lang);
      window.location.reload();
    }
  }
};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DifferencyTable = __webpack_require__(414);

var _DifferencyTable2 = _interopRequireDefault(_DifferencyTable);

var _DebitTable = __webpack_require__(413);

var _DebitTable2 = _interopRequireDefault(_DebitTable);

var _TrafficChart = __webpack_require__(421);

var _TrafficChart2 = _interopRequireDefault(_TrafficChart);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _DashCard = __webpack_require__(412);

var _DashCard2 = _interopRequireDefault(_DashCard);

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _lodash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dashboard',
  components: {
    DifferencyTable: _DifferencyTable2.default,
    TrafficChart: _TrafficChart2.default,
    DashCard: _DashCard2.default,
    DebitTable: _DebitTable2.default
  },
  data: function data() {
    return {
      Auth: _Auth2.default,
      trafficChart: _Storage2.default.dashboardStatistic.traffic,
      averageBillTable: _Storage2.default.dashboardStatistic.average_bill,
      approveTable: _Storage2.default.dashboardStatistic.approve,
      adverticeDbt: _Storage2.default.dashboardStatistic.advertising_debt
    };
  },

  computed: {
    adverticeDebit: function adverticeDebit() {
      var total = 0.0;
      (0, _lodash.map)(this.adverticeDbt, function (d, i) {
        total += parseFloat(d.balance);
      });
      return parseFloat(total).toFixed(2);
    },
    trafficTotal: function trafficTotal() {
      var total = 0;
      (0, _lodash.map)(this.trafficChart.values, function (d) {
        total += d[d.length - 1];
      });
      return total;
    },
    approvedTotal: function approvedTotal() {
      var total = 0;
      (0, _lodash.map)(this.approveTable, function (d) {
        total += d.count;
      });
      return total;
    },
    approvedPercents: function approvedPercents() {
      return parseFloat(this.approvedTotal / this.trafficTotal * 100).toFixed(1) + '%';
    },
    leadsForDash: function leadsForDash() {
      var data = _Storage2.default.dashboardStatistic.leads;
      (0, _lodash.map)(data, function (d, i) {
        data[i].difference = data[i].weekAverage - data[i].limit;
      });
      return data;
    }
  }
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _Language = __webpack_require__(179);

var _Language2 = _interopRequireDefault(_Language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Impersonate',
  components: {
    Language: _Language2.default
  },
  data: function data() {
    return {
      credentials: {
        code: ''
      },
      error: false,
      authLoading: false,
      routese: {}
    };
  },
  mounted: function mounted() {
    _Auth2.default.logoutImpersonate();
    this.routese = this.$route.query;
  },
  methods: {
    redirect: function redirect() {
      if (this.routese.username && this.routese.password && this.routese.user_from) {
        _Auth2.default.loginImpersonate(this);
      }
      this.error = false;
      this.authLoading = true;
    }
  }
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Loading',
  data: function data() {
    return {
      step: 0,
      total: 8,
      isLoading: true,
      error: null
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      _Helper2.default.checkLang();

      _API2.default.getLastVersion().then(function (response) {
        _this.step++;
        _Storage2.default.lastVersion = response.data.last_version;
        _API2.default.getLastUpdateTime().then(function (response) {
          _this.step++;
          _Storage2.default.lastUpdate = response.data.last_update;
          _API2.default.getCountries().then(function (response) {
            _this.step++;
            if (Object.keys(response.data).length === 0) {
              _this.isLoading = false;
              _this.error = _this.$t('message.no_countries');
            } else {
              _Storage2.default.countries = (0, _lodash.orderBy)(Object.keys(response.data).map(function (key) {
                return response.data[key];
              }), ['name'], ['asc']);
              _Storage2.default.selectedCountry = _Helper2.default.findCountry(_Storage2.default.enterRouter.query.country_id);
              _API2.default.getOffers(_Storage2.default.selectedCountry.id).then(function (response) {
                _this.step++;
                _Storage2.default.offers = response.data;
                _Storage2.default.selectedOffer = _Helper2.default.findSelectedOffers(_Storage2.default.enterRouter.query.offer_id);
                _API2.default.getWebmasters(_Storage2.default.selectedCountry.id).then(function (response) {
                  _this.step++;
                  _Storage2.default.webFilter = response.data;
                  _Storage2.default.webSelectedFilter = _Helper2.default.findSelectedWebs(_Storage2.default.enterRouter.query.web_id);
                  _API2.default.getOperators(_Storage2.default.selectedCountry.id).then(function (response) {
                    _this.step++;
                    _Storage2.default.operators = Object.keys(response.data).map(function (key) {
                      return response.data[key];
                    });
                    _Storage2.default.selectedOperator = _Helper2.default.findSelectedOperators(_Storage2.default.enterRouter.query.operator_id);
                    _API2.default.getCouriers().then(function (response) {
                      _this.step++;
                      _Storage2.default.couriers = Object.keys(response.data).map(function (key) {
                        return response.data[key];
                      });
                      _Storage2.default.selectedCouriers = _Helper2.default.findSelectedCouriers(_Storage2.default.enterRouter.query.courier_id);
                      _API2.default.getDashboardStatistic().then(function (response) {
                        _this.step++;
                        _Storage2.default.dashboardStatistic = response.data;
                        if (_Storage2.default.enterRouter.query.date_from && _Storage2.default.enterRouter.query.date_to) {
                          _Storage2.default.selectedDateFrom = new Date(_Storage2.default.enterRouter.query.date_from);
                          _Storage2.default.selectedDateTo = new Date(_Storage2.default.enterRouter.query.date_to);
                        }
                        _this.isLoading = false;
                        _vue2.default.console.log('Pushing to ' + _Storage2.default.enterRouter.fullPath);
                        _this.$router.push(_Storage2.default.enterRouter.fullPath);
                      });
                    });
                  });
                });
              });
            }
          });
        }, function () {
          window.location = window.location.origin;
        });
      });
    });
  }
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _Language = __webpack_require__(179);

var _Language2 = _interopRequireDefault(_Language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Login',
  components: {
    Language: _Language2.default
  },
  data: function data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      error: false,
      authLoading: false
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      return _Auth2.default.user.authenticated ? this.$router.push('/') : null;
    });
  },
  methods: {
    login: function login() {
      _Auth2.default.login(this);
      this.error = false;
      this.authLoading = true;
    }
  }
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Auth = __webpack_require__(12);

var _Auth2 = _interopRequireDefault(_Auth);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Switch = __webpack_require__(20);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Profile',
  components: {
    MultiSelect: _vueMultiselect2.default,
    cSwitch: _Switch2.default
  },
  data: function data() {
    return {
      developMode: false,
      Storage: _Storage2.default,
      Auth: _Auth2.default,
      security: {
        isLoading: false,
        password: null,
        passwordRepeat: null,
        oldPassword: null,
        alert: null
      },
      personal: {
        isLoading: false,
        email: _Auth2.default.user.profile.email,
        firstName: _Auth2.default.user.profile.first_name,
        lastName: _Auth2.default.user.profile.last_name,
        alert: null
      },
      language: {
        isLoading: null,
        list: [{ value: 'ru', label: 'Русский' }, { value: 'en', label: 'English' }],
        selected: {},
        alert: null
      }
    };
  },
  mounted: function mounted() {
    this.language.selected = (0, _lodash.find)(this.language.list, { value: _Storage2.default.language });
    this.developMode = _Storage2.default.developMode;
  },

  methods: {
    handleDevelopMode: function handleDevelopMode(event) {
      localStorage.setItem('developMode', this.developMode);
      window.location.reload();
    },
    changePassword: function changePassword() {
      var _this = this;

      this.security.isLoading = true;
      this.security.alert = null;
      if (this.security.alert === null && (!this.security.password || this.security.password.length < 6)) {
        this.security.alert = {
          message: this.$root.$t('profile.password_error_9')
        };
      }
      if (this.security.alert === null && this.security.password !== this.security.passwordRepeat) {
        this.security.alert = {
          message: this.$root.$t('profile.password_error_8')
        };
      }
      if (this.security.alert === null && (!this.security.oldPassword || this.security.oldPassword.length < 6)) {
        this.security.alert = {
          message: this.$root.$t('profile.password_error_10')
        };
      }
      if (this.security.alert === null) {
        _API2.default.profileChangePassword(this.security.oldPassword, this.security.password, this.security.passwordRepeat).then(function () {
          _this.security.alert = {
            type: 'success',
            message: _this.$root.$t('profile.password_changed')
          };
          _this.security.oldPassword = null;
          _this.security.password = null;
          _this.security.passwordRepeat = null;
          _this.security.isLoading = null;
        }).catch(function (response) {
          _this.security.alert = {
            message: _this.$root.$t('profile.password_error_' + response.body.code)
          };
          _this.security.isLoading = null;
        });
      } else {
        this.security.isLoading = null;
      }
    },
    saveProfile: function saveProfile() {
      var _this2 = this;

      this.personal.isLoading = true;
      this.personal.alert = null;
      if (this.personal.email.length === 0 || this.personal.firstName.length === 0 || this.personal.lastName.length === 0) {
        this.personal.alert = {
          message: this.$root.$t('profile.need_all')
        };
        this.personal.isLoading = false;
      } else {
        _API2.default.profileUpdate(this.personal.email, this.personal.firstName, this.personal.lastName).then(function (response) {
          if (!response.body.response) {
            _this2.personal.alert = {
              message: response.body[Object.keys(response.body)[0]][0]
            };
            _this2.personal.isLoading = false;
          } else {
            _Auth2.default.user.profile.email = _this2.personal.email;
            _Auth2.default.user.profile.first_name = _this2.personal.firstName;
            _Auth2.default.user.profile.last_name = _this2.personal.lastName;
            _this2.personal.alert = {
              type: 'success',
              message: _this2.$root.$t('profile.updated')
            };
            _this2.personal.isLoading = false;
          }
        }).catch(function (response) {
          _this2.personal.alert = {
            message: response.body.message
          };
          _this2.personal.isLoading = false;
        });
      }
    },
    changeLanguage: function changeLanguage() {
      var _this3 = this;

      this.language.isLoading = true;
      _API2.default.profileChangeLanguage(this.language.selected.value).then(function () {
        _this3.language.alert = {
          type: 'success',
          message: _this3.$root.$t('profile.language_changed')
        };
        localStorage.setItem('lang', _this3.language.selected.value);
        window.location.reload();
        _this3.language.isLoading = false;
      }).catch(function (response) {
        _this3.language.alert = {
          message: !response.body.message ? response.body : response.body.message
        };
      });
    }
  }
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ChangeLog',
  data: function data() {
    return {
      logs: [],
      isline: false,
      selecteds: 1,
      perpage: 15,
      page: 1,
      count_page: 1,
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    _API2.default.getChengeLog(1, 1, this.perpage).then(function (response) {
      var json = response.data;
      var logs = json.items;
      _this.logs = logs;
      _this.page++;
      _this.count_page = json.count_pages;
    }).catch();
  },
  methods: {
    showlistclick: function showlistclick(num) {
      var _this2 = this;

      this.page = 1;
      this.selecteds = num;
      this.loading = true;
      _API2.default.getChengeLog(num, this.page, this.perpage).then(function (response) {
        var json = response.data;
        var logs = json.items;
        _this2.logs = logs;
        _this2.page++;
        _this2.loading = false;
      }).catch();
    },
    showlist: function showlist() {
      var _this3 = this;

      this.loading = true;
      _API2.default.getChengeLog(this.selecteds, this.page, this.perpage).then(function (response) {
        var json = response.data;
        var logs = json.items;
        _this3.logs = _this3.logs.concat(logs);
        console.log(_this3.page);
        _this3.page++;
        _this3.loading = false;
      }).catch();
    },
    handleScroll: function handleScroll(event) {
      var diff = window.scrollY + event.target.firstElementChild.clientHeight;
      var documentHeight = event.target.firstElementChild.offsetHeight;
      if (diff > documentHeight && this.page <= this.count_page && !this.loading) {
        this.showlist();
      }
    }
  },
  beforeMount: function beforeMount() {
    window.scrollTo(0, 0);
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ChangeVersion',
  data: function data() {
    return {
      logs: [],
      isline: false,
      selecteds: 1,
      perpage: 15,
      page: 1,
      count_page: 1,
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    _API2.default.getChangeVersion(1, this.perpage).then(function (response) {
      var json = response.data;
      var logs = json.items;
      _this.logs = logs;
      _this.page++;
      _this.count_page = json.count_pages;
    }).catch();
  },
  methods: {
    showlistclick: function showlistclick(num) {
      var _this2 = this;

      this.page = 1;
      this.selecteds = num;
      this.loading = true;
      _API2.default.getChangeVersion(this.page, this.perpage).then(function (response) {
        var json = response.data;
        var logs = json.items;
        _this2.logs = logs;
        _this2.page++;
        _this2.loading = false;
      }).catch();
    },
    showlist: function showlist() {
      var _this3 = this;

      this.loading = true;
      _API2.default.getChengeLog(this.selecteds, this.page, this.perpage).then(function (response) {
        var json = response.data;
        var logs = json.items;
        _this3.logs = _this3.logs.concat(logs);
        console.log(_this3.page);
        _this3.page++;
        _this3.loading = false;
      }).catch();
    },
    handleScroll: function handleScroll(event) {
      var diff = window.scrollY + event.target.firstElementChild.clientHeight;
      var documentHeight = event.target.firstElementChild.offsetHeight;
      if (diff > documentHeight && this.page <= this.count_page && !this.loading) {
        this.showlist();
      }
    },

    htmlNow: function htmlNow(text) {
      var textNew = text.replace(/\n/g, '<br />');
      return textNew;
    }
  },
  beforeMount: function beforeMount() {
    window.scrollTo(0, 0);
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Page404'
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'WebTabs'
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _vueStrap = __webpack_require__(9);

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _WebTabs = __webpack_require__(180);

var _WebTabs2 = _interopRequireDefault(_WebTabs);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Webmasters',
  components: {
    WebTabs: _WebTabs2.default,
    modal: _vueStrap.modal,
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      statusStop: 1,
      statusFilter: 2,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byWmFilter: true
      },
      chartModal: false,
      webModal: false,
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      webid: null,
      webid_modal: '',
      headColumns: [{ label: this.$root.$t('statistic.webmaster'), field: 'webmaster' }, { label: this.$root.$t('statistic.proportion'), field: 'proportion' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2 }, { label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2 }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2 }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }, { label: this.$root.$t('statistic.ad_approved'), field: 'ad_approved' }, { label: this.$root.$t('statistic.ad_pre_approved'), field: 'ad_pre_approved' }, { label: this.$root.$t('statistic.ad_difference'), field: 'ad_difference' }, { label: this.$root.$t('statistic.ad_approve_percent'), field: 'approve_percent' }],
      headColumnsReason: [{ label: this.$root.$t('statistic.country_id_web'), field: 'country_id' }, { label: this.$root.$t('statistic.offer_id_web'), field: 'offer_id' }],
      rowsReason: [],
      rows: [],
      footColumns: {},
      chart: {
        isBuilded: false,
        isHidden: false,
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          title: {
            text: null
          },
          tickInterval: 1
        }],
        tooltip: {
          valueSuffix: null
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m-%d}'
          }
        },
        series: []
      },
      statusForWebmasters: [],
      exportHistiryModal: false,
      exportRows: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getWebmasterStatistic().then(function (response) {
        var sumTotal = 0;
        var count = Object(response.data).keys.length;

        (0, _lodash.map)(response.data, function (d) {
          sumTotal += parseInt(d.total);
        });
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });

        var sumProcessed = 0;
        var countProcessed = 0;
        var sumApproved = 0;
        var countApproved = 0;
        var sumCanceled = 0;
        var countCanceled = 0;
        var sumError = 0;
        var countError = 0;
        var sumPaid = 0;
        var countPaid = 0;
        var sumReturn = 0;
        var countReturn = 0;
        var sumAverageBillLocal = 0.0;
        var sumAverageBuybackLocal = 0.0;
        var sumAverageBill = 0.0;
        var sumAverageBuyback = 0.0;
        var sumAdApproved = 0;
        var sumAdPreApproved = 0;
        var sumAdDifference = 0;
        var sumApprovePercent = 0;
        (0, _lodash.map)(response.data, function (d) {
          if (d.processed > 0) {
            sumProcessed += parseInt(d.processed);
            countProcessed++;
          }
          if (d.approved > 0) {
            sumApproved += parseInt(d.approved);
            countApproved++;
            sumAverageBill += parseFloat(d.average_bill_usd) * d.approved;
            sumAverageBillLocal += parseFloat(d.average_bill_local) * d.approved;
            sumAverageBuyback += parseFloat(d.average_buyout_usd) * d.paid;
            sumAverageBuybackLocal += parseFloat(d.average_buyout_local);
            _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
          }
          if (d.canceled > 0) {
            sumCanceled += parseInt(d.canceled);
            countCanceled++;
          }
          if (d.error > 0) {
            sumError += parseInt(d.error);
            countError++;
          }
          if (d.paid > 0) {
            sumPaid += parseInt(d.paid);
            countPaid++;
          }
          if (d.return > 0) {
            sumReturn += parseInt(d.return);
            countReturn++;
          }
          if (d.ad_approved > 0) {
            sumAdApproved += parseInt(d.ad_approved);
          }
          if (d.ad_pre_approved > 0) {
            sumAdPreApproved += parseInt(d.ad_pre_approved);
          }
          if (d.approve_percent < 0) {
            sumApprovePercent += parseInt(d.approve_percent);
          }

          sumAdDifference += isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : d.ad_approved - d.ad_pre_approved;

          _this2.rows.push({
            webmaster: {
              isCollspaned: true,
              value: d.wm_id,
              is_new: d.is_new,
              popup: true,
              statusFilter: d.count_filter,
              statusStop: d.count_stop
            },
            proportion: {
              value: _Helper2.default.percents(sumTotal, d.total),
              bgg: _Helper2.default.renderSingleGist(parseInt(d.total), parseInt(d.canceled)),
              ocb: function ocb(value) {
                return _Helper2.default.getRawNumber(value);
              }
            },
            total: {
              value: d.total,
              bg: true,
              webGraph: true,
              wb: d.wm_id
            },
            processed: {
              value: d.processed,
              bgg: _Helper2.default.renderGistPart(d.total, d.processed),
              isCollspaned: true
            },
            processedPercents: {
              value: _Helper2.default.percents(d.total, d.processed),
              bgg: _Helper2.default.renderGistPart(d.total, d.processed, true)
            },
            accepted: {
              value: d.approved,
              bgg: _Helper2.default.renderGistPart(d.total, d.approved),
              isCollspaned: true
            },
            acceptedPercents: {
              value: _Helper2.default.percents(d.total, d.approved),
              bgg: _Helper2.default.renderGistPart(d.total, d.approved, true),
              webGraph: true,
              wb: d.wm_id,
              webGraphSymbol: '%'
            },
            paid: {
              value: d.paid,
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
              isCollspaned: true
            },
            paidPercents: {
              value: _Helper2.default.percents(parseInt(d.approved), parseInt(d.paid)),
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true),
              webGraph: true,
              wb: d.wm_id,
              webGraphSymbol: '%'
            },
            return: {
              value: d.return,
              bgg: _Helper2.default.renderGistPart(d.approved, d.return),
              isCollspaned: true
            },
            returnPercents: {
              value: _Helper2.default.percents(parseInt(d.approved), parseInt(d.return)),
              bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
            },
            averageBill: {
              value: '$ ' + d.average_bill_usd.toFixed(2),

              isCollspaned: true
            },
            averageBillLocal: {
              value: d.local_currency.split(',').length === 1 ? d.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
            },
            averageBuyback: {
              value: '$ ' + d.average_buyout_usd.toFixed(2),

              isCollspaned: true
            },
            averageBuybackLocal: {
              value: d.local_currency.split(',').length === 1 ? d.average_buyout_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
            },
            canceled: {
              value: d.canceled,
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled),
              isCollspaned: true
            },
            canceledPercents: {
              value: _Helper2.default.percents(parseInt(d.total), parseInt(d.canceled)),
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled, true)
            },
            error: {
              value: d.error,
              bgg: _Helper2.default.renderGistPart(d.total, d.error),
              isCollspaned: true
            },
            errorPercents: {
              value: _Helper2.default.percents(parseInt(d.total), parseInt(d.error)),
              bgg: _Helper2.default.renderGistPart(d.total, d.error, true)
            },
            approvedFromValid: {
              value: d.approved_from_valid.toFixed(1) + '%'
            },
            ad_approved: {
              value: d.ad_approved ? Number(d.ad_approved.toFixed(2)) : 0
            },
            ad_pre_approved: {
              value: d.ad_pre_approved ? Number(d.ad_pre_approved.toFixed(2)) : 0
            },
            ad_difference: {
              value: isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : Number((d.ad_approved - d.ad_pre_approved).toFixed(2))
            },
            approve_percent: {
              value: d.approve_percent
            }
          });
        });
        _this2.footColumns = {
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          proportion: {
            value: null
          },
          total: {
            value: '' + sumTotal
          },
          processed: {
            value: '' + sumProcessed
          },
          processedPercents: {
            value: _Helper2.default.percents(sumTotal, sumProcessed)
          },
          accepted: {
            value: '' + sumApproved
          },
          acceptedPercents: {
            value: _Helper2.default.percents(sumTotal, sumApproved)
          },
          paid: {
            value: '' + sumPaid
          },
          paidPercents: {
            value: _Helper2.default.percents(sumApproved, sumPaid)
          },
          return: {
            value: '' + sumReturn
          },
          returnPercents: {
            value: _Helper2.default.percents(sumApproved, sumReturn)
          },
          averageBill: {
            value: _Helper2.default.averageBillDayCount(sumAverageBill, sumApproved),
            graph: {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: '$'
            }
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumApproved, _this2.localCurrencySymbol) : '-',
            graph: filterCurrency.length === 1 ? {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: _this2.localCurrencySymbol
            } : false
          },
          averageBuyback: {
            value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid),
            graph: {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: '$'
            }
          },
          averageBuybackLocal: {
            value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBuybackLocal, _this2.rows.filter(function (row) {
              return Number(row.averageBuybackLocal.value.split(' ')[0]);
            }).length, _this2.localCurrencySymbol) : '-',
            graph: filterCurrency.length === 1 ? {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: _this2.localCurrencySymbol
            } : false
          },
          canceled: {
            value: sumCanceled + ' (' + _Helper2.default.average(sumCanceled, countCanceled) + ')'
          },
          canceledPercents: {
            value: _Helper2.default.percents(sumTotal, sumCanceled)
          },
          error: {
            value: sumError + ' (' + _Helper2.default.average(sumError, countError) + ')'
          },
          errorPercents: {
            value: _Helper2.default.percents(sumTotal, sumError)
          },
          approvedFromValid: {
            value: _Helper2.default.approvedFromValid(sumApproved, sumTotal, sumError)
          },
          ad_approved: {
            value: sumAdApproved
          },
          ad_pre_approved: {
            value: sumAdPreApproved
          },
          ad_difference: {
            value: sumAdDifference
          },
          approve_percent: {
            value: sumApprovePercent
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        console.log(response);
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: response,
          animationType: 'velocity'
        });
      });
    },
    webGraph: function webGraph(cell, i) {
      var _this3 = this;

      var name = i === 'acceptedPercents' ? 'approved' : i === 'paidPercents' ? 'paid' : 'total';
      this.webid = cell.wb;
      var approvedAll = [];
      var acceptedPercentsName = this.$root.$t('statistic.approved');
      var totalPercentsTotal = this.$root.$t('statistic.total');
      var totals = this.$root.$t('verbs.total');
      _API2.default.getWebmastersGraphs(cell.wb).then(function (response) {
        var rows = (0, _lodash.orderBy)(response.body, [function (item) {
          return item.date.value;
        }], ['asc']);
        var series = [];
        (0, _lodash.map)(rows, function (row) {
          var value = i === 'acceptedPercents' ? _Helper2.default.percentsF(row['total'], row['approved']) : i === 'paidPercents' ? _Helper2.default.percentsF(row['approved'], row['paid']) : row['total'];
          approvedAll[Date.parse(row.date)] = row['approved'];
          series.push([Date.parse(row.date), value]);
        });
        if (cell.webGraphSymbol) {
          _this3.chart.tooltip.valueSuffix = cell.webGraphSymbol;
        } else {
          _this3.chart.tooltip.valueSuffix = null;
        }
        _this3.chart.title = _this3.$root.$t('statistic.' + name);
        _this3.chart.series[0] = {
          data: series,
          color: _TypeColor2.default[i],
          name: _this3.$root.$t('statistic.' + name)
        };
        _this3.chart.yAxis[0].min = 0;
        _this3.chart.yAxis[0].title.text = _this3.$root.$t('statistic.' + name);
        _this3.chart.tooltip.formatter = function () {
          if (this.series.name === acceptedPercentsName) {
            return this.series.name + ': <b>' + this.point.y + ' %</b><br>' + totals + ': <b>' + approvedAll[this.x] + '</b>';
          } else if (this.series.name === totalPercentsTotal) {
            return this.series.name + ': <b>' + this.point.y + ' </b>';
          } else {
            return this.series.name + ': <b>' + this.point.y + ' %</b>';
          }
        };
        _highcharts2.default.chart('chart-container-' + _this3.webid, _this3.chart);
        _this3.chartModal = true;
      });
    },
    getApiOffers: function getApiOffers(countries, offer) {
      return new Promise(function (resolve, reject) {
        var offerTitle = [];
        _API2.default.getOffers(countries).then(function (response) {
          (0, _lodash.map)(response.body, function (data) {
            if (parseInt(offer) === data.id) {
              offerTitle.push(data.title);
              resolve(offerTitle);
            }
          });
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    isPopup: function isPopup(cell) {
      var _this4 = this;

      this.rowsReason = [];
      this.webid_modal = cell.value;
      this.statusForWebmasters = [];
      _API2.default.getWebPopup(cell.value).then(function (response) {
        (0, _lodash.map)(response.data, function (d) {
          var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(d.country_id) });
          _this4.getApiOffers(d.country_id, d.offer_id).then(function (response) {
            response.forEach(function (item) {
              _this4.rowsReason.push({
                wm_id: cell.value,
                country: { country_id: d.country_id, name: country.name },
                offer: { offer_id: d.offer_id, name: item },
                status: d.status,
                active: false
              });
            });
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
      this.webModal = true;
    },
    getClasses: function getClasses(row) {
      var classes = [];
      var status = parseInt(row.status);
      if (status === 1) {
        classes.push('stop');
      }
      if (status === 2) {
        classes.push('filter');
      }
      if (row.active) {
        classes.push('active');
      }
      return classes;
    },
    getWebmastersRow: function getWebmastersRow(row) {
      if (row.active) {
        row.active = false;
      } else {
        row.active = true;
      }
      this.statusForWebmasters.push(row);
    },
    statusWebmasterFilter: function statusWebmasterFilter(status) {
      this.statusForWebmasters.forEach(function (item) {
        if (status === parseInt(item.status)) {
          _API2.default.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, 0);
        } else {
          _API2.default.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, status);
        }
      });
      this.webModal = false;
      this.calculateRows();
    },
    statusWebmasterStop: function statusWebmasterStop(status) {
      this.statusForWebmasters.forEach(function (item) {
        if (status === parseInt(item.status)) {
          _API2.default.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, 0);
        } else {
          _API2.default.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, status);
        }
      });
      this.webModal = false;
      this.calculateRows();
    },
    toggleExportHistoryModal: function toggleExportHistoryModal() {
      var _this5 = this;

      this.exportRows = [];
      _API2.default.historyWebmasterStatus().then(function (response) {
        var returnStatusText = function returnStatusText(status) {
          if (+status === 1) {
            return 'Стоп';
          }
          if (+status === 2) {
            return 'Фильтр';
          }
          if (+status === 0) {
            return 'По умолчанию';
          }
        };
        (0, _lodash.map)(response.body, function (d) {
          _this5.exportRows.push({
            user: d.username,
            offer: d.offer,
            webmasters: d.webmaster_id,
            date: d.datetime,
            fix_from: { text: returnStatusText(d.status_from), status: d.status_from },
            fix_to: { text: returnStatusText(d.status_to), status: d.status_to }
          });
        });
      });
      this.exportHistiryModal = true;
    },
    getClassesModal: function getClassesModal(row) {
      var classes = [];
      if (+row === 1) {
        classes.push('stop');
      }
      if (+row === 2) {
        classes.push('filter');
      }
      if (+row === 0) {
        classes.push('default');
      }
      return classes;
    }
  }
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'BuyoutTabs'
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _BuyoutTabs = __webpack_require__(21);

var _BuyoutTabs2 = _interopRequireDefault(_BuyoutTabs);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Buyout',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    BuyoutTabs: _BuyoutTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.courier'), field: 'courier' }, { label: this.$root.$t('statistic.shipped'), field: 'shipped' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }],
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getBuyoutStatistic().then(function (response) {
        var statistic = {};
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        (0, _lodash.map)(response.body, function (d) {
          if (!statistic[d.courier_id]) {
            statistic[d.courier_id] = d;
          } else {
            statistic[d.courier_id].shipped += d.shipped;
            statistic[d.courier_id].paid += d.paid;
            statistic[d.courier_id].return += d.return;
            statistic[d.courier_id].delivered += d.delivered;
            statistic[d.courier_id].transit += d.transit;
            statistic[d.courier_id].approved += d.approved;
            statistic[d.courier_id].total_bill_usd += d.total_bill_usd;
            statistic[d.courier_id].total_bill_local += d.total_bill_local;
          }
        });
        var totalShipped = 0;
        var totalReturn = 0;
        var totalPaid = 0;
        var countReturn = 0;
        var totalTransit = 0;
        var countTransit = 0;
        var totalDelivered = 0;
        var sumAverageBill = 0.0;
        var sumTransit = 0;
        var sumAverageBillLocal = 0.0;
        (0, _lodash.map)(statistic, function (d) {
          _this2.rows.push({
            courier: {
              value: _Helper2.default.getCourierTitle(_Storage2.default.couriers, d.courier_id) + ' ' + (_Storage2.default.developMode ? '(' + d.courier_id + ')' : ''),
              style: { textAlign: 'left' }
            },
            shipped: {
              value: d.shipped,
              bg: true
            },
            delivered: {
              value: d.delivered,
              bg: true
            },
            transit: {
              value: d.transit,
              bgg: _Helper2.default.renderGistPart(d.shipped, d.transit),
              isCollspaned: true
            },
            transitPercents: {
              value: _Helper2.default.percents(d.shipped, d.transit),
              bgg: _Helper2.default.renderGistPart(d.shipped, d.transit, true)
            },
            return: {
              value: d.return,
              bgg: _Helper2.default.renderGistPart(d.shipped, d.return),
              isCollspaned: true
            },
            returnPercents: {
              value: _Helper2.default.percents(d.shipped, d.return),
              bgg: _Helper2.default.renderGistPart(d.shipped, d.return, true)
            },
            buyout: {
              colspan: 2,
              value: _Helper2.default.percents(d.shipped, d.delivered),
              dbgg: [{ name: 'delivered', width: parseFloat(_Helper2.default.percents(d.shipped, d.delivered - d.paid)) }, { name: 'buyout', width: parseFloat(_Helper2.default.percents(d.shipped, d.paid)) }],
              htmlValue: '<p style="display: inline; float: left; margin-left: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered - d.paid) + ' ' + (_Storage2.default.developMode ? '(' + (d.delivered - d.paid) + ')' : '') + '</p> <p style="display: inline; float: right; margin-right: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered) + ' ' + (_Storage2.default.developMode ? '(' + d.paid + ')' : '') + '</p></div>'
            },
            averageBill: {
              value: d.approved > 0 ? '$ ' + (d.total_bill_usd / d.approved).toFixed(2) : '$ 0.0',

              isCollspaned: true
            },
            averageBillLocal: {
              value: d.local_currency.split(',').length === 1 && d.approved > 0 ? (d.total_bill_local / d.approved).toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
            }
          });
          totalShipped += d.shipped;
          totalDelivered += d.delivered;
          if (d.return > 0) {
            totalReturn += d.return;
            countReturn++;
          }
          if (d.paid > 0) {
            totalPaid += d.paid;
          }
          if (d.approved > 0) {
            sumAverageBill += parseFloat(d.total_bill_usd);
            sumTransit += parseInt(d.approved);
            sumAverageBillLocal += parseFloat(d.total_bill_local);
            _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
          }
          if (d.transit > 0) {
            totalTransit += d.transit;
            countTransit++;
          }
        });
        _this2.footColumns = {
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          shipped: {
            value: totalShipped
          },
          delivered: {
            value: totalDelivered
          },
          transit: {
            value: totalTransit + ' (' + _Helper2.default.average(totalTransit, countTransit) + ')'
          },
          transitPercents: {
            value: _Helper2.default.percents(totalShipped, totalTransit)
          },
          return: {
            value: totalReturn + ' (' + _Helper2.default.average(totalReturn, countReturn) + ')'
          },
          returnPercents: {
            value: _Helper2.default.percents(totalShipped, totalReturn)
          },
          buyout: {
            value: _Helper2.default.percents(totalShipped, totalDelivered - totalPaid) + ' (' + (totalDelivered - totalPaid) + ')'
          },
          buyoutPercents: {
            value: _Helper2.default.percents(totalShipped, totalDelivered) + ' (' + totalDelivered + ')'
          },
          averageBill: {
            value: _Helper2.default.averageBillDayCount(sumAverageBill, sumTransit)
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumTransit, _this2.localCurrencySymbol) : '-',
            graph: filterCurrency.length === 1 ? {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: _this2.localCurrencySymbol
            } : false
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _BuyoutTabs = __webpack_require__(21);

var _BuyoutTabs2 = _interopRequireDefault(_BuyoutTabs);

var _AlbhabetScroll = __webpack_require__(19);

var _AlbhabetScroll2 = _interopRequireDefault(_AlbhabetScroll);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Couriers',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    BuyoutTabs: _BuyoutTabs2.default,
    AlphabetScroll: _AlbhabetScroll2.default
  },
  data: function data() {
    return {
      scrollPos: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.offer'), field: 'offer' }, { label: this.$root.$t('statistic.shipped'), field: 'shipped' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }],
      rows: [],
      footColumns: [],
      offers: [],
      alphabet: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  ready: function ready() {
    this.$scrollSet();
  },
  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = {};
      this.footColumns = [];
      this.alphabet = [];
      this.couriers = _Storage2.default.couriers.slice(0);
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getBuyoutStatistic().then(function (response) {
        var statistic = {};
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        (0, _lodash.map)(response.body, function (d) {
          if (!statistic[d.courier_id]) {
            statistic[d.courier_id] = [];
          }
          statistic[d.courier_id].push(d);
        });
        var sortedResponse = (0, _lodash.orderBy)(statistic, [function (i) {
          var title = _Helper2.default.getCourierTitle(_Storage2.default.couriers, i[0].courier_id);
          return !title ? 'A' : title;
        }], ['asc']);
        (0, _lodash.map)(sortedResponse, function (offer, i) {
          var courierId = offer[0].courier_id;
          if (_Helper2.default.getCourierTitle(_Storage2.default.couriers, courierId)[0]) {
            var totalShipped = 0;
            var totalReturn = 0;
            var totalPaid = 0;
            var countReturn = 0;
            var totalTransit = 0;
            var countTransit = 0;
            var totalDelivered = 0;
            var sumAverageBill = 0.0;
            var sumTransit = 0;
            var sumAverageBillLocal = 0.0;
            var letter = _Helper2.default.getCourierTitle(_Storage2.default.couriers, courierId)[0].toUpperCase();
            var letterIndex = (0, _lodash.findIndex)(_this2.alphabet, { letter: letter });
            if (letterIndex === -1) {
              _this2.alphabet.push({
                id: courierId,
                letter: letter,
                count: 1
              });
              _this2.rows[letter] = [];
              i = 0;
            } else {
              _this2.alphabet[letterIndex].count++;
              i = _this2.rows[letter].length;
            }
            _this2.rows[letter][i] = {
              id: courierId,
              cells: []
            };
            (0, _lodash.map)(offer, function (d) {
              _this2.rows[letter][i].cells.push({
                courier: {
                  value: _Helper2.default.getOfferTitle(_Storage2.default.offers, d.offer_id) + ' ' + (_Storage2.default.developMode ? '(' + d.offer_id + ')' : ''),
                  style: { textAlign: 'left' }
                },
                shipped: {
                  value: d.shipped,
                  bg: true
                },
                delivered: {
                  value: d.delivered,
                  bg: true
                },
                transit: {
                  value: d.shipped - d.delivered - d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return),
                  isCollspaned: true
                },
                transitPercents: {
                  value: _Helper2.default.percents(d.shipped, d.shipped - d.delivered - d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return, true)
                },
                return: {
                  value: d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: _Helper2.default.percents(d.shipped, d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return, true)
                },
                buyout: {
                  colspan: 2,
                  value: _Helper2.default.percents(d.shipped, d.delivered),
                  dbgg: [{ name: 'delivered', width: parseFloat(_Helper2.default.percents(d.shipped, d.delivered - d.paid)) }, { name: 'buyout', width: parseFloat(_Helper2.default.percents(d.shipped, d.paid)) }],
                  htmlValue: '<p style="display: inline; float: left; margin-left: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered - d.paid) + ' ' + (_Storage2.default.developMode ? '(' + (d.delivered - d.paid) + ')' : '') + '</p> <p style="display: inline; float: right; margin-right: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered) + ' ' + (_Storage2.default.developMode ? '(' + d.paid + ')' : '') + '</p></div>'
                },
                averageBill: {
                  value: d.approved > 0 ? '$ ' + (d.total_bill_usd / d.approved).toFixed(2) : '$ 0.0'
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length === 1 && d.approved > 0 ? (d.total_bill_local / d.approved).toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
                }
              });
              totalShipped += d.shipped;
              totalDelivered += d.delivered;
              if (d.return > 0) {
                totalReturn += d.return;
                countReturn++;
              }
              if (d.paid > 0) {
                totalPaid += d.paid;
              }
              if (d.approved > 0) {
                sumAverageBill += parseFloat(d.total_bill_usd);
                sumAverageBillLocal += parseFloat(d.total_bill_local);
                sumTransit += parseInt(d.approved);
                _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
              }
              if (d.transit > 0) {
                totalTransit += d.transit;
                countTransit++;
              }
            });
            _this2.footColumns[courierId] = {
              label: {
                value: _this2.$root.$t('statistic.in_total')
              },
              shipped: {
                value: totalShipped
              },
              delivered: {
                value: totalDelivered
              },
              transit: {
                value: totalTransit + ' (' + _Helper2.default.average(totalTransit, countTransit) + ')'
              },
              transitPercents: {
                value: _Helper2.default.percents(totalShipped, totalTransit)
              },
              return: {
                value: totalReturn + ' (' + _Helper2.default.average(totalReturn, countReturn) + ')'
              },
              returnPercents: {
                value: _Helper2.default.percents(totalShipped, totalReturn)
              },
              buyout: {
                value: _Helper2.default.percents(totalShipped, totalDelivered - totalPaid) + ' (' + (totalDelivered - totalPaid) + ')'
              },
              buyoutPercents: {
                value: _Helper2.default.percents(totalShipped, totalDelivered) + ' (' + totalDelivered + ')'
              },
              averageBill: {
                value: _Helper2.default.averageBillDayCount(sumAverageBill, sumTransit)
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumTransit, _this2.localCurrencySymbol) : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: function cb(value) {
                    return _Helper2.default.getRawNumber(value);
                  },
                  symbol: _this2.localCurrencySymbol
                } : false
              }
            };
          }
        });
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        console.log(response);
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _BuyoutTabs = __webpack_require__(21);

var _BuyoutTabs2 = _interopRequireDefault(_BuyoutTabs);

var _AlbhabetScroll = __webpack_require__(19);

var _AlbhabetScroll2 = _interopRequireDefault(_AlbhabetScroll);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Days',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    BuyoutTabs: _BuyoutTabs2.default,
    AlphabetScroll: _AlbhabetScroll2.default
  },
  data: function data() {
    return {
      scrollPos: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.day'), field: 'week' }, { label: this.$root.$t('statistic.shipped'), field: 'shipped' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }],
      rows: [],
      footColumns: [],
      offers: [],
      alphabet: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  ready: function ready() {
    this.$scrollSet();
  },
  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = {};
      this.footColumns = [];
      this.alphabet = [];
      this.couriers = _Storage2.default.couriers.slice(0);
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getBuyoutStatisticByDays().then(function (response) {
        var statistic = {};
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        (0, _lodash.map)(response.body, function (d) {
          if (!statistic[d.courier_id]) {
            statistic[d.courier_id] = [];
          }
          statistic[d.courier_id].push(d);
        });
        var sortedResponse = (0, _lodash.orderBy)(statistic, [function (i) {
          var title = _Helper2.default.getCourierTitle(_Storage2.default.couriers, i[0].courier_id);
          return !title ? 'A' : title;
        }], ['asc']);
        (0, _lodash.map)(sortedResponse, function (offer, i) {
          var courierId = offer[0].courier_id;
          if (_Helper2.default.getCourierTitle(_Storage2.default.couriers, courierId)[0]) {
            var totalShipped = 0;
            var totalReturn = 0;
            var totalPaid = 0;
            var countReturn = 0;
            var totalTransit = 0;
            var countTransit = 0;
            var totalDelivered = 0;
            var sumTransit = 0;
            var sumAverageBill = 0.0;
            var sumAverageBillLocal = 0.0;
            var letter = _Helper2.default.getCourierTitle(_Storage2.default.couriers, courierId)[0].toUpperCase();
            var letterIndex = (0, _lodash.findIndex)(_this2.alphabet, { letter: letter });
            if (letterIndex === -1) {
              _this2.alphabet.push({
                id: courierId,
                letter: letter,
                count: 1
              });
              _this2.rows[letter] = [];
              i = 0;
            } else {
              _this2.alphabet[letterIndex].count++;
              i = _this2.rows[letter].length;
            }
            _this2.rows[letter][i] = {
              id: courierId,
              cells: []
            };
            offer = (0, _lodash.orderBy)(offer, ['week'], ['asc']);
            (0, _lodash.map)(offer, function (d) {
              _this2.rows[letter][i].cells.push({
                date: { value: d.date },
                shipped: {
                  value: d.shipped,
                  bg: true
                },
                delivered: {
                  value: d.delivered,
                  bg: true
                },
                transit: {
                  value: d.shipped - d.delivered - d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return),
                  isCollspaned: true
                },
                transitPercents: {
                  value: _Helper2.default.percents(d.shipped, d.shipped - d.delivered - d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return, true)
                },
                return: {
                  value: d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: _Helper2.default.percents(d.shipped, d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return, true)
                },
                buyout: {
                  colspan: 2,
                  value: _Helper2.default.percents(d.shipped, d.delivered),
                  dbgg: [{ name: 'delivered', width: parseFloat(_Helper2.default.percents(d.shipped, d.delivered - d.paid)) }, { name: 'buyout', width: parseFloat(_Helper2.default.percents(d.shipped, d.paid)) }],
                  htmlValue: '<p style="display: inline; float: left; margin-left: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered - d.paid) + ' ' + (_Storage2.default.developMode ? '(' + (d.delivered - d.paid) + ')' : '') + '</p> <p style="display: inline; float: right; margin-right: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered) + ' ' + (_Storage2.default.developMode ? '(' + d.paid + ')' : '') + '</p></div>'
                },
                averageBill: {
                  value: d.approved > 0 ? '$ ' + (d.total_bill_usd / d.approved).toFixed(2) : '$ 0.0',

                  isCollspaned: true
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length === 1 && d.approved > 0 ? (d.total_bill_local / d.approved).toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
                }
              });
              totalShipped += d.shipped;
              totalDelivered += d.delivered;
              if (d.return > 0) {
                totalReturn += d.return;
                countReturn++;
              }
              if (d.paid > 0) {
                totalPaid += d.paid;
              }
              if (d.transit > 0) {
                totalTransit += d.transit;
                countTransit++;
              }
              if (d.approved > 0) {
                sumTransit += d.approved;
                sumAverageBill += parseFloat(d.total_bill_usd);
                sumAverageBillLocal += parseFloat(d.total_bill_local);
                _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
              }
            });
            _this2.footColumns[courierId] = {
              label: {
                value: _this2.$root.$t('statistic.in_total')
              },
              shipped: {
                value: totalShipped
              },
              delivered: {
                value: totalDelivered
              },
              transit: {
                value: totalTransit + ' (' + _Helper2.default.average(totalTransit, countTransit) + ')'
              },
              transitPercents: {
                value: _Helper2.default.percents(totalShipped, totalTransit)
              },
              return: {
                value: totalReturn + ' (' + _Helper2.default.average(totalReturn, countReturn) + ')'
              },
              returnPercents: {
                value: _Helper2.default.percents(totalShipped, totalReturn)
              },
              buyout: {
                value: _Helper2.default.percents(totalShipped, totalDelivered - totalPaid) + ' (' + (totalDelivered - totalPaid) + ')'
              },
              buyoutPercents: {
                value: _Helper2.default.percents(totalShipped, totalDelivered) + ' (' + totalDelivered + ')'
              },
              averageBill: {
                value: _Helper2.default.averageBillDayCount(sumAverageBill, sumTransit),
                graph: {
                  cb: function cb(value) {
                    return _Helper2.default.getRawNumber(value);
                  },
                  symbol: '$'
                }
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumTransit, _this2.localCurrencySymbol) : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: function cb(value) {
                    return _Helper2.default.getRawNumber(value);
                  },
                  symbol: _this2.localCurrencySymbol
                } : false
              }
            };
          }
        });
        _this2.$root.$emit('data_loaded');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _lodash = __webpack_require__(5);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _BuyoutTabs = __webpack_require__(21);

var _BuyoutTabs2 = _interopRequireDefault(_BuyoutTabs);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

var _TemporaryTable = __webpack_require__(420);

var _TemporaryTable2 = _interopRequireDefault(_TemporaryTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'Flypost',
  components: {
    TemporaryTable: _TemporaryTable2.default,
    BuyoutTabs: _BuyoutTabs2.default,
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true
      },
      Storage: _Storage2.default,
      branchStatistics: false,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      loading: false,
      country: null,
      headColumnsTotal: [{ label: this.$root.$t('statistic.courier'), field: 'courier' }, { label: this.$root.$t('statistic.shipped'), field: 'shipped' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout' }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }],
      headColumns: [{ label: this.$root.$t('statistic.day'), field: 'week' }, { label: this.$root.$t('statistic.shipped'), field: 'shipped' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout' }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }],
      month: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      rows: [],
      rowsTotal: [],
      footColumns: {},
      summary: {},
      totalAllColumns: {},
      offers: [],
      totalCourier: {},
      x: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var offset1 = document.getElementById('swipe1').offsetWidth;
      var scroll1 = document.getElementById('swipe1').scrollWidth;
      var width = scroll - offset;
      var width1 = scroll1 - offset1;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }

        if (width1 > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10;
          } else {
            this.x -= e.distance / 10;
          }
          if (this.x > 0) {
            this.x = 0;
          }
          if (Math.abs(this.x) > width1) {
            this.x = -width1;
          }
        }
      }
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.rows = [];
      this.footColumns = {};
      this.$root.$emit('data_loading');
      this.loading = true;
      _API2.default.getBuyoutStatisticMonth().then(function (response) {
        _this2.rows = _this2.statisticData(response.body);
        _this2.loading = false;
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.loading = false;
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    statisticData: function statisticData(rows) {
      var _this3 = this;

      var newRows = {};
      var totalDeliveredCount1 = {};
      var years = [];
      this.footColumns = {};
      this.totalAllColumns = {};

      var oldArrCurrency = [];
      var newArrCurrency = [];
      var filterCurrency = [];

      var totalShipped = 0;
      var totalReturn = 0;
      var totalPaid = 0;
      var totalDelivered = 0;
      var totalTransit = 0;
      var sumTransit = 0;
      var sumAverageBill = 0.0;
      var sumAverageBillLocal = 0.0;

      var allTotalShipped = 0;
      var allTotalReturn = 0;
      var allTotalPaid = 0;
      var allTotalDelivered = 0;
      var allTotalTransit = 0;
      var allTotalSumTransit = 0;
      var allTotalSumAverageBill = 0.0;
      var allTotalSumAverageBillLocal = 0.0;

      this.offers = _Storage2.default.offers.slice(0);
      this.couriers = _Storage2.default.couriers.slice(0);

      var arrayMonth = [];

      (0, _lodash.map)(rows, function (rowsMonth, indexYear) {
        var _totalDeliveredCount;

        if (!newRows[indexYear]) {
          newRows[indexYear] = {};
          _this3.footColumns[indexYear] = {};
          _this3.totalAllColumns[indexYear] = {};
        }
        years.push(indexYear);
        totalDeliveredCount1 = (_totalDeliveredCount = {}, _defineProperty(_totalDeliveredCount, indexYear, {}), _defineProperty(_totalDeliveredCount, 'rowsMonth', rowsMonth), _defineProperty(_totalDeliveredCount, 'years', years), _totalDeliveredCount);
        (0, _lodash.map)(rowsMonth, function (rowsCourier, indexMonth) {
          arrayMonth.push(indexMonth);
          totalDeliveredCount1[indexYear] = _extends(_defineProperty({}, indexMonth, {}), totalDeliveredCount1[indexYear]);
          for (var courierIndex in rowsCourier) {
            rowsCourier[courierIndex].map(function (courierKey) {
              totalDeliveredCount1[indexYear][indexMonth] = _extends(_defineProperty({}, courierKey.courier_id, {
                courier_name: _Helper2.default.getCourierTitle(_this3.couriers, courierKey.courier_id),
                shipped: 0,
                delivered: 0,
                transit: 0,
                transitPercent: 0.0,
                return: 0,
                returnPercent: 0.0,
                buyout: 0,
                totalLocal: 0.0,
                approved: 0,
                totalBillLocal: 0.0,
                totalBill: 0
              }), totalDeliveredCount1[indexYear][indexMonth]);
            });
          }
          if (!_this3.totalAllColumns[indexYear][indexMonth]) {
            _this3.totalAllColumns[indexYear][indexMonth] = [];
            allTotalShipped = 0;
            allTotalReturn = 0;
            allTotalPaid = 0;
            allTotalDelivered = 0;
            allTotalTransit = 0;
            allTotalSumAverageBill = 0.0;
            allTotalSumAverageBillLocal = 0.0;
          }
          (0, _lodash.map)(rowsCourier, function (rowsData, indexCourier) {
            if (!newRows[indexYear][indexCourier]) {
              newRows[indexYear][indexCourier] = {};
              _this3.footColumns[indexYear][indexCourier] = {};
            }
            if (!newRows[indexYear][indexCourier][indexMonth]) {
              newRows[indexYear][indexCourier][indexMonth] = [];
              _this3.footColumns[indexYear][indexCourier][indexMonth] = [];
            }
            (0, _lodash.map)(arrayMonth, function (perMonth) {
              if (!newRows[indexYear][indexCourier][perMonth]) {
                newRows[indexYear][indexCourier][perMonth] = [];
                _this3.footColumns[indexYear][indexCourier][perMonth] = [];
              }
            });
            totalShipped = 0;
            totalDelivered = 0;
            totalReturn = 0;
            totalPaid = 0;
            totalTransit = 0;
            sumTransit = 0;
            sumAverageBill = 0.0;
            sumAverageBillLocal = 0.0;
            (0, _lodash.map)(rowsData, function (rowsOfferTotal, i) {
              oldArrCurrency.push(rowsOfferTotal.local_currency.split(','));
              oldArrCurrency.forEach(function (array) {
                array.forEach(function (item) {
                  newArrCurrency.push(item);
                });
              });
              filterCurrency = newArrCurrency.filter(function (item, index) {
                return newArrCurrency.indexOf(item) === index;
              });
              totalShipped += parseInt(rowsOfferTotal.shipped);
              totalDelivered += parseInt(rowsOfferTotal.delivered);
              totalReturn += parseInt(rowsOfferTotal.return);
              totalPaid += parseInt(rowsOfferTotal.paid);
              totalTransit += parseInt(rowsOfferTotal.transit);
              if (rowsOfferTotal.approved > 0) {
                sumTransit += rowsOfferTotal.approved;
                sumAverageBill += parseFloat(rowsOfferTotal.average_bill_usd) * rowsOfferTotal.approved;
                sumAverageBillLocal += parseFloat(rowsOfferTotal.average_bill_local) * rowsOfferTotal.approved;
                _this3.localCurrencySymbol = (0, _currencySymbolMap2.default)(rowsOfferTotal.local_currency);
              }
            });
            allTotalShipped += parseInt(totalShipped);
            allTotalDelivered += parseInt(totalDelivered);
            allTotalReturn += parseInt(totalReturn);
            allTotalPaid += parseInt(totalPaid);
            allTotalTransit += parseInt(totalTransit);
            allTotalSumTransit += parseFloat(sumTransit);
            allTotalSumAverageBill += parseFloat(sumAverageBill);
            allTotalSumAverageBillLocal += parseFloat(sumAverageBillLocal);
            (0, _lodash.map)(rowsData, function (rowsOffer) {
              newRows[indexYear][indexCourier][indexMonth].push({
                courier: {
                  value: _Helper2.default.getCourierTitle(_this3.couriers, rowsOffer.courier_id),
                  indexCourier: rowsOffer.courier_id,
                  indexMonth: indexMonth
                },
                shipped: {
                  value: rowsOffer.shipped,
                  bg: true
                },
                delivered: {
                  value: rowsOffer.delivered,
                  bg: true
                },
                transit: {
                  value: rowsOffer.shipped - rowsOffer.delivered - rowsOffer.return
                },
                transitPercents: {
                  value: _Helper2.default.percents(rowsOffer.shipped, rowsOffer.shipped - rowsOffer.delivered - rowsOffer.return)
                },
                return: {
                  value: rowsOffer.return
                },
                returnPercents: {
                  value: _Helper2.default.percents(rowsOffer.shipped, rowsOffer.return)
                },
                buyout: {
                  value: _Helper2.default.percents(rowsOffer.shipped, rowsOffer.delivered)
                },
                averageBill: {
                  value: '$ ' + rowsOffer.average_bill_usd.toFixed(2)
                },
                averageBillLocal: {
                  value: rowsOffer.local_currency.split(',').length === 1 && rowsOffer.average_bill_local > 0 ? rowsOffer.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(rowsOffer.local_currency) : '-'
                }
              });
            });
            _this3.footColumns[indexYear][indexCourier][indexMonth].push({
              label: {
                value: _this3.$root.$t('statistic.in_total')
              },
              shipped: {
                value: totalShipped
              },
              delivered: {
                value: totalDelivered
              },
              transit: {
                value: totalTransit
              },
              transitPercents: {
                value: _Helper2.default.percents(totalShipped, totalTransit)
              },
              return: {
                value: totalReturn
              },
              returnPercents: {
                value: _Helper2.default.percents(totalShipped, totalReturn)
              },
              buyout: {
                value: _Helper2.default.percents(totalShipped, totalDelivered)
              },
              averageBill: {
                value: _Helper2.default.averageBillDayCount(sumAverageBill, sumTransit)
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumTransit, _this3.localCurrencySymbol) : '-'
              }
            });
          });
          _this3.totalAllColumns[indexYear][indexMonth].push({
            label: {
              value: _this3.$root.$t('statistic.in_total'),
              width: '14%'
            },
            shipped: {
              value: allTotalShipped,
              width: '12%'
            },
            delivered: {
              value: allTotalDelivered,
              width: '15%'
            },
            transit: {
              value: allTotalTransit,
              width: '13%'
            },
            transitPercents: {
              value: _Helper2.default.percents(allTotalShipped, allTotalTransit),
              width: '5%'
            },
            return: {
              value: allTotalReturn,
              width: '7%'
            },
            returnPercents: {
              value: _Helper2.default.percents(allTotalShipped, allTotalReturn),
              bg: true,
              width: '10%'
            },
            buyout: {
              value: _Helper2.default.percents(allTotalShipped, allTotalDelivered),
              bg: true,
              width: '10%'
            },
            averageBill: {
              value: _Helper2.default.averageBillDayCount(allTotalSumAverageBill, allTotalSumTransit),
              width: '13%'
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(allTotalSumAverageBillLocal, allTotalSumTransit, _this3.localCurrencySymbol) : '-',
              width: '13%'
            }
          });
        });
        if (totalDeliveredCount1.years) {
          totalDeliveredCount1.years.map(function (year) {
            var _loop = function _loop(key) {
              var month = key;
              var company = totalDeliveredCount1.rowsMonth[key];
              for (var _key in company) {
                company[_key].map(function (courierId) {
                  _this3.localCurrencySymbol = (0, _currencySymbolMap2.default)(courierId.local_currency);

                  totalDeliveredCount1[year][month][courierId.courier_id].shipped += parseInt(courierId.shipped);
                  totalDeliveredCount1[year][month][courierId.courier_id].delivered += parseInt(courierId.delivered);
                  totalDeliveredCount1[year][month][courierId.courier_id].transit += parseInt(courierId.transit);
                  totalDeliveredCount1[year][month][courierId.courier_id].transitPercent = _Helper2.default.percents(totalDeliveredCount1[year][month][courierId.courier_id].shipped, totalDeliveredCount1[year][month][courierId.courier_id].transit);
                  totalDeliveredCount1[year][month][courierId.courier_id].return += parseInt(courierId.return);
                  totalDeliveredCount1[year][month][courierId.courier_id].returnPercent = _Helper2.default.percents(totalDeliveredCount1[year][month][courierId.courier_id].shipped, totalDeliveredCount1[year][month][courierId.courier_id].return);
                  totalDeliveredCount1[year][month][courierId.courier_id].buyout = _Helper2.default.percents(totalDeliveredCount1[year][month][courierId.courier_id].shipped, totalDeliveredCount1[year][month][courierId.courier_id].delivered);

                  totalDeliveredCount1[year][month][courierId.courier_id].totalBill += parseFloat(courierId.total_bill_usd);
                  totalDeliveredCount1[year][month][courierId.courier_id].totalBillLocal += parseFloat(courierId.total_bill_local);
                  totalDeliveredCount1[year][month][courierId.courier_id].approved += parseInt(courierId.approved);
                  totalDeliveredCount1[year][month][courierId.courier_id].totalLocal = totalDeliveredCount1[year][month][courierId.courier_id].totalBillLocal;
                  totalDeliveredCount1[year][month][courierId.courier_id].totalLocal = filterCurrency.length === 1 && totalDeliveredCount1[year][month][courierId.courier_id].approved > 0 ? _Helper2.default.newLocalAverageBill(totalDeliveredCount1[year][month][courierId.courier_id].totalBillLocal, totalDeliveredCount1[year][month][courierId.courier_id].approved, _this3.localCurrencySymbol) : '-';
                });
              }
            };

            for (var key in totalDeliveredCount1.rowsMonth) {
              _loop(key);
            }
          });
        }
      });
      this.totalCourier = totalDeliveredCount1;
      return newRows;
    }
  }
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _BuyoutTabs = __webpack_require__(21);

var _BuyoutTabs2 = _interopRequireDefault(_BuyoutTabs);

var _AlbhabetScroll = __webpack_require__(19);

var _AlbhabetScroll2 = _interopRequireDefault(_AlbhabetScroll);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Offer',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    BuyoutTabs: _BuyoutTabs2.default,
    AlphabetScroll: _AlbhabetScroll2.default
  },
  data: function data() {
    return {
      scrollPos: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.courier'), field: 'courier' }, { label: this.$root.$t('statistic.shipped'), field: 'shipped' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }],
      rows: [],
      footColumns: [],
      offers: [],
      alphabet: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  ready: function ready() {
    this.$scrollSet();
  },
  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = {};
      this.footColumns = [];
      this.alphabet = [];
      this.offers = _Storage2.default.offers.slice(0);
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getBuyoutStatistic().then(function (response) {
        var statistic = {};
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        (0, _lodash.map)(response.body, function (d) {
          if (!statistic[d.offer_id]) {
            statistic[d.offer_id] = [];
          }
          statistic[d.offer_id].push(d);
        });
        var sortedResponse = (0, _lodash.orderBy)(statistic, [function (i) {
          var title = _Helper2.default.getOfferTitle(_Storage2.default.offers, i[0].offer_id);
          return !title ? 'A' : title;
        }], ['asc']);
        (0, _lodash.map)(sortedResponse, function (offer, i) {
          var offerId = offer[0].offer_id;
          if (_Helper2.default.getOfferTitle(_Storage2.default.offers, offerId)[0]) {
            var totalShipped = 0;
            var totalReturn = 0;
            var totalPaid = 0;
            var countReturn = 0;
            var totalTransit = 0;
            var countTransit = 0;
            var totalDelivered = 0;
            var sumAverageBill = 0.0;
            var sumTransit = 0;
            var sumAverageBillLocal = 0.0;
            var letter = _Helper2.default.getOfferTitle(_Storage2.default.offers, offerId)[0].toUpperCase();
            var letterIndex = (0, _lodash.findIndex)(_this2.alphabet, { letter: letter });
            if (letterIndex === -1) {
              _this2.alphabet.push({
                id: offerId,
                letter: letter,
                count: 1
              });
              _this2.rows[letter] = [];
              i = 0;
            } else {
              _this2.alphabet[letterIndex].count++;
              i = _this2.rows[letter].length;
            }
            _this2.rows[letter][i] = {
              id: offerId,
              cells: []
            };
            (0, _lodash.map)(offer, function (d) {
              _this2.rows[letter][i].cells.push({
                courier: {
                  value: _Helper2.default.getCourierTitle(_Storage2.default.couriers, d.courier_id) + ' ' + (_Storage2.default.developMode ? '(' + d.courier_id + ')' : ''),
                  style: { textAlign: 'left' }
                },
                shipped: {
                  value: d.shipped,
                  bg: true
                },
                delivered: {
                  value: d.delivered,
                  bg: true
                },
                transit: {
                  value: d.shipped - d.delivered - d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return),
                  isCollspaned: true
                },
                transitPercents: {
                  value: _Helper2.default.percents(d.shipped, d.shipped - d.delivered - d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return, true)
                },
                return: {
                  value: d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: _Helper2.default.percents(d.shipped, d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return, true)
                },
                buyout: {
                  colspan: 2,
                  value: _Helper2.default.percents(d.shipped, d.delivered),
                  dbgg: [{ name: 'delivered', width: parseFloat(_Helper2.default.percents(d.shipped, d.delivered - d.paid)) }, { name: 'buyout', width: parseFloat(_Helper2.default.percents(d.shipped, d.paid)) }],
                  htmlValue: '<p style="display: inline; float: left; margin-left: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered - d.paid) + ' ' + (_Storage2.default.developMode ? '(' + (d.delivered - d.paid) + ')' : '') + '</p> <p style="display: inline; float: right; margin-right: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered) + ' ' + (_Storage2.default.developMode ? '(' + d.paid + ')' : '') + '</p></div>'
                },
                averageBill: {
                  value: d.approved > 0 ? '$ ' + (d.total_bill_usd / d.approved).toFixed(2) : '$ 0.0'
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length === 1 && d.approved > 0 ? (d.total_bill_local / d.approved).toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
                }
              });
              totalShipped += d.shipped;
              totalDelivered += d.delivered;
              if (d.return > 0) {
                totalReturn += d.return;
                countReturn++;
              }
              if (d.paid > 0) {
                totalPaid += d.paid;
              }
              if (d.approved > 0) {
                sumAverageBill += parseFloat(d.total_bill_usd);
                sumAverageBillLocal += parseFloat(d.total_bill_local);
                sumTransit += parseInt(d.approved);
                _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
              }
              if (d.transit > 0) {
                totalTransit += d.transit;
                countTransit++;
              }
            });
            _this2.footColumns[offerId] = {
              label: {
                value: _this2.$root.$t('statistic.in_total')
              },
              shipped: {
                value: totalShipped
              },
              delivered: {
                value: totalDelivered
              },
              transit: {
                value: totalTransit + ' (' + _Helper2.default.average(totalTransit, countTransit) + ')'
              },
              transitPercents: {
                value: _Helper2.default.percents(totalShipped, totalTransit)
              },
              return: {
                value: totalReturn + ' (' + _Helper2.default.average(totalReturn, countReturn) + ')'
              },
              returnPercents: {
                value: _Helper2.default.percents(totalShipped, totalReturn)
              },
              buyout: {
                value: _Helper2.default.percents(totalShipped, totalDelivered - totalPaid) + ' (' + (totalDelivered - totalPaid) + ')'
              },
              buyoutPercents: {
                value: _Helper2.default.percents(totalShipped, totalDelivered) + ' (' + totalDelivered + ')'
              },
              averageBill: {
                value: _Helper2.default.averageBillDayCount(sumAverageBill, sumTransit)
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumTransit, _this2.localCurrencySymbol) : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: function cb(value) {
                    return _Helper2.default.getRawNumber(value);
                  },
                  symbol: _Storage2.default.selectedCountry.currency_symbol
                } : false
              }
            };
          }
        });
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        console.log(response);
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _BuyoutTabs = __webpack_require__(21);

var _BuyoutTabs2 = _interopRequireDefault(_BuyoutTabs);

var _AlbhabetScroll = __webpack_require__(19);

var _AlbhabetScroll2 = _interopRequireDefault(_AlbhabetScroll);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Week',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    BuyoutTabs: _BuyoutTabs2.default,
    AlphabetScroll: _AlbhabetScroll2.default
  },
  data: function data() {
    return {
      scrollPos: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.week'), field: 'week' }, { label: this.$root.$t('statistic.shipped'), field: 'shipped' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }],
      rows: [],
      footColumns: [],
      offers: [],
      alphabet: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  ready: function ready() {
    this.$scrollSet();
  },
  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = {};
      this.footColumns = [];
      this.alphabet = [];
      this.couriers = _Storage2.default.couriers.slice(0);
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getBuyoutStatisticByWeeks().then(function (response) {
        var statistic = {};
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        (0, _lodash.map)(response.body, function (d) {
          if (!statistic[d.courier_id]) {
            statistic[d.courier_id] = [];
          }
          statistic[d.courier_id].push(d);
        });

        var sortedResponse = (0, _lodash.orderBy)(statistic, [function (i) {
          var title = _Helper2.default.getCourierTitle(_Storage2.default.couriers, i[0].courier_id);
          return !title ? 'A' : title;
        }], ['asc']);
        (0, _lodash.map)(sortedResponse, function (offer, i) {
          var courierId = offer[0].courier_id;
          if (_Helper2.default.getCourierTitle(_Storage2.default.couriers, courierId)[0]) {
            var totalShipped = 0;
            var totalReturn = 0;
            var totalPaid = 0;
            var countReturn = 0;
            var totalTransit = 0;
            var countTransit = 0;
            var totalDelivered = 0;
            var sumTransit = 0;
            var sumAverageBill = 0.0;
            var sumAverageBillLocal = 0.0;
            var letter = _Helper2.default.getCourierTitle(_Storage2.default.couriers, courierId)[0].toUpperCase();
            var letterIndex = (0, _lodash.findIndex)(_this2.alphabet, { letter: letter });
            if (letterIndex === -1) {
              _this2.alphabet.push({
                id: courierId,
                letter: letter,
                count: 1
              });
              _this2.rows[letter] = [];
              i = 0;
            } else {
              _this2.alphabet[letterIndex].count++;
              i = _this2.rows[letter].length;
            }
            _this2.rows[letter][i] = {
              id: courierId,
              cells: []
            };
            offer = (0, _lodash.orderBy)(offer, ['week'], ['asc']);
            (0, _lodash.map)(offer, function (d) {
              var year = new Date().getFullYear();
              var dateStart = _Helper2.default.getDateOfISOWeek(d.week, year);
              var monthName = new Date(dateStart).toLocaleString(_Storage2.default.language, { month: 'short' });
              var startString = dateStart.getDate() + ' ' + monthName;
              var dateEnd = dateStart.setDate(dateStart.getDate() + 6);
              dateEnd = new Date(dateEnd);
              var endString = dateEnd.getDate() + ' ' + dateEnd.toLocaleString(_Storage2.default.language, { month: 'short' });
              _this2.rows[letter][i].cells.push({
                week: { value: startString + ' - ' + endString },
                shipped: {
                  value: d.shipped,
                  bg: true
                },
                delivered: {
                  value: d.delivered,
                  bg: true
                },
                transit: {
                  value: d.shipped - d.delivered - d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return),
                  isCollspaned: true
                },
                transitPercents: {
                  value: _Helper2.default.percents(d.shipped, d.shipped - d.delivered - d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.shipped - d.delivered - d.return, true)
                },
                return: {
                  value: d.return,
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: _Helper2.default.percents(d.shipped, d.return),
                  bgg: _Helper2.default.renderGistPart(d.shipped, d.return, true)
                },
                buyout: {
                  colspan: 2,
                  value: _Helper2.default.percents(d.shipped, d.delivered),
                  dbgg: [{ name: 'delivered', width: parseFloat(_Helper2.default.percents(d.shipped, d.delivered - d.paid)) }, { name: 'buyout', width: parseFloat(_Helper2.default.percents(d.shipped, d.paid)) }],
                  htmlValue: '<p style="display: inline; float: left; margin-left: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered - d.paid) + ' ' + (_Storage2.default.developMode ? '(' + (d.delivered - d.paid) + ')' : '') + '</p> <p style="display: inline; float: right; margin-right: 5px; margin-bottom: 0;">' + _Helper2.default.percents(d.shipped, d.delivered) + ' ' + (_Storage2.default.developMode ? '(' + d.paid + ')' : '') + '</p></div>'
                },
                averageBill: {
                  value: d.approved > 0 ? '$ ' + (d.total_bill_usd / d.approved).toFixed(2) : '$ 0.0',

                  isCollspaned: true
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length === 1 && d.approved > 0 ? (d.total_bill_local / d.approved).toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
                }
              });
              totalShipped += d.shipped;
              totalDelivered += d.delivered;
              if (d.return > 0) {
                totalReturn += d.return;
                countReturn++;
              }
              if (d.paid > 0) {
                totalPaid += d.paid;
              }
              if (d.transit > 0) {
                totalTransit += d.transit;
                countTransit++;
              }
              if (d.approved > 0) {
                sumTransit += d.approved;
                sumAverageBill += parseFloat(d.total_bill_usd);
                sumAverageBillLocal += parseFloat(d.total_bill_local);
                _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
              }
            });
            _this2.footColumns[courierId] = {
              label: {
                value: _this2.$root.$t('statistic.in_total')
              },
              shipped: {
                value: totalShipped
              },
              delivered: {
                value: totalDelivered
              },
              transit: {
                value: totalTransit + ' (' + _Helper2.default.average(totalTransit, countTransit) + ')'
              },
              transitPercents: {
                value: _Helper2.default.percents(totalShipped, totalTransit)
              },
              return: {
                value: totalReturn + ' (' + _Helper2.default.average(totalReturn, countReturn) + ')'
              },
              returnPercents: {
                value: _Helper2.default.percents(totalShipped, totalReturn)
              },
              buyout: {
                value: _Helper2.default.percents(totalShipped, totalDelivered - totalPaid) + ' (' + (totalDelivered - totalPaid) + ')'
              },
              buyoutPercents: {
                value: _Helper2.default.percents(totalShipped, totalDelivered) + ' (' + totalDelivered + ')'
              },
              averageBill: {
                value: _Helper2.default.averageBillDayCount(sumAverageBill, sumTransit),
                graph: {
                  cb: function cb(value) {
                    return _Helper2.default.getRawNumber(value);
                  },
                  symbol: '$'
                }
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumTransit, _this2.localCurrencySymbol) : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: function cb(value) {
                    return _Helper2.default.getRawNumber(value);
                  },
                  symbol: _Storage2.default.selectedCountry.currency_symbol
                } : false
              }
            };
          }
        });
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        console.log(response);
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _ConversionsTabs = __webpack_require__(18);

var _ConversionsTabs2 = _interopRequireDefault(_ConversionsTabs);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'Buyout',
  components: {
    Filters: _Filters2.default,
    ConversionsTabs: _ConversionsTabs2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      scrollPos: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.sets'), field: 'date', width: '200px' }, { label: this.$root.$t('statistic.cross_sell_cost'), field: 'cross_sell_cost', colspan: 2 }, { label: this.$root.$t('statistic.orders_accepted'), field: 'orders_accepted' }, { label: this.$root.$t('statistic.proportion'), field: 'proportion' }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2 }],
      rows: [],
      data: [],
      footColumns: {},
      offers: [],
      alphabet: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var findGoodsItem;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$root.$emit('data_loading');
                this.rows = [];
                this.footColumns = {};
                findGoodsItem = [];
                _context.next = 6;
                return _API2.default.getGoodsMain().then(function (response) {
                  findGoodsItem = response.body;
                });

              case 6:
                _context.next = 8;
                return _API2.default.getConversionsBuyoutStatistic().then(function (response) {
                  var sumTotalBillCross = 0.0;
                  var sumTotalLocalCross = 0.0;
                  var sumTotalBill = 0.0;
                  var sumTotalBillLocal = 0.0;
                  var sumTotalBuyout = 0.0;
                  var sumTotalBuyoutLocal = 0.0;
                  var sumApproved = 0;
                  var sumTotalRefunded = 0;
                  var sumTotalPaid = 0;
                  var oldArrCurrency = [];
                  var newArrCurrency = [];
                  var resultAverage = function resultAverage(billCost, approvedCost) {
                    return billCost > 0 ? '$ ' + (billCost / approvedCost).toFixed(2) : '$ 0.00';
                  };
                  var resultAverageLocal = function resultAverageLocal(localCost, localApproved, currency, currencyItem) {
                    return localCost > 0 && currency === 1 ? (localCost / localApproved).toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(currencyItem) : '-';
                  };
                  (0, _lodash.map)(response.data, function (d) {
                    oldArrCurrency.push(d.local_currency.split(','));
                    oldArrCurrency.forEach(function (array) {
                      array.forEach(function (item) {
                        newArrCurrency.push(item);
                      });
                    });
                  });
                  var filterCurrency = newArrCurrency.filter(function (item, index) {
                    return newArrCurrency.indexOf(item) === index;
                  });
                  var approvedSum = 0;
                  (0, _lodash.map)(response.data, function (d) {
                    approvedSum += d.approved;
                  });
                  (0, _lodash.map)(response.data, function (d) {
                    var resultStr = d.combination.map(function (x) {
                      return x.quantity + ' ' + _Helper2.default.getGoodNameById(findGoodsItem, x.good_id);
                    });
                    _this2.rows.push({
                      goods: {
                        value: resultStr.join(' + ')
                      },
                      cross_sell_cost: {
                        value: resultAverage(d.total_bill_cross_usd, d.approved),
                        bg: true
                      },
                      cross_sell_local: {
                        value: resultAverageLocal(d.total_bill_cross_local, d.approved, d.local_currency.split(',').length, d.local_currency)
                      },
                      orders_accepted: {
                        value: d.approved,
                        bg: true
                      },
                      proportion: {
                        value: _Helper2.default.percents(approvedSum, d.approved)
                      },
                      averageBill: {
                        value: resultAverage(d.total_bill_usd, d.approved)
                      },
                      averageBillLocal: {
                        value: resultAverageLocal(d.total_bill_local, d.approved, d.local_currency.split(',').length, d.local_currency)
                      },
                      averageBuyback: {
                        value: resultAverage(d.total_buyout_usd, d.paid)
                      },
                      averageBuybackLocal: {
                        value: resultAverageLocal(d.total_buyout_local, d.paid, d.local_currency.split(',').length, d.local_currency)
                      },
                      return: {
                        value: d.refunded,
                        bgg: _Helper2.default.renderGistPart(d.approved, d.refunded),
                        isCollspaned: true
                      },
                      returnPercent: {
                        value: _Helper2.default.percents(d.approved, d.refunded),
                        bgg: _Helper2.default.renderGistPart(d.approved, d.refunded, true)
                      },
                      buyout: {
                        value: d.paid,
                        bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
                        isCollspaned: true
                      },
                      buyoutPercent: {
                        value: _Helper2.default.percents(d.approved, d.paid),
                        bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true)
                      }
                    });
                    sumApproved += d.approved;
                    if (d.total_bill_cross_usd > 0) {
                      sumTotalBillCross += d.total_bill_cross_usd;
                    }
                    if (d.total_bill_cross_local > 0) {
                      sumTotalLocalCross += d.total_bill_cross_local;
                    }
                    if (d.total_bill_usd > 0) {
                      sumTotalBill += d.total_bill_usd;
                    }
                    if (d.total_bill_local > 0) {
                      sumTotalBillLocal += d.total_bill_local;
                    }
                    if (d.total_buyout_usd > 0) {
                      sumTotalBuyout += d.total_buyout_usd;
                    }
                    if (d.total_buyout_local > 0) {
                      sumTotalBuyoutLocal += d.total_buyout_local;
                    }
                    if (d.refunded > 0) {
                      sumTotalRefunded += d.refunded;
                    }
                    if (d.paid > 0) {
                      sumTotalPaid += d.paid;
                    }
                    _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
                  });
                  _this2.footColumns = {
                    label: {
                      value: _this2.$root.$t('statistic.in_total')
                    },
                    cross_sell_cost: {
                      value: resultAverage(sumTotalBillCross, sumApproved)
                    },
                    cross_sell_local: {
                      value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumTotalLocalCross, sumApproved, _this2.localCurrencySymbol) : '-'
                    },
                    orders_accepted: {
                      value: '' + sumApproved
                    },
                    proportion: {
                      value: null
                    },
                    averageBill: {
                      value: resultAverage(sumTotalBill, sumApproved)
                    },
                    averageBillLocal: {
                      value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumTotalBillLocal, sumApproved, _this2.localCurrencySymbol) : '-'
                    },
                    averageBuyback: {
                      value: resultAverage(sumTotalBuyout, sumTotalPaid)
                    },
                    averageBuybackLocal: {
                      value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumTotalBuyoutLocal, sumTotalPaid, _this2.localCurrencySymbol) : '-'
                    },
                    return: {
                      value: sumTotalRefunded
                    },
                    returnPercents: {
                      value: _Helper2.default.percents(sumApproved, sumTotalRefunded)
                    },
                    paid: {
                      value: sumTotalPaid
                    },
                    paidPercents: {
                      value: _Helper2.default.percents(sumApproved, sumTotalPaid)
                    }
                  };
                  _this2.$root.$emit('data_loaded');
                }).catch(function (response) {
                  _this2.$root.$emit('data_loaded');
                  _this2.$notify({
                    type: 'danger',
                    title: _this2.$root.$t('verbs.error'),
                    text: !response.body.message ? response.body : response.body.message,
                    animationType: 'velocity'
                  });
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }()
  }
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ConversionsTabs'
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _ConversionsTabs = __webpack_require__(18);

var _ConversionsTabs2 = _interopRequireDefault(_ConversionsTabs);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Country',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    ConversionsTabs: _ConversionsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.date'), field: 'date', width: '120px' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2 }, { label: this.$root.$t('statistic.accepted'), field: 'accepted' }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2 }, { label: this.$root.$t('statistic.approve'), field: 'approve', width: '50px' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }, { label: this.$root.$t('statistic.ad_approved'), field: 'ad_approved' }, { label: this.$root.$t('statistic.ad_pre_approved'), field: 'ad_pre_approved' }, { label: this.$root.$t('statistic.ad_difference'), field: 'ad_difference' }],
      rows: [],
      rowsReason: [],
      footColumns: {},
      footColumnsReason: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    newCurrencyHistory: function newCurrencyHistory(currency) {
      return new Promise(function (resolve, reject) {
        var currencyHistory = [];
        _API2.default.getCurrencyHistory(currency).then(function (response) {
          if (response.status === 200) {
            currencyHistory = response.body;
            resolve(currencyHistory);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getConversionsCountryStatistic().then(function (response) {
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });

        _this2.newCurrencyHistory(filterCurrency).then(function (valueCurrency) {
          var localCurrency = function localCurrency(date, currency) {
            var localValueCurrency = valueCurrency.find(function (item) {
              if (item.date === date && item.currency === currency) {
                return item;
              }
            });
            if (localValueCurrency) {
              return localValueCurrency.value;
            }
          };

          var sumTotal = 0;
          var sumProcessed = 0;
          var countProcessed = 0;
          var sumAccepted = 0;
          var countAccepted = 0;
          var sumCanceled = 0;
          var countCanceled = 0;
          var sumError = 0;
          var countError = 0;
          var sumReturn = 0;
          var countReturn = 0;
          var sumPaid = 0;
          var countPaid = 0;
          var sumAverageBillLocal = 0.0;
          var sumAverageBuybackLocal = 0.0;
          var sumAverageBill = 0.0;
          var sumAverageBuyback = 0.0;
          var sumAdApproved = 0;
          var sumAdPreApproved = 0;
          var sumAdDifference = 0;
          var count = Object.keys(response.data).length;

          (0, _lodash.map)(response.data, function (d, index) {
            var isAverageBillUsd = !!d.average_bill_usd;
            var isAverageBillLocal = !!d.average_bill_local;
            var isAverageBuyoutUsd = !!d.average_buyout_usd;
            var isAverageBuyoutLocal = !!d.average_buyout_local;

            _this2.rows.push({
              date: {
                value: d.date,
                colouredDayOff: true
              },
              total: {
                value: d.total,
                bg: true
              },
              processed: {
                value: d.processed,
                bg: true,
                bgg: _Helper2.default.renderGistPart(d.total, d.processed),
                isCollspaned: true
              },
              processedPercent: {
                value: _Helper2.default.percents(d.total, d.processed),
                bgg: _Helper2.default.renderGistPart(d.total, d.processed, true)
              },
              accepted: {
                value: d.approved,
                bg: true
              },
              canceled: {
                value: d.canceled,
                bgg: _Helper2.default.renderGistPart(d.total, d.canceled),
                isCollspaned: true,
                popup: true,
                id: index,
                date: d.date
              },
              canceledPercents: {
                value: _Helper2.default.percents(d.total, d.canceled),
                bgg: _Helper2.default.renderGistPart(d.total, d.canceled, true)
              },
              error: {
                value: d.error,
                bgg: _Helper2.default.renderGistPart(d.total, d.error),
                isCollspaned: true
              },
              errorPercents: {
                value: _Helper2.default.percents(d.total, d.error),
                bgg: _Helper2.default.renderGistPart(d.total, d.error, true)
              },
              return: {
                value: d.return,
                bgg: _Helper2.default.renderGistPart(d.approved, d.return),
                isCollspaned: true
              },
              returnPercents: {
                value: _Helper2.default.percents(d.approved, d.return),
                bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
              },
              paid: {
                value: d.paid,
                bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
                isCollspaned: true
              },
              paidPercents: {
                value: _Helper2.default.percents(d.approved, d.paid),
                bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true)
              },
              averageBill: {
                value: '$ ' + d[isAverageBillUsd ? 'average_bill_usd' : 'average_bill'].toFixed(2),

                isCollspaned: true
              },
              averageBillLocal: {
                value: d.local_currency.split(',').length !== 2 && localCurrency(d.date, d.local_currency) ? '' + _Helper2.default.newAverageBillDay(isAverageBillLocal ? d.average_bill_local : d.average_bill, localCurrency(d.date, d.local_currency), (0, _currencySymbolMap2.default)(d.local_currency)) : '-'
              },
              averageBuyback: {
                value: '$ ' + d[isAverageBuyoutUsd ? 'average_buyout_usd' : 'average_buyout'].toFixed(2),
                isCollspaned: true
              },
              averageBuybackLocal: {
                value: d.local_currency.split(',').length !== 2 && localCurrency(d.date, d.local_currency) ? '' + _Helper2.default.newAverageBillDay(isAverageBuyoutLocal ? d.average_buyout_local : d.average_buyout, localCurrency(d.date, d.local_currency), (0, _currencySymbolMap2.default)(d.local_currency)) : '-'
              },
              approve: {
                value: _Helper2.default.percents(d.total, d.approved),
                bgg: _Helper2.default.renderSingleGist(d.total, d.approved)
              },
              approvedFromValid: {
                value: d.approved_from_valid.toFixed(1) + '%'
              },
              ad_approved: {
                value: d.ad_approved ? Number(d.ad_approved.toFixed(2)) : 0
              },
              ad_pre_approved: {
                value: d.ad_pre_approved ? Number(d.ad_pre_approved.toFixed(2)) : 0
              },
              ad_difference: {
                value: isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : Number((d.ad_approved - d.ad_pre_approved).toFixed(2))
              }
            });
            sumTotal += d.total;
            if (d.processed > 0) {
              sumProcessed += d.processed;
              countProcessed++;
            }
            if (d.approved) {
              sumAccepted += parseInt(d.approved);
              countAccepted++;
            }
            if (d.approved > 0) {
              sumAverageBill += parseFloat(d.average_bill) * d.approved;
              sumAverageBuyback += parseFloat(d.average_buyout) * d.paid;
              sumAverageBillLocal += d.average_bill * localCurrency(d.date, d.local_currency) * d.approved;
              sumAverageBuybackLocal += parseFloat(d.average_buyout * localCurrency(d.date, d.local_currency)) * d.paid;
              _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
            }
            if (d.canceled > 0) {
              sumCanceled += d.canceled;
              countCanceled++;
            }
            if (d.error > 0) {
              sumError += d.error;
              countError++;
            }
            if (d.return > 0) {
              sumReturn += d.return;
              countReturn++;
            }
            if (d.paid > 0) {
              sumPaid += d.paid;
              countPaid++;
            }
            if (d.ad_approved > 0) {
              sumAdApproved += parseInt(d.ad_approved);
            }
            if (d.ad_pre_approved > 0) {
              sumAdPreApproved += parseInt(d.ad_pre_approved);
            }

            sumAdDifference += isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : d.ad_approved - d.ad_pre_approved;
          });
          _this2.footColumns = {
            label: {
              value: _this2.$root.$t('statistic.in_total')
            },
            total: {
              value: sumTotal + ' (' + _Helper2.default.average(sumTotal, count) + ')',
              graph: true
            },
            processed: {
              value: sumProcessed + ' (' + _Helper2.default.average(sumProcessed, countProcessed) + ')',
              graph: true
            },
            processedPercent: {
              value: _Helper2.default.percents(sumTotal, sumProcessed)
            },
            accepted: {
              value: sumAccepted + ' (' + _Helper2.default.average(sumAccepted, countAccepted) + ')',
              graph: true
            },
            canceled: {
              value: sumCanceled + ' (' + _Helper2.default.average(sumCanceled, countCanceled) + ')',
              graph: true
            },
            canceledPercents: {
              value: _Helper2.default.percents(sumTotal, sumCanceled),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            error: {
              value: sumError + ' (' + _Helper2.default.average(sumError, countError) + ')',
              graph: true
            },
            errorPercents: {
              value: _Helper2.default.percents(sumTotal, sumError),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            return: {
              value: sumReturn + ' (' + _Helper2.default.average(sumReturn, countReturn) + ')',
              graph: true
            },
            returnPercents: {
              value: _Helper2.default.percents(sumAccepted, sumReturn),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            paid: {
              value: sumPaid + ' (' + _Helper2.default.average(sumPaid, countPaid) + ')',
              graph: true
            },
            paidPercents: {
              value: _Helper2.default.percents(sumAccepted, sumPaid),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            averageBill: {
              value: _Helper2.default.averageBillDayCount(sumAverageBill, sumAccepted),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '$'
              }
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? '' + _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumAccepted, _this2.localCurrencySymbol) : '-',
              graph: filterCurrency.length === 1 ? {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: _this2.localCurrencySymbol
              } : false
            },
            averageBuyback: {
              value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '$'
              }
            },
            averageBuybackLocal: {
              value: filterCurrency.length === 1 ? '' + _Helper2.default.newLocalAverageBill(sumAverageBuybackLocal, sumPaid, _this2.localCurrencySymbol) : '-',
              graph: filterCurrency.length === 1 ? {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: _this2.localCurrencySymbol
              } : false
            },
            approve: {
              value: _Helper2.default.percents(sumTotal, sumAccepted),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            approvedFromValid: {
              value: _Helper2.default.approvedFromValid(sumAccepted, sumTotal, sumError)
            },
            ad_approved: {
              value: sumAdApproved
            },
            ad_pre_approved: {
              value: sumAdPreApproved
            },
            ad_difference: {
              value: sumAdDifference
            }
          };
        });
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _fileSaver = __webpack_require__(17);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _ConversionsTabs = __webpack_require__(18);

var _ConversionsTabs2 = _interopRequireDefault(_ConversionsTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'Period',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    ConversionsTabs: _ConversionsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        filterWebCountry: true,
        countryFilter: true
      },
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      he: null,
      loading: false,
      headColumns: [{ label: this.$root.$t('statistic.offer'), field: 'offer', width: '100px' }, { label: this.$root.$t('statistic.total'), field: 'total', colspan: 2, width: '150px' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered', width: '50px' }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', width: '150px' }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, width: '60px' }, { label: this.$root.$t('statistic.shippeds'), field: 'shipped', width: '35px' }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', width: '35px' }, { label: 'Изм.', field: 'shift', width: '35px' }],
      month: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      rows: [],
      rowsTotal: [],
      footColumns: {},
      summary: {},
      totalAllColumns: {},
      offers: [],
      totalCourier: {},
      x: 0,
      dataForExel: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    setTimeout(this.filterSectionHeight, 1500);
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
      _this.he = null;
      setTimeout(_this.filterSectionHeight, 1500);
    });
  },

  methods: {
    filterSectionHeight: function filterSectionHeight() {
      this.he = null;
      var filterSectionDOM = document.querySelectorAll('.heightInner');
      var maxArr = [];
      for (var i = 0; i < filterSectionDOM.length; i++) {
        var boxes = filterSectionDOM[i].clientHeight;
        maxArr.push(boxes);
      }
      this.he = (0, _lodash.max)(maxArr);
      return this.he;
    },
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var offset1 = document.getElementById('swipe1').offsetWidth;
      var scroll1 = document.getElementById('swipe1').scrollWidth;
      var width = scroll - offset;
      var width1 = scroll1 - offset1;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }

        if (width1 > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10;
          } else {
            this.x -= e.distance / 10;
          }
          if (this.x > 0) {
            this.x = 0;
          }
          if (Math.abs(this.x) > width1) {
            this.x = -width1;
          }
        }
      }
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.rows = [];
      this.footColumns = {};
      this.loading = true;
      _API2.default.getConversionsCouriersStatistic().then(function (response) {
        _this2.rows = _this2.statisticData(response.body);
        _this2.loading = false;
      }).catch(function (response) {
        _this2.loading = false;
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    isNumeric: function isNumeric(x) {
      return (typeof x === 'number' || typeof x === 'string') && !(0, _lodash.isNaN)(Number(x));
    },
    statisticData: function statisticData(rows) {
      var _this3 = this;

      var newRows = {};
      var totalDeliveredCount1 = {};
      var years = [];
      this.footColumns = {};
      this.totalAllColumns = {};
      var totalSum = void 0,
          deliveredSum = void 0,
          returnSum = void 0,
          shippedSum = void 0,
          sumPaid = void 0,
          sumAverageBuyback = void 0;
      var allColumnsTotal = void 0,
          allColumnsPaid = void 0,
          allColumnsDelivered = void 0,
          allColumnsReturn = void 0,
          allColumnsShipped = void 0,
          allColumnsAverageBuyback = void 0;
      var arrayMonth = [];
      (0, _lodash.map)(rows, function (rowsMonth, indexYear) {
        var _totalDeliveredCount;

        if (!newRows[indexYear]) {
          newRows[indexYear] = {};
          _this3.footColumns[indexYear] = {};
          _this3.totalAllColumns[indexYear] = {};
        }
        years.push(indexYear);
        totalDeliveredCount1 = (_totalDeliveredCount = {}, _defineProperty(_totalDeliveredCount, indexYear, {}), _defineProperty(_totalDeliveredCount, 'rowsMonth', rowsMonth), _defineProperty(_totalDeliveredCount, 'years', years), _totalDeliveredCount);
        (0, _lodash.map)(rowsMonth, function (rowsCourier, indexMonth) {
          _this3.totalDeliveredCount = {};
          arrayMonth.push(indexMonth);
          totalDeliveredCount1[indexYear] = _extends(_defineProperty({}, indexMonth, {}), totalDeliveredCount1[indexYear]);
          _this3.dataForExel = indexYear + '-' + indexMonth;
          for (var courierIndex in rowsCourier) {
            Object.keys(rowsCourier[courierIndex]).map(function (courierKey) {
              var courier = (0, _lodash.find)(_Storage2.default.couriers, { id: parseInt(courierKey) });
              if (!courier) {
                if (courierKey === 'unsent') {
                  totalDeliveredCount1[indexYear][indexMonth] = _extends(_defineProperty({}, courierKey, {
                    courier_name: 'Неотправленные',
                    total: 0,
                    delivered: 0,
                    average_buyout: 0,
                    paid: 0,
                    refunded: 0,
                    shipped: 0
                  }), totalDeliveredCount1[indexYear][indexMonth]);
                } else if (courierKey === 'without') {
                  totalDeliveredCount1[indexYear][indexMonth] = _extends(_defineProperty({}, courierKey, {
                    courier_name: 'Без курьерки',
                    total: 0,
                    delivered: 0,
                    average_buyout: 0,
                    paid: 0,
                    refunded: 0,
                    shipped: 0
                  }), totalDeliveredCount1[indexYear][indexMonth]);
                } else {
                  totalDeliveredCount1[indexYear][indexMonth] = _extends(_defineProperty({}, courierKey, {
                    courier_name: 'Undefined',
                    total: 0,
                    delivered: 0,
                    average_buyout: 0,
                    paid: 0,
                    refunded: 0,
                    shipped: 0
                  }), totalDeliveredCount1[indexYear][indexMonth]);
                }
              } else {
                totalDeliveredCount1[indexYear][indexMonth] = _extends(_defineProperty({}, courier.id, {
                  courier_name: courier.title,
                  total: 0,
                  delivered: 0,
                  average_buyout: 0,
                  average_paid: 0,
                  paid: 0,
                  refunded: 0,
                  shipped: 0
                }), totalDeliveredCount1[indexYear][indexMonth]);
              }
            });
          }
          if (!_this3.totalAllColumns[indexYear][indexMonth]) {
            _this3.totalAllColumns[indexYear][indexMonth] = [];
            allColumnsTotal = 0;
            allColumnsPaid = 0;
            allColumnsDelivered = 0;
            allColumnsAverageBuyback = 0.0;
            allColumnsReturn = 0;
            allColumnsShipped = 0;
          }
          (0, _lodash.map)(rowsCourier, function (rowsData, indexCourier) {
            if (!newRows[indexYear][indexCourier]) {
              newRows[indexYear][indexCourier] = {};
              _this3.footColumns[indexYear][indexCourier] = {};
            }
            if (!newRows[indexYear][indexCourier][indexMonth]) {
              newRows[indexYear][indexCourier][indexMonth] = [];
              _this3.footColumns[indexYear][indexCourier][indexMonth] = [];
            }
            (0, _lodash.map)(arrayMonth, function (perMonth) {
              if (!newRows[indexYear][indexCourier][perMonth]) {
                newRows[indexYear][indexCourier][perMonth] = [];
                _this3.footColumns[indexYear][indexCourier][perMonth] = [];
              }
            });
            totalSum = 0;
            deliveredSum = 0;
            sumAverageBuyback = 0.0;
            returnSum = 0;
            shippedSum = 0;
            sumPaid = 0;
            (0, _lodash.map)(rowsData, function (rowsOfferTotal, i) {
              rowsOfferTotal.forEach(function (item) {
                totalSum += parseInt(item.total);
                deliveredSum += parseInt(item.delivered);
                if (item.refunded) {
                  returnSum += parseInt(item.refunded);
                }
                shippedSum += parseInt(item.shipped);
                if (item.percent_rate > 0) {}
                if (item.paid > 0) {
                  sumPaid += parseInt(item.paid);
                }
                if (item.average_buyout_usd > 0) {
                  sumAverageBuyback += parseFloat(item.average_buyout_usd) * item.paid;
                }
              });
            });
            allColumnsPaid += parseInt(sumPaid);
            allColumnsTotal += parseInt(totalSum);
            allColumnsDelivered += parseInt(deliveredSum);
            allColumnsAverageBuyback += parseFloat(sumAverageBuyback);
            allColumnsReturn += parseInt(returnSum);
            allColumnsShipped += parseInt(shippedSum);
            (0, _lodash.map)(rowsData, function (rowsOffer, i) {
              rowsOffer.forEach(function (item) {
                newRows[indexYear][indexCourier][indexMonth].push({
                  offer: {
                    value: '' + (_this3.isNumeric(i) ? _Helper2.default.getCourierTitleWithUndefinedCourier(_Storage2.default.couriers, i) : _this3.$root.$t('verbs.' + i))
                  },
                  total: {
                    value: item.total,
                    bg: true
                  },
                  totalPercent: {
                    value: _Helper2.default.percents(totalSum, item.total),
                    bgg: _Helper2.default.renderGistPart(totalSum, item.total, true)
                  },
                  delivered: {
                    value: item.delivered,
                    bg: true
                  },
                  averageBuyback: {
                    value: '$ ' + item.average_buyout_usd.toFixed(2),
                    bg: true
                  },
                  return: {
                    value: item.refunded,
                    bg: true
                  },
                  returnPercents: {
                    value: _Helper2.default.percents(parseFloat(item.approved), item.refunded),
                    bgg: _Helper2.default.renderGistPart(item.approved, item.refunded, true)
                  },
                  shipped: {
                    value: item.shipped,
                    bg: true
                  },
                  buyout: {
                    value: item.percent_rate + '%',
                    bg: true
                  },
                  shift: {
                    value: (item.percent_rate - item.old_buyout_percent).toFixed(2) + '%',
                    bg: true
                  }
                });
              });
            });
            _this3.footColumns[indexYear][indexCourier][indexMonth].push({
              label: {
                value: _this3.$root.$t('statistic.in_total')
              },
              total: {
                value: totalSum
              },
              totalPercent: {
                value: ''
              },
              delivered: {
                value: deliveredSum
              },
              averageBuyback: {
                value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid)
              },
              return: {
                value: returnSum
              },
              returnPercents: {
                value: parseFloat(returnSum / totalSum * 100).toFixed(0) + '%'
              },
              shipped: {
                value: shippedSum
              },
              buyout: {
                value: '' + _Helper2.default.percents(totalSum, deliveredSum),
                bg: true
              },
              shift: {
                value: ''
              }
            });
          });
          _this3.totalAllColumns[indexYear][indexMonth].push({
            label: {
              value: _this3.$root.$t('statistic.in_total'),
              width: '14%'
            },
            total: {
              value: allColumnsTotal,
              width: '10%'
            },
            totalPercent: {
              value: '',
              width: '13%'
            },
            delivered: {
              value: allColumnsDelivered,
              width: '15%'
            },
            averageBuyback: {
              value: _Helper2.default.averageBillDayCount(allColumnsAverageBuyback, allColumnsPaid),
              width: '15%'
            },
            return: {
              value: allColumnsReturn,
              width: '5%'
            },
            returnPercents: {
              value: parseFloat(allColumnsReturn / allColumnsTotal * 100).toFixed(0) + '%',
              width: '9%'
            },
            shipped: {
              value: allColumnsShipped,
              width: '12%'
            },
            buyout: {
              value: '' + _Helper2.default.percents(allColumnsTotal, allColumnsDelivered),
              bg: true,
              width: '10%'
            },
            shift: {
              value: '',
              width: '11%'
            }
          });
        });
      });
      totalDeliveredCount1.years.map(function (year) {
        var _loop = function _loop(key) {
          var month = key;
          var company = totalDeliveredCount1.rowsMonth[key];

          var _loop2 = function _loop2(_key) {
            Object.keys(company[_key]).map(function (courierId) {
              company[_key][courierId].forEach(function (item) {
                totalDeliveredCount1[year][month][courierId].total += parseInt(item.total);
                totalDeliveredCount1[year][month][courierId].delivered += parseInt(item.delivered);
                totalDeliveredCount1[year][month][courierId].paid += parseInt(item.paid);
                totalDeliveredCount1[year][month][courierId].average_buyout += parseFloat(item.average_buyout_usd.toFixed(2)) * parseInt(item.paid);
                totalDeliveredCount1[year][month][courierId].refunded += parseInt(item.refunded);
                totalDeliveredCount1[year][month][courierId].shipped += parseInt(item.shipped);
                totalDeliveredCount1[year][month][courierId].returnPercents = parseFloat(totalDeliveredCount1[year][month][courierId].refunded / totalDeliveredCount1[year][month][courierId].total * 100).toFixed(0) + '%';
                totalDeliveredCount1[year][month][courierId].buyout = '' + _Helper2.default.percents(totalDeliveredCount1[year][month][courierId].total, totalDeliveredCount1[year][month][courierId].delivered);
                totalDeliveredCount1[year][month][courierId].totalPercents = _this3.totalAllColumns[year][month][0].total.value;
              });
            });
          };

          for (var _key in company) {
            _loop2(_key);
          }
        };

        for (var key in totalDeliveredCount1.rowsMonth) {
          _loop(key);
        }
      });

      this.totalCourier = totalDeliveredCount1;
      return newRows;
    },
    exportingAll: function exportingAll() {
      var classes = document.getElementsByClassName('exelAll');
      var doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + this.title + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
      (0, _lodash.map)(classes, function (cl, i) {
        doc += cl.innerHTML + '<br/>';
      });
      doc += '</body></html>';
      _fileSaver2.default.saveAs(new Blob([doc], {
        encoding: 'UTF-8',
        type: 'application/octet-stream'
      }), 'analytics-' + this.dataForExel + '.xls');
    }
  }
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _fileSaver = __webpack_require__(17);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _ConversionsTabs = __webpack_require__(18);

var _ConversionsTabs2 = _interopRequireDefault(_ConversionsTabs);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _vueStrap = __webpack_require__(9);

var _lodash = __webpack_require__(5);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'Flypost',
  components: {
    Filters: _Filters2.default,
    ConversionsTabs: _ConversionsTabs2.default,
    StatisticTable: _StatisticTable2.default,
    modal: _vueStrap.modal
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      Storage: _Storage2.default,
      branchStatistics: false,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      loading: false,
      country: null,
      headColumnsFlyPost: [{ label: this.$root.$t('statistic.city'), field: 'offer', width: '100px' }, { label: this.$root.$t('statistic.total'), field: 'total', colspan: 2, width: '105px' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered', width: '90px' }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, width: '100px' }, { label: this.$root.$t('statistic.shippeds'), field: 'shipped', width: '90px' }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', width: '80px' }, { label: this.$root.$t('statistic.cost_price'), field: 'cost_price', width: '80px' }, { label: 'Изм.', field: 'shift', width: '75px' }],
      headColumns: [{ label: this.$root.$t('statistic.city'), field: 'offer', width: '100px' }, { label: this.$root.$t('statistic.total'), field: 'total', colspan: 2, width: '105px' }, { label: this.$root.$t('statistic.delivered'), field: 'delivered', width: '90px' }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, width: '100px' }, { label: this.$root.$t('statistic.shippeds'), field: 'shipped', width: '90px' }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', width: '80px' }, { label: this.$root.$t('statistic.cost_price'), field: 'cost_price', width: '80px' }, { label: 'Изм.', field: 'shift', width: '75px' }],
      headColumnsPopup: [{ label: this.$root.$t('statistic.city'), field: 'offer' }, { label: this.$root.$t('statistic.total'), field: 'total', colspan: 2 }, { label: this.$root.$t('statistic.delivered'), field: 'delivered' }, { label: this.$root.$t('statistic.averageBillPopup'), field: 'averageBillPopup' }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.shippeds'), field: 'shipped' }, { label: this.$root.$t('statistic.buyout'), field: 'buyout' }],
      month: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      rows: [],
      rowsDataPopup: [],
      rowsTotal: [],
      footColumns: {},
      footColumnsPopup: {},
      summary: {},
      totalAllColumns: {},
      offers: [],
      totalCourier: {},
      x: 0,
      dataForExel: '',
      popupTitle: '',
      popupTitleTable: '',
      clickFlyPost: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var offset1 = document.getElementById('swipe1').offsetWidth;
      var scroll1 = document.getElementById('swipe1').scrollWidth;
      var width = scroll - offset;
      var width1 = scroll1 - offset1;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }

        if (width1 > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10;
          } else {
            this.x -= e.distance / 10;
          }
          if (this.x > 0) {
            this.x = 0;
          }
          if (Math.abs(this.x) > width1) {
            this.x = -width1;
          }
        }
      }
    },

    checkForm: function checkForm(e) {
      var _this2 = this;

      var post = [];
      var additional6 = void 0,
          country = void 0,
          indexOfMonth = void 0,
          indexOfYear = void 0,
          offer = void 0,
          lengthOfId = void 0;
      (0, _lodash.map)(e.target, function (elem) {
        if (elem.name) {
          offer = elem.id.substring(0, 4);
          indexOfYear = elem.id.substring(5, 9);
          lengthOfId = elem.id.length;
          indexOfMonth = elem.id.substring(10, lengthOfId);
          if (indexOfMonth >= 1 && indexOfMonth <= 9) {
            indexOfMonth = '0' + indexOfMonth;
          }
          additional6 = elem.name;
          country = _Storage2.default.selectedCountry.id;
          post.push({
            'country_id': country,
            'additional6': additional6,
            'cost': elem.value,
            'month': indexOfYear + '-' + indexOfMonth,
            'offer_id': offer
          });
        }
      });
      this.loading = true;
      _API2.default.postConversionsFlypost(post).then(function (res) {
        _this2.calculateRows();
        _this2.loading = false;
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
      e.preventDefault();
    },
    isNumeric: function isNumeric(x) {
      return (typeof x === 'number' || typeof x === 'string') && !(0, _lodash.isNaN)(Number(x));
    },
    calculateRows: function calculateRows() {
      var _this3 = this;

      this.rows = [];
      this.footColumns = {};
      this.$root.$emit('data_loading');
      this.loading = true;
      _API2.default.getConversionsFlypost().then(function (response) {
        _this3.rows = _this3.statisticData(response.body);
        _this3.loading = false;
        _this3.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this3.loading = false;
        _this3.$notify({
          type: 'danger',
          title: _this3.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    statisticData: function statisticData(rows) {
      var _this4 = this;

      var newRows = {};
      var totalDeliveredCount1 = {};
      var years = [];
      this.footColumns = {};
      this.totalAllColumns = {};
      var totalSum = void 0,
          deliveredSum = void 0,
          returnSum = void 0,
          shippedSum = void 0,
          costSum = void 0;
      var allColumnsTotal = void 0,
          allColumnsDelivered = void 0,
          allColumnsReturn = void 0,
          allColumnsShipped = void 0,
          allColumnsCost = void 0;
      var arrayMonth = [];
      (0, _lodash.map)(rows, function (rowsMonth, indexYear) {
        var _totalDeliveredCount;

        if (!newRows[indexYear]) {
          newRows[indexYear] = {};
          _this4.footColumns[indexYear] = {};
          _this4.totalAllColumns[indexYear] = {};
        }
        years.push(indexYear);
        totalDeliveredCount1 = (_totalDeliveredCount = {}, _defineProperty(_totalDeliveredCount, indexYear, {}), _defineProperty(_totalDeliveredCount, 'rowsMonth', rowsMonth), _defineProperty(_totalDeliveredCount, 'years', years), _totalDeliveredCount);
        (0, _lodash.map)(rowsMonth, function (rowsCourier, indexMonth) {
          arrayMonth.push(indexMonth);
          totalDeliveredCount1[indexYear] = _extends(_defineProperty({}, indexMonth, {}), totalDeliveredCount1[indexYear]);
          _this4.dataForExel = indexYear + '-' + indexMonth;
          for (var courierIndex in rowsCourier) {
            Object.keys(rowsCourier[courierIndex]).map(function (courierKey) {
              totalDeliveredCount1[indexYear][indexMonth] = _extends(_defineProperty({}, courierKey, {
                courier_name: courierKey,
                total: 0,
                delivered: 0,
                refunded: 0,
                shipped: 0,
                cost: 0
              }), totalDeliveredCount1[indexYear][indexMonth]);
            });
          }
          if (!_this4.totalAllColumns[indexYear][indexMonth]) {
            _this4.totalAllColumns[indexYear][indexMonth] = [];
            allColumnsTotal = 0;
            allColumnsDelivered = 0;
            allColumnsReturn = 0;
            allColumnsShipped = 0;
            allColumnsCost = 0;
          }
          (0, _lodash.map)(rowsCourier, function (rowsData, indexCourier) {
            if (!newRows[indexYear][indexCourier]) {
              newRows[indexYear][indexCourier] = {};
              _this4.footColumns[indexYear][indexCourier] = {};
            }
            if (!newRows[indexYear][indexCourier][indexMonth]) {
              newRows[indexYear][indexCourier][indexMonth] = [];
              _this4.footColumns[indexYear][indexCourier][indexMonth] = [];
            }
            (0, _lodash.map)(arrayMonth, function (perMonth) {
              if (!newRows[indexYear][indexCourier][perMonth]) {
                newRows[indexYear][indexCourier][perMonth] = [];
                _this4.footColumns[indexYear][indexCourier][perMonth] = [];
              }
            });
            totalSum = 0;
            deliveredSum = 0;
            returnSum = 0;
            shippedSum = 0;
            costSum = 0;
            (0, _lodash.map)(rowsData, function (rowsOfferTotal, i) {
              totalSum += parseInt(rowsOfferTotal.total);
              deliveredSum += parseInt(rowsOfferTotal.delivered);
              costSum += Number(rowsOfferTotal.cost);
              if (rowsOfferTotal.refunded) {
                returnSum += parseInt(rowsOfferTotal.refunded);
              }
              shippedSum += parseInt(rowsOfferTotal.shipped);
              if (rowsOfferTotal.percent_rate > 0) {}
            });
            allColumnsTotal += parseInt(totalSum);
            allColumnsDelivered += parseInt(deliveredSum);
            allColumnsReturn += parseInt(returnSum);
            allColumnsShipped += parseInt(shippedSum);
            allColumnsCost += Number(costSum);
            (0, _lodash.map)(rowsData, function (rowsOffer, i) {
              newRows[indexYear][indexCourier][indexMonth].push({
                city: {
                  value: '' + i,
                  popup: true,
                  indexCourier: indexCourier,
                  indexMonth: indexMonth
                },
                total: {
                  value: rowsOffer.total,
                  bg: true
                },
                totalPercent: {
                  value: _Helper2.default.percents(totalSum, rowsOffer.total),
                  bgg: _Helper2.default.renderGistPart(totalSum, rowsOffer.total, true)
                },
                delivered: {
                  value: rowsOffer.delivered,
                  bg: true
                },
                return: {
                  value: rowsOffer.refunded,
                  bg: true
                },
                returnPercents: {
                  value: _Helper2.default.percents(parseFloat(rowsOffer.approved), rowsOffer.refunded),
                  bgg: _Helper2.default.renderGistPart(rowsOffer.approved, rowsOffer.refunded, true)
                },
                shipped: {
                  value: rowsOffer.shipped,
                  bg: true
                },
                buyout: {
                  value: rowsOffer.percent_rate + '%',
                  bg: true
                },
                cost_price: {
                  htmlValue: '<input class="cellInput" id="' + indexCourier + '-' + indexYear + '-' + indexMonth + '" name="' + i + '" type="text" onchange="" value="' + rowsOffer.cost + '" >',
                  oldvalue: rowsOffer.cost,
                  name: i,
                  notupdate: true,
                  orderData: parseInt(rowsOffer.cost)
                },
                shift: {
                  value: (rowsOffer.percent_rate - rowsOffer.old_buyout_percent).toFixed(2) + '%',
                  bg: true
                }
              });
            });
            _this4.footColumns[indexYear][indexCourier][indexMonth].push({
              label: {
                value: _this4.$root.$t('statistic.in_total')
              },
              total: {
                value: totalSum
              },
              totalPercent: {
                value: ''
              },
              delivered: {
                value: deliveredSum
              },
              return: {
                value: returnSum
              },
              returnPercents: {
                value: parseFloat(returnSum / totalSum * 100).toFixed(0) + '%'
              },
              shipped: {
                value: shippedSum
              },
              buyout: {
                value: '' + _Helper2.default.percents(totalSum, deliveredSum),
                bg: true
              },
              cost_price: {
                value: costSum,
                bg: true
              },
              shift: {
                value: ''
              }
            });
          });
          _this4.totalAllColumns[indexYear][indexMonth].push({
            label: {
              value: _this4.$root.$t('statistic.in_total'),
              width: '14%'
            },
            total: {
              value: allColumnsTotal,
              width: '10%'
            },
            totalPercent: {
              value: '',
              width: '13%'
            },
            delivered: {
              value: allColumnsDelivered,
              width: '15%'
            },
            return: {
              value: allColumnsReturn,
              width: '5%'
            },
            returnPercents: {
              value: parseFloat(allColumnsReturn / allColumnsTotal * 100).toFixed(0) + '%',
              width: '9%'
            },
            shipped: {
              value: allColumnsShipped,
              width: '12%'
            },
            buyout: {
              value: '' + _Helper2.default.percents(allColumnsTotal, allColumnsDelivered),
              bg: true,
              width: '10%'
            },
            cost_price: {
              value: allColumnsCost,
              bg: true,
              width: '15%'
            },
            shift: {
              value: '',
              width: '11%'
            }
          });
        });
      });
      if (totalDeliveredCount1.years) {
        totalDeliveredCount1.years.map(function (year) {
          var _loop = function _loop(key) {
            var month = key;
            var company = totalDeliveredCount1.rowsMonth[key];

            var _loop2 = function _loop2(_key) {
              Object.keys(company[_key]).map(function (courierId) {
                totalDeliveredCount1[year][month][courierId].total += parseInt(company[_key][courierId].total);
                totalDeliveredCount1[year][month][courierId].delivered += parseInt(company[_key][courierId].delivered);
                totalDeliveredCount1[year][month][courierId].refunded += parseInt(company[_key][courierId].refunded);
                totalDeliveredCount1[year][month][courierId].shipped += parseInt(company[_key][courierId].shipped);
                if (company[_key][courierId].cost) {
                  totalDeliveredCount1[year][month][courierId].cost += parseInt(company[_key][courierId].cost);
                }
                totalDeliveredCount1[year][month][courierId].returnPercents = parseFloat(totalDeliveredCount1[year][month][courierId].refunded / totalDeliveredCount1[year][month][courierId].total * 100).toFixed(0) + '%';
                totalDeliveredCount1[year][month][courierId].buyout = '' + _Helper2.default.percents(totalDeliveredCount1[year][month][courierId].total, totalDeliveredCount1[year][month][courierId].delivered);
                totalDeliveredCount1[year][month][courierId].totalPercents = _this4.totalAllColumns[year][month][0].total.value;
                totalDeliveredCount1[year][month][courierId].month = month;
              });
            };

            for (var _key in company) {
              _loop2(_key);
            }
          };

          for (var key in totalDeliveredCount1.rowsMonth) {
            _loop(key);
          }
        });
      }
      this.totalCourier = totalDeliveredCount1;
      return newRows;
    },
    exportingAll: function exportingAll() {
      var classes = document.getElementsByClassName('exelAll');
      var doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' + this.title + '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
      (0, _lodash.map)(classes, function (cl, i) {
        doc += cl.innerHTML + '<br/>';
      });
      doc += '</body></html>';
      _fileSaver2.default.saveAs(new Blob([doc], {
        encoding: 'UTF-8',
        type: 'application/octet-stream'
      }), 'analytics-' + this.dataForExel + '.xls');
      console.log(doc, 'doc');
    },
    isPopup: function isPopup(cell) {
      var _this5 = this;

      var nch = _Storage2.default.selectedCountry.rate;
      var indexCourier = parseInt(cell.indexCourier);
      var indexCourierTitle = _Helper2.default.getOfferTitle(_Storage2.default.offers, cell.indexCourier);
      this.rowsDataPopup = [];
      this.footColumnsPopup = {};
      this.popupTitle = indexCourierTitle + ' — ' + cell.value;
      var totalSumModal = void 0;
      var get = new Promise(function (resolve) {
        _API2.default.getBranch(cell.value, indexCourier, cell.indexMonth).then(function (response) {
          resolve(response.body);
        });
      });
      get.then(function (response) {
        (0, _lodash.map)(response, function (rowsMonth, indexYear) {
          (0, _lodash.map)(rowsMonth, function (rowsBranch) {
            (0, _lodash.map)(rowsBranch, function (data) {
              totalSumModal = 0;
              for (var i in data) {
                var value = data[i];
                totalSumModal += parseInt(value.total);
                _this5.rowsDataPopup.push({
                  offer: {
                    value: '' + i
                  },
                  total: {
                    value: value.total
                  },
                  totalPercent: {
                    value: _Helper2.default.percents(totalSumModal, value.total),
                    bgg: _Helper2.default.renderGistPart(totalSumModal, value.total, true)
                  },
                  delivered: {
                    value: value.delivered
                  },
                  averageBillPopup: {
                    value: _Helper2.default.averageBillDay(value.average_bill, nch)
                  },
                  return: {
                    value: value.refunded
                  },
                  returnPercents: {
                    value: _Helper2.default.percents(parseFloat(value.approved), value.refunded),
                    bgg: _Helper2.default.renderGistPart(value.approved, value.refunded, true)
                  },
                  shipped: {
                    value: value.shipped
                  },
                  buyout: {
                    value: _Helper2.default.percents(value.approved, value.paid)
                  }
                });
              }
            });
          });
        });
      });
      this.branchStatistics = true;
    },
    isPopupFlyPost: function isPopupFlyPost(cell) {
      var _this6 = this;

      this.rowsDataPopup = [];
      this.footColumnsPopup = {};
      this.popupTitle = cell.courier_name;
      var totalSumModal = 0;
      var totalSumDelivered = 0;
      var totalSumAverageBill = 0.0;
      var totalSumAccepted = 0;
      var totalSumReturn = 0;
      var totalSunShipped = 0;
      var get = new Promise(function (resolve) {
        _API2.default.getBranchSum(cell.courier_name, cell.month).then(function (response) {
          resolve(response.body);
        });
      });
      get.then(function (response) {
        (0, _lodash.map)(response, function (rowsMonth, indexYear) {
          (0, _lodash.map)(rowsMonth, function (rowsBranch) {
            (0, _lodash.map)(rowsBranch, function (data) {
              var _loop3 = function _loop3(i) {
                var value = data[i];
                value.forEach(function (item) {
                  totalSumModal += parseInt(item.total);
                  totalSumDelivered += parseInt(item.delivered);
                  if (item.approved) {
                    totalSumAccepted += item.approved;
                  }
                  if (item.approved > 0) {
                    totalSumAverageBill += item.average_bill_usd * item.approved;
                  }
                  if (item.refunded) {
                    totalSumReturn += item.refunded;
                  }
                  if (item.shipped) {
                    totalSunShipped += item.shipped;
                  }
                  _this6.rowsDataPopup.push({
                    offer: {
                      value: '' + i
                    },
                    total: {
                      value: item.total
                    },
                    totalPercent: {
                      value: _Helper2.default.percents(totalSumModal, item.total),
                      bgg: _Helper2.default.renderGistPart(totalSumModal, item.total, true)
                    },
                    delivered: {
                      value: item.delivered
                    },
                    averageBillPopup: {
                      value: '$ ' + item.average_bill_usd.toFixed(2)
                    },
                    return: {
                      value: item.refunded
                    },
                    returnPercents: {
                      value: _Helper2.default.percents(parseFloat(item.approved), item.refunded),
                      bgg: _Helper2.default.renderGistPart(item.approved, item.refunded, true)
                    },
                    shipped: {
                      value: item.shipped
                    },
                    buyout: {
                      value: _Helper2.default.percents(item.approved, item.paid)
                    }
                  });
                });
                _this6.footColumnsPopup = {
                  label: {
                    value: _this6.$root.$t('statistic.in_total')
                  },
                  total: {
                    value: totalSumModal
                  },
                  totalPercent: {
                    value: ''
                  },
                  delivered: {
                    value: totalSumDelivered
                  },
                  averageBillPopup: {
                    value: _Helper2.default.averageBillDayCount(totalSumAverageBill, totalSumAccepted)
                  },
                  return: {
                    value: totalSumReturn
                  },
                  returnPercents: {
                    value: parseFloat(totalSumReturn / totalSumModal * 100).toFixed(0) + '%'
                  },
                  shipped: {
                    value: totalSunShipped
                  },
                  buyout: {
                    value: '' + _Helper2.default.percents(totalSumModal, totalSumDelivered),
                    bg: true
                  }
                };
              };

              for (var i in data) {
                _loop3(i);
              }
            });
          });
        });
      });
      this.branchStatistics = true;
    }
  }
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _ConversionsTabs = __webpack_require__(18);

var _ConversionsTabs2 = _interopRequireDefault(_ConversionsTabs);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConversionGraph',
  components: {
    Filters: _Filters2.default,
    ConversionsTabs: _ConversionsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        monthFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      loading: false,
      Helper: _Helper2.default,
      Storage: _Storage2.default,
      chart: {
        colors: ['#f86c6b', '#4ebd74', '#64c2de'],
        chart: {
          type: 'area'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m}'
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: null
          },
          labels: {
            formatter: function formatter() {
              return this.value;
            }
          }
        },
        tooltip: {
          xDateFormat: '%Y-%m',
          pointFormat: '{series.name}1: <b>{point.y}</b><br/>'
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        plotOptions: {
          area: {
            fillOpacity: 0.3,
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          }
        },
        series: []
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.createGraph();
    this.$root.$on('filters_load_new_data', function () {
      _this.createGraph();
    });
    this.createGraph();
  },
  methods: {
    createGraph: function createGraph() {
      var _this2 = this;

      _API2.default.getGraphConversion().then(function (response) {
        if (response.status === 200) {
          _this2.renderChart(response.body);
        }
      });
    },
    renderChart: function renderChart(rows) {
      var approved = [];
      var approvedVal = [];
      var averageBill = [];
      var averageBillLocal = [];
      var paid = [];
      var paidVal = [];
      var averageBillName = this.$root.$t('statistic.averageBill');
      var paidName = this.$root.$t('statistic.paid');
      var approvedName = this.$root.$t('statistic.approved');
      var totals = this.$root.$t('verbs.total');
      var currencyOld = [];
      var currencyNew = [];
      (0, _lodash.map)(rows, function (row) {
        currencyOld.push(row.local_currency.split(','));
        approved.push([Date.UTC(row.year, row.month - 1), row.approved_percent]);
        averageBillLocal[Date.UTC(row.year, row.month - 1)] = row.local_currency.split(',').length === 1 ? row.average_bill_local.toFixed(2) + ' ' + (0, _currencySymbolMap2.default)(row.local_currency) : ' ';
        approvedVal[Date.UTC(row.year, row.month - 1)] = row.approved;
        paidVal[Date.UTC(row.year, row.month - 1)] = row.paid;
        averageBill.push([Date.UTC(row.year, row.month - 1), row.average_bill_usd]);
        paid.push([Date.UTC(row.year, row.month - 1), row.paid_percent]);
      });
      currencyOld.forEach(function (array) {
        array.forEach(function (item) {
          currencyNew.push(item);
        });
      });
      var currency = currencyNew.filter(function (item, index) {
        return currencyNew.indexOf(item) === index;
      });
      this.chart.series = [{
        name: this.$root.$t('statistic.approved'),
        data: approved
      }, {
        name: this.$root.$t('statistic.averageBill'),
        data: averageBill
      }, {
        name: this.$root.$t('statistic.paid'),
        data: paid
      }];
      this.chart.tooltip.formatter = function () {
        if (this.series.name === averageBillName) {
          return this.series.name + ':<br/>\u0412 \u043C\u0435\u0441\u0442\u043D\u043E\u0439 \u0432\u0430\u043B\u044E\u0442\u0435 <b> ' + (currency.length === 1 ? averageBillLocal[this.x] : '') + '</b><br/>\u0412 \u0434\u043E\u043B\u043B\u0430\u0440\u0430\u0445 <b>' + this.y.toFixed(2) + '$</b>';
        } else if (this.series.name === approvedName) {
          return this.series.name + ': <b>' + this.point.y + ' %</b><br/>' + totals + ' <b>' + approvedVal[this.x] + '</b>';
        } else if (this.series.name === paidName) {
          return this.series.name + ': <b>' + this.point.y + ' %</b><br/>' + totals + ' <b>' + paidVal[this.x] + '</b>';
        }
      };
      _highcharts2.default.chart('chart-conversion', this.chart);
    }
  }
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _ConversionsTabs = __webpack_require__(18);

var _ConversionsTabs2 = _interopRequireDefault(_ConversionsTabs);

var _AlbhabetScroll = __webpack_require__(19);

var _AlbhabetScroll2 = _interopRequireDefault(_AlbhabetScroll);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Offer',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    ConversionsTabs: _ConversionsTabs2.default,
    AlphabetScroll: _AlbhabetScroll2.default
  },
  data: function data() {
    return {
      scrollPos: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.date'), field: 'date', width: '120px' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2 }, { label: this.$root.$t('statistic.accepted'), field: 'accepted' }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2 }, { label: this.$root.$t('statistic.approve'), field: 'approve', width: '50px' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }, { label: this.$root.$t('statistic.ad_approved'), field: 'ad_approved' }, { label: this.$root.$t('statistic.ad_pre_approved'), field: 'ad_pre_approved' }, { label: this.$root.$t('statistic.ad_difference'), field: 'ad_difference' }],
      rows: [],
      footColumns: [],
      offers: [],
      alphabet: [],
      localCurrencySymbol: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  ready: function ready() {
    this.$scrollSet();
  },
  methods: {
    getApiCurrencyHistory: function getApiCurrencyHistory(currency) {
      return new Promise(function (resolve, reject) {
        var currencyHistory = [];
        _API2.default.getCurrencyHistory(currency).then(function (response) {
          if (response.status === 200) {
            currencyHistory = response.body;
            resolve(currencyHistory);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    newCurrencyHistory: function newCurrencyHistory(currency) {
      return new Promise(function (resolve, reject) {
        var currencyHistory = [];
        _API2.default.getCurrencyHistory(currency).then(function (response) {
          if (response.status === 200) {
            currencyHistory = response.body;
            resolve(currencyHistory);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.offers = _Storage2.default.offers.slice(0);
      this.rows = {};
      this.footColumns = [];
      this.alphabet = [];
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getConversionsOffersStatistic().then(function (response) {
        (0, _lodash.map)(response.data, function (array) {
          array.forEach(function (d) {
            oldArrCurrency.push(d.local_currency.split(','));
          });
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        var sortedResponse = (0, _lodash.orderBy)(response.body, [function (i) {
          var title = _Helper2.default.getOfferTitle(_Storage2.default.offers, i[0].offer_id);
          return !title ? 'A' : title;
        }], ['asc']);
        _this2.newCurrencyHistory(filterCurrency).then(function (valueCurrency) {
          var localCurrency = function localCurrency(date, currency) {
            var localValueCurrency = valueCurrency.find(function (item) {
              if (item.date === date && item.currency === currency) {
                return item;
              }
            });
            if (localValueCurrency) {
              return localValueCurrency.value;
            }
          };
          (0, _lodash.map)(sortedResponse, function (offer, i) {
            var offerId = offer[0].offer_id;

            if (_Helper2.default.getOfferTitle(_this2.offers, offerId)[0]) {
              var sumTotal = 0;
              var sumProcessed = 0;
              var countProcessed = 0;
              var sumAccepted = 0;
              var countAccepted = 0;
              var sumCanceled = 0;
              var countCanceled = 0;
              var sumError = 0;
              var countError = 0;
              var sumReturn = 0;
              var countReturn = 0;
              var sumPaid = 0;
              var countPaid = 0;
              var sumAverageBillLocal = 0.0;
              var sumAverageBill = 0.0;
              var sumAverageBuyback = 0.0;
              var sumAverageBuybackLocal = 0.0;
              var sumAdApproved = 0;
              var sumAdPreApproved = 0;
              var sumAdDifference = 0;
              var count = Object.keys(offer).length;
              var letter = _Helper2.default.getOfferTitle(_Storage2.default.offers, offerId)[0].toUpperCase();
              var letterIndex = (0, _lodash.findIndex)(_this2.alphabet, { letter: letter });
              if (letterIndex === -1) {
                _this2.alphabet.push({
                  id: offerId,
                  letter: letter,
                  count: 1
                });
                _this2.rows[letter] = [];
                i = 0;
              } else {
                _this2.alphabet[letterIndex].count++;
                i = _this2.rows[letter].length;
              }
              _this2.rows[letter][i] = {
                id: offerId,
                cells: []
              };
              (0, _lodash.map)(offer, function (d) {
                _this2.rows[letter][i].cells.push({
                  date: {
                    value: d.date,
                    colouredDayOff: true
                  },
                  total: {
                    value: d.total,
                    bg: true
                  },
                  processed: {
                    value: d.processed,
                    bgg: _Helper2.default.renderGistPart(d.total, d.processed),
                    bg: true,
                    isCollspaned: true
                  },
                  processedPercent: {
                    value: _Helper2.default.percents(d.total, d.processed),
                    bgg: _Helper2.default.renderGistPart(d.total, d.processed, true)
                  },
                  accepted: {
                    value: d.approved,
                    bg: true
                  },
                  canceled: {
                    value: d.canceled,
                    bgg: _Helper2.default.renderGistPart(d.total, d.canceled),
                    isCollspaned: true
                  },
                  canceledPercents: {
                    value: _Helper2.default.percents(d.total, d.canceled),
                    bgg: _Helper2.default.renderGistPart(d.total, d.canceled, true)
                  },
                  error: {
                    value: d.error,
                    bgg: _Helper2.default.renderGistPart(d.total, d.error),
                    isCollspaned: true
                  },
                  errorPercents: {
                    value: _Helper2.default.percents(d.total, d.error),
                    bgg: _Helper2.default.renderGistPart(d.total, d.error, true)
                  },
                  return: {
                    value: d.return,
                    bgg: _Helper2.default.renderGistPart(d.approved, d.return),
                    isCollspaned: true
                  },
                  returnPercents: {
                    value: _Helper2.default.percents(d.approved, d.return),
                    bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
                  },
                  paid: {
                    value: d.paid,
                    bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
                    isCollspaned: true
                  },
                  paidPercents: {
                    value: _Helper2.default.percents(d.approved, d.paid),
                    bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true)
                  },
                  averageBill: {
                    value: '$ ' + d.average_bill.toFixed(2),

                    isCollspaned: true
                  },
                  averageBillLocal: {
                    value: d.average_bill > 0 ? '' + _Helper2.default.newAverageBillDay(d.average_bill, localCurrency(d.date, d.local_currency), (0, _currencySymbolMap2.default)(d.local_currency)) : 0 + ' ' + (0, _currencySymbolMap2.default)(d.local_currency)
                  },
                  averageBuyback: {
                    value: '$ ' + d.average_buyout.toFixed(2)
                  },
                  averageBuybackLocal: {
                    value: d.average_bill > 0 ? '' + _Helper2.default.newAverageBillDay(d.average_buyout, localCurrency(d.date, d.local_currency), (0, _currencySymbolMap2.default)(d.local_currency)) : 0 + ' ' + (0, _currencySymbolMap2.default)(d.local_currency)
                  },
                  approve: {
                    value: _Helper2.default.percents(d.total, d.approved),
                    bgg: _Helper2.default.renderSingleGist(d.total, d.approved)
                  },
                  approvedFromValid: {
                    value: d.approved_from_valid.toFixed(1) + '%'
                  },
                  ad_approved: {
                    value: d.ad_approved ? Number(d.ad_approved.toFixed(2)) : 0
                  },
                  ad_pre_approved: {
                    value: d.ad_pre_approved ? Number(d.ad_pre_approved.toFixed(2)) : 0
                  },
                  ad_difference: {
                    value: isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : Number((d.ad_approved - d.ad_pre_approved).toFixed(2))
                  }
                });
                sumTotal += d.total;
                if (d.processed > 0) {
                  sumProcessed += d.processed;
                  countProcessed++;
                }
                if (d.approved) {
                  sumAccepted += parseFloat(d.approved);
                  countAccepted++;
                }
                if (d.approved > 0 && localCurrency(d.date, d.local_currency)) {
                  sumAverageBill += parseFloat(d.average_bill) * d.approved;
                  sumAverageBuyback += parseFloat(d.average_buyout) * d.paid;
                  sumAverageBillLocal += d.average_bill * localCurrency(d.date, d.local_currency) * d.approved;
                  sumAverageBuybackLocal += parseFloat(d.average_buyout * localCurrency(d.date, d.local_currency)) * d.paid;
                  _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
                }
                if (d.canceled > 0) {
                  sumCanceled += d.canceled;
                  countCanceled++;
                }
                if (d.error > 0) {
                  sumError += d.error;
                  countError++;
                }
                if (d.return > 0) {
                  sumReturn += d.return;
                  countReturn++;
                }
                if (d.paid > 0) {
                  sumPaid += d.paid;
                  countPaid++;
                }
                if (d.ad_approved > 0) {
                  sumAdApproved += parseInt(d.ad_approved);
                }
                if (d.ad_pre_approved > 0) {
                  sumAdPreApproved += parseInt(d.ad_pre_approved);
                }

                sumAdDifference += isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : d.ad_approved - d.ad_pre_approved;

                _this2.rows[letter][i].cells = (0, _lodash.orderBy)(_this2.rows[letter][i].cells, [function (item) {
                  return item.date.value;
                }], ['asc']);
              });
              _this2.footColumns[offerId] = {
                label: {
                  value: _this2.$root.$t('statistic.in_total')
                },
                total: {
                  value: sumTotal + ' (' + _Helper2.default.average(sumTotal, count) + ')',
                  graph: true
                },
                processed: {
                  value: sumProcessed + ' (' + _Helper2.default.average(sumProcessed, countProcessed) + ')',
                  graph: true
                },
                proceedPercent: {
                  value: _Helper2.default.percents(sumTotal, sumProcessed)
                },
                accepted: {
                  value: sumAccepted + ' (' + _Helper2.default.average(sumAccepted, countAccepted) + ')',
                  graph: true
                },
                canceled: {
                  value: sumCanceled + ' (' + _Helper2.default.average(sumCanceled, countCanceled) + ')',
                  graph: true
                },
                canceledPercents: {
                  value: _Helper2.default.percents(sumTotal, sumCanceled),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: '%'
                  }
                },
                error: {
                  value: sumError + ' (' + _Helper2.default.average(sumError, countError) + ')',
                  graph: true
                },
                errorPercents: {
                  value: _Helper2.default.percents(sumTotal, sumError),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: '%'
                  }
                },
                return: {
                  value: sumReturn + ' (' + _Helper2.default.average(sumReturn, countReturn) + ')',
                  graph: true
                },
                returnPercents: {
                  value: _Helper2.default.percents(sumAccepted, sumReturn),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: '%'
                  }
                },
                paid: {
                  value: sumPaid + ' (' + _Helper2.default.average(sumPaid, countPaid) + ')',
                  graph: true
                },
                paidPercents: {
                  value: _Helper2.default.percents(sumAccepted, sumPaid),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: '%'
                  }
                },
                averageBill: {
                  value: _Helper2.default.averageBillDayCount(sumAverageBill, sumAccepted),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: '$'
                  }
                },
                averageBillLocal: {
                  value: '' + _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumAccepted, _this2.localCurrencySymbol),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: _this2.localCurrencySymbol
                  }
                },
                averageBuyback: {
                  value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: '$'
                  }
                },
                averageBuybackLocal: {
                  value: '' + _Helper2.default.newLocalAverageBill(sumAverageBuybackLocal, sumPaid, _this2.localCurrencySymbol),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: _this2.localCurrencySymbol
                  }
                },
                approve: {
                  value: _Helper2.default.percents(sumTotal, sumAccepted),
                  graph: {
                    cb: function cb(value) {
                      return _Helper2.default.getRawNumber(value);
                    },
                    symbol: '%'
                  }
                },
                approvedFromValid: {
                  value: _Helper2.default.approvedFromValid(sumAccepted, sumTotal, sumError)
                },
                ad_approved: {
                  value: sumAdApproved
                },
                ad_pre_approved: {
                  value: sumAdPreApproved
                },
                ad_difference: {
                  value: sumAdDifference
                }
              };
            }
          });
        });
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        console.log(response);
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _ConversionsTabs = __webpack_require__(18);

var _ConversionsTabs2 = _interopRequireDefault(_ConversionsTabs);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Period',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    ConversionsTabs: _ConversionsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.offer'), field: 'offer', width: '200px' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2 }, { label: this.$root.$t('statistic.accepted'), field: 'accepted' }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2 }, { label: this.$root.$t('statistic.approve'), field: 'approve', width: '50px' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }, { label: this.$root.$t('statistic.ad_approved'), field: 'ad_approved' }, { label: this.$root.$t('statistic.ad_pre_approved'), field: 'ad_pre_approved' }, { label: this.$root.$t('statistic.ad_difference'), field: 'ad_difference' }],
      rows: [],
      footColumns: {},
      offers: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getConversionsPeriodStatistic().then(function (response) {
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        _this2.offers = _Storage2.default.offers.slice(0);
        var sumTotal = 0;
        var sumProcessed = 0;
        var countProcessed = 0;
        var sumAccepted = 0;
        var countAccepted = 0;
        var sumCanceled = 0;
        var countCanceled = 0;
        var sumError = 0;
        var countError = 0;
        var sumReturn = 0;
        var countReturn = 0;
        var sumPaid = 0;
        var countPaid = 0;
        var sumAverageBill = 0.0;
        var sumAverageBillLocal = 0.0;
        var sumAverageBuyback = 0.0;
        var sumAverageBuybackLocal = 0.0;
        var sumAdApproved = 0;
        var sumAdPreApproved = 0;
        var sumAdDifference = 0;
        var count = Object.keys(response.data).length;

        (0, _lodash.map)(response.data, function (d) {
          _this2.rows.push({
            offer: {
              value: '<b>' + _Helper2.default.findCountry(d.country_id).name + '</b> | ' + _Helper2.default.getOfferTitle(_this2.offers, d.offer_id)
            },
            total: {
              value: d.total,
              bg: true
            },
            processed: {
              value: d.processed,
              bg: true,
              bgg: _Helper2.default.renderGistPart(d.total, d.processed),
              isCollspaned: true
            },
            processedPercent: {
              value: _Helper2.default.percents(d.total, d.processed),
              bgg: _Helper2.default.renderGistPart(d.total, d.processed, true)
            },
            accepted: {
              value: d.approved,
              bg: true
            },
            canceled: {
              value: d.canceled,
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled),
              isCollspaned: true
            },
            canceledPercents: {
              value: _Helper2.default.percents(d.total, d.canceled),
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled, true)
            },
            error: {
              value: d.error,
              bgg: _Helper2.default.renderGistPart(d.total, d.error),
              isCollspaned: true
            },
            errorPercents: {
              value: _Helper2.default.percents(d.total, d.error),
              bgg: _Helper2.default.renderGistPart(d.total, d.error, true)
            },
            return: {
              value: d.return,
              bgg: _Helper2.default.renderGistPart(d.approved, d.return),
              isCollspaned: true
            },
            returnPercents: {
              value: _Helper2.default.percents(d.approved, d.return),
              bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
            },
            paid: {
              value: d.paid,
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
              isCollspaned: true
            },
            paidPercents: {
              value: _Helper2.default.percents(d.approved, d.paid),
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true)
            },
            averageBill: {
              value: '$ ' + d.average_bill.toFixed(2),
              bgg: _Helper2.default.renderGistPart(d.average_bill, d.rate, true)
            },
            averageBillLocal: {
              value: '' + _Helper2.default.newAverageBillDay(d.average_bill, d.rate, (0, _currencySymbolMap2.default)(d.local_currency)),
              bgg: _Helper2.default.renderGistPart(d.average_buyout, d.rate, true)
            },
            averageBuyback: {
              value: '$ ' + d.average_buyout.toFixed(2)
            },
            averageBuybackLocal: {
              value: '' + _Helper2.default.newAverageBillDay(d.average_buyout, d.rate, (0, _currencySymbolMap2.default)(d.local_currency))
            },
            approve: {
              value: _Helper2.default.percents(d.total, d.approved),
              bgg: _Helper2.default.renderSingleGist(d.total, d.approved)
            },
            approvedFromValid: {
              value: d.approved_from_valid.toFixed(1) + '%'
            },
            ad_approved: {
              value: d.ad_approved ? Number(d.ad_approved.toFixed(2)) : 0
            },
            ad_pre_approved: {
              value: d.ad_pre_approved ? Number(d.ad_pre_approved.toFixed(2)) : 0
            },
            ad_difference: {
              value: isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : Number((d.ad_approved - d.ad_pre_approved).toFixed(2))
            }
          });
          sumTotal += d.total;
          if (d.processed > 0) {
            sumProcessed += d.processed;
            countProcessed++;
          }
          if (d.approved) {
            sumAccepted += parseInt(d.approved);
            countAccepted++;
          }
          if (d.approved > 0) {
            sumAverageBill += parseFloat(d.average_bill) * d.approved;
            sumAverageBuyback += parseFloat(d.average_buyout) * d.paid;
            sumAverageBillLocal += parseFloat(d.average_bill * d.rate) * d.approved;
            sumAverageBuybackLocal += parseFloat(d.average_buyout * d.rate) * d.paid;
            _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
          }
          if (d.canceled > 0) {
            sumCanceled += d.canceled;
            countCanceled++;
          }
          if (d.error > 0) {
            sumError += d.error;
            countError++;
          }
          if (d.return > 0) {
            sumReturn += d.return;
            countReturn++;
          }
          if (d.paid > 0) {
            sumPaid += d.paid;
            countPaid++;
          }
          if (d.ad_approved > 0) {
            sumAdApproved += parseInt(d.ad_approved);
          }
          if (d.ad_pre_approved > 0) {
            sumAdPreApproved += parseInt(d.ad_pre_approved);
          }

          sumAdDifference += isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : d.ad_approved - d.ad_pre_approved;
        });
        _this2.footColumns = {
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          total: {
            value: sumTotal + ' (' + _Helper2.default.average(sumTotal, count) + ')'
          },
          processed: {
            value: sumProcessed + ' (' + _Helper2.default.average(sumProcessed, countProcessed) + ')'
          },
          processedPercent: {
            value: _Helper2.default.percents(sumTotal, sumProcessed)
          },
          accepted: {
            value: sumAccepted + ' (' + _Helper2.default.average(sumAccepted, countAccepted) + ')'
          },
          canceled: {
            value: sumCanceled + ' (' + _Helper2.default.average(sumCanceled, countCanceled) + ')'
          },
          canceledPercents: {
            value: _Helper2.default.percents(sumTotal, sumCanceled)
          },
          error: {
            value: sumError + ' (' + _Helper2.default.average(sumError, countError) + ')'
          },
          errorPercents: {
            value: _Helper2.default.percents(sumTotal, sumError)
          },
          return: {
            value: sumReturn + ' (' + _Helper2.default.average(sumReturn, countReturn) + ')'
          },
          returnPercents: {
            value: _Helper2.default.percents(sumAccepted, sumReturn)
          },
          paid: {
            value: sumPaid + ' (' + _Helper2.default.average(sumPaid, countPaid) + ')'
          },
          paidPercents: {
            value: _Helper2.default.percents(sumAccepted, sumPaid)
          },
          averageBill: {
            value: _Helper2.default.averageBillDayCount(sumAverageBill, sumAccepted)
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? '' + _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumAccepted, _this2.localCurrencySymbol) : '-'
          },
          averageBuyback: {
            value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid)
          },
          averageBuybackLocal: {
            value: filterCurrency.length === 1 ? '' + _Helper2.default.newLocalAverageBill(sumAverageBuybackLocal, sumPaid, _this2.localCurrencySymbol) : '-'
          },
          approve: {
            value: _Helper2.default.percents(sumTotal, sumAccepted)
          },
          approvedFromValid: {
            value: _Helper2.default.approvedFromValid(sumAccepted, sumTotal, sumError)
          },
          ad_approved: {
            value: sumAdApproved
          },
          ad_pre_approved: {
            value: sumAdPreApproved
          },
          ad_difference: {
            value: sumAdDifference
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _vueStrap = __webpack_require__(9);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'Rentability',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    modal: _vueStrap.modal
  },
  data: function data() {
    return {
      filtersScope: {
        countryFilter: true,
        dateFilter: true,
        offerFilter: true,
        byWmFilter: true,
        oneCountryFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      confirmModal: false,
      reskc: 0,
      resdoc: 0,
      resVozv: 0,
      oldValue: {},
      ChangeValue: String,
      headColumns: [{ label: this.$root.$t('statistic.offer'), field: 'offer' }, { label: this.$root.$t('statistic.vat'), field: 'vat' }, { label: this.$root.$t('statistic.out'), field: 'out' }, { label: this.$root.$t('statistic.packaging'), field: 'packaging' }, { label: this.$root.$t('statistic.price_for_one'), field: 'price_for_one', width: '60px' }, { label: this.$root.$t('statistic.averageBill'), field: 'average_bill', colspan: 2 }, { label: this.$root.$t('statistic.buyout'), field: 'buyout' }, { label: this.$root.$t('statistic.shippeds'), field: 'shipped' }, { label: this.$root.$t('statistic.average_payments'), field: 'average_payments' }, { label: this.$root.$t('statistic.profitlid'), field: 'profit_for_one' }, { label: this.$root.$t('statistic.profitperiod'), field: 'profit_for_period' }],
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    getApi: function getApi() {
      return new Promise(function (resolve, reject) {
        var statistic = {};
        _API2.default.getOfferRentabilityStatistic().then(function (response) {
          if (response.status === 200) {
            statistic = response.body;
            statistic.status = response.status;
            resolve(statistic);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    checkForm: function checkForm(e) {
      var _this2 = this;

      var post = {};
      var idnum = void 0;
      (0, _lodash.map)(e.target.elements, function (elem) {
        if (elem.name) {
          idnum = elem.id.substring(1);
          if (!post[idnum]) {
            post[idnum] = [];
          }
          post[idnum].push(_defineProperty({}, elem.name, elem.value));
        }
      });
      _API2.default.postEditOfferRentability(post).then(function (response) {
        if (response.status === 200) {
          _this2.calculateRows();
        }
      }).catch(function (error) {
        console.log('Ошибка в запросе', error);
      });

      e.preventDefault();
    },
    calculateRows: function calculateRows() {
      var _this3 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      var max = {
        average_x_price: 0,
        average_bill: 0,
        profit_for_one: 0,
        profit_for_period: 0
      };
      var min = {
        profit_for_one: 0,
        profit_for_period: 0
      };
      var statistic = {};
      var expenses = {};
      this.getApi().then(function (statisticBek) {
        expenses = statisticBek.expenses;
        if (_Storage2.default.selectedCountry.id === 77 || _Storage2.default.selectedCountry.id === 1535 || _Storage2.default.selectedCountry.id === 1547) {
          _this3.reskc = expenses.call_centre.toFixed(2) + '\u20BD';
          _this3.resdoc = expenses.ship.toFixed(2) + '\u20BD';
          _this3.resVozv = expenses.return.toFixed(2) + '\u20BD';
        } else {
          _this3.reskc = expenses.call_centre.toFixed(2) + '$';
          _this3.resdoc = expenses.ship.toFixed(2) + '$';
          _this3.resVozv = expenses.return.toFixed(2) + '$';
        }
        statistic = statisticBek.statistic;
        var sumVat = 0;
        var countVat = 0;
        var sumOut = 0;
        var countOut = 0;
        var sumPack = 0;
        var countPack = 0;
        var sumAverageBill = 0;
        var countAverageBill = 0;
        var sumAverageXPrice = 0;
        var countAverageXPrice = 0;
        var sumBuyout = 0;
        var countBuyout = 0;
        var sumPrice = 0;
        var countPrice = 0;
        var sumShip = 0;
        var countShip = 0;
        var sumProfPer = 0;
        var sumApproved = 0;
        var sumAveragePayment = 0;
        var countAveragePayment = 0;
        var colorProf = '#fff';
        var colorProfT = '#000';
        var colorProfPer = '#fff';
        var colorProfPerT = '#000';
        (0, _lodash.map)(statistic, function (offer, offerid) {
          offer.average_x_price = _Helper2.default.getxstart(offer.average_bill, offer.average_start_price);
          offer.average_payment = parseFloat(offer.average_payment).toFixed(1);
          if (parseFloat(max.average_x_price) < parseFloat(offer.average_x_price)) {
            max.average_x_price = parseFloat(offer.average_x_price);
          }
          if (parseFloat(max.average_bill) < parseFloat(offer.average_bill)) {
            max.average_bill = parseFloat(offer.average_bill);
          }
          if (parseFloat(max.profit_for_one) < parseFloat(offer.profit_for_one)) {
            max.profit_for_one = parseFloat(offer.profit_for_one);
            offer.red = 0;
          }
          if (parseFloat(min.profit_for_one) > parseFloat(offer.profit_for_one)) {
            min.profit_for_one = parseFloat(offer.profit_for_one);
          }
          if (parseFloat(max.profit_for_period) < parseFloat(offer.profit_for_period)) {
            max.profit_for_period = parseFloat(offer.profit_for_period);
          }
          if (parseFloat(min.profit_for_period) > parseFloat(offer.profit_for_period)) {
            min.profit_for_period = parseFloat(offer.profit_for_period);
          }
          if (offer.vat > 0) {
            sumVat += parseFloat(offer.vat);
            countVat++;
          }
          if (offer.out > 0) {
            sumOut += parseFloat(offer.out);
            countOut++;
          }
          if (offer.packaging > 0) {
            sumPack += parseFloat(offer.packaging);
            countPack++;
          }
          if (offer.average_bill > 0) {
            sumAverageBill += parseFloat(offer.average_bill);
            countAverageBill++;
          }
          if (offer.average_x_price > 0) {
            sumAverageXPrice += parseFloat(offer.average_x_price);
            countAverageXPrice++;
          }
          if (offer.shipped > 0) {
            sumShip += parseInt(_Helper2.default.percents(offer.approved, offer.shipped));
            countShip++;
          }
          if (offer.average_payment > 0) {
            sumAveragePayment += parseInt(offer.average_payment);
            countAveragePayment++;
          }
          if (offer.buyout > 0) {
            sumBuyout += parseFloat(_Helper2.default.percents(offer.approved, offer.buyout));
            countBuyout++;
          }
          if (offer.profit_for_period !== 0) {
            sumProfPer += parseInt(offer.profit_for_period);
          }
          if (offer.price_for_one !== 0) {
            sumPrice += parseInt(offer.price_for_one);
            countPrice++;
          }
          if (offer.approved !== 0) {
            sumApproved += parseInt(offer.approved);
          }
        });
        if (sumProfPer > 0) {
          colorProfPer = '#c8e6c9';
          colorProfPerT = '#4f874f';
        } else {
          colorProfPer = '#ef9a9a';
          colorProfPerT = '#a54949';
        }
        if (parseFloat(sumProfPer / sumApproved) > 0) {
          colorProf = '#c8e6c9';
          colorProfT = '#4f874f';
        } else {
          colorProf = '#ef9a9a';
          colorProfT = '#a54949';
        }
        (0, _lodash.map)(statistic, function (d, id) {
          if (_Storage2.default.selectedCountry.id === 77 || _Storage2.default.selectedCountry.id === 1535 || _Storage2.default.selectedCountry.id === 1547) {
            _this3.rows.push({
              offer: { value: _Helper2.default.getOfferTitle(_Storage2.default.offers, id) },
              vat: {
                htmlValue: '<input class="cellInput" id="v' + id + '" name="vat" type="text" onchange="" value="' + d.vat + '" >',
                id: id,
                oldvalue: d.vat,
                name: 'vat',
                notupdate: true,
                orderData: parseInt(d.vat)
              },
              out: {
                htmlValue: '<input class="cellInput" id="o' + id + '" name="out" type="text" onchange="" value="' + d.out + '" >',
                id: id,
                oldvalue: d.out,
                name: 'out',
                notupdate: true,
                orderData: parseInt(d.out)
              },
              packaging: {
                htmlValue: '<input class="cellInput" id="p' + id + '"  name="packaging" type="text" onchange="" value="' + d.packaging + '" >',
                id: id,
                oldvalue: d.packaging,
                name: 'packaging',
                notupdate: true,
                orderData: parseFloat(d.packaging)
              },
              price_for_one: {
                value: parseFloat(d.price_for_one).toFixed(2),
                isCollspaned: true,
                orderData: parseFloat(d.price_for_one)
              },
              average_bill: {
                value: d.average_bill.toFixed(2) + '\u20BD',
                bgg: _Helper2.default.renderSingleGist(max.average_bill, d.average_bill),
                isCollspaned: true,
                orderData: parseFloat(d.average_bill)
              },
              average_x_price2: {
                value: 'x' + parseFloat(d.average_x_price),
                isCollspaned: true,
                orderData: parseFloat(d.average_x_price)
              },
              buyout: {
                value: _Helper2.default.percents(d.approved, d.buyout),
                bgg: _Helper2.default.renderSingleGist(d.approved, d.buyout),
                isCollspaned: true,
                approved: d.approved,
                orderData: parseFloat(d.approved / d.buyout)
              },
              shipped: {
                value: _Helper2.default.percents(d.approved, d.shipped),
                bgg: _Helper2.default.renderSingleGist(d.approved, d.shipped),
                isCollspaned: true,
                orderData: parseFloat(d.approved / d.shipped)
              },
              average_payments: {
                value: parseFloat(d.average_payment) + ' \u20BD',
                bg: true,
                orderData: parseFloat(d.average_payment)
              },
              profit_for_one: {
                value: parseFloat(d.profit_for_one).toFixed(2) + ' \u20BD',
                bgColorTwo: {
                  max: {
                    value: max.profit_for_one,
                    color: '#c8e6c9'
                  },
                  min: {
                    value: min.profit_for_one,
                    color: '#ef9a9a'
                  },
                  value: d.profit_for_one
                },
                orderData: parseFloat(d.profit_for_one)
              },
              profit_for_period: {
                value: parseInt(d.profit_for_period) + ' \u20BD',
                bgColorTwo: {
                  max: {
                    value: max.profit_for_period,
                    color: '#c8e6c9'
                  },
                  min: {
                    value: min.profit_for_period,
                    color: '#ef9a9a'
                  },
                  value: d.profit_for_period
                },
                orderData: parseInt(d.profit_for_period)
              }
            });
          } else {
            _this3.rows.push({
              offer: { value: _Helper2.default.getOfferTitle(_Storage2.default.offers, id) },
              vat: {
                htmlValue: '<input class="cellInput" id="v' + id + '" name="vat" type="text" onchange="" value="' + d.vat + '" >',
                id: id,
                oldvalue: d.vat,
                name: 'vat',
                notupdate: true,
                orderData: parseInt(d.vat)
              },
              out: {
                htmlValue: '<input class="cellInput" id="o' + id + '" name="out" type="text" onchange="" value="' + d.out + '" >',
                id: id,
                oldvalue: d.out,
                name: 'out',
                notupdate: true,
                orderData: parseInt(d.out)
              },
              packaging: {
                htmlValue: '<input class="cellInput" id="p' + id + '"  name="packaging" type="text" onchange="" value="' + d.packaging + '" >',
                id: id,
                oldvalue: d.packaging,
                name: 'packaging',
                notupdate: true,
                orderData: parseFloat(d.packaging)
              },
              price_for_one: {
                value: parseFloat(d.price_for_one).toFixed(2),
                isCollspaned: true,
                orderData: parseFloat(d.price_for_one)
              },
              average_bill: {
                value: '$ ' + d.average_bill.toFixed(2),
                bgg: _Helper2.default.renderSingleGist(max.average_bill, d.average_bill),
                isCollspaned: true,
                orderData: parseFloat(d.average_bill)
              },
              average_x_price2: {
                value: 'x' + parseFloat(d.average_x_price),
                isCollspaned: true,
                orderData: parseFloat(d.average_x_price)
              },
              buyout: {
                value: _Helper2.default.percents(d.approved, d.buyout),
                bgg: _Helper2.default.renderSingleGist(d.approved, d.buyout),
                isCollspaned: true,
                approved: d.approved,
                orderData: parseFloat(d.approved / d.buyout)
              },
              shipped: {
                value: _Helper2.default.percents(d.approved, d.shipped),
                bgg: _Helper2.default.renderSingleGist(d.approved, d.shipped),
                isCollspaned: true,
                orderData: parseFloat(d.approved / d.shipped)
              },
              average_payments: {
                value: parseFloat(d.average_payment) + ' $',
                bg: true,
                orderData: parseFloat(d.average_payment)
              },
              profit_for_one: {
                value: parseFloat(d.profit_for_one).toFixed(2) + ' $',
                bgColorTwo: {
                  max: {
                    value: max.profit_for_one,
                    color: '#c8e6c9'
                  },
                  min: {
                    value: min.profit_for_one,
                    color: '#ef9a9a'
                  },
                  value: d.profit_for_one
                },
                orderData: parseFloat(d.profit_for_one)
              },
              profit_for_period: {
                value: parseInt(d.profit_for_period) + ' $',
                bgColorTwo: {
                  max: {
                    value: max.profit_for_period,
                    color: '#c8e6c9'
                  },
                  min: {
                    value: min.profit_for_period,
                    color: '#ef9a9a'
                  },
                  value: d.profit_for_period
                },
                orderData: parseInt(d.profit_for_period)
              }
            });
          }
        });
        _this3.rows = (0, _lodash.orderBy)(_this3.rows, [function (item) {
          return parseInt(item['buyout'].approved);
        }], ['desc']);
        if (_Storage2.default.selectedCountry.id === 77 || _Storage2.default.selectedCountry.id === 1535 || _Storage2.default.selectedCountry.id === 1547) {
          _this3.footColumns = {
            label: {
              value: _this3.$root.$t('statistic.in_total')
            },
            vat: {
              value: _Helper2.default.average(sumVat, countVat) + ' %',
              isCollspaned: true
            },
            out: {
              value: _Helper2.default.average(sumOut, countOut) + ' %',
              bg: true
            },
            packaging: {
              value: parseFloat(sumPack / countPack).toFixed(2) + ' $',
              bg: true
            },
            price_for_one: {
              value: parseFloat(sumPrice / countPrice).toFixed(1),
              bg: true
            },
            average_bill: {
              value: _Helper2.default.average(sumAverageBill, countAverageBill) + '\u20BD',
              grbgaph: true
            },
            average_x_price2: {
              value: 'x' + parseFloat(sumAverageXPrice / countAverageXPrice).toFixed(2),
              isCollspaned: true
            },
            buyout: {
              value: _Helper2.default.average(sumBuyout, countBuyout) + ' %',
              bg: true
            },
            shipped: {
              value: _Helper2.default.average(sumShip, countShip) + ' %',
              bg: true
            },
            average_payments: {
              value: _Helper2.default.average(sumAveragePayment, countAveragePayment) + ' \u20BD',
              bg: true
            },
            profit_for_one: {
              value: _Helper2.default.averageFloat(sumProfPer, sumApproved) + ' \u20BD',
              bc: colorProf,
              c: colorProfT
            },
            profit_for_period: {
              value: sumProfPer + ' \u20BD',
              bc: colorProfPer,
              c: colorProfPerT
            }
          };
        } else {
          _this3.footColumns = {
            label: {
              value: _this3.$root.$t('statistic.in_total')
            },
            vat: {
              value: _Helper2.default.average(sumVat, countVat) + ' %',
              isCollspaned: true
            },
            out: {
              value: _Helper2.default.average(sumOut, countOut) + ' %',
              bg: true
            },
            packaging: {
              value: parseFloat(sumPack / countPack).toFixed(2) + ' $',
              bg: true
            },
            price_for_one: {
              value: parseFloat(sumPrice / countPrice).toFixed(1),
              bg: true
            },
            average_bill: {
              value: '$ ' + (sumAverageBill / countAverageBill).toFixed(2),
              grbgaph: true
            },
            average_x_price2: {
              value: 'x' + parseFloat(sumAverageXPrice / countAverageXPrice).toFixed(2),
              isCollspaned: true
            },
            buyout: {
              value: _Helper2.default.average(sumBuyout, countBuyout) + ' %',
              bg: true
            },
            shipped: {
              value: _Helper2.default.average(sumShip, countShip) + ' %',
              bg: true
            },
            average_payments: {
              value: _Helper2.default.average(sumAveragePayment, countAveragePayment) + ' $',
              bg: true
            },
            profit_for_one: {
              value: _Helper2.default.averageFloat(sumProfPer, sumApproved) + ' $',
              bc: colorProf,
              c: colorProfT
            },
            profit_for_period: {
              value: sumProfPer + ' $',
              bc: colorProfPer,
              c: colorProfPerT
            }
          };
        }
        _this3.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this3.$root.$emit('data_loaded');
        _this3.$notify({
          type: 'danger',
          title: _this3.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    changeElem: function changeElem(cell, value) {
      if (!cell.notupdate) {
        this.confirmModal = true;
        this.oldValue = cell;
        this.ChangeValue = value;
      }
    },
    confirmValue: function confirmValue(valueBool) {
      var _this4 = this;

      if (valueBool) {
        if (this.oldValue.name === 'vat') {
          _API2.default.getOfferRentabilityСhangeStatisticVAT(this.oldValue.id, this.ChangeValue).then(function (response) {
            _this4.calculateRows();
          });
        }
        if (this.oldValue.name === 'out') {
          _API2.default.getOfferRentabilityСhangeStatisticOUT(this.oldValue.id, this.ChangeValue).then(function (response) {
            _this4.calculateRows();
          });
        }
        if (this.oldValue.name === 'packaging') {
          _API2.default.getOfferRentabilityСhangeStatisticPACK(this.oldValue.id, this.ChangeValue).then(function (response) {
            _this4.calculateRows();
          });
        }
      } else {
        this.calculateRows();
      }
      this.confirmModal = false;
    }
  }
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OperatorActivityChart = __webpack_require__(418);

var _OperatorActivityChart2 = _interopRequireDefault(_OperatorActivityChart);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Activity',
  components: {
    OperatorActivityChart: _OperatorActivityChart2.default,
    Filters: _Filters2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      chartsData: null,
      Helper: _Helper2.default,
      operators: [],
      isLoading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.operators = _Storage2.default.operators.slice(0);
    this.$root.$on('filters_load_new_data', function () {
      _this.calculate();
    });
    this.calculate();
  },

  methods: {
    calculate: function calculate() {
      var _this2 = this;

      this.isLoading = true;
      this.$root.$emit('data_loading');
      this.chartsData = [];
      _API2.default.getOperatorActivity().then(function (response) {
        _this2.operators = _Storage2.default.operators.slice(0);
        _this2.chartsData = response.body.stat;
        _this2.$root.$emit('data_loaded');
        _this2.isLoading = false;
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.isLoading = false;
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true,
        WorkShifts: true
      },
      title: 'Статистика по звонкам',
      headColumns: [{ label: this.$root.$t('statistic.date'), field: 'date', width: '120px' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed' }, { label: this.$root.$t('statistic.accepted'), field: 'accepted' }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.dialer'), field: 'dialer' }, { label: this.$root.$t('statistic.average_first_call_time'), field: 'average_first_call_time', width: '200px' }, { label: this.$root.$t('statistic.average_number_touches'), field: 'average_number_touches', width: '200px' }, { label: this.$root.$t('statistic.average_calls'), field: 'average_calls', width: '200px' }, { label: this.$root.$t('statistic.active_operators'), field: 'active_operators', width: '180px' }, { label: this.$root.$t('statistic.approve'), field: 'approve' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }],
      rows: [],
      footColumns: {},
      isWork: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('handleChangeClose', function (isWorkShift) {
      _this.isWork = isWorkShift;
      _this.calculateRows(_this.isWork);
    });
    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    hourAndMin: function hourAndMin(data) {
      var hourse = Math.floor(data / 60 / 60);
      var minutes = Math.floor(data / 60) - hourse * 60;
      var seconds = Math.floor(data % 60);
      return hourse + ' \u0447. ' + minutes + ' \u043C. ' + seconds + ' \u0441.';
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.rows = [];
      this.footColumns = {};
      this.title = 'Статистика по звонкам';
      _API2.default.getCallStatistics(this.isWork).then(function (response) {
        var sumTotal = 0;
        var sumProcessed = 0;
        var countProcessed = 0;
        var sumAccepted = 0;
        var countAccepted = 0;
        var sumCanceled = 0;
        var countCanceled = 0;
        var sumError = 0;
        var countError = 0;
        var sumDialer = 0.0;
        var sumAverageFirstCallTime = 0.0;
        var sumAverageFirstCallTimeCount = 0;
        var sumAverageChanges = 0.0;
        var sumAverageChangesCount = 0;
        var sumVverageCalls = 0.0;
        var sumVverageCallsCount = 0;
        var countDialer = 0.0;
        var arrActiveOperators = [];
        var totalOperatorsActive = 0;
        var count = Object.keys(response.data).length;
        (0, _lodash.map)(response.data, function (data) {
          var arr = data.active_operators;
          arrActiveOperators.push(arr);
        });
        var splitArr = arrActiveOperators.map(function (item) {
          return item.split(',');
        });
        var concatArrOperatorsActive = [];
        for (var i = 0; i < splitArr.length; i++) {
          concatArrOperatorsActive.push.apply(concatArrOperatorsActive, _toConsumableArray(splitArr[i]));
        }
        var filterArr = concatArrOperatorsActive.filter(function (item, index) {
          return concatArrOperatorsActive.indexOf(item) === index;
        });
        totalOperatorsActive = filterArr.length;
        (0, _lodash.map)(response.data, function (data) {
          _this2.rows.push({
            date: {
              value: data.date
            },
            total: {
              value: data.total
            },
            processed: {
              value: data.processed
            },
            accepted: {
              value: data.approved
            },
            canceled: {
              value: data.canceled
            },
            canceledPercents: {
              value: _Helper2.default.percents(data.total, data.canceled),
              bgg: _Helper2.default.renderGistPart(data.total, data.canceled, true)
            },
            error: {
              value: data.error
            },
            errorPercents: {
              value: _Helper2.default.percents(data.total, data.error),
              bgg: _Helper2.default.renderGistPart(data.total, data.error, true)
            },
            dialer: {
              value: data.ring_up_percent + ' %'
            },
            average_first_call_time: {
              value: '' + _this2.hourAndMin(data.average_first_call_time)
            },
            average_number_touches: {
              value: data.average_changes.toString().replace('.', ',')
            },
            average_calls: {
              value: data.average_calls.toString().replace('.', ',')
            },
            active_operators: {
              value: data.active_operators.split(',').length
            },
            approve: {
              value: _Helper2.default.percents(data.total, data.approved),
              bgg: _Helper2.default.renderSingleGist(data.total, data.approved)
            },
            approvedFromValid: {
              value: _Helper2.default.approvedFromValid(data.approved, data.total, data.error)
            }
          });
          if (data.total > 0) {
            sumTotal += parseInt(data.total);
          }
          if (data.processed > 0) {
            sumProcessed += parseInt(data.processed);
            countProcessed++;
          }
          if (data.approved > 0) {
            sumAccepted += parseInt(data.approved);
            countAccepted++;
          }
          if (data.canceled > 0) {
            sumCanceled += parseInt(data.canceled);
            countCanceled++;
          }
          if (data.error > 0) {
            sumError += parseInt(data.error);
            countError++;
          }
          if (data.ring_up_percent > 0) {
            sumDialer += data.ring_up_percent;
            countDialer++;
          }
          if (data.average_first_call_time > 0) {
            sumAverageFirstCallTime += data.average_first_call_time;
            sumAverageFirstCallTimeCount++;
          }
          if (data.average_changes > 0) {
            sumAverageChanges += data.average_changes;
            sumAverageChangesCount++;
          }
          if (data.average_calls) {
            sumVverageCalls += data.average_calls;
            sumVverageCallsCount++;
          }
          _this2.footColumns = {
            label: {
              value: _this2.$root.$t('statistic.in_total')
            },
            total: {
              value: '' + sumTotal,
              graph: true
            },
            processed: {
              value: '' + sumProcessed,
              graph: true
            },
            accepted: {
              value: '' + sumAccepted,
              graph: true
            },
            canceled: {
              value: '' + sumCanceled,
              graph: true
            },
            canceledPercents: {
              value: _Helper2.default.percents(sumTotal, sumCanceled),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            error: {
              value: '' + sumError,
              graph: true
            },
            errorPercents: {
              value: _Helper2.default.percents(sumTotal, sumError),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            dialer: {
              value: _Helper2.default.averageFloat(sumDialer, countDialer) + ' %',
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            average_first_call_time: {
              value: _this2.hourAndMin(_Helper2.default.averageFloat(sumAverageFirstCallTime, sumAverageFirstCallTimeCount))
            },
            average_number_touches: {
              value: sumAverageChanges ? _Helper2.default.averageFloat(sumAverageChanges, sumAverageChangesCount).replace('.', ',') : '0,0'
            },
            average_calls: {
              value: sumVverageCalls ? _Helper2.default.averageFloat(sumVverageCalls, sumVverageCallsCount).replace('.', ',') : '0,0'
            },
            active_operators: {
              value: totalOperatorsActive
            },
            approve: {
              value: _Helper2.default.percents(sumTotal, sumAccepted),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            approvedFromValid: {
              value: _Helper2.default.approvedFromValid(sumAccepted, sumTotal, sumError)
            }
          };
        });
      });
    }
  }
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  components: {
    StatisticTable: _StatisticTable2.default,
    Filters: _Filters2.default,
    modal: _vueStrap.modal
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      headColumns: [],
      rows: [],
      footColumns: [],
      crossSellModal: false,
      titleModal: '',
      rowsModal: [],
      changeOffers: [],
      search: '',
      getOffersSell: [],
      x: 0,
      operators: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  computed: {
    filterRowsModal: function filterRowsModal() {
      var _this2 = this;

      return this.rowsModal.filter(function (item) {
        return item.offerName.indexOf(_this2.search) !== -1;
      });
    }
  },
  methods: {
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    filterArr: function filterArr(arr) {
      var newArr = arr.filter(function (item, index) {
        return arr.indexOf(item) === index;
      });
      return newArr;
    },
    findOperator: function findOperator(id) {
      var operator = _Helper2.default.getOperatorLogin(this.operators, id);
      return operator;
    },
    approvedFromValid: function approvedFromValid(approved, total, spam) {
      return (approved / (total - spam) * 100).toFixed(1) + '%';
    },
    countById: function countById(array) {
      var resultSplit = array.map(function (item) {
        if (item) {
          return item.split(',');
        } else {
          return [];
        }
      });
      var resultSplitConcat = [];
      for (var i = 0; i < resultSplit.length; i++) {
        resultSplitConcat.push.apply(resultSplitConcat, _toConsumableArray(resultSplit[i]));
      }
      (0, _lodash.uniq)(resultSplitConcat);
      return (0, _lodash.uniq)(resultSplitConcat);
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this3 = this;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.headColumns = [];
                this.rows = [];
                this.footColumns = [];
                _context.next = 5;
                return _API2.default.getOperators(_Helper2.default.getCountryList()).then(function (operators) {
                  _this3.operators = operators.body;
                });

              case 5:
                _context.next = 7;
                return _API2.default.getCrossSell().then(function (response) {
                  _API2.default.getGoodsMain().then(function (goods) {
                    var goodsAll = goods.body;
                    var data = [];
                    var rowItemsGoods = [];
                    var rowItemsGoodsId = [];

                    var goodsId = [];
                    var operatorId = [];

                    var goodsIsMain = goodsAll.filter(function (item) {
                      return item.is_main_good;
                    });
                    var goodsIsMainId = goodsIsMain.map(function (item) {
                      return item.id;
                    });

                    (0, _lodash.map)(response.body, function (arr) {
                      arr.forEach(function (item) {
                        goodsId.push(item.good_id);
                        operatorId.push(item.operator_id);
                      });
                      data.push(arr);
                    });
                    var filterGoodsId = _this3.filterArr(goodsId);
                    var filterOperatorId = _this3.filterArr(operatorId);
                    var totalSumApproved = [];
                    var totalSumAllTotal = [];
                    var totalSumSpam = [];
                    (0, _lodash.map)(data, function (arr) {
                      for (var i = 0; i < filterGoodsId.length; i++) {
                        arr.push({
                          operator_id: arr[i].operator_id,
                          good_id: filterGoodsId[i],
                          total_bill: 0,
                          quantity: 0
                        });
                      }
                      var uniqGoods = (0, _lodash.orderBy)((0, _lodash.uniqBy)(arr, 'good_id'), 'good_id', 'asc');
                      var row = {};
                      var rowItems = [];
                      var quantitySum = 0;
                      var totalSum = 0;
                      var arrApproved = [];
                      var arrApprovedId = [];
                      var arrTotal = [];
                      var arrTotalId = [];
                      var arrSpam = [];
                      var arrSpamId = [];
                      for (var j = 0; j < filterOperatorId.length; j++) {
                        for (var _i = 0; _i < uniqGoods.length; _i++) {
                          if (filterOperatorId[j] === uniqGoods[_i].operator_id) {
                            quantitySum += uniqGoods[_i].quantity ? uniqGoods[_i].quantity : 0;
                            totalSum += uniqGoods[_i].total_bill ? uniqGoods[_i].total_bill : 0;
                            arrApproved = uniqGoods[_i].approved;
                            arrApprovedId.push(arrApproved);
                            arrTotal = uniqGoods[_i].total;
                            arrTotalId.push(arrTotal);
                            arrSpam = uniqGoods[_i].spam;
                            arrSpamId.push(arrSpam);
                            if (goodsIsMainId.includes(uniqGoods[_i].good_id)) {
                              uniqGoods[_i].is_main = true;
                              rowItems.unshift(uniqGoods[_i]);
                            } else {
                              rowItems.push(uniqGoods[_i]);
                            }
                            var countApproved = _this3.countById(arrApprovedId);
                            var countTotal = _this3.countById(arrTotalId);
                            var countSpam = _this3.countById(arrSpamId);
                            rowItems.Quantity = quantitySum;
                            rowItems.AverageBill = quantitySum > 0 ? '$ ' + (totalSum / quantitySum).toFixed(2) : 0;
                            rowItems.Approved = countApproved.length;
                            rowItems.Total = countTotal.length;
                            rowItems.Spam = countSpam.length;
                            row = _defineProperty({}, filterOperatorId[j], rowItems);
                          }
                        }
                      }
                      _this3.rows.push(row);
                      if ((typeof row === 'undefined' ? 'undefined' : _typeof(row)) === 'object') {
                        _this3.headColumns = [];
                        (0, _lodash.map)(row, function (arr) {
                          (0, _lodash.map)(arr, function (item) {
                            _this3.headColumns.push({ label: _Helper2.default.getGoodNameById(goods.body, item.good_id), isMain: item.is_main, color: '#fff9c4', id: item.good_id });
                          });
                        });
                      }
                      (0, _lodash.map)(row[0], function (item) {
                        _this3.headColumns.push({ label: _Helper2.default.getGoodNameById(goods.body, item.good_id), isMain: item.is_main, color: '#fff9c4', id: item.good_id });
                      });
                      (0, _lodash.map)(row, function (arrs) {
                        totalSumApproved.push(arrs.Approved);
                        totalSumAllTotal.push(arrs.Total);
                        totalSumSpam.push(arrs.Spam);
                        (0, _lodash.map)(arrs, function (item) {
                          rowItemsGoods.push(item);
                          rowItemsGoodsId.push(item.good_id);
                        });
                      });
                    });
                    var newIdGoods = _this3.filterArr(rowItemsGoodsId);
                    var totalSumNQuantity = [];
                    var totalSumTotal = [];
                    for (var i = 0; i < newIdGoods.length; i++) {
                      var row = [];
                      for (var j = 0; j < rowItemsGoods.length; j++) {
                        if (newIdGoods[i] === rowItemsGoods[j].good_id) {
                          row.push(rowItemsGoods[j]);
                        }
                      }
                      totalSumNQuantity.push(row.map(function (x) {
                        return x.quantity;
                      }).reduce(function (a, b) {
                        return a + b;
                      }));
                      totalSumTotal.push(row.map(function (x) {
                        return x.total_bill ? x.total_bill : 0;
                      }).reduce(function (a, b) {
                        return a + b;
                      }));
                      _this3.footColumns.push({
                        good_id: newIdGoods[i],
                        footQuantity: row.map(function (x) {
                          return x.quantity;
                        }).reduce(function (a, b) {
                          return a + b;
                        }),
                        footTotal: row.map(function (x) {
                          return x.total_bill;
                        }).reduce(function (a, b) {
                          return a + b;
                        })
                      });
                    }
                    _this3.footColumns.footSumQuantity = (0, _lodash.sum)(totalSumNQuantity);
                    _this3.footColumns.footSumAverageBill = '$ ' + ((0, _lodash.sum)(totalSumTotal) / (0, _lodash.sum)(totalSumNQuantity)).toFixed(2);
                    _this3.footColumns.footSumApproved = (0, _lodash.sum)(totalSumApproved);
                    _this3.footColumns.footSumTotal = (0, _lodash.sum)(totalSumAllTotal);
                    _this3.footColumns.footSumSpam = (0, _lodash.sum)(totalSumSpam);
                  });
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }(),
    getClasses: function getClasses(item) {
      var classes = [];
      if (item.productIsOn) {
        classes.push('isActive');
      } else {
        classes.push('noActive');
      }
      return classes;
    },
    isPopup: function isPopup(product) {
      var _this4 = this;

      this.rowsModal = [];
      this.titleModal = product.label;
      this.getOffersSell = [];
      _API2.default.getOffers(_Helper2.default.getCountryList()).then(function (response) {
        (0, _lodash.map)(response.body, function (item) {
          _this4.rowsModal.push({
            offerName: item.name,
            offerId: item.id,
            countryId: item.country_id,
            productId: product.id,
            productIsOn: item.main_good_id !== null && product.id === item.main_good_id
          });
        });
      });
      this.crossSellModal = true;
    },
    selectedOffers: function selectedOffers(item) {
      if (this.getOffersSell.includes(item)) {
        (0, _lodash.every)(this.getOffersSell, { productIsOn: item.productIsOn = !item.productIsOn });
      } else {
        item.productIsOn = !item.productIsOn;
        this.getOffersSell.push(item);
      }
    },
    crossSellApply: function crossSellApply() {
      var country = [];
      var offersOn = [];
      var offersOff = [];
      (0, _lodash.map)(this.getOffersSell, function (item) {
        country.push(item.countryId);
        if (item.productIsOn) {
          offersOn.push({
            offer_id: item.offerId,
            good_id: item.productId
          });
        } else {
          offersOff.push({
            offer_id: item.offerId,
            good_id: item.productId
          });
        }
      });
      country = this.filterArr(country).join(',');
      if (offersOn.length) {
        _API2.default.postChooseMainGood(country, offersOn);
      }
      if (offersOff.length) {
        _API2.default.postCancelMainGood(country, offersOff);
      }
      this.calculateRows();
      this.crossSellModal = false;
    }
  }
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _vueStrap = __webpack_require__(9);

var _fileSaver = __webpack_require__(17);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _OperatorsTab = __webpack_require__(181);

var _OperatorsTab2 = _interopRequireDefault(_OperatorsTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'Efficiency',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    modal: _vueStrap.modal,
    dropdown: _vueStrap.dropdown,
    OperatorsTab: _OperatorsTab2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      columns: null,
      headColumns: [{ label: 'ID', field: 'id' }, { label: this.$root.$t('statistic.operator'), field: 'operator' }, { label: this.$root.$t('statistic.processed_leads'), field: 'processed' }, { label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2 }, { label: this.$root.$t('statistic.additional_sale'), field: 'additionalSale' }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill' }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback' }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2, splitter: true }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.acceptedSum'), field: 'acceptedSum' }, { label: this.$root.$t('statistic.buyoutSum'), field: 'paidSum' }, { label: this.$root.$t('statistic.old_bonus'), field: 'oldBonus' }, { label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead' }, { label: this.$root.$t('statistic.deviation_mean'), field: 'deviation_mean' }],
      rows: [],
      footColumns: {},
      oldBonusRate: 0.16,
      newBonusRate: 0.0,
      systemOldBonusSum: 0,

      oldBonusSum: 0,

      error: null,
      bonusModal: false,
      exportHistiryModal: false,
      exportHeadColumns: [{ label: this.$root.$t('verbs.manager'), field: 'manager' }, { label: this.$root.$t('statistic.offer'), field: 'offer' }, { label: this.$root.$t('statistic.date'), field: 'date' }, { label: this.$root.$t('filters.period'), field: 'period' }, { label: this.$root.$t('statistic.system_bonus'), field: 'oldBonus' }],
      exportRows: [],
      operators: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    isPopup: function isPopup(cell) {
      var el = document.createElement('textarea');
      el.value = cell.value.trim();
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Скопирован оператор ' + el.value);
    },
    toggleExportHistoryModal: function toggleExportHistoryModal() {
      var _this2 = this;

      if (!this.exportHistiryModal) {
        this.exportRows = [];
        _API2.default.getOperatorStatisticExportHistory().then(function (response) {
          var orderedResponse = (0, _lodash.orderBy)(response.body, ['date'], ['ASC']);
          orderedResponse.map(function (d) {
            _this2.exportRows.push({
              manager: { value: d.manager, bg: true },
              offer: { value: _Helper2.default.getExportedOffers(d.offer_id), bg: true },
              date: { value: d.date, bg: true },
              period: { value: d.period, bg: true },
              systemBonus: { value: '$ ' + d.system_bonus, bgc: d.bonus_type === 0 ? _TypeColor2.default.oldBonusHistory : _TypeColor2.default.newBonusHistory },
              paidBonus: { value: '$ ' + d.paid_bonus, bgc: d.bonus_type === 0 ? _TypeColor2.default.oldBonusHistory : _TypeColor2.default.newBonusHistory }
            });
          });
          _this2.exportHistiryModal = true;
        }).catch(function (response) {
          _this2.$notify({
            type: 'danger',
            title: _this2.$root.$t('verbs.error'),
            text: response.body.message ? response.body.message : response.body,
            animationType: 'velocity'
          });
        });
      } else {
        this.exportHistiryModal = false;
      }
    },
    exportBonus: function exportBonus(type) {
      var _this3 = this;

      _API2.default.saveOperatorStatisticExportHistory(type === 0 ? this.systemOldBonusSum : this.systemNewBonusSum, type === 0 ? this.oldBonusSum : this.newBonusSum, type).then(function () {
        _this3.columns = {
          operator: true,
          processed: true,
          accepted: true,
          averageBill: true,
          paidSum: true,
          additionalSale: true,
          oldBonus: type === 0,
          newBonus: type === 1
        };
        _this3.headColumns[6].label = _this3.$root.$t('statistic.paid');
        _this3.$nextTick(function () {
          this.$refs.statisticTable.exporting(null);
          this.headColumns[6].label = this.$root.$t('statistic.buyoutSum');
          this.columns = null;
        });
      }).catch(function () {
        _this3.$notify({
          type: 'danger',
          title: _this3.$root.$t('verbs.error'),
          text: _this3.$root.$t('statistic.export_error'),
          animationType: 'velocity'
        });
      });
    },
    toggleBonusModal: function toggleBonusModal() {
      this.bonusModal = !this.bonusModal;
    },
    applyBonus: function applyBonus() {
      this.error = null;
      if (!_Helper2.default.isFloat(parseFloat(this.oldBonusRate)) && !_Helper2.default.isInt(parseFloat(this.oldBonusRate)) || !_Helper2.default.isInt(parseFloat(this.newBonusRate)) && !_Helper2.default.isInt(parseFloat(this.newBonusRate))) {
        this.error = this.$root.$t('verbs.invalid_parameters');
      } else {
        this.toggleBonusModal();
        this.calculateRows(true);
      }
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(isApplyBonus) {
        var _this4 = this;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$root.$emit('data_loading');
                this.rows = [];
                this.operators = [];
                _context.next = 5;
                return _API2.default.getOperators(_Helper2.default.getCountryList()).then(function (operators) {
                  _this4.operators = operators.body;
                });

              case 5:
                _context.next = 7;
                return _API2.default.getOperatorStatistic().then(function (response) {
                  var countItems = response.body.length;
                  var sumProcessedLeads = 0;
                  var sumAccepted = 0;
                  var sumAcceptedRevenua = 0;
                  var countAcceptedRevenua = 0;
                  var countAccepted = 0;
                  var sumPaid = 0;
                  var countPaid = 0;
                  var sumPaidRevenua = 0;
                  var countPaidRevenua = 0;
                  var sumReturn = 0;
                  var countReturn = 0;
                  var sumAverageBill = 0.0;
                  var sumAverageBuyback = 0.0;
                  var sumAverageSum = 0.0;
                  var sumBuyoutSum = 0.0;
                  var sumAdditionslSale = 0;
                  var countAdditionalSale = 0;
                  var sumOldBonus = 0;
                  var countOldBonus = 0;
                  var resultAverageLead = 0.0;
                  var resultRevenuaLeadAverage = 0.0;
                  var count = 0;
                  if (!isApplyBonus) {
                    _this4.newBonusRate = 0.0;
                    var sortedData = (0, _lodash.orderBy)(response.data, [function (item) {
                      return item.average_bill * item.buyout;
                    }], ['desc']);
                    var topIndex = 0;
                    for (; topIndex < 10; topIndex++) {
                      if (sortedData[topIndex]) {
                        if (sortedData[topIndex].additional_sale < 0) {
                          sortedData[topIndex].additional_sale = 0;
                        }
                        if (parseFloat(_Helper2.default.averageBill(sortedData[topIndex].average_bill * sortedData[topIndex].buyout, false, true)) < 1) {
                          break;
                        }
                        _this4.newBonusRate += parseFloat(_Helper2.default.averageBill(sortedData[topIndex].average_bill * sortedData[topIndex].buyout, false, true)) / parseFloat(sortedData[topIndex].additional_sale * _this4.oldBonusRate);
                      } else {
                        break;
                      }
                    }
                    _this4.newBonusRate = parseFloat(parseFloat(_this4.newBonusRate) / parseFloat(topIndex)).toFixed(0);
                    if (isNaN(_this4.newBonusRate)) {
                      _this4.newBonusRate = 0;
                    }
                    _this4.systemNewBonusRate = _this4.newBonusRate;
                  }

                  (0, _lodash.map)(response.data, function (d) {
                    var oldBonus = parseFloat(parseFloat(d.additional_sale) * _this4.oldBonusRate).toFixed(0);
                    if (d) {
                      count++;
                    }
                    if (isNaN(oldBonus)) {
                      oldBonus = 0;
                    }
                    if (d.approved > 0) {
                      sumAcceptedRevenua += parseInt(d.approved);
                      countAcceptedRevenua++;
                    }
                    if (d.buyout > 0) {
                      sumPaidRevenua += parseInt(d.buyout);
                      countPaidRevenua++;
                    }
                    if (d.approved) {
                      countAccepted++;
                      sumAverageBill += parseFloat(d.average_bill_usd) * parseInt(d.approved);
                      sumAverageBuyback += parseFloat(d.average_buyout_usd) * parseInt(d.buyout);
                      sumAccepted += parseInt(d.approved);
                    }
                    if (d.buyout > 0) {
                      sumPaid += parseInt(d.buyout);
                      countPaid++;
                    }

                    var percentPaid = _Helper2.default.percents(d.approved, d.buyout).replace('%', '').replace(',', '.');
                    var revenuaLead = d.average_buyout_usd * (parseFloat(percentPaid) / 100);
                    var averageBuyoutGlobal = _Helper2.default.averageBill(d.average_buyout_global_usd).replace('$', '').replace(',', '.');
                    var averageSum = _Helper2.default.percents(sumAcceptedRevenua, sumPaidRevenua).replace('%', '').replace(',', '.');
                    resultAverageLead = averageBuyoutGlobal / averageSum * 100;
                    _this4.$nextTick(function () {
                      var rezultDeviation = 0.0;
                      rezultDeviation = resultRevenuaLeadAverage > 0 ? -(1 - revenuaLead / resultRevenuaLeadAverage) * 100 : 0;
                      this.rows.push({
                        id: {
                          value: d.operator_id
                        },
                        operator: { value: _Helper2.default.getOperatorLogin(this.operators, d.operator_id) + ' ' + (_Storage2.default.developMode ? '(' + d.operator_id + ')' : ''), popup: true },
                        processed: {
                          value: d.total,
                          bg: true,
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        accepted: {
                          value: d.approved,
                          isCollspaned: true,
                          bgg: _Helper2.default.renderGistPart(d.total, d.approved),
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        acceptedPercents: {
                          value: _Helper2.default.percents(parseInt(d.total), parseInt(d.approved)),
                          isCollspaned: true,
                          bgg: _Helper2.default.renderGistPart(d.total, d.approved, true),
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        additionalSale: {
                          value: d.additional_sale,
                          bg: true
                        },
                        averageBill: {
                          value: '$ ' + d.average_bill_usd.toFixed(2)
                        },
                        averageBuyback: {
                          value: '$ ' + d.average_buyout_usd.toFixed(2)
                        },
                        paid: {
                          value: d.buyout,
                          bgg: _Helper2.default.renderGistPart(d.approved, d.buyout),
                          isCollspaned: true
                        },
                        paidPercents: {
                          value: _Helper2.default.percents(d.approved, d.buyout),
                          bgg: _Helper2.default.renderGistPart(d.approved, d.buyout, true),
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        return: {
                          value: d.return,
                          bgg: _Helper2.default.renderGistPart(d.approved, d.return),
                          isCollspaned: true
                        },
                        returnPercents: {
                          value: _Helper2.default.percents(d.approved, d.return),
                          bgg: _Helper2.default.renderGistPart(d.approved, d.return, true),
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        acceptedSum: {
                          value: '$ ' + (d.average_bill_usd * d.approved).toFixed(2),
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        paidSum: {
                          value: '$ ' + (d.average_buyout_usd * d.buyout).toFixed(2),
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        oldBonus: {
                          value: '$ ' + oldBonus,
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        revenue_lead: {
                          value: '$ ' + revenuaLead.toFixed(2)
                        },
                        deviation_mean: {
                          value: rezultDeviation.toFixed(2) + '%',
                          plusBg: rezultDeviation >= 0
                        }
                      });
                    });
                    if (d.total > 0) {
                      sumProcessedLeads += parseInt(d.total);
                    }
                    if (oldBonus > 0) {
                      sumOldBonus += parseInt(oldBonus, 10);
                      countOldBonus++;
                    }
                    sumReturn += parseInt(d.return);
                    if (d.return > 0) {
                      countReturn++;
                    }
                    if (d.additional_sale > 0) {
                      sumAdditionslSale += parseInt(d.additional_sale);
                      countAdditionalSale++;
                    }
                    sumAverageSum += d.average_bill_usd * d.approved;
                    sumBuyoutSum += d.average_buyout_usd * d.buyout;
                  });

                  var sumAverageBuybackRevenua = _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid).replace('$', '').replace(',', '.');
                  var paidPercentsRevenua = _Helper2.default.percents(sumAccepted, sumPaid).replace('%', '').replace(',', '.');
                  resultRevenuaLeadAverage = (sumAverageBuybackRevenua * paidPercentsRevenua / 100).toFixed(2);
                  _this4.footColumns = {
                    id: {
                      value: ' '
                    },
                    label: {
                      value: _this4.$root.$t('statistic.in_total')
                    },
                    processed: {
                      value: '' + sumProcessedLeads
                    },
                    accepted: {
                      value: '' + sumAccepted
                    },
                    acceptedPercents: {
                      value: _Helper2.default.percents(sumProcessedLeads, sumAccepted)
                    },
                    additionalSale: {
                      value: '' + sumAdditionslSale
                    },
                    averageBill: {
                      value: _Helper2.default.averageBillDayCount(sumAverageBill, sumAccepted)
                    },
                    averageBuyback: {
                      value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid)
                    },
                    paid: {
                      value: '' + sumPaid
                    },
                    paidPercents: {
                      value: _Helper2.default.percents(sumAccepted, sumPaid)
                    },
                    return: {
                      value: '' + sumReturn
                    },
                    returnPercents: {
                      value: _Helper2.default.percents(sumAccepted, sumReturn)
                    },
                    acceptedSum: {
                      value: '$ ' + (sumAverageSum / countItems).toFixed(2)
                    },
                    paidSum: {
                      value: '$ ' + (sumBuyoutSum / countItems).toFixed(2)
                    },
                    oldBonus: {
                      value: '$ ' + sumOldBonus
                    },
                    revenue_lead: {
                      value: '$ ' + resultRevenuaLeadAverage
                    }
                  };
                  if (!isApplyBonus) {
                    _this4.systemOldBonusSum = _this4.oldBonusSum = sumOldBonus;
                  } else {
                    _this4.oldBonusSum = sumOldBonus;
                  }
                  _this4.$root.$emit('data_loaded');
                }).catch(function (response) {
                  _this4.$root.$emit('data_loaded');
                  _this4.$notify({
                    type: 'danger',
                    title: _this4.$root.$t('verbs.error'),
                    text: !response.body.message ? response.body : response.body.message,
                    animationType: 'velocity'
                  });
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows(_x) {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }(),
    exportingAll: function exportingAll() {
      var doc = [];
      this.rows.forEach(function (item) {
        doc.push('<?xml version="1.0"?>\n            <?mso-application progid="Excel.Sheet"?>\n            <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"\n             xmlns:o="urn:schemas-microsoft-com:office:office"\n             xmlns:x="urn:schemas-microsoft-com:office:excel"\n             xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"\n             xmlns:html="http://www.w3.org/TR/REC-html40">\n             <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office">\n             </DocumentProperties>\n             <ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel">\n             </ExcelWorkbook>\n             <Styles>\n              <Style ss:ID="Default" ss:Name="Normal">\n               <Alignment ss:Vertical="Bottom"/>\n               <Borders/>\n               <Font ss:FontName="Calibri" x:CharSet="204" x:Family="Swiss" ss:Size="11" ss:Color="#000000"/>\n               <Interior/>\n               <NumberFormat/>\n               <Protection/>\n              </Style>\n              <Style ss:ID="s62">\n               <NumberFormat ss:Format="#,##0.00&quot;\u0440.&quot;"/>\n              </Style>\n             </Styles>\n             <Worksheet ss:Name="' + item.operator.value + '">\n              <Table ss:ExpandedColumnCount="2" ss:ExpandedRowCount="3" x:FullColumns="1" x:FullRows="1" ss:DefaultRowHeight="15">\n               <Row ss:AutoFitHeight="0">\n                <Cell><Data ss:Type="String">\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440</Data></Cell>\n                <Cell><Data ss:Type="String">\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043E \u043B\u0438\u0434\u043E\u0432</Data></Cell>\n                <Cell><Data ss:Type="String">\u041E\u0434\u043E\u0431\u0440\u0435\u043D\u043E</Data></Cell>\n               </Row>\n              </Table>\n              <WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">\n               <PageSetup>\n                <Header x:Margin="0.3"/>\n                <Footer x:Margin="0.3"/>\n                <PageMargins x:Bottom="0.75" x:Left="0.7" x:Right="0.7" x:Top="0.75"/>\n               </PageSetup>\n               <Unsynced/>\n               <Print>\n                <ValidPrinterInfo/>\n                <PaperSizeIndex>9</PaperSizeIndex>\n                <HorizontalResolution>600</HorizontalResolution>\n                <VerticalResolution>600</VerticalResolution>\n               </Print>\n               <Selected/>\n               <ProtectObjects>False</ProtectObjects>\n               <ProtectScenarios>False</ProtectScenarios>\n              </WorksheetOptions>\n             </Worksheet>\n            </Workbook>');
      });
      _fileSaver2.default.saveAs(new Blob([doc], {
        encoding: 'UTF-8',
        type: 'application/octet-stream'
      }), 'analytics-offers.xls');
    }
  }
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _lodash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ExpectedExpensesKC',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        monthFilter: true,
        byManualFilter: true
      },
      loading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      rows: [],
      title: this.$root.$t('pages.expenses_by_kc'),
      oldValue: {},
      ChangeValue: String,
      countryTitle: [],
      headColumns: [{ label: this.$root.$t('statistic.month'), width: '20%' }, { label: this.$root.$t('statistic.leads'), field: 'leads', width: '11%' }, { label: this.$root.$t('statistic.approve'), field: 'approved_rentabilty', width: '11%' }, { label: this.$root.$t('statistic.approve_percent'), field: 'approved_percent', width: '11%' }, { label: this.$root.$t('pages.expenses_by_kc'), field: 'expenses_by_kc', width: '11%' }, { label: this.$root.$t('statistic.expenses_by_lead'), field: 'expenses_by_lead', width: '11%' }, { label: this.$root.$t('statistic.expected_lead_increase'), field: 'expected_lead_increase', width: '11%' }, { label: this.$root.$t('statistic.cost_change'), field: 'cost_change_other_month', width: '11%' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid' }],
      date: null,
      footColumns: [],
      rowsAll: [],
      footAll: {},
      other: {},
      allCountry: false,
      month: {
        1: 'Январь',
        2: 'Февраль',
        3: 'Март',
        4: 'Апрель',
        5: 'Май',
        6: 'Июнь',
        7: 'Июль',
        8: 'Август',
        9: 'Сентябрь',
        10: 'Октябрь',
        11: 'Ноябрь',
        12: 'Декабрь'
      }
    };
  },

  computed: {
    computedHeadColumns: function computedHeadColumns() {
      var _this = this;

      if (!this.columns) {
        return this.headColumns;
      } else {
        var headColumns = [];
        this.headColumns.map(function (d) {
          if (_this.columns[d.field]) {
            headColumns.push(d);
          }
        });
        return headColumns;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getData();
    this.getCountry();
    this.$root.$on('filters_load_new_data', function () {
      _this2.getData();
      _this2.getCountry();
    });
  },

  methods: {
    renderBackground: function renderBackground(cell, i, bc) {
      var style = !cell.style ? {} : cell.style;
      if (!cell || cell.bgg === undefined && !cell.dbgg) {
        style.backgroundColor = !cell.bgc ? this.TypeColor[i] : cell.bgc;
      } else {
        if (!cell.dbgg) {
          if (!cell.bgl) {
            style.background = 'linear-gradient(to right, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
          } else {
            style.background = 'linear-gradient(to left, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
            style.position = 'relative';
          }
        } else {
          style.background = 'linear-gradient(to right, ' + this.TypeColor[cell.dbgg[0].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + (cell.dbgg[0].width + cell.dbgg[1].width) + '%, transparent 0%)';
        }
      }
      if (bc.bc) {
        style.backgroundColor = '' + bc.bc;
        style.color = bc.c;
      }
      if (cell.bgColorTwo) {
        var summ = Math.abs(cell.bgColorTwo.max.value) + Math.abs(cell.bgColorTwo.min.value);
        var minPercent = (Math.abs(cell.bgColorTwo.min.value) / summ * 100).toFixed(0);
        var maxPercent = (Math.abs(cell.bgColorTwo.max.value) / summ * 100).toFixed(0);
        var percent = void 0;
        if (cell.bgColorTwo.value < 0) {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.min.value) * minPercent + parseInt(maxPercent);
          style.background = 'linear-gradient(to left, transparent 0%, transparent ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        } else {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.max.value) * maxPercent + parseInt(minPercent);
          style.background = 'linear-gradient(to right, transparent 0%, transparent ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        }
        style.position = 'relative';
      }
      return style;
    },
    getData: function getData() {
      var _this3 = this;

      this.$root.$emit('data_loading');
      this.loading = true;
      this.rows = [];
      this.rowsAll = [];
      this.footColumns = [];
      this.footAll = {};
      _API2.default.getRentabilityExpenseExpection().then(function (res) {
        var date = new Date().getDate();
        var dateNow = new Date();
        var yearsNow = dateNow.getFullYear();
        var monthNow = dateNow.getMonth() + 1;
        if (monthNow !== 10 || monthNow !== 11 || monthNow !== 12) {
          monthNow = '0' + monthNow;
        }
        _this3.date = yearsNow + '-' + monthNow;
        var total = 0;
        var count = 0;
        var totalApproved = 0;
        var otherKC = 0;
        var totalAllKC = 0;
        var totalApprovedPercent = 0;
        var totalKc = 0;
        var indexCur = 0;
        var indexPrev = 0;
        var pricePrev = 0;
        var storageCountry = {};
        var leadIncrease = 0;
        var objArr = [];
        var arrNameCountry = [];
        var totalSpam = 0;
        if (_Storage2.default.selectedCountry.id === -1) {
          _this3.allCountry = true;
          (0, _lodash.map)(_Storage2.default.countries, function (stCountry) {
            (0, _lodash.map)(res.body, function (o, countryId) {
              var innCur = 0;
              var innPrev = 0;
              if (o.length === 1) {
                pricePrev = Number(o[o.length - 1].price);
              } else if (o.length > 1) {
                pricePrev = Number(o[o.length - 2].price);
              }
              if (stCountry.id === parseInt(countryId)) {
                (0, _lodash.map)(o, function (d, i) {
                  if (!storageCountry[d.country_id]) {
                    storageCountry[d.country_id] = [];
                  }
                  if (_this3.date === d.month) {
                    leadIncrease = _Helper2.default.leadIncrease(o[o.length - 1].price, o[o.length - 1].approved, o[o.length - 1].total, date, _this3.getDays(monthNow, yearsNow));
                  }
                  var fullMonth = d.month;

                  var monthIndex = parseInt(fullMonth.substr(5, 2));
                  var year = fullMonth.substr(0, 4);
                  if (parseInt(o[innCur].price) === 0 && parseInt(o[innPrev].price) === 0) {
                    storageCountry[d.country_id].push({
                      id: i,
                      dateByRows: d.month,
                      month: _this3.month[monthIndex] + ' ' + year,
                      leads: parseInt(d.total),
                      approved_percent: '' + d.approved / d.total,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                      expenses_by_lead: parseFloat(d.price),
                      expected_lead_increase: leadIncrease,
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: 0,
                      cost_change_current_month: ((leadIncrease - pricePrev) / pricePrev * 100).toFixed(2),
                      approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                    });
                  } else if (parseInt(o[innPrev].price) === 0) {
                    storageCountry[d.country_id].push({
                      id: i,
                      dateByRows: d.month,
                      month: _this3.month[monthIndex] + ' ' + year,
                      leads: parseInt(d.total),
                      approved_percent: '' + d.approved / d.total,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                      expenses_by_lead: Number(d.price),
                      expected_lead_increase: leadIncrease,
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: 0,
                      cost_change_current_month: ((leadIncrease - pricePrev) / pricePrev * 100).toFixed(2),
                      approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                    });
                  } else if (Number(d.price) === 0) {
                    var increaseForMonth = Number(o[innPrev].price) * Number(o[innPrev].approved) / (Number(o[o.length - 1].total) / date * _this3.getDays(monthNow, yearsNow) * (Number(d.approved) / Number(d.total)));
                    storageCountry[d.country_id].push({
                      id: i,
                      dateByRows: d.month,
                      month: _this3.month[monthIndex] + ' ' + year,
                      leads: parseInt(d.total),
                      approved_percent: '' + d.approved / d.total,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(o[innPrev].price) * parseInt(o[innPrev].approved)).toFixed(2),
                      expenses_by_lead: Number(o[innPrev].price),
                      expected_lead_increase: increaseForMonth.toFixed(2),
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: 0,
                      cost_change_current_month: ((increaseForMonth - pricePrev).toFixed(3) / pricePrev * 100).toFixed(2),
                      approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam)),
                      isChanged: true
                    });
                  } else {
                    storageCountry[d.country_id].push({
                      id: i,
                      dateByRows: d.month,
                      month: _this3.month[monthIndex] + ' ' + year,
                      leads: parseInt(d.total),
                      approved_percent: '' + d.approved / d.total,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                      expenses_by_lead: Number(d.price),
                      expected_lead_increase: leadIncrease,
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: ((o[innCur].price - o[innPrev].price) / o[innPrev].price * 100).toFixed(2),
                      cost_change_current_month: ((leadIncrease - pricePrev) / pricePrev * 100).toFixed(2),
                      approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                    });
                  }
                  innPrev = innCur;
                  if (innCur !== o.length - 1) {
                    innCur = innCur = innCur + 1;
                  } else {
                    innCur = o.length - 1;
                  }
                });
              }
            });
          });
        } else {
          (0, _lodash.map)(res.body, function (o) {
            if (o.length === 1) {
              pricePrev = Number(o[o.length - 1].price);
            } else if (o.length > 1) {
              pricePrev = Number(o[o.length - 2].price);
            }
            (0, _lodash.map)(o, function (d, i) {
              _this3.allCountry = false;
              count = i + 1;
              if (_this3.date === d.month) {
                leadIncrease = _Helper2.default.leadIncrease(o[o.length - 1].price, o[o.length - 1].approved, o[o.length - 1].total, date, _this3.getDays(monthNow, yearsNow));
              }
              if (indexCur === o.length - 1) {
                indexCur = o.length - 1;
              }
              var fullMonth = d.month;
              total += parseInt(d.total);
              totalApprovedPercent += d.approved / d.total;
              totalApproved += parseInt(d.approved);
              totalSpam += parseInt(d.spam);
              if (Number(d.price) === 0) {
                otherKC += Number(o[indexPrev].price) * parseInt(o[indexPrev].approved).toFixed(2);
              } else {
                totalKc += Number(d.price) * Number(d.approved);
              }
              totalAllKC = otherKC + totalKc;
              var monthIndex = parseInt(fullMonth.substr(5, 2));
              var year = fullMonth.substr(0, 4);
              var country = _Helper2.default.findCountry(parseInt(d.country_id));
              _this3.countryTitle = country.name;
              if (parseInt(o[indexCur].price) === 0 && parseInt(o[indexPrev].price) === 0) {
                _this3.rows.push({
                  id: i,
                  dateByRows: d.month,
                  month: _this3.month[monthIndex] + ' ' + year,
                  leads: parseInt(d.total),
                  approved_percent: '' + d.approved / d.total,
                  approved: parseInt(d.approved),
                  expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                  expenses_by_lead: parseFloat(d.price),
                  expected_lead_increase: leadIncrease,
                  country_id: parseInt(d.country_id),
                  cost_change_other_month: 0,
                  cost_change_current_month: ((leadIncrease - pricePrev) / pricePrev * 100).toFixed(2),
                  approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam)),
                  was_empty: parseInt(d.was_empty)
                });
              } else if (parseInt(o[indexPrev].price) === 0) {
                _this3.rows.push({
                  id: i,
                  dateByRows: d.month,
                  month: _this3.month[monthIndex] + ' ' + year,
                  leads: parseInt(d.total),
                  approved_percent: '' + d.approved / d.total,
                  approved: parseInt(d.approved),
                  expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                  expenses_by_lead: Number(d.price),
                  expected_lead_increase: leadIncrease,
                  country_id: parseInt(d.country_id),
                  cost_change_other_month: 0,
                  cost_change_current_month: ((leadIncrease - pricePrev) / pricePrev * 100).toFixed(2),
                  approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                });
              } else if (Number(d.price) === 0) {
                var increaseForMonth = Number(o[indexPrev].price) * Number(o[indexPrev].approved) / (Number(o[o.length - 1].total) / date * _this3.getDays(monthNow, yearsNow) * (Number(d.approved) / Number(d.total)));
                _this3.rows.push({
                  id: i,
                  dateByRows: d.month,
                  month: _this3.month[monthIndex] + ' ' + year,
                  leads: parseInt(d.total),
                  approved_percent: '' + d.approved / d.total,
                  approved: parseInt(d.approved),
                  expenses_by_kc: (Number(o[indexPrev].price) * parseInt(o[indexPrev].approved)).toFixed(2),
                  expenses_by_lead: Number(o[indexPrev].price),
                  expected_lead_increase: increaseForMonth.toFixed(3),
                  country_id: parseInt(d.country_id),
                  cost_change_other_month: 0,
                  cost_change_current_month: ((increaseForMonth - pricePrev).toFixed(3) / pricePrev * 100).toFixed(2),
                  approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam)),
                  isChanged: true
                });
              } else {
                _this3.rows.push({
                  id: i,
                  dateByRows: d.month,
                  month: _this3.month[monthIndex] + ' ' + year,
                  leads: parseInt(d.total),
                  approved_percent: '' + d.approved / d.total,
                  approved: parseInt(d.approved),
                  expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                  expenses_by_lead: Number(d.price),
                  expected_lead_increase: leadIncrease,
                  country_id: parseInt(d.country_id),
                  cost_change_other_month: ((o[indexCur].price - o[indexPrev].price) / o[indexPrev].price * 100).toFixed(2),
                  cost_change_current_month: ((leadIncrease - pricePrev) / pricePrev * 100).toFixed(2),
                  approvedFromValid: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                });
              }
              indexPrev = indexCur;
              indexCur = indexCur + 1;
            });
          });
        }
        (0, _lodash.map)(storageCountry, function (b, countryId) {
          var totalAll = 0;
          var totalApproved = 0;
          var byTotalAprrovedPercent = 0;
          var byTotalExpenses = 0;
          indexCur = 0;
          indexPrev = 0;
          var indexCount = 0;
          var totalAllCountryKc = 0;

          (0, _lodash.map)(b, function (g, index) {
            if (!g.expenses_by_lead) {
              g.expenses_by_lead = 0;
              byTotalExpenses += Number(g.expenses_by_lead) * Number(g.approved);
              totalAllCountryKc += Number(g.expenses_by_kc);
            } else {
              byTotalExpenses += Number(g.expenses_by_lead) * Number(g.approved);
              totalAllCountryKc += Number(g.expenses_by_kc);
            }
            totalAll += parseInt(g.leads);
            totalApproved += parseInt(g.approved);
            byTotalAprrovedPercent += parseInt(g.approved) / parseInt(g.leads);
            indexCount = index + 1;

            indexPrev = indexCur;
            indexCur = indexCur + 1;
          });
          if (!_this3.footAll[countryId]) {
            _this3.footAll[countryId] = {};
          }
          _this3.footAll[countryId] = {
            total: (totalAll / indexCount).toFixed(0),
            totalApproved: (totalApproved / indexCount).toFixed(0),
            totalApprovedPercent: (byTotalAprrovedPercent / indexCount * 100).toFixed(2),
            totalKc: (totalAllCountryKc / indexCount).toFixed(0),
            approvedFromValid: _Helper2.default.approvedFromValid(totalApproved, total, totalSpam)
          };
        });
        _this3.rowsAll = storageCountry;
        _this3.footColumns.push({
          total: (total / count).toFixed(0),
          totalApproved: (totalApproved / count).toFixed(0),
          totalApprovedPercent: totalApprovedPercent / count,
          totalKc: (totalAllKC / count).toFixed(0),
          approvedFromValid: _Helper2.default.approvedFromValid(totalApproved, total, totalSpam)
        });
        _this3.loading = false;
        _this3.$root.$emit('data_loaded');
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeElem: function changeElem(cell, value) {
      this.oldValue = cell;
      this.ChangeValue = value;
    },
    getDays: function getDays(month, year) {
      return new Date(year, month, 0).getDate();
    },
    getCountry: function getCountry() {
      _API2.default.getCountries().then(function (res) {
        _Storage2.default.countries = res.body;
      }).catch(function (error) {
        console.log(error);
      });
    },

    checkForm: function checkForm(e) {
      var _this4 = this;

      var post = [];
      var month = void 0,
          country = void 0;
      (0, _lodash.map)(e.target.elements, function (elem) {
        if (elem.name) {
          month = elem.id.substring(1);
          country = elem.name.substring(1);
          post.push({
            'country_id': country,
            'month': month,
            'price': elem.value
          });
        }
      });
      _API2.default.postRentabilityExpenseExpection(post).then(function (res) {
        _this4.getData();
      }).catch(function (response) {
        _this4.$root.$emit('data_loaded');
        _this4.$notify({
          type: 'danger',
          title: _this4.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
      e.preventDefault();
    }
  }
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _lodash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OperatorSchedule',
  components: {
    Filters: _Filters2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true
      },
      loading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      rows: [],
      rowsAll: [],
      headColumns: [],
      headColumnsAll: [],
      hoursHead: [],
      allCountry: false,
      isShow: false,
      approved: null,
      total: null
    };
  },

  computed: {
    computedHeadColumns: function computedHeadColumns() {
      var _this = this;

      if (!this.columns) {
        return this.headColumns;
      } else {
        var headColumns = [];
        this.headColumns.map(function (d) {
          if (_this.columns[d.field]) {
            headColumns.push(d);
          }
        });
        return headColumns;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.operators = _Storage2.default.operators.slice(0);
    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this2.calculateRows();
    });
  },

  methods: {
    mouseOver: function mouseOver(approved, total, e) {
      if (e.target && !e.target.classList.contains('no-tool')) {
        var dBlock = e.target.querySelector('.tool');
        dBlock.style.display = 'block';
        var approvedText = '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E: ' + approved;
        var totalText = '\u0412\u0441\u0435\u0433\u043E: ' + total;
        dBlock.innerText = approvedText + ' \r\n ' + totalText;
      }
    },
    mouseleave: function mouseleave(approved, total, e) {
      if (e.target) {
        var dBlock = e.target.querySelector('.tool');
        dBlock.style.display = 'none';
      }
    },
    calculateRows: function calculateRows() {
      var _this3 = this;

      this.$root.$emit('data_loading');
      this.loading = true;
      this.rows = [];
      this.headColumns = [];
      this.rowsAll = [];
      this.headColumnsAll = [];
      _API2.default.getOperatorApprovedDuringDay().then(function (res) {
        var hours = [];
        for (var i = 1; i <= 24; i++) {
          hours.push({
            hour: i
          });
        }
        (0, _lodash.map)(hours, function (byHour) {
          var header = {};
          var storageCountry = {};
          var storageHoursCountry = {};
          var storageHours = {
            label: null
          };
          (0, _lodash.map)(res.body, function (d, i) {
            if (_Storage2.default.selectedCountry.id === -1) {
              _this3.allCountry = true;
              if (byHour.hour === d.created_time) {
                storageHours = {
                  label: d.created_time
                };
                if (!storageHoursCountry[d.country_id]) {
                  storageHoursCountry[d.country_id] = {};
                }
                storageHoursCountry[d.country_id] = d.created_time;
              }
              if (!storageCountry[d.country_id]) {
                storageCountry[d.country_id] = {};
              }
              if (!storageCountry[d.country_id][d.date]) {
                storageCountry[d.country_id][d.date] = {};
              }
              storageCountry[d.country_id][d.date][d.created_time] = (parseInt(d.approved) / parseInt(d.total) * 100).toFixed(2);
            } else {
              _this3.allCountry = false;
              if (!header[d.date]) {
                header[d.date] = {};
              }
              if (byHour.hour === d.created_time) {
                storageHours = {
                  label: d.created_time
                };
              }
              header[d.date][d.created_time] = {};
              header[d.date][d.created_time] = {
                data: (parseInt(d.approved) / parseInt(d.total) * 100).toFixed(2),
                approved: d.approved,
                total: d.total
              };
            }
          });
          _this3.rowsAll = storageCountry;
          _this3.headColumnsAll.push(storageHoursCountry);
          _this3.rows = header;
          _this3.headColumns.push(storageHours);
          _this3.headColumns = _this3.headColumns.filter(function (hour) {
            return hour.label;
          });
        });
        _this3.loading = false;
        _this3.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this3.$notify({
          type: 'danger',
          title: _this3.$root.$t('verbs.error'),
          text: response.body.message ? response.body.message : response.body,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _OperatorsTab = __webpack_require__(181);

var _OperatorsTab2 = _interopRequireDefault(_OperatorsTab);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    OperatorsTab: _OperatorsTab2.default
  },
  data: function data() {
    return {
      x: 0,
      filtersScope: {
        dateFilter: true,
        dateFilterSecond: true,
        offerFilter: true,
        byWmFilter: true
      },
      headColumns: [{ label: this.$root.$t('statistic.operator'), field: 'operator' }, { label: this.$root.$t('statistic.accepted'), field: 'accepted' }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback' }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead' }, { label: this.$root.$t('statistic.deviation_mean'), field: 'deviation_mean' }],
      rows_first: [],
      firstFootColumns: {},
      rows_second: [],
      secondFootColumns: {},
      rows_difference: [],
      headColumnsDifference: [{ label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead' }, { label: this.$root.$t('statistic.paid'), field: 'paid' }],
      differenceFootColumns: {},
      headColumnsLst: [{ label: this.$root.$t('statistic.operator'), field: 'operator' }, { label: this.$root.$t('statistic.processed_leads'), field: 'processed' }],
      rows_last: [],
      lastFootColumns: {},
      percent: 0,
      operators: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    isPopup: function isPopup(cell) {
      var el = document.createElement('textarea');
      el.value = cell.value.trim();
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Скопирован оператор ' + el.value);
    },
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    getPercent: function getPercent() {
      var _this2 = this;

      this.rows_first.forEach(function (item) {
        if (parseFloat(_this2.percent) > parseFloat(item.paidPercents.value.replace(',', '.'))) {
          item.operator.percentBg = true;
        } else {
          item.operator.percentBg = false;
        }
      });
      this.rows_second.forEach(function (item) {
        if (item.paidPercents.value && parseFloat(_this2.percent) > parseFloat(item.paidPercents.value.replace(',', '.'))) {
          item.operator.percentBg = true;
        } else {
          item.operator.percentBg = false;
        }
      });
    },
    sortRows: function sortRows(firstArr, secondArr, lastArr) {
      var firstPeriod = [];
      var secondPeriod = [];
      var lastPeriod = [];
      var existsValues = [];
      var existsValuesSecond = [];
      firstArr.sort(function (a, b) {
        if (parseInt(a.approved) > parseInt(b.approved)) {
          return -1;
        } else {
          return 1;
        }
      });

      firstPeriod = firstArr;
      for (var iFirst in firstArr) {
        var toPush = [];
        var arrValue = firstArr[iFirst];
        existsValues.push(firstArr[iFirst].operator_id);
        for (var iSecond in secondArr) {
          if (!secondArr.hasOwnProperty(iSecond)) {
            continue;
          }
          var value = secondArr[iSecond];
          if (value['operator_id'] === arrValue['operator_id']) {
            toPush = value;
            break;
          }
        }
        secondPeriod.push(toPush);
      }
      for (var val in secondArr) {
        if (!firstArr.hasOwnProperty(val)) {
          continue;
        }
        if (secondArr[val].total_percent) {
          var unsortValue = secondArr[val];
          if (existsValues.indexOf(unsortValue['operator_id']) === -1) {
            firstPeriod.push({});
            secondPeriod.push(unsortValue);
          }
        }
      }
      var secondPeriod2 = [];
      for (var _val in secondPeriod) {
        var _arrValue = secondPeriod[_val];
        existsValuesSecond.push(_arrValue['operator_id']);
        var _toPush = [];
        for (var unsortVal in lastArr) {
          if (!lastArr.hasOwnProperty(unsortVal)) {
            continue;
          }
          if (lastArr[unsortVal].total_percent) {
            var _unsortValue = lastArr[unsortVal];
            if (_unsortValue['operator_id'] === _arrValue['operator_id']) {
              if (_unsortValue.total_percent) {
                _toPush = _unsortValue;
                break;
              }
            }
          }
        }
        secondPeriod2.push(secondPeriod[_val]);
        lastPeriod.push(_toPush);
      }
      for (var _val2 in lastArr) {
        if (!secondPeriod2.hasOwnProperty(_val2)) {
          continue;
        }
        if (lastArr[_val2].total_percent) {
          var lastValue = lastArr[_val2];
          if (existsValuesSecond.indexOf(lastValue['operator_id']) === -1) {
            secondPeriod2.push({});
            lastPeriod.push(lastValue);
          }
        }
      }

      return [firstPeriod, secondPeriod, lastPeriod];
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this3 = this;

        var firstPeriod, secondPeriod, lastPeriod;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.rows_first = [];
                this.rows_second = [];
                this.rows_difference = [];
                this.rows_last = [];
                firstPeriod = [];
                secondPeriod = [];
                lastPeriod = [];

                this.operators = [];
                _context.next = 10;
                return _API2.default.getOperators(_Helper2.default.getCountryList()).then(function (operators) {
                  _this3.operators = operators.body;
                });

              case 10:
                _context.next = 12;
                return _API2.default.getOperatorsAnalysis().then(function (response) {
                  var _sortRows = _this3.sortRows(response.data.first_period, response.data.second_period, response.data.last_week);

                  var _sortRows2 = _slicedToArray(_sortRows, 3);

                  firstPeriod = _sortRows2[0];
                  secondPeriod = _sortRows2[1];
                  lastPeriod = _sortRows2[2];

                  var sumAccepted = 0;
                  var countAccepted = 0;
                  var sumAverageBuyback = 0.0;
                  var sumPaid = 0;
                  var countPaid = 0;
                  var sumReturn = 0;
                  var countReturn = 0;
                  var resultRevenuaLeadAverage = 0.0;
                  var firstSumApproved = 0;
                  var firstSumPaid = 0;

                  var sumAcceptedSecond = 0;
                  var countAcceptedSecond = 0;
                  var sumAverageBuybackSecond = 0.0;
                  var sumPaidSecond = 0;
                  var countPaidSecond = 0;
                  var sumReturnSecond = 0;
                  var countReturnSecond = 0;
                  var resultRevenuaLeadAverageSecond = 0.0;
                  var sumApprovedSecond = 0;

                  var revenuaLead1 = [];
                  var revenuaLead2 = [];
                  var paid1 = [];
                  var paid2 = [];
                  (0, _lodash.map)(firstPeriod, function (d) {
                    if (d.approved && d.buyout) {
                      paid1.push(parseFloat(parseFloat(d.buyout) / parseFloat(d.approved) * 100));
                    } else {
                      paid1.push('');
                    }

                    var rateFirst = d.average_buyout_local / d.average_buyout_usd;
                    var percentPaid = _Helper2.default.percents(d.approved, d.buyout).replace('%', '').replace(',', '.');
                    var revenuaLead = (d.average_buyout_usd * (parseFloat(percentPaid) / 100)).toFixed(2);
                    revenuaLead1.push((parseFloat(revenuaLead) / parseFloat(rateFirst)).toFixed(2));

                    if (d.approved > 0) {
                      firstSumApproved += parseInt(d.approved);
                      firstSumApproved = firstSumApproved++;
                      countAccepted++;
                      sumAccepted += parseInt(d.approved);
                      sumAverageBuyback += parseFloat(d.average_buyout_usd) * parseInt(d.buyout);
                    }
                    if (d.buyout > 0) {
                      firstSumPaid += parseInt(d.buyout);
                      sumPaid += parseInt(d.buyout);
                      countPaid++;
                    }
                    if (d.return > 0) {
                      sumReturn += parseInt(d.return);
                      countReturn++;
                    }
                    _this3.$nextTick(function () {
                      var rezultDeviation = 0.0;
                      rezultDeviation = -(1 - revenuaLead / resultRevenuaLeadAverage) * 100;
                      this.rows_first.push({
                        operator: {
                          value: d.operator_id ? '' + _Helper2.default.getOperatorLogin(this.operators, d.operator_id) : '-',
                          percentBg: false,
                          popup: true
                        },
                        accepted: {
                          value: d.approved,
                          isCollspaned: true,
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        averageBuyback: {
                          value: d.average_buyout_usd ? '$ ' + d.average_buyout_usd.toFixed(2) : '$ 0,00'
                        },
                        paid: {
                          value: d.buyout,
                          bgg: _Helper2.default.renderGistPart(d.approved, d.buyout),
                          isCollspaned: true
                        },
                        paidPercents: {
                          value: d.approved && d.buyout ? _Helper2.default.percents(parseInt(d.approved), parseInt(d.buyout)) : '',
                          bgg: _Helper2.default.renderGistPart(d.approved, d.buyout, true),
                          webGraph: true,
                          webGraphSymbol: '%'
                        },
                        return: {
                          value: d.return,
                          bgg: _Helper2.default.renderGistPart(d.approved, d.return),
                          isCollspaned: true
                        },
                        returnPercents: {
                          value: d.approved && d.return ? _Helper2.default.percents(d.approved, d.return) : '0%',
                          bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
                        },
                        revenue_lead: {
                          value: revenuaLead > 0 ? '$ ' + revenuaLead : '$ 0,00'
                        },
                        deviation_mean: {
                          value: !isNaN(rezultDeviation) ? rezultDeviation.toFixed(2) + '%' : '0%',
                          plusBg: rezultDeviation >= 0
                        }
                      });
                    });
                  });
                  var sumAverageBuybackRevenua = _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid).replace('$', '').replace(',', '.');
                  var paidPercentsRevenua = _Helper2.default.percents(sumAccepted, sumPaid).replace('%', '').replace(',', '.');
                  resultRevenuaLeadAverage = (sumAverageBuybackRevenua * paidPercentsRevenua / 100).toFixed(2);
                  _this3.firstFootColumns = {
                    label: {
                      value: _this3.$root.$t('statistic.in_total')
                    },
                    accepted: {
                      value: '' + sumAccepted
                    },
                    averageBuyback: {
                      value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid)
                    },
                    paid: {
                      value: '' + sumPaid
                    },
                    paidPercents: {
                      value: _Helper2.default.percents(firstSumApproved, firstSumPaid)
                    },
                    return: {
                      value: '' + sumReturn
                    },
                    returnPercents: {
                      value: _Helper2.default.percents(firstSumApproved, sumReturn)
                    },
                    revenue_lead: {
                      value: '$ ' + resultRevenuaLeadAverage
                    }
                  };

                  (0, _lodash.map)(secondPeriod, function (d) {
                    if (d.approved && d.buyout) {
                      paid2.push(parseFloat(parseFloat(d.buyout) / parseFloat(d.approved) * 100));
                    } else {
                      paid2.push('');
                    }

                    var rateSecond = d.average_buyout_local / d.average_buyout_usd;
                    var percentPaid = _Helper2.default.percents(d.approved, d.buyout).replace('%', '').replace(',', '.');
                    var revenuaLead = (d.average_buyout_usd * (parseFloat(percentPaid) / 100)).toFixed(2);
                    revenuaLead2.push((parseFloat(revenuaLead) / parseFloat(rateSecond)).toFixed(2));

                    if (d.approved > 0) {
                      countAcceptedSecond++;
                      sumAcceptedSecond += parseInt(d.approved);
                      sumAverageBuybackSecond += parseFloat(d.average_buyout_usd) * parseInt(d.buyout);
                    }
                    if (d.approved > 0) {
                      sumApprovedSecond += parseInt(d.approved);
                      sumApprovedSecond = sumApprovedSecond++;
                    }
                    if (d.buyout > 0) {
                      sumPaidSecond += parseInt(d.buyout);
                      countPaidSecond++;
                    }
                    if (d.return > 0) {
                      sumReturnSecond += parseInt(d.return);
                      countReturnSecond++;
                    }
                    _this3.$nextTick(function () {
                      var rezultDeviationSecond = 0.0;
                      rezultDeviationSecond = -(1 - revenuaLead / resultRevenuaLeadAverage) * 100;
                      this.rows_second.push({
                        operator: {
                          value: d.operator_id ? '' + _Helper2.default.getOperatorLogin(this.operators, d.operator_id) : '-',
                          percentBg: false,
                          popup: true
                        },
                        accepted: {
                          value: d.approved,
                          ocb: function ocb(value) {
                            return _Helper2.default.getRawNumber(value);
                          }
                        },
                        averageBuyback: {
                          value: d.average_buyout_usd ? '$ ' + d.average_buyout_usd.toFixed(2) : '$ 0,00'
                        },
                        paid: {
                          value: d.buyout,
                          bgg: _Helper2.default.renderGistPart(d.approved, d.buyout),
                          isCollspaned: true
                        },
                        paidPercents: {
                          value: d.approved && d.buyout ? _Helper2.default.percents(parseInt(d.approved), parseInt(d.buyout)) : '',
                          bgg: _Helper2.default.renderGistPart(d.approved, d.buyout, true),
                          webGraph: true,
                          webGraphSymbol: '%'
                        },
                        return: {
                          value: d.return,
                          bgg: _Helper2.default.renderGistPart(d.approved, d.return),
                          isCollspaned: true
                        },
                        returnPercents: {
                          value: d.approved && d.return ? _Helper2.default.percents(d.approved, d.return) : '0%',
                          bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
                        },
                        revenue_lead: {
                          value: revenuaLead > 0 ? '$ ' + revenuaLead : '$ 0,00'
                        },
                        deviation_mean: {
                          value: !isNaN(rezultDeviationSecond) ? rezultDeviationSecond.toFixed(2) + '%' : '',
                          plusBg: rezultDeviationSecond >= 0
                        }
                      });
                    });
                  });
                  var sumAverageBuybackRevenuaSecond = _Helper2.default.averageBillDayCount(sumAverageBuybackSecond, sumPaidSecond).replace('$', '').replace(',', '.');
                  var paidPercentsRevenuaSecond = _Helper2.default.percents(sumAcceptedSecond, sumPaidSecond).replace('%', '').replace(',', '.');
                  resultRevenuaLeadAverageSecond = (sumAverageBuybackRevenuaSecond * paidPercentsRevenuaSecond / 100).toFixed(2);
                  _this3.secondFootColumns = {
                    label: {
                      value: _this3.$root.$t('statistic.in_total')
                    },
                    accepted: {
                      value: '' + sumAcceptedSecond
                    },
                    averageBuyback: {
                      value: _Helper2.default.averageBillDayCount(sumAverageBuybackSecond, sumPaidSecond)
                    },
                    paid: {
                      value: '' + sumPaidSecond
                    },
                    paidPercents: {
                      value: _Helper2.default.percents(sumApprovedSecond, sumPaidSecond)
                    },
                    return: {
                      value: '' + sumReturnSecond
                    },
                    returnPercents: {
                      value: _Helper2.default.percents(sumApprovedSecond, sumReturnSecond)
                    },
                    revenue_lead: {
                      value: '$ ' + resultRevenuaLeadAverageSecond
                    }
                  };

                  for (var i = 0; i < revenuaLead1.length; i++) {
                    var paidValue = 0;
                    if (paid2[i] && paid1[i]) {
                      paidValue = paid2[i] - paid1[i];
                    } else if (!paid2[i] && paid1[i]) {
                      paidValue = paid1[i];
                    } else {
                      paidValue = paid2[i];
                    }
                    _this3.rows_difference.push({
                      revenue_lead: {
                        value: !isNaN((revenuaLead2[i] - revenuaLead1[i]).toFixed(2)) ? '$ ' + (revenuaLead2[i] - revenuaLead1[i]).toFixed(2) : '$ 0,00'
                      },
                      paid: {
                        value: paidValue ? paidValue.toFixed(1) + '%' : paidValue,
                        minusBg: paidValue <= 0
                      }
                    });
                  }

                  (0, _lodash.map)(lastPeriod, function (d) {
                    _this3.rows_last.push({
                      operator: {
                        value: d.operator_id ? '' + _Helper2.default.getOperatorLogin(_this3.operators, d.operator_id) : '-',
                        popup: true
                      },
                      processed: {
                        value: d.total,
                        bg: true,
                        ocb: function ocb(value) {
                          return _Helper2.default.getRawNumber(value);
                        }
                      }
                    });
                  });
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }()
  }
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Order',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.operator'), field: 'operator' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }, { label: this.$root.$t('statistic.ProcessAccept'), field: 'ProcessAccept' }, { label: this.$root.$t('statistic.ProcessCancel'), field: 'ProcessCancel' }, { label: this.$root.$t('statistic.ProcessSpam'), field: 'ProcessSpam' }, { label: this.$root.$t('statistic.AcceptCancel'), field: 'AcceptCancel' }, { label: this.$root.$t('statistic.CancelAccept'), field: 'CancelAccept' }, { label: this.$root.$t('statistic.SpamAccept'), field: 'SpamAccept' }],
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    isPopup: function isPopup(cell) {
      var el = document.createElement('textarea');
      el.value = cell.value.trim();
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Скопирован оператор ' + el.value);
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      _API2.default.getOperatorOrder().then(function (response) {
        _this2.operators = _Storage2.default.operators.slice(0);
        var statistic = {};
        var sumTotal = 0;
        var countTotal = 0;
        var sumProcessAccept = 0;
        var sumProcessCancel = 0;
        var sumProcessSpam = 0;
        var sumAcceptCancel = 0;
        var sumCancelAccept = 0;
        var sumSpamAccept = 0;
        (0, _lodash.map)(response.body, function (operatorData, id) {
          statistic[id] = operatorData[0];
          statistic[id].operator_id = id;
          (0, _lodash.map)(operatorData, function (val, key) {
            if (key !== 0) {
              statistic[id].process_accept += parseInt(val.process_accept);
              statistic[id].total += parseInt(val.total);
              statistic[id].cancel_accept += parseInt(val.cancel_accept);
              statistic[id].accept_cancel += parseInt(val.accept_cancel);
              statistic[id].process_cancel += parseInt(val.process_cancel);
              statistic[id].process_spam += parseInt(val.process_spam);
              statistic[id].spam_accept += parseInt(val.spam_accept);
            }
          });
        });
        (0, _lodash.map)(statistic, function (d) {
          _this2.rows.push({
            operator: { value: _Helper2.default.getOperatorLogin(_this2.operators, d.operator_id) + ' ' + (_Storage2.default.developMode ? '(' + d.operator_id + ')' : ''), popup: true },
            total: {
              value: parseInt(d.total),
              bg: true
            },
            approvedFromValid: {
              value: _Helper2.default.approvedFromValid(d.process_accept, d.total, d.spam_accept)
            },
            ProcessAccept: {
              value: parseInt(d.process_accept),
              bg: true,
              bgg: _Helper2.default.renderGistPart(d.total, d.process_accept)
            },
            ProcessCancel: {
              value: parseInt(d.process_cancel),
              bg: true,
              bgg: _Helper2.default.renderGistPart(d.total, d.process_cancel)
            },
            ProcessSpam: {
              value: parseInt(d.process_spam),
              bg: true,
              bgg: _Helper2.default.renderGistPart(d.total, d.process_cancel)
            },
            AcceptCancel: {
              value: parseInt(d.cancel_accept),
              bg: true,
              bgg: _Helper2.default.renderGistPart(d.total, d.cancel_accept)
            },
            CancelAccept: {
              value: parseInt(d.accept_cancel),
              bg: true,
              bgg: _Helper2.default.renderGistPart(d.total, d.accept_cancel)
            },
            SpamAccept: {
              value: parseInt(d.spam_accept),
              bg: true,
              bgg: _Helper2.default.renderGistPart(d.total, d.spam_accept)
            }
          });
          if (d.total > 0) {
            sumTotal += parseInt(d.total);
            countTotal++;
          }
          if (d.process_accept > 0) {
            sumProcessAccept += parseInt(d.process_accept);
          }
          if (d.process_cancel > 0) {
            sumProcessCancel += parseInt(d.process_cancel);
          }
          if (d.process_spam > 0) {
            sumProcessSpam += parseInt(d.process_spam);
          }
          if (d.cancel_accept > 0) {
            sumAcceptCancel += parseInt(d.cancel_accept);
          }
          if (d.accept_cancel > 0) {
            sumCancelAccept += parseInt(d.accept_cancel);
          }
          if (d.spam_accept > 0) {
            sumSpamAccept += parseInt(d.spam_accept);
          }
        });
        _this2.footColumns = {
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          total: {
            value: sumTotal + ' (' + _Helper2.default.average(sumTotal, countTotal) + ')'
          },
          approvedFromValid: {
            value: _Helper2.default.approvedFromValid(sumProcessAccept, sumTotal, sumProcessSpam)
          },
          ProcessAccept: {
            value: '' + sumProcessAccept
          },
          ProcessCancel: {
            value: '' + sumProcessCancel
          },
          ProcessSpam: {
            value: '' + sumProcessSpam
          },
          AcceptCancel: {
            value: '' + sumAcceptCancel
          },
          CancelAccept: {
            value: '' + sumCancelAccept
          },
          SpamAccept: {
            value: '' + sumSpamAccept
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  components: {
    Filters: _Filters2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byWmFilter: true
      },
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    approvedFromValid: function approvedFromValid(approved, total, spam) {
      return (approved / (total - spam) * 100).toFixed(1) + '%';
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var sumTotalProcessed, sumChanges, sumCalls, ringOneDay, createdOneDay, approvedOneDay, ringTwoDay, createdTwoDay, approvedTwoDay, ringThreeDay, createdThreeDay, approvedThreeDay, ringMoreDay, createdMoreDay, approvedMoreDay, totalApproved, totalSpam;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.rows = [];
                this.footColumns = {};
                sumTotalProcessed = 0;
                sumChanges = 0.0;
                sumCalls = 0.0;
                ringOneDay = 0.0;
                createdOneDay = 0;
                approvedOneDay = 0;
                ringTwoDay = 0.0;
                createdTwoDay = 0;
                approvedTwoDay = 0;
                ringThreeDay = 0.0;
                createdThreeDay = 0;
                approvedThreeDay = 0;
                ringMoreDay = 0.0;
                createdMoreDay = 0;
                approvedMoreDay = 0;
                totalApproved = 0;
                totalSpam = 0;
                _context.next = 21;
                return _API2.default.getRingingHolds().then(function (response) {
                  _this2.rows = response.body;

                  (0, _lodash.map)(response.body, function (d) {
                    if (d.total_processed > 0) {
                      sumTotalProcessed += parseInt(d.total_processed);
                    }
                    if (d.average_changes && d.total_processed > 0) {
                      sumChanges += d.average_changes * d.total_processed;
                    }
                    if (d.average_calls > 0) {
                      sumCalls += d.average_calls * d.total_processed;
                    }

                    if (d.ring_up_one_day_ago > 0) {
                      ringOneDay += d.ring_up_one_day_ago * d.total_processed;
                    }
                    if (d.created_one_day_ago > 0) {
                      createdOneDay += parseInt(d.created_one_day_ago);
                    }
                    if (d.approved_one_day_ago > 0) {
                      approvedOneDay += parseInt(d.approved_one_day_ago);
                    }

                    if (d.ring_up_two_days_ago > 0) {
                      ringTwoDay += d.ring_up_two_days_ago * d.total_processed;
                    }
                    if (d.created_two_days_ago > 0) {
                      createdTwoDay += parseInt(d.created_two_days_ago);
                    }
                    if (d.approved_two_days_ago > 0) {
                      approvedTwoDay += parseInt(d.approved_two_days_ago);
                    }

                    if (d.ring_up_three_days_ago > 0) {
                      ringThreeDay += d.ring_up_three_days_ago * d.total_processed;
                    }
                    if (d.created_three_days_ago > 0) {
                      createdThreeDay += parseInt(d.created_three_days_ago);
                    }
                    if (d.approved_three_days_ago > 0) {
                      approvedThreeDay += parseInt(d.approved_three_days_ago);
                    }

                    if (d.ring_up_more_three_days_ago > 0) {
                      ringMoreDay += d.ring_up_more_three_days_ago * d.total_processed;
                    }
                    if (d.created_more_three_days_ago > 0) {
                      createdMoreDay += parseInt(d.created_more_three_days_ago);
                    }
                    if (d.approved_more_three_days_ago > 0) {
                      approvedMoreDay += parseInt(d.approved_more_three_days_ago);
                    }

                    if (d.total_approved > 0) {
                      totalApproved += parseInt(d.total_approved);
                    }
                    totalSpam += parseInt(d.total_spam);
                  });
                });

              case 21:
                this.footColumns = {
                  label: 'Итого',
                  total_processed: sumTotalProcessed,
                  average_changes: '' + (sumChanges / sumTotalProcessed).toFixed(2),
                  average_calls: '' + (sumCalls / sumTotalProcessed).toFixed(2),
                  ring_one_day: (ringOneDay / sumTotalProcessed).toFixed(2) + ' %',
                  created_one_day: createdOneDay,
                  approved_one_day: approvedOneDay,
                  percent_one_day: '' + _Helper2.default.percentHungry(approvedOneDay, createdOneDay),
                  ring_two_day: (ringTwoDay / sumTotalProcessed).toFixed(2) + ' %',
                  created_two_day: createdTwoDay,
                  approved_two_day: approvedTwoDay,
                  percent_two_day: '' + _Helper2.default.percentHungry(approvedTwoDay, createdTwoDay),
                  ring_three_day: (ringThreeDay / sumTotalProcessed).toFixed(2) + ' %',
                  created_three_day: createdThreeDay,
                  approved_three_day: approvedThreeDay,
                  percent_three_day: '' + _Helper2.default.percentHungry(approvedThreeDay, createdThreeDay),
                  ring_more_day: (ringMoreDay / sumTotalProcessed).toFixed(2) + ' %',
                  created_more_day: createdMoreDay,
                  approved_more_day: approvedMoreDay,
                  percent_more_day: (approvedMoreDay / createdMoreDay).toFixed(2) + ' %',
                  total_approved: totalApproved,
                  percent_approved: '' + _Helper2.default.percentHungry(totalApproved, sumTotalProcessed),
                  approvedFormValid: _Helper2.default.approvedFromValid(totalApproved, sumTotalProcessed, totalSpam)
                };

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }()
  }
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _lodash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  components: {
    StatisticTable: _StatisticTable2.default,
    Filters: _Filters2.default
  },
  data: function data() {
    return {
      filtersScope: {
        countryFilter: true,
        dateFilter: true,
        offerFilter: true,
        byWmFilter: true,
        oneCountryFilter: true
      },
      data: [],
      x: 0,
      checkForking: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    approvedFromValid: function approvedFromValid(approved, total, spam) {
      return (approved / (total - spam) * 100).toFixed(1) + '%';
    },
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    renderBackground: function renderBackground(td) {
      var local = parseInt(td.local_period);
      if (local === 0 || local < 6) {
        return 'background-color: rgb(144, 202, 249);';
      }
      if (local === 7 || local < 11) {
        return 'background-color: rgb(255, 249, 196);';
      }
      if (local === 12 || local < 16) {
        return 'background-color: rgb(255, 217, 106);';
      }
      if (local === 17 || local <= 23) {
        return 'background-color: rgb(186, 224, 255);';
      }
    },
    getClasses: function getClasses(td) {
      var local = parseInt(td.local_period);
      var classes = [];
      if (local === 0) {
        classes.push('td-time night');
      }
      if (local === 6) {
        classes.push('td-time morning');
      }
      if (local === 11) {
        classes.push('td-time day');
      }
      if (local === 16) {
        classes.push('td-time evening');
      }
      return classes;
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var dataItems, totalItems, time;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$root.$emit('data_loading');
                this.data = [];
                dataItems = [];
                totalItems = [];
                time = [];
                _context.next = 7;
                return _API2.default.getWorkTimingKC().then(function (response) {
                  _this2.checkForking = [];
                  dataItems = response.body.data;
                  totalItems = response.body.totals;
                  time = response.body.working_time;
                  _this2.checkForking = response.body.working_time;
                  var hourse = [];
                  var inTime = [];
                  for (var i = 0; i < 24; i++) {
                    hourse.push(i);
                  }

                  for (var _i = 0; _i < time.length; _i++) {
                    var from = parseInt(time[_i].time_from);
                    var to = parseInt(time[_i].time_to);
                    if (from > to) {
                      inTime.push.apply(inTime, _toConsumableArray(hourse.slice(from).concat(hourse.slice(0, to))));
                    } else {
                      inTime.push.apply(inTime, _toConsumableArray(hourse.slice(from, to)));
                    }
                  }

                  for (var keyItems in dataItems) {
                    for (var keyTotal in totalItems) {
                      if (keyTotal === keyItems) {
                        dataItems[keyItems].total_per_day = totalItems[keyTotal].total_per_day;
                        dataItems[keyItems].working_percent = totalItems[keyTotal].working_percent;
                      }
                    }
                  }
                  var rezult = [];
                  for (var _i2 in dataItems) {
                    rezult.push({
                      date: _i2,
                      data: dataItems[_i2],
                      time: inTime
                    });
                  }
                  var newRezult = rezult.sort(function (a, b) {
                    if (a.date > b.date) {
                      return 1;
                    } else if (a.date < b.date) {
                      return -1;
                    } else {
                      return 0;
                    }
                  });
                  _this2.data = newRezult;
                });

              case 7:
                this.$root.$emit('data_loaded');

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }()
  }
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _OperatorsConversionTabs = __webpack_require__(32);

var _OperatorsConversionTabs2 = _interopRequireDefault(_OperatorsConversionTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'Conversion',
  components: {
    OperatorsConversionTabs: _OperatorsConversionTabs2.default,
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.operator'), field: 'operator' }, { label: this.$root.$t('statistic.processed_leads'), field: 'total' }, { label: this.$root.$t('statistic.approved'), field: 'approved' }, { label: this.$root.$t('statistic.canceled'), field: 'canceled' }, { label: this.$root.$t('statistic.averageBill'), field: 'average_bill', colspan: 2 }, { label: this.$root.$t('statistic.average_x_price'), field: 'average_x_price' }, { label: this.$root.$t('statistic.paid'), field: 'paid' }],
      rows: [],
      footColumns: {},
      operators: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    isPopup: function isPopup(cell) {
      var el = document.createElement('textarea');
      el.value = cell.value.trim();
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Скопирован оператор ' + el.value);
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var oldArrCurrency, newArrCurrency;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$root.$emit('data_loading');
                this.rows = [];
                oldArrCurrency = [];
                newArrCurrency = [];

                this.operators = [];
                _context.next = 7;
                return _API2.default.getOperators(_Helper2.default.getCountryList()).then(function (operators) {
                  _this2.operators = operators.body;
                });

              case 7:
                _context.next = 9;
                return _API2.default.getOperatorConversion().then(function (response) {
                  var sumTotal = 0;
                  var count = 0;
                  var sumApproved = 0;
                  var countApproved = 0;
                  var sumCanceled = 0;
                  var countCanceled = 0;
                  var sumAverageBill = 0.0;
                  var sumAverageBillLocal = 0.0;
                  var sumAverageXprice = 0;
                  var sumAverageStartPrice = 0;
                  var countAverageXprice = 0;
                  var sumPaid = 0;
                  var countPaid = 0;
                  var statistic = {};
                  var max = {
                    approved: 0,
                    canceled: 0,
                    paid: 0,
                    average_bill: 0,
                    average_x_price: 0
                  };
                  (0, _lodash.map)(response.body, function (array, id) {
                    (0, _lodash.map)(array, function (operatorData) {
                      operatorData.average_x_price = _Helper2.default.getxstart(operatorData.average_bill_usd, operatorData.average_start_price_usd);
                      statistic[id] = operatorData;
                      if (parseInt(max.approved) < parseInt(operatorData.approved)) {
                        max.approved = operatorData.approved;
                      }
                      if (parseInt(max.canceled) < parseInt(operatorData.canceled)) {
                        max.canceled = operatorData.canceled;
                      }
                      if (parseInt(max.paid) < parseInt(operatorData.paid)) {
                        max.paid = operatorData.paid;
                      }
                      if (parseFloat(max.average_bill_usd) < parseFloat(operatorData.average_bill_usd)) {
                        max.average_bill = parseFloat(operatorData.average_bill_usd);
                      }
                      if (parseFloat(max.average_x_price) < parseFloat(operatorData.average_x_price)) {
                        max.average_x_price = parseFloat(operatorData.average_x_price);
                      }
                      oldArrCurrency.push(operatorData.local_currency.split(','));
                      oldArrCurrency.forEach(function (array) {
                        array.forEach(function (item) {
                          newArrCurrency.push(item);
                        });
                      });
                    });
                  });
                  var filterCurrency = newArrCurrency.filter(function (item, index) {
                    return newArrCurrency.indexOf(item) === index;
                  });
                  (0, _lodash.map)(statistic, function (d) {
                    _this2.rows.push({
                      operator: { value: _Helper2.default.getOperatorLogin(_this2.operators, d.operator_id) + ' ' + (_Storage2.default.developMode ? '(' + d.operator_id + ')' : ''), popup: true },
                      total: {
                        value: parseInt(d.total),
                        bg: true
                      },
                      approved: {
                        value: parseInt(d.approved),
                        bgg: _Helper2.default.renderSingleGist(max.approved, d.approved),
                        isCollspaned: true
                      },
                      canceled: {
                        value: parseInt(d.canceled),
                        bgg: _Helper2.default.renderSingleGist(max.canceled, d.canceled),
                        isCollspaned: true
                      },
                      averageBill: {
                        value: '$ ' + d.average_bill_usd.toFixed(2),

                        isCollspaned: true
                      },
                      averageBillLocal: {
                        value: d.local_currency.split(',').length === 1 ? d.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
                      },
                      average_x_price: {
                        value: d.average_x_price,
                        bgg: _Helper2.default.renderSingleGist(max.average_x_price, d.average_x_price)
                      },
                      paid: {
                        value: parseInt(d.paid),
                        bgg: _Helper2.default.renderSingleGist(max.paid, d.paid)
                      } });
                    sumTotal = sumTotal + d.total;
                    count = count + 1;
                    if (d.approved > 0) {
                      sumApproved = sumApproved + d.approved;
                      countApproved = countApproved + 1;
                      if (d.average_bill_usd > 0) {
                        sumAverageBill += parseFloat(d.average_bill_usd) * d.approved;
                      }
                      sumAverageBillLocal += parseFloat(d.average_bill_local) * d.approved;
                    }
                    if (d.canceled > 0) {
                      sumCanceled = sumCanceled + d.canceled;
                      countCanceled = countCanceled + 1;
                    }
                    if (d.average_start_price_usd > 0) {
                      sumAverageStartPrice = parseFloat(sumAverageStartPrice) + parseFloat(d.average_start_price_usd);
                    }
                    if (d.average_x_price > 0) {
                      sumAverageXprice = parseFloat(sumAverageXprice) + parseFloat(d.average_x_price);
                      countAverageXprice = countAverageXprice + 1;
                    }
                    if (d.paid > 0) {
                      sumPaid = sumPaid + d.paid;
                      countPaid = countPaid + 1;
                    }
                  });
                  _this2.footColumns = {
                    label: {
                      value: _this2.$root.$t('statistic.in_total')
                    },
                    total: {
                      value: sumTotal + ' (' + _Helper2.default.average(sumTotal, count) + ')',
                      graph: true
                    },
                    approved: {
                      value: sumApproved + ' (' + _Helper2.default.average(sumApproved, countApproved) + ')',
                      graph: true
                    },
                    canceled: {
                      value: sumCanceled + ' (' + _Helper2.default.average(sumCanceled, countCanceled) + ')',
                      graph: true
                    },
                    averageBill: {
                      value: filterCurrency.length === 1 ? '' + _Helper2.default.localAverageBill(_Helper2.default.average(sumAverageBillLocal, sumApproved)) : '-',
                      colspan: 2,
                      graph: true
                    },
                    average_x_price: {
                      value: '' + _Helper2.default.getxstart(sumAverageBill, sumAverageStartPrice),
                      graph: true
                    },
                    paid: {
                      value: sumPaid + ' (' + _Helper2.default.average(sumPaid, countPaid) + ')',
                      graph: true
                    } };
                  _this2.$root.$emit('data_loaded');
                }).catch(function (response) {
                  _this2.$root.$emit('data_loaded');
                  _this2.$notify({
                    type: 'danger',
                    title: _this2.$root.$t('verbs.error'),
                    text: !response.body.message ? response.body : response.body.message,
                    animationType: 'velocity'
                  });
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }()
  }
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _OperatorsConversionTabs = __webpack_require__(32);

var _OperatorsConversionTabs2 = _interopRequireDefault(_OperatorsConversionTabs);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  components: {
    OperatorsConversionTabs: _OperatorsConversionTabs2.default,
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      x: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true,
        byManualFilter: true
      },
      headColumns: [{ label: this.$root.$t('statistic.operator'), field: 'operator' }, { label: this.$root.$t('statistic.new_orders'), field: 'new_orders' }, { label: this.$root.$t('statistic.approve'), field: 'approve', colspan: 2 }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid' }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.shipped'), field: 'shipped', colspan: 2 }, { label: this.$root.$t('statistic.buyoutSum'), field: 'buyoutSum', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.spam'), field: 'spam' }, { label: this.$root.$t('statistic.holds'), field: 'holds' }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2 }, { label: this.$root.$t('statistic.call_duration'), field: 'call_duration' }, { label: this.$root.$t('statistic.time_processing'), field: 'time_processing' }, { label: this.$root.$t('statistic.time_out_calls'), field: 'time_out_calls' }, { label: this.$root.$t('statistic.call_duration_approve'), field: 'call_duration_approve' }, { label: this.$root.$t('statistic.call_duration_cancel'), field: 'call_duration_cancel' }],
      rows: [],
      footColumns: {},
      operators: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    isPopup: function isPopup(cell) {
      var el = document.createElement('textarea');
      el.value = cell.value.trim();
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Скопирован оператор ' + el.value);
    },
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var oldArrCurrency, newArrCurrency;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.rows = [];
                this.footColumns = {};
                oldArrCurrency = [];
                newArrCurrency = [];

                this.operators = [];
                _context.next = 7;
                return _API2.default.getOperators(_Helper2.default.getCountryList()).then(function (operators) {
                  _this2.operators = operators.body;
                });

              case 7:
                _context.next = 9;
                return _API2.default.getNewOrders().then(function (response) {
                  (0, _lodash.map)(response.data, function (d) {
                    oldArrCurrency.push(d.local_currency.split(','));
                    oldArrCurrency.forEach(function (array) {
                      array.forEach(function (item) {
                        newArrCurrency.push(item);
                      });
                    });
                  });
                  var filterCurrency = newArrCurrency.filter(function (item, index) {
                    return newArrCurrency.indexOf(item) === index;
                  });
                  var sumTotal = 0;
                  var sumApproved = 0;
                  var sumApprovedValid = 0;
                  var sumReturn = 0;
                  var sumCanceled = 0;
                  var sumShipped = 0;
                  var sumPaid = 0;
                  var sumSpam = 0;
                  var sumAverageBill = 0.0;
                  var sumAverageBillLocal = 0.0;
                  var sumAverageBuyback = 0.0;
                  var sumAverageBuybackLocal = 0.0;
                  var sumAverageCallDuration = 0;
                  var sumAverageSpentTime = 0;
                  var sumAverageWithoutCalls = 0;
                  var sumHold = 0;
                  var sumTotalCallApproved = 0.0;
                  var sumTotalCallCanceled = 0.0;

                  (0, _lodash.map)(response.body, function (d, index) {
                    _this2.rows.push({
                      operator: {
                        value: '' + (index + 1) + ' - ' + (_Helper2.default.getOperatorLogin(_this2.operators, d.operator_id) + ' ' + (_Storage2.default.developMode ? '(' + d.operator_id + ')' : '')),
                        popup: true
                      },
                      new_orders: {
                        value: d.total
                      },
                      approve: {
                        value: d.approved
                      },
                      approvePercent: {
                        value: d.total > 0 ? _Helper2.default.percents(d.total, d.approved) : '0%',
                        bgg: _Helper2.default.renderSingleGist(d.total, d.approved)
                      },
                      approvedFromValid: {
                        value: d.total > 0 ? _Helper2.default.percents(d.total - d.spam, d.approved) : '0%'
                      },
                      canceled: {
                        value: d.cancelled
                      },
                      canceledPercents: {
                        value: d.total > 0 ? _Helper2.default.percents(d.total, d.cancelled) : '0%',
                        bgg: _Helper2.default.renderGistPart(d.total, d.cancelled, true)
                      },
                      shipped: {
                        value: d.shipped
                      },
                      shippedPercents: {
                        value: d.total > 0 ? _Helper2.default.percents(d.total, d.shipped) : '0%',
                        bgg: _Helper2.default.renderGistPart(d.total, d.shipped, true)
                      },
                      buyoutSum: {
                        value: d.paid
                      },
                      buyoutSumPercents: {
                        value: d.total > 0 ? _Helper2.default.percents(d.approved, d.paid) : '0%',
                        bgg: _Helper2.default.renderGistPart(d.total, d.paid, true)
                      },
                      return: {
                        value: d.refunded
                      },
                      returnCountPercents: {
                        value: d.total > 0 ? _Helper2.default.percents(d.approved, d.refunded) : '0%',
                        bgg: _Helper2.default.renderGistPart(d.total, d.refunded, true)
                      },
                      spam: {
                        value: d.spam
                      },
                      holds: {
                        value: d.hold
                      },
                      averageBill: {
                        value: d.average_bill_usd > 0 ? '$ ' + d.average_bill_usd.toFixed(2) : '$ 0.00',

                        isCollspaned: true
                      },
                      averageBillLocal: {
                        value: d.local_currency.split(',').length === 1 ? d.average_bill_local + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
                      },
                      averageBuyback: {
                        value: d.average_buyout_usd > 0 ? '$ ' + d.average_buyout_usd.toFixed(2) : '$ 0.00',

                        isCollspaned: true
                      },
                      averageBuybackLocal: {
                        value: d.local_currency.split(',').length === 1 ? d.average_buyout_local + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
                      },
                      call_duration: {
                        value: _Helper2.default.hourAndMin(d.average_call_duration)
                      },
                      time_processing: {
                        value: _Helper2.default.hourAndMin(d.average_spent_time)
                      },
                      time_out_calls: {
                        value: _Helper2.default.hourAndMin(d.average_spent_time_without_calls)
                      },
                      call_duration_approve: {
                        value: d.approved > 0 ? _Helper2.default.hourAndMin(d.total_call_duration_approved / d.approved) : _Helper2.default.hourAndMin(d.total_call_duration_approved)
                      },
                      call_duration_cancel: {
                        value: d.cancelled > 0 ? _Helper2.default.hourAndMin(d.total_call_duration_canceled / d.cancelled) : _Helper2.default.hourAndMin(d.total_call_duration_canceled)
                      }
                    });
                    if (d.total > 0) {
                      sumTotal += parseInt(d.total);
                    }
                    if (d.approved > 0) {
                      sumApproved += parseInt(d.approved);
                      sumAverageBill += parseFloat(d.total_bill_usd);
                      sumAverageBillLocal += parseFloat(d.total_bill_local);
                      sumAverageBuyback += parseFloat(d.total_buyout_usd);
                      sumAverageBuybackLocal += parseFloat(d.total_buyout_local);
                      _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
                    }
                    if (d.total && d.spam > 0) {
                      sumApprovedValid += parseFloat(d.total) - parseFloat(d.spam);
                    }
                    if (d.return > 0) {
                      sumReturn += parseInt(d.refunded);
                    }
                    if (d.cancelled > 0) {
                      sumCanceled += parseInt(d.cancelled);
                    }
                    if (d.shipped > 0) {
                      sumShipped += parseInt(d.shipped);
                    }
                    if (d.paid > 0) {
                      sumPaid += parseInt(d.paid);
                    }
                    if (d.spam > 0) {
                      sumSpam += parseInt(d.spam);
                    }
                    if (d.total_call_duration > 0) {
                      sumAverageCallDuration += d.total_call_duration;
                    }
                    if (d.total_spent_time > 0) {
                      sumAverageSpentTime += d.total_spent_time;
                    }
                    if (d.total_spent_time_without_calls > 0) {
                      sumAverageWithoutCalls += d.total_spent_time_without_calls;
                    }
                    if (d.hold) {
                      sumHold += d.hold;
                    }
                    if (d.total_call_duration_approved > 0) {
                      sumTotalCallApproved += d.total_call_duration_approved;
                    }
                    if (d.total_call_duration_canceled > 0) {
                      sumTotalCallCanceled += d.total_call_duration_canceled;
                    }
                    if (d.refunded > 0) {
                      sumReturn += d.refunded;
                    }
                  });
                  _this2.footColumns = {
                    label: {
                      value: _this2.$root.$t('statistic.in_total')
                    },
                    total: {
                      value: '' + sumTotal,
                      graph: true
                    },
                    approve: {
                      value: '' + sumApproved
                    },
                    approvePercent: {
                      value: _Helper2.default.percents(sumTotal, sumApproved)
                    },
                    approvedFromValid: {
                      value: _Helper2.default.percents(sumTotal - sumSpam, sumApproved)
                    },
                    canceled: {
                      value: '' + sumCanceled,
                      graph: true
                    },
                    canceledPercents: {
                      value: _Helper2.default.percents(sumTotal, sumCanceled),
                      graph: {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: '%'
                      }
                    },
                    shipped: {
                      value: '' + sumShipped
                    },
                    shippedPercents: {
                      value: _Helper2.default.percents(sumApproved, sumShipped),
                      graph: {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: '%'
                      }
                    },
                    paid: {
                      value: '' + sumPaid,
                      graph: true
                    },
                    paidPercents: {
                      value: _Helper2.default.percents(sumApproved, sumPaid),
                      graph: {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: '%'
                      }
                    },
                    return: {
                      value: '' + sumReturn
                    },
                    returnPercents: {
                      value: _Helper2.default.percents(sumApproved, sumReturn),
                      graph: {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: '%'
                      }
                    },
                    spam: {
                      value: '' + sumSpam
                    },
                    holds: {
                      value: sumHold
                    },
                    averageBill: {
                      value: _Helper2.default.averageBillDayCount(sumAverageBill, sumApproved),
                      graph: {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: '$'
                      }
                    },
                    averageBillLocal: {
                      value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumApproved, _this2.localCurrencySymbol) : '-',
                      graph: filterCurrency.length === 1 ? {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: _this2.localCurrencySymbol
                      } : false
                    },
                    averageBuyback: {
                      value: _Helper2.default.averageBillDayCount(sumAverageBuyback, sumPaid),
                      graph: {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: '$'
                      }
                    },
                    averageBuybackLocal: {
                      value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBuybackLocal, sumPaid, _this2.localCurrencySymbol) : '-',
                      graph: filterCurrency.length === 1 ? {
                        cb: function cb(value) {
                          return _Helper2.default.getRawNumber(value);
                        },
                        symbol: _this2.localCurrencySymbol
                      } : false
                    },
                    call_duration: {
                      value: _Helper2.default.hourAndMin(_Helper2.default.averageFloat(sumAverageCallDuration, sumTotal))
                    },
                    time_processing: {
                      value: _Helper2.default.hourAndMin(_Helper2.default.averageFloat(sumAverageSpentTime, sumTotal))
                    },
                    time_out_calls: {
                      value: _Helper2.default.hourAndMin(_Helper2.default.averageFloat(sumAverageWithoutCalls, sumTotal))
                    },
                    call_duration_approve: {
                      value: _Helper2.default.hourAndMin(_Helper2.default.averageFloat(sumTotalCallApproved, sumApproved))
                    },
                    call_duration_cancel: {
                      value: _Helper2.default.hourAndMin(_Helper2.default.averageFloat(sumTotalCallCanceled, sumCanceled))
                    }
                  };
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }()
  }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(13);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _OperatorsConversionTabs = __webpack_require__(32);

var _OperatorsConversionTabs2 = _interopRequireDefault(_OperatorsConversionTabs);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  name: 'NewOrdersWeek',
  components: { StatisticTable: _StatisticTable2.default, Filters: _Filters2.default, OperatorsConversionTabs: _OperatorsConversionTabs2.default },
  data: function data() {
    return {
      x: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true,
        byManualFilter: true
      },
      headColumns: [{ label: this.$root.$t('statistic.operator'), field: 'operator', color: '#e0e0e0' }, { label: this.$root.$t('statistic.approve'), field: 'approve', colspan: 3, color: '#81c784' }, { label: this.$root.$t('statistic.buyoutSum'), field: 'buyoutSum', colspan: 2, color: '#b9f6ca' }, { label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2, color: '#bae0ff' }, { label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead', color: '#ffd96a' }, { label: this.$root.$t('statistic.total_revenue'), field: 'total_revenue', color: '#60b3f6' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px', color: '#8fbc8f' }],
      rows: {},
      footColumns: {},
      monthIndex: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
      operators: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    approvedFromValid: function approvedFromValid(approved, total, spam) {
      return (approved / (total - spam) * 100).toFixed(1) + '%';
    },
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    localCurrency: function localCurrency(currency) {
      return (0, _currencySymbolMap2.default)(currency);
    },
    operatorsReturn: function operatorsReturn(id) {
      return _Helper2.default.getOperatorLogin(this.operators, id) + ' ' + (_Storage2.default.developMode ? '(' + id + ')' : '');
    },
    getWeekDaysByWeekNumber: function getWeekDaysByWeekNumber(week) {
      var date = (0, _moment2.default)().isoWeek(week || 1).startOf('week'),
          weeklength = 7,
          result = [],
          month = '';
      while (weeklength--) {
        result.push(date.format('DD'));
        month = date.format('MM');
        date.add(1, 'day');
      }
      return '\u041D\u0435\u0434\u0435\u043B\u044F \u0441 ' + result[0] + ' - ' + result[6] + ' ' + this.monthIndex[month - 1];
    },
    calculateRows: function () {
      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.rows = [];
                this.footColumns = [];
                this.operators = [];
                _context.next = 5;
                return _API2.default.getOperators(_Helper2.default.getCountryList()).then(function (operators) {
                  _this2.operators = operators.body;
                });

              case 5:
                _context.next = 7;
                return _API2.default.getNewOrdersWeek().then(function (response) {
                  _this2.rows = response.body;
                  (0, _lodash.map)(_this2.rows, function (arr) {
                    var sumApproved = 0;
                    var sumTotal = 0;
                    var sumPaid = 0;
                    var sumSpam = 0;
                    var sumAverageBill = 0.0;
                    var currencyArr = [];
                    var sumAverageBillLocal = 0.0;
                    var currency = '';
                    arr.forEach(function (d) {
                      sumApproved += d.approved;
                      sumTotal += d.total;
                      sumPaid += d.paid;
                      sumSpam += d.spam;
                      sumAverageBill += d.total_buyout_usd;
                      sumAverageBillLocal += d.total_buyout_local;
                      currencyArr.push(d.local_currency);
                      currency = d.local_currency;
                    });
                    var newFilterCurrenct = currencyArr.filter(function (item, index) {
                      return currencyArr.indexOf(item) === index;
                    });

                    var sumAverageBuybackRevenua = _Helper2.default.averageBillDayCount(sumAverageBill, sumPaid).replace('$', '').replace(',', '.');

                    var paidPercentsRevenua = _Helper2.default.percents(sumApproved, sumPaid).replace('%', '').replace(',', '.');
                    var resultRevenuaLeadAverage = (sumAverageBuybackRevenua * paidPercentsRevenua / 100).toFixed(2);
                    arr.total = [{
                      label: 'Итого',
                      total: sumTotal,
                      approved: sumApproved,
                      paid: sumPaid,
                      total_bill: _Helper2.default.averageBillDayCount(sumAverageBill, sumPaid),
                      total_local: newFilterCurrenct.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumPaid, _this2.localCurrency(currency)) : '-',
                      total_revenue: resultRevenuaLeadAverage,
                      total_all_average: (sumPaid * (sumAverageBill / sumPaid)).toFixed(2),
                      approvedFromValid: _Helper2.default.approvedFromValid(sumApproved, sumTotal, sumSpam)
                    }];
                  });
                  _this2.$root.$emit('data_loaded');
                }).catch(function (response) {
                  _this2.loading = false;
                  _this2.$notify({
                    type: 'danger',
                    title: _this2.$root.$t('verbs.error'),
                    text: !response.body.message ? response.body : response.body.message,
                    animationType: 'velocity'
                  });
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function calculateRows() {
        return _ref.apply(this, arguments);
      }

      return calculateRows;
    }()
  }
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _RingingTabs = __webpack_require__(182);

var _RingingTabs2 = _interopRequireDefault(_RingingTabs);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    RingingTabs: _RingingTabs2.default,
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      sms: 0,
      call: 0,
      TypeColor: _TypeColor2.default,
      isLoading: false,
      filtersScope: {
        countryFilter: true,
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        oneCountryFilter: true,
        byWmFilterAll: true

      },
      headColumns: [{ label: this.$root.$t('statistic.date'), field: 'date', width: '120px' }, { label: this.$root.$t('statistic.approve_percent'), field: 'approve_percent' }, { label: this.$root.$t('statistic.total_sms_sent'), field: 'total_sms_sent' }, { label: this.$root.$t('statistic.total_all'), field: 'total_all' }, { label: this.$root.$t('statistic.total_lead_sms_sent'), field: 'total_lead_sms_sent' }, { label: this.$root.$t('statistic.total_sms'), field: 'total_sms' }, { label: this.$root.$t('statistic.total_minutes'), field: 'total_minutes' }, { label: this.$root.$t('statistic.total_all_minutes'), field: 'total_all_minutes' }, { label: this.$root.$t('statistic.total_minutes_lead'), field: 'total_minutes_lead' }, { label: this.$root.$t('statistic.total_lead'), field: 'total_lead' }, { label: this.$root.$t('statistic.total_seconds_call'), field: 'total_seconds_call' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }],
      footColumns: {},
      rows: [],
      columns: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    checkForm: function checkForm(e) {
      var _this2 = this;

      e.preventDefault();
      var rate = {
        sms: this.sms,
        call: this.call
      };
      _API2.default.postRingingRates(rate).then(function (response) {
        if (response.status === 200) {
          _this2.calculateRows();
        }
      }).catch(function (error) {
        console.log('Ошибка в запросе', error);
      });
    },
    calculateRows: function calculateRows() {
      var _this3 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      _API2.default.getRingingRates().then(function (response) {
        _this3.sms = response.data.sms;
        _this3.call = response.data.call;
      });
      var totalApproved = 0;
      var totalSmsSent = 0;
      _API2.default.getRingingSms().then(function (response) {
        (0, _lodash.map)(response.data, function (d) {
          totalSmsSent += parseInt(d.count_sms);
          _this3.rows.push({
            date: {
              value: d.date,
              bg: true
            },
            approve_percent: {
              value: '' + parseInt(d.approved).toFixed(0),
              bg: true
            },
            total_sms_sent: {
              value: d.count_sms,
              bg: true
            },
            total_all: {
              value: d.sms_cost_sum,
              bg: true
            },
            total_lead_sms_sent: {
              value: d.sms_per_lead,
              bg: true
            },
            total_sms: {
              value: d.cost_per_sms,
              bg: true
            },
            total_minutes: {
              value: !d.call_time_minutes ? d.call_time_minutes = 0 : d.call_time_minutes
            },
            total_all_minutes: {
              value: d.call_cost_sum,
              bg: true
            },
            total_minutes_lead: {
              value: d.call_per_lead,
              bg: true
            },
            total_lead: {
              value: d.cost_per_call,
              bg: true
            },
            total_seconds_call: {
              value: d.sum_cost_per_lead.toFixed(2),
              bg: true
            },
            approvedFromValid: {
              value: _Helper2.default.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
            }
          });
        });
        _this3.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this3.$root.$emit('data_loaded');
        _this3.$notify({
          type: 'danger',
          title: _this3.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _RingingTabs = __webpack_require__(182);

var _RingingTabs2 = _interopRequireDefault(_RingingTabs);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SentSmsTemplate',
  components: { RingingTabs: _RingingTabs2.default, StatisticTable: _StatisticTable2.default, Filters: _Filters2.default },
  data: function data() {
    return {
      sms: 0,
      call: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byWmFilterAll: true
      },
      headColumns: [{ label: this.$root.$t('statistic.template_sms'), field: 'template_sms', width: '1100px' }, { label: this.$root.$t('statistic.parts_sms'), field: 'parts_sms', width: '110px' }, { label: this.$root.$t('statistic.approvals'), field: 'approvals' }, { label: this.$root.$t('statistic.sent_sms'), field: 'sent_sms' }, { label: this.$root.$t('statistic.total_amount'), field: 'total_amount' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }],
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    checkForm: function checkForm(e) {
      var _this2 = this;

      e.preventDefault();
      var rate = {
        sms: this.sms,
        call: this.call
      };
      _API2.default.postRingingRates(rate).then(function (response) {
        if (response.status === 200) {
          _this2.calculateRows();
        }
      }).catch(function (error) {
        console.log('Ошибка в запросе', error);
      });
    },
    calculateRows: function calculateRows() {
      var _this3 = this;

      this.rows = [];
      this.footColumns = {};
      _API2.default.getRingingRates().then(function (response) {
        _this3.sms = response.data.sms;
        _this3.call = response.data.call;
      });
      _API2.default.getTemplateSms().then(function (template) {
        var smsTemplates = template.body;
        _API2.default.getSentSmsTemplate().then(function (response) {
          var sumTotal = 0;
          var totalParts = 0;
          var totalApproved = 0;
          var totalSent = 0;
          var totalAmount = 0;
          var totalSpam = 0;
          (0, _lodash.map)(response.body, function (d) {
            sumTotal += d.total;
            totalParts += d.parts;
            totalApproved += d.approved;
            totalSent += d.sent;
            totalAmount += d.total_price;
            totalSpam += d.span;
            _this3.rows.push({
              template_sms: {
                value: _Helper2.default.getSmsText(smsTemplates, d.template_id)
              },
              parts_sms: {
                value: d.parts
              },
              approvals: {
                value: d.approved
              },
              sent_sms: {
                value: d.sent
              },
              total_amount: {
                value: '$ ' + d.total_price.toFixed(2)
              },
              approvedFromValid: {
                value: d.total - d.spam > 0 ? _Helper2.default.approvedFromValid(d.approved, d.total, d.spam) : '0%'
              }
            });

            _this3.footColumns = {
              label: {
                value: _this3.$root.$t('statistic.in_total')
              },
              parts_sms: {
                value: totalParts
              },
              approvals: {
                value: totalApproved
              },
              sent_sms: {
                value: totalSent
              },
              total_amount: {
                value: '$ ' + totalAmount.toFixed(2)
              },
              approvedFromValid: {
                value: sumTotal - totalSpam > 0 ? _Helper2.default.approvedFromValid(totalApproved, sumTotal, totalSpam) : '0%'
              }
            };
          });
        });
      });
    }
  }
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _Orders = __webpack_require__(183);

var _Orders2 = _interopRequireDefault(_Orders);

var _Receipt = __webpack_require__(184);

var _Receipt2 = _interopRequireDefault(_Receipt);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _ProductTabs = __webpack_require__(22);

var _ProductTabs2 = _interopRequireDefault(_ProductTabs);

var _vueStrap = __webpack_require__(9);

var _pdfmake = __webpack_require__(176);

var _pdfmake2 = _interopRequireDefault(_pdfmake);

var _vfs_fonts = __webpack_require__(177);

var _vfs_fonts2 = _interopRequireDefault(_vfs_fonts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Orders-Receipt',
  components: {
    Filters: _Filters2.default,
    ProductOrders: _Orders2.default,
    ReceiptOrders: _Receipt2.default,
    DatePicker: _vuejsDatepicker2.default,
    StatisticTable: _StatisticTable2.default,
    MultiSelect: _vueMultiselect2.default,
    ProductTabs: _ProductTabs2.default,
    modal: _vueStrap.modal
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilterCreated: true,
        dateFilterReceipt: true
      },
      form: {
        product: null,
        orders_count: null,
        price: null,
        provider: null,
        delivery_time: Date.now(),
        status: null,
        comment: null,
        country: null
      },
      expiration: Date.now(),
      errors: [],
      errorsByOrder: [],
      storageGoodsAll: null,
      customs: null,
      logistics: null,
      idoffer: null,
      confirmModal: false,
      isLoad: false,
      loadingProduct: false,
      isBlock: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      orders: [],
      receipt: [],
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.product'), field: 'product_id' }, { label: this.$root.$t('statistic.ordered'), field: 'orders_count' }, { label: this.$root.$t('statistic.price'), field: 'price' }, { label: this.$root.$t('statistic.provider'), field: 'provider' }, { label: this.$root.$t('statistic.time'), field: 'delivery_time' }, { label: this.$root.$t('statistic.status'), field: 'status' }, { label: this.$root.$t('statistic.comment'), field: 'comment' }],
      rows: [],
      rowsOrder: [],
      rowsReceipt: [],
      footColumns: {},
      info: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getCountries();
    this.getOrders();
    this.getGoods();
    this.$root.$on('filters_load_new_data', function () {
      _this.getOrders();
      _this.getGoods();
    });
  },

  methods: {
    getOrders: function getOrders() {
      var _this2 = this;

      this.rowsOrder = [];
      this.rowsReceipt = [];
      this.loadingProduct = true;
      _API2.default.getRemnantsOrdersReceipt().then(function (response) {
        if (response.status === 200) {
          _this2.loadingProduct = false;
          _this2.rowsOrder = (0, _lodash.filter)(response.body, function (o) {
            return o.is_receipt === 0;
          });
          _this2.rowsReceipt = (0, _lodash.filter)(response.body, function (o) {
            return o.is_receipt === 1;
          });
        }
      }).catch(function (response) {
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    clickAdd: function clickAdd() {
      this.isBlock = !this.isBlock;
    },

    checkForm: function checkForm(order) {
      var _this3 = this;

      this.$emit('update');
      this.errors = [];
      if (!this.form.product) {
        this.errors.push('Укажите продукт');
      }
      if (!this.form.orders_count) {
        this.errors.push('Укажите Количество заказов');
      }
      if (!this.form.price) {
        this.errors.push('Укажите цену');
      }
      if (!this.form.provider) {
        this.errors.push('Укажите Постовщика');
      }
      if (!this.form.status) {
        this.errors.push('Укажите Статус');
      }
      if (_Storage2.default.selectedCountry.id === -1) {
        if (!this.form.country) {
          this.errors.push('Укажите Страну');
        }
      }
      if (!this.errors.length) {
        this.isLoading = true;
        var formData = new FormData();
        if (_Storage2.default.selectedCountry.id === -1) {
          for (var key in this.form) {
            if (key !== 'country') {
              formData.append(key, this.form[key]);
            }
          }
          formData.append('delivery_time', (0, _moment2.default)(this.form.delivery_time).format('Y-MM-DD'));
          formData.append('file', this.files);
          formData.append('country_id', this.form.country);
          formData.append('product_id', this.form.product.alias);
        } else {
          for (var _key in this.form) {
            formData.append(_key, this.form[_key]);
          }
          formData.append('delivery_time', (0, _moment2.default)(this.form.delivery_time).format('Y-MM-DD'));
          formData.append('file', this.files);
          formData.append('country_id', _Storage2.default.selectedCountry.id);
          formData.append('product_id', this.form.product.alias);
        }
        _API2.default.postRemnandsNew(formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (res) {
          if (res.body === true) {
            console.log(formData);
            _this3.isLoading = false;
            _this3.isBlock = false;
            _this3.getOrders();
            _this3.getRemnands();
          }
        }).catch(function (response) {
          _this3.isLoading = false;
          _this3.$root.$emit('data_loaded');
          _this3.$notify({
            type: 'danger',
            title: _this3.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          });
        });
        this.form.product = null;
        this.form.orders_count = null;
        this.form.price = null;
        this.form.provider = null;
        this.form.delivery_time = Date.now();
        this.form.status = null;
        this.form.comment = null;
      }
      order.preventDefault();
    },
    getGoods: function getGoods() {
      var _this4 = this;

      _API2.default.getGoods(_Storage2.default.selectedCountry.id).then(function (res) {
        _Storage2.default.goods = res.body;
      }).catch(function (response) {
        _this4.isLoading = false;
        _this4.$root.$emit('data_loaded');
        _this4.$notify({
          type: 'danger',
          title: _this4.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    getGoodsAll: function getGoodsAll() {
      var _this5 = this;

      _API2.default.getGoods(this.form.country).then(function (res) {
        _this5.storageGoodsAll = res.body;
      }).catch(function (response) {
        _this5.isLoading = false;
        _this5.$root.$emit('data_loaded');
        _this5.$notify({
          type: 'danger',
          title: _this5.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    addReceipt: function addReceipt(idOffer) {
      this.confirmModal = true;
      this.idoffer = idOffer;
    },
    addExpiration: function addExpiration() {
      var _this6 = this;

      this.$emit('update');
      this.errorsByOrder = [];
      if (!this.errorsByOrder.length) {
        this.isLoading = true;
        var date = (0, _moment2.default)(this.expiration).format('YYYY-MM-DD');
        var obj = {
          is_receipt: 1,
          expiration_date: date,
          logistic: this.logistics,
          customs: this.customs
        };
        _API2.default.postEditOrder(this.idoffer, obj).then(function (response) {
          _this6.getOrders();
          _this6.getRemnands();
          _this6.confirmModal = false;
          _this6.logistics = null;
          _this6.customs = null;
          _this6.errorsByOrder = [];
        }).catch(function (response) {
          _this6.$root.$emit('data_loaded');
          _this6.$notify({
            type: 'danger',
            title: _this6.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          });
        });
      }
    },
    download: function download(idOffer) {
      var _this7 = this;

      _API2.default.getRemnantsOrdersReceipt().then(function (response) {
        _Storage2.default.info = response.body;
        var bb = {};
        _this7.info = (0, _lodash.filter)(_Storage2.default.info, function (o) {
          return o.id === idOffer;
        });
        for (var i in _this7.info) {
          bb = _this7.info[i];
        }
        function toDataURL(url, callback) {
          var xhr = new XMLHttpRequest();
          xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
              callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
        }

        _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
        var product = (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          return o.alias === bb.product_id;
        });
        var productName = void 0;
        for (var _i in product) {
          productName = product[_i].name;
        }
        if (!bb.image) {
          _pdfmake2.default.createPdf({
            content: [{ text: 'Ваш заказ', style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, {
              table: {
                alignment: 'center',
                widths: [60, 80, 80, 80, 90, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true
                }, { text: 'Цена', alignment: 'center', bold: true }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true
                }, { text: 'Срок поставки', alignment: 'center', bold: true }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true
                }], [{ text: productName, alignment: 'center' }, {
                  text: bb.orders_count,
                  alignment: 'center'
                }, { text: bb.price, alignment: 'center' }, {
                  text: bb.provider,
                  alignment: 'center'
                }, { text: bb.delivery_time, alignment: 'center' }, { text: bb.comment, alignment: 'center' }]]
              }
            }]
          }).download('Order.pdf');
        } else {
          toDataURL('https://api.analytics.leadgroup.su/order_images/' + bb.image, function (dataUrl) {
            _pdfmake2.default.createPdf({
              content: [{
                text: 'Ваш заказ',
                style: 'header',
                alignment: 'center',
                fontSize: 25,
                margin: [0, 10, 0, 20]
              }, {
                table: {
                  alignment: 'center',
                  widths: [60, 80, 80, 80, 90, 80],
                  margin: [0, 20, 20, 0],
                  body: [[{ text: 'Товар', alignment: 'center', bold: true }, {
                    text: 'Количество',
                    alignment: 'center',
                    bold: true
                  }, { text: 'Цена', alignment: 'center', bold: true }, {
                    text: 'Поставщик',
                    alignment: 'center',
                    bold: true
                  }, { text: 'Срок поставки', alignment: 'center', bold: true }, {
                    text: 'Комментарии',
                    alignment: 'center',
                    bold: true
                  }], [{ text: productName, alignment: 'center' }, {
                    text: bb.orders_count,
                    alignment: 'center'
                  }, { text: bb.price, alignment: 'center' }, {
                    text: bb.provider,
                    alignment: 'center'
                  }, { text: bb.delivery_time, alignment: 'center' }, {
                    text: bb.comment,
                    alignment: 'center'
                  }]]
                }
              }, { text: 'Фото вашего товара', alignment: 'center', fontSize: 25, margin: [0, 20, 0, 20] }, {
                image: '' + dataUrl,
                width: 400,
                alignment: 'center'
              }]
            }).download('Order.pdf');
          });
        }
      }).catch(function (response) {
        _this7.$notify({
          type: 'danger',
          title: _this7.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    downloadPdfReceipt: function downloadPdfReceipt(idOffer) {
      var _this8 = this;

      _API2.default.getRemnantsOrdersReceipt().then(function (response) {
        _Storage2.default.info = response.body;
        var bb = {};
        _this8.info = (0, _lodash.filter)(_Storage2.default.info, function (o) {
          return o.id === idOffer;
        });
        for (var i in _this8.info) {
          console.log(i, _this8.info[i], 'инфо1');
          bb = _this8.info[i];
        }
        console.log(bb, 'log1');

        function toDataURL(url, callback) {
          var xhr = new XMLHttpRequest();
          xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
              callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
        }

        _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
        console.log(bb.product_id, 'product');
        var product = (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          return o.alias === bb.product_id;
        });
        var productName = void 0;
        for (var _i2 in product) {
          productName = product[_i2].name;
        }
        if (!bb.image) {
          _pdfmake2.default.createPdf({
            content: [{ text: 'Ваш заказ', style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, {
              table: {
                alignment: 'center',
                widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Цена', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Логистика', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Долг', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }], [{ text: productName, alignment: 'center', fontSize: 9 }, {
                  text: bb.orders_count,
                  alignment: 'center',
                  fontSize: 9
                }, { text: bb.price, alignment: 'center', fontSize: 9 }, { text: bb.logistic, alignment: 'center', fontSize: 9 }, { text: bb.customs, alignment: 'center', fontSize: 9 }, {
                  text: bb.provider,
                  alignment: 'center',
                  fontSize: 9
                }, { text: bb.delivery_time, alignment: 'center', fontSize: 9 }, { text: (bb.price + bb.logistic + bb.customs) * bb.orders_count, alignment: 'center', fontSize: 9 }, { text: bb.comment, alignment: 'center', fontSize: 9 }]]
              }
            }]
          }).download('Receipt.pdf');
        } else {
          toDataURL('https://api.analytics.leadgroup.su/order_images/' + bb.image, function (dataUrl) {
            _pdfmake2.default.createPdf({
              content: [{
                text: 'Ваш заказ',
                style: 'header',
                alignment: 'center',
                fontSize: 25,
                margin: [0, 10, 0, 20]
              }, {
                table: {
                  alignment: 'center',
                  widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                  margin: [0, 0, 0, 0],
                  body: [[{ text: 'Товар', alignment: 'center', bold: true, fontSize: 9 }, {
                    text: 'Кол-тво',
                    alignment: 'center',
                    bold: true,
                    fontSize: 9
                  }, { text: 'Цена', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Логистика', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9 }, {
                    text: 'Поставщик',
                    alignment: 'center',
                    bold: true,
                    fontSize: 9
                  }, { text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Долг', alignment: 'center', bold: true, fontSize: 9 }, {
                    text: 'Комментарии',
                    alignment: 'center',
                    bold: true,
                    fontSize: 9
                  }], [{ text: productName, alignment: 'center', fontSize: 9 }, {
                    text: bb.orders_count,
                    alignment: 'center',
                    fontSize: 9
                  }, { text: bb.price, alignment: 'center', fontSize: 9 }, { text: bb.logistic, alignment: 'center', fontSize: 9 }, { text: bb.customs, alignment: 'center', fontSize: 9 }, {
                    text: bb.provider,
                    alignment: 'center',
                    fontSize: 9
                  }, { text: bb.delivery_time, alignment: 'center', fontSize: 9 }, { text: (bb.price + bb.logistic + bb.customs) * bb.orders_count, alignment: 'center', fontSize: 9 }, {
                    text: bb.comment,
                    alignment: 'center',
                    fontSize: 9
                  }]]
                }
              }, { text: 'Фото вашего товара', alignment: 'center', fontSize: 25, margin: [0, 20, 0, 20] }, {
                image: '' + dataUrl,
                width: 400,
                alignment: 'center'
              }]
            }).download('Receipt.pdf');
          });
        }
      }).catch(function (response) {
        _this8.$notify({
          type: 'danger',
          title: _this8.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    uploadImageOrder: function uploadImageOrder(idOrder, files, name) {
      var _this9 = this;

      var formData = new FormData();
      formData.append('file', name[0]);
      _API2.default.postEditOrder(idOrder, formData).then(function (response) {
        _this9.getOrders();
        _this9.getRemnands();
      }).catch(function (response) {
        _this9.$root.$emit('data_loaded');
        _this9.$notify({
          type: 'danger',
          title: _this9.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    uploadImageReceipt: function uploadImageReceipt(idOrder, files, name) {
      var _this10 = this;

      var formData = new FormData();
      formData.append('file', name[0]);
      _API2.default.postEditOrder(idOrder, formData).then(function (response) {
        _this10.getOrders();
        _this10.getRemnands();
      }).catch(function (response) {
        _this10.$root.$emit('data_loaded');
        _this10.$notify({
          type: 'danger',
          title: _this10.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    downloadAll: function downloadAll() {
      _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
      var pdfAllOrder = [];
      (0, _lodash.map)(Object.values(this.rowsOrder), function (i) {
        return (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          if (_Storage2.default.selectedCountry.id === -1) {
            if (o.alias === i.product_id && o.country_id === i.country_id) {
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          } else {
            if (o.alias === i.product_id) {
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          }
        });
      });
      _pdfmake2.default.createPdf({
        content: (0, _lodash.map)(pdfAllOrder, function (i, index) {
          return [{ text: '\u0417\u0430\u043A\u0430\u0437 \u2116' + (index + 1), style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [60, 80, 80, 80, 90, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true
                }, { text: 'Цена', alignment: 'center', bold: true }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true
                }, { text: 'Срок поставки', alignment: 'center', bold: true }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true
                }]]
              }
            }]
          }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [60, 80, 80, 80, 90, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: i.name, alignment: 'center', style: 'tableAll' }, { text: i.orders_count, alignment: 'center', style: 'tableAll' }, { text: i.price, alignment: 'center', style: 'tableAll' }, { text: i.provider, alignment: 'center', style: 'tableAll' }, { text: i.time, alignment: 'center', style: 'tableAll' }, { text: i.comment, alignment: 'center', style: 'tableAll' }]]
              }
            }]
          }];
        })
      }).download('Orders.pdf');
    },
    downloadAllReceipt: function downloadAllReceipt() {
      _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
      var pdfAllOrder = [];
      (0, _lodash.map)(Object.values(this.rowsReceipt), function (i) {
        return (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          if (_Storage2.default.selectedCountry.id === -1) {
            if (o.alias === i.product_id && o.country_id === i.country_id) {
              var credit = (i.price + i.logistic + i.customs) * i.orders_count;
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                logistic: i.logistic,
                customs: i.customs,
                credit: credit,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          } else {
            if (o.alias === i.product_id) {
              var _credit = (i.price + i.logistic + i.customs) * i.orders_count;
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                logistic: i.logistic,
                customs: i.customs,
                credit: _credit,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          }
        });
      });
      console.log(pdfAllOrder, 'pdfAllOrder');
      _pdfmake2.default.createPdf({
        content: (0, _lodash.map)(pdfAllOrder, function (i, index) {
          return [{ text: '\u0417\u0430\u043A\u0430\u0437 \u2116' + (index + 1), style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                margin: [0, 0, 0, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Цена', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Логистика', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Долг', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }]]
              }
            }]
          }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                margin: [0, 0, 0, 0],
                body: [[{ text: i.name, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.orders_count, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.price, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.logistic, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.customs, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.provider, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.time, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.credit, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.comment, alignment: 'center', style: 'tableAll', fontSize: 9 }]]
              }
            }]
          }];
        })
      }).download('Receipts.pdf');
    },
    changeValRemnants: function changeValRemnants(obj) {
      var _this11 = this;

      _API2.default.putEditRemains(obj).then(function (response) {
        _this11.getOrders();
        _this11.getRemnands();
      }).catch(function (response) {
        _this11.$notify({
          type: 'danger',
          title: _this11.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    changeVal: function changeVal(obj) {
      var _this12 = this;

      _API2.default.putEditOrder(obj).then(function (response) {
        _this12.getOrders();
        _this12.getRemnands();
      }).catch(function (response) {
        _this12.$root.$emit('data_loaded');
        _this12.$notify({
          type: 'danger',
          title: _this12.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    deleteChange: function deleteChange(id) {
      var _this13 = this;

      _API2.default.deleteOrder(id).then(function (response) {
        _this13.getOrders();
      }).catch(function (response) {
        _this13.$root.$emit('data_loaded');
        _this13.$notify({
          type: 'danger',
          title: _this13.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    handleFilesUpload: function handleFilesUpload(fileName, file) {
      this.files = file[0];
    },
    getCountries: function getCountries() {
      _API2.default.getCountries().then(function (res) {
        _Storage2.default.countries = res.body;
        console.log(_Storage2.default.countries, 'country');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _OrderTable = __webpack_require__(31);

var _OrderTable2 = _interopRequireDefault(_OrderTable);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Orders',
  components: {
    Filters: _Filters2.default,
    OrderTable: _OrderTable2.default
  },
  props: {
    rowsOrder: Array,
    loading: Boolean
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      form: {
        product: null,
        orders_count: null,
        price: null,
        provider: null,
        delivery_time: null,
        status: null,
        comment: null
      },
      isLoading: false,
      isBlock: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.country'), field: 'country_id' }, { label: this.$root.$t('statistic.product'), field: 'product_id' }, { label: this.$root.$t('statistic.ordered'), field: 'orders_count', input: { type: 'number' } }, { label: this.$root.$t('statistic.price'), field: 'price', input: { type: 'text' } }, { label: this.$root.$t('statistic.provider'), field: 'provider' }, { label: this.$root.$t('statistic.time'), field: 'delivery_time', input: { type: 'date' } }, { label: this.$root.$t('statistic.status'), field: 'status', input: { type: 'selectStatus' }, color: [{ value: 0, bg: '#fff9c4' }, { value: 1, bg: '#53d3a2' }] }, { label: this.$root.$t('statistic.comment'), field: 'comment', input: { type: 'text' } }],
      footColumns: {},
      rows: []
    };
  },
  created: function created() {
    var _this = this;

    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  watch: {
    rowsOrder: function rowsOrder(newq, old) {
      if (!(0, _lodash.isEqual)(newq, old)) {
        this.calculateRows(newq);
      }
    }
  },
  methods: {
    calculateRows: function calculateRows(rowsOrder) {
      var _this2 = this;

      this.rows = [];
      (0, _lodash.map)(rowsOrder, function (item, index) {
        var value = [];
        var auxvalue = void 0;
        (0, _lodash.forEach)(_this2.headColumns, function (headCol) {
          if (headCol.field === 'price') {
            if (_Storage2.default.selectedCountry.id === -1) {
              if (item.country_id === 77 || item.country_id === 1535 || item.country_id === 1547) {
                auxvalue = '₽';
              } else {
                auxvalue = '$';
              }
            } else {
              if (_Storage2.default.selectedCountry.currency === 'RUB') {
                auxvalue = _Storage2.default.selectedCountry.currency_symbol;
              } else {
                auxvalue = '$';
              }
            }
          } else if (headCol.field === 'orders_count') {
            auxvalue = 'шт.';
          } else {
            auxvalue = null;
          }
          value.push({
            key: headCol.field,
            input: headCol.input ? headCol.input : null,
            value: item[headCol.field],
            color: headCol.color ? headCol.color : null,
            aux: auxvalue
          });
        });
        _this2.rows.push({
          key: item.id,
          value: value
        });
      });
    },
    clickAdd: function clickAdd() {
      this.isBlock = !this.isBlock;
    },
    addReceipt: function addReceipt(id) {
      this.$emit('addReceipt', id);
    },
    uploadImage: function uploadImage(id, files, name) {
      this.$emit('uploadImage', id, files, name);
    },
    download: function download(id) {
      this.$emit('download', id);
    },
    downloadAll: function downloadAll(row) {
      this.$emit('downloadAll', row.rows);
    },
    changeVal: function changeVal(key, cell) {
      if (cell.key === 'delivery_time') {
        cell.value = (0, _moment2.default)(cell.value).format('Y-MM-DD');
      }
      this.$emit('changeVal', { id: key, title: cell.key, value: cell.value });
    },
    deleteChange: function deleteChange(id) {
      this.$emit('deleteChange', id);
    }
  }
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _Remnants = __webpack_require__(487);

var _Remnants2 = _interopRequireDefault(_Remnants);

var _Orders = __webpack_require__(183);

var _Orders2 = _interopRequireDefault(_Orders);

var _Receipt = __webpack_require__(184);

var _Receipt2 = _interopRequireDefault(_Receipt);

var _lodash = __webpack_require__(5);

var _vuejsDatepicker = __webpack_require__(15);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _ProductTabs = __webpack_require__(22);

var _ProductTabs2 = _interopRequireDefault(_ProductTabs);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vueMultiselect = __webpack_require__(11);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vueStrap = __webpack_require__(9);

var _pdfmake = __webpack_require__(176);

var _pdfmake2 = _interopRequireDefault(_pdfmake);

var _vfs_fonts = __webpack_require__(177);

var _vfs_fonts2 = _interopRequireDefault(_vfs_fonts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Product',
  components: {
    Filters: _Filters2.default,
    RemnantsOrders: _Remnants2.default,
    ProductTabs: _ProductTabs2.default,
    ProductOrders: _Orders2.default,
    ReceiptOrders: _Receipt2.default,
    DatePicker: _vuejsDatepicker2.default,
    moment: _moment2.default,
    StatisticTable: _StatisticTable2.default,
    MultiSelect: _vueMultiselect2.default,
    modal: _vueStrap.modal
  },
  data: function data() {
    return {
      offers: [],
      filtersScope: {
        dateFilterCreated: true,
        dateFilterReceipt: true
      },
      loadingRemnants: false,
      isBlock: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      orders: [],
      receipt: [],
      country: null,
      rowRemnants: [],
      footColumns: {},
      form: {
        product: null,
        orders_count: null,
        price: null,
        provider: null,
        delivery_time: Date.now(),
        status: null,
        comment: null,
        country: null
      },
      expiration: Date.now(),
      errors: [],
      errorsByOrder: [],
      storageGoodsAll: null,
      customs: null,
      logistics: null,
      idoffer: null,
      confirmModal: false,
      isLoad: false,
      loadingProduct: false,
      headColumns: [{ label: this.$root.$t('statistic.product'), field: 'product_id' }, { label: this.$root.$t('statistic.ordered'), field: 'orders_count' }, { label: this.$root.$t('statistic.price'), field: 'price' }, { label: this.$root.$t('statistic.provider'), field: 'provider' }, { label: this.$root.$t('statistic.time'), field: 'delivery_time' }, { label: this.$root.$t('statistic.status'), field: 'status' }, { label: this.$root.$t('statistic.comment'), field: 'comment' }],
      rows: [],
      rowsOrder: [],
      rowsReceipt: [],
      info: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getCountries();
    this.getOrders();
    this.getGoods();
    this.getRemnands();
    this.$root.$on('filters_load_new_data', function () {
      _this.getOrders();
      _this.getGoods();
      _this.getRemnands();
    });
  },

  methods: {
    getOrders: function getOrders() {
      var _this2 = this;

      this.rowsOrder = [];
      this.rowsReceipt = [];
      this.loadingProduct = true;
      _API2.default.getRemnantsOrdersReceipt().then(function (response) {
        if (response.status === 200) {
          _this2.loadingProduct = false;
          _this2.rowsOrder = (0, _lodash.filter)(response.body, function (o) {
            return o.is_receipt === 0;
          });
          _this2.rowsReceipt = (0, _lodash.filter)(response.body, function (o) {
            return o.is_receipt === 1;
          });
        }
      }).catch(function (response) {
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    clickAdd: function clickAdd() {
      this.isBlock = !this.isBlock;
    },

    checkForm: function checkForm(order) {
      var _this3 = this;

      this.$emit('update');
      this.errors = [];
      if (!this.form.product) {
        this.errors.push('Укажите продукт');
      }
      if (!this.form.orders_count) {
        this.errors.push('Укажите Количество заказов');
      }
      if (!this.form.price) {
        this.errors.push('Укажите цену');
      }
      if (!this.form.provider) {
        this.errors.push('Укажите Постовщика');
      }
      if (!this.form.status) {
        this.errors.push('Укажите Статус');
      }
      if (_Storage2.default.selectedCountry.id === -1) {
        if (!this.form.country) {
          this.errors.push('Укажите Страну');
        }
      }
      if (!this.errors.length) {
        this.isLoading = true;
        var formData = new FormData();
        if (_Storage2.default.selectedCountry.id === -1) {
          for (var key in this.form) {
            if (key !== 'country') {
              formData.append(key, this.form[key]);
            }
          }
          formData.append('delivery_time', (0, _moment2.default)(this.form.delivery_time).format('Y-MM-DD'));
          formData.append('file', this.files);
          formData.append('country_id', this.form.country);
          formData.append('product_id', this.form.product.alias);
        } else {
          for (var _key in this.form) {
            formData.append(_key, this.form[_key]);
          }
          formData.append('delivery_time', (0, _moment2.default)(this.form.delivery_time).format('Y-MM-DD'));
          formData.append('file', this.files);
          formData.append('country_id', _Storage2.default.selectedCountry.id);
          formData.append('product_id', this.form.product.alias);
        }
        _API2.default.postRemnandsNew(formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (res) {
          if (res.body === true) {
            console.log(formData, 'formdata');
            _this3.isLoading = false;
            _this3.isBlock = false;
            _this3.getOrders();
            _this3.getRemnands();
          }
        }).catch(function (response) {
          _this3.isLoading = false;
          _this3.$root.$emit('data_loaded');
          _this3.$notify({
            type: 'danger',
            title: _this3.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          });
        });
        this.form.product = null;
        this.form.orders_count = null;
        this.form.price = null;
        this.form.provider = null;
        this.form.delivery_time = Date.now();
        this.form.status = null;
        this.form.comment = null;
      }
      order.preventDefault();
    },
    getRemnands: function getRemnands() {
      var _this4 = this;

      this.rowRemnants = [];
      this.loadingRemnants = true;
      _API2.default.getRemnands().then(function (response) {
        if (response.status === 200) {
          _this4.loadingRemnants = false;
          _this4.rowRemnants = response.body;
        }
      }).catch(function (response) {
        _this4.$notify({
          type: 'danger',
          title: _this4.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    getGoods: function getGoods() {
      var _this5 = this;

      _API2.default.getGoods(_Helper2.default.getCountryList()).then(function (res) {
        _Storage2.default.goods = res.body;
      }).catch(function (response) {
        _this5.isLoading = false;
        _this5.$root.$emit('data_loaded');
        _this5.$notify({
          type: 'danger',
          title: _this5.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    getGoodsAll: function getGoodsAll() {
      var _this6 = this;

      _API2.default.getGoods(this.form.country).then(function (res) {
        _this6.storageGoodsAll = res.body;
      }).catch(function (response) {
        _this6.isLoading = false;
        _this6.$root.$emit('data_loaded');
        _this6.$notify({
          type: 'danger',
          title: _this6.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    changeValRemnants: function changeValRemnants(obj) {
      var _this7 = this;

      _API2.default.putEditRemains(obj).then(function (response) {
        _this7.getOrders();
        _this7.getRemnands();
      }).catch(function (response) {
        _this7.$notify({
          type: 'danger',
          title: _this7.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    changeVal: function changeVal(obj) {
      var _this8 = this;

      _API2.default.putEditOrder(obj).then(function (response) {
        _this8.getOrders();
        _this8.getRemnands();
      }).catch(function (response) {
        _this8.$root.$emit('data_loaded');
        _this8.$notify({
          type: 'danger',
          title: _this8.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    deleteChange: function deleteChange(id) {
      var _this9 = this;

      _API2.default.deleteOrder(id).then(function (response) {
        _this9.getOrders();
      }).catch(function (response) {
        _this9.$root.$emit('data_loaded');
        _this9.$notify({
          type: 'danger',
          title: _this9.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    addReceipt: function addReceipt(idOffer) {
      this.confirmModal = true;
      this.idoffer = idOffer;
    },
    addExpiration: function addExpiration() {
      var _this10 = this;

      this.$emit('update');
      this.errorsByOrder = [];
      if (!this.errorsByOrder.length) {
        this.isLoading = true;
        var date = (0, _moment2.default)(this.expiration).format('YYYY-MM-DD');
        var obj = {
          is_receipt: 1,
          expiration_date: date,
          logistic: this.logistics,
          customs: this.customs
        };
        _API2.default.postEditOrder(this.idoffer, obj).then(function (response) {
          _this10.getOrders();
          _this10.getRemnands();
          _this10.confirmModal = false;
          _this10.logistics = null;
          _this10.customs = null;
          _this10.errorsByOrder = [];
        }).catch(function (response) {
          _this10.$root.$emit('data_loaded');
          _this10.$notify({
            type: 'danger',
            title: _this10.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          });
        });
      }
    },
    download: function download(idOffer) {
      var _this11 = this;

      _API2.default.getRemnantsOrdersReceipt().then(function (response) {
        _Storage2.default.info = response.body;
        var bb = {};
        _this11.info = (0, _lodash.filter)(_Storage2.default.info, function (o) {
          return o.id === idOffer;
        });
        for (var i in _this11.info) {
          console.log(i, _this11.info[i], 'инфо1');
          bb = _this11.info[i];
        }
        console.log(bb, 'log1');

        function toDataURL(url, callback) {
          var xhr = new XMLHttpRequest();
          xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
              callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
        }

        _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
        console.log(bb.product_id, 'product');
        var product = (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          return o.alias === bb.product_id;
        });
        var productName = void 0;
        for (var _i in product) {
          productName = product[_i].name;
        }
        if (!bb.image) {
          _pdfmake2.default.createPdf({
            content: [{ text: 'Ваш заказ', style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, {
              table: {
                alignment: 'center',
                widths: [60, 80, 80, 80, 90, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true
                }, { text: 'Цена', alignment: 'center', bold: true }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true
                }, { text: 'Срок поставки', alignment: 'center', bold: true }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true
                }], [{ text: productName, alignment: 'center' }, {
                  text: bb.orders_count,
                  alignment: 'center'
                }, { text: bb.price, alignment: 'center' }, {
                  text: bb.provider,
                  alignment: 'center'
                }, { text: bb.delivery_time, alignment: 'center' }, { text: bb.comment, alignment: 'center' }]]
              }
            }]
          }).download('Order.pdf');
        } else {
          toDataURL('https://api.analytics.leadgroup.su/order_images/' + bb.image, function (dataUrl) {
            _pdfmake2.default.createPdf({
              content: [{
                text: 'Ваш заказ',
                style: 'header',
                alignment: 'center',
                fontSize: 25,
                margin: [0, 10, 0, 20]
              }, {
                table: {
                  alignment: 'center',
                  widths: [60, 80, 80, 80, 90, 80],
                  margin: [0, 20, 20, 0],
                  body: [[{ text: 'Товар', alignment: 'center', bold: true }, {
                    text: 'Количество',
                    alignment: 'center',
                    bold: true
                  }, { text: 'Цена', alignment: 'center', bold: true }, {
                    text: 'Поставщик',
                    alignment: 'center',
                    bold: true
                  }, { text: 'Срок поставки', alignment: 'center', bold: true }, {
                    text: 'Комментарии',
                    alignment: 'center',
                    bold: true
                  }], [{ text: productName, alignment: 'center' }, {
                    text: bb.orders_count,
                    alignment: 'center'
                  }, { text: bb.price, alignment: 'center' }, {
                    text: bb.provider,
                    alignment: 'center'
                  }, { text: bb.delivery_time, alignment: 'center' }, {
                    text: bb.comment,
                    alignment: 'center'
                  }]]
                }
              }, { text: 'Фото вашего товара', alignment: 'center', fontSize: 25, margin: [0, 20, 0, 20] }, {
                image: '' + dataUrl,
                width: 400,
                alignment: 'center'
              }]
            }).download('Order.pdf');
          });
        }
      }).catch(function (response) {
        _this11.$notify({
          type: 'danger',
          title: _this11.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    downloadPdfReceipt: function downloadPdfReceipt(idOffer) {
      var _this12 = this;

      _API2.default.getRemnantsOrdersReceipt().then(function (response) {
        _Storage2.default.info = response.body;
        var bb = {};
        _this12.info = (0, _lodash.filter)(_Storage2.default.info, function (o) {
          return o.id === idOffer;
        });
        for (var i in _this12.info) {
          console.log(i, _this12.info[i], 'инфо1');
          bb = _this12.info[i];
        }
        console.log(bb, 'log1');

        function toDataURL(url, callback) {
          var xhr = new XMLHttpRequest();
          xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
              callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
        }

        _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
        console.log(bb.product_id, 'product');
        var product = (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          return o.alias === bb.product_id;
        });
        var productName = void 0;
        for (var _i2 in product) {
          productName = product[_i2].name;
        }
        if (!bb.image) {
          _pdfmake2.default.createPdf({
            content: [{ text: 'Ваш заказ', style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, {
              table: {
                alignment: 'center',
                widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Цена', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Логистика', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Долг', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }], [{ text: productName, alignment: 'center', fontSize: 9 }, {
                  text: bb.orders_count,
                  alignment: 'center',
                  fontSize: 9
                }, { text: bb.price, alignment: 'center', fontSize: 9 }, { text: bb.logistic, alignment: 'center', fontSize: 9 }, { text: bb.customs, alignment: 'center', fontSize: 9 }, {
                  text: bb.provider,
                  alignment: 'center',
                  fontSize: 9
                }, { text: bb.delivery_time, alignment: 'center', fontSize: 9 }, { text: (bb.price + bb.logistic + bb.customs) * bb.orders_count, alignment: 'center', fontSize: 9 }, { text: bb.comment, alignment: 'center', fontSize: 9 }]]
              }
            }]
          }).download('Receipt.pdf');
        } else {
          toDataURL('https://api.analytics.leadgroup.su/order_images/' + bb.image, function (dataUrl) {
            _pdfmake2.default.createPdf({
              content: [{
                text: 'Ваш заказ',
                style: 'header',
                alignment: 'center',
                fontSize: 25,
                margin: [0, 10, 0, 20]
              }, {
                table: {
                  alignment: 'center',
                  widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                  margin: [0, 0, 0, 0],
                  body: [[{ text: 'Товар', alignment: 'center', bold: true, fontSize: 9 }, {
                    text: 'Кол-тво',
                    alignment: 'center',
                    bold: true,
                    fontSize: 9
                  }, { text: 'Цена', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Логистика', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9 }, {
                    text: 'Поставщик',
                    alignment: 'center',
                    bold: true,
                    fontSize: 9
                  }, { text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Долг', alignment: 'center', bold: true, fontSize: 9 }, {
                    text: 'Комментарии',
                    alignment: 'center',
                    bold: true,
                    fontSize: 9
                  }], [{ text: productName, alignment: 'center', fontSize: 9 }, {
                    text: bb.orders_count,
                    alignment: 'center',
                    fontSize: 9
                  }, { text: bb.price, alignment: 'center', fontSize: 9 }, { text: bb.logistic, alignment: 'center', fontSize: 9 }, { text: bb.customs, alignment: 'center', fontSize: 9 }, {
                    text: bb.provider,
                    alignment: 'center',
                    fontSize: 9
                  }, { text: bb.delivery_time, alignment: 'center', fontSize: 9 }, { text: (bb.price + bb.logistic + bb.customs) * bb.orders_count, alignment: 'center', fontSize: 9 }, {
                    text: bb.comment,
                    alignment: 'center',
                    fontSize: 9
                  }]]
                }
              }, { text: 'Фото вашего товара', alignment: 'center', fontSize: 25, margin: [0, 20, 0, 20] }, {
                image: '' + dataUrl,
                width: 400,
                alignment: 'center'
              }]
            }).download('Receipt.pdf');
          });
        }
      }).catch(function (response) {
        _this12.$notify({
          type: 'danger',
          title: _this12.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    uploadImageOrder: function uploadImageOrder(idOrder, files, name) {
      var _this13 = this;

      var formData = new FormData();
      formData.append('file', name[0]);
      _API2.default.postEditOrder(idOrder, formData).then(function (response) {
        _this13.getOrders();
        _this13.getRemnands();
      }).catch(function (response) {
        _this13.$root.$emit('data_loaded');
        _this13.$notify({
          type: 'danger',
          title: _this13.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    uploadImageReceipt: function uploadImageReceipt(idOrder, files, name) {
      var _this14 = this;

      var formData = new FormData();
      formData.append('file', name[0]);
      _API2.default.postEditOrder(idOrder, formData).then(function (response) {
        _this14.getOrders();
        _this14.getRemnands();
      }).catch(function (response) {
        _this14.$root.$emit('data_loaded');
        _this14.$notify({
          type: 'danger',
          title: _this14.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    downloadAll: function downloadAll() {
      console.log('downloadAll');
      _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
      var pdfAllOrder = [];
      (0, _lodash.map)(Object.values(this.rowsOrder), function (i) {
        return (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          if (_Storage2.default.selectedCountry.id === -1) {
            if (o.alias === i.product_id && o.country_id === i.country_id) {
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          } else {
            if (o.alias === i.product_id) {
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          }
        });
      });
      console.log(pdfAllOrder, 'pdfAllOrder');
      _pdfmake2.default.createPdf({
        content: (0, _lodash.map)(pdfAllOrder, function (i, index) {
          return [{ text: '\u0417\u0430\u043A\u0430\u0437 \u2116' + (index + 1), style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [60, 80, 80, 80, 90, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true
                }, { text: 'Цена', alignment: 'center', bold: true }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true
                }, { text: 'Срок поставки', alignment: 'center', bold: true }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true
                }]]
              }
            }]
          }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [60, 80, 80, 80, 90, 80],
                margin: [0, 20, 20, 0],
                body: [[{ text: i.name, alignment: 'center', style: 'tableAll' }, { text: i.orders_count, alignment: 'center', style: 'tableAll' }, { text: i.price, alignment: 'center', style: 'tableAll' }, { text: i.provider, alignment: 'center', style: 'tableAll' }, { text: i.time, alignment: 'center', style: 'tableAll' }, { text: i.comment, alignment: 'center', style: 'tableAll' }]]
              }
            }]
          }];
        })
      }).download('Orders.pdf');
    },
    downloadAllReceipt: function downloadAllReceipt() {
      _pdfmake2.default.vfs = _vfs_fonts2.default.pdfMake.vfs;
      var pdfAllOrder = [];
      (0, _lodash.map)(Object.values(this.rowsReceipt), function (i) {
        return (0, _lodash.filter)(_Storage2.default.goods, function (o) {
          if (_Storage2.default.selectedCountry.id === -1) {
            if (o.alias === i.product_id && o.country_id === i.country_id) {
              var credit = (i.price + i.logistic + i.customs) * i.orders_count;
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                logistic: i.logistic,
                customs: i.customs,
                credit: credit,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          } else {
            if (o.alias === i.product_id) {
              var _credit = (i.price + i.logistic + i.customs) * i.orders_count;
              pdfAllOrder.push({
                name: o.name,
                id: i.product_id,
                comment: i.comment,
                logistic: i.logistic,
                customs: i.customs,
                credit: _credit,
                orders_count: i.orders_count,
                provider: i.provider,
                price: i.price,
                time: i.delivery_time
              });
            }
          }
        });
      });
      console.log(pdfAllOrder, 'pdfAllOrder');
      _pdfmake2.default.createPdf({
        content: (0, _lodash.map)(pdfAllOrder, function (i, index) {
          return [{ text: '\u0417\u0430\u043A\u0430\u0437 \u2116' + (index + 1), style: 'header', alignment: 'center', fontSize: 25, margin: [0, 10, 0, 20] }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                margin: [0, 0, 0, 0],
                body: [[{ text: 'Товар', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Количество',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Цена', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Логистика', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Растоможка', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Поставщик',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }, { text: 'Срок поставки', alignment: 'center', bold: true, fontSize: 9 }, { text: 'Долг', alignment: 'center', bold: true, fontSize: 9 }, {
                  text: 'Комментарии',
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
                }]]
              }
            }]
          }, { unbreakable: true,
            stack: [{ table: {
                alignment: 'center',
                widths: [55, 40, 30, 55, 60, 50, 50, 30, 80],
                margin: [0, 0, 0, 0],
                body: [[{ text: i.name, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.orders_count, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.price, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.logistic, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.customs, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.provider, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.time, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.credit, alignment: 'center', style: 'tableAll', fontSize: 9 }, { text: i.comment, alignment: 'center', style: 'tableAll', fontSize: 9 }]]
              }
            }]
          }];
        })
      }).download('Receipts.pdf');
    },
    handleFilesUpload: function handleFilesUpload(fileName, file) {
      this.files = file[0];
    },
    getCountries: function getCountries() {
      _API2.default.getCountries().then(function (res) {
        _Storage2.default.countries = res.body;
        console.log(_Storage2.default.countries, 'country');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProductTabs = __webpack_require__(22);

var _ProductTabs2 = _interopRequireDefault(_ProductTabs);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _lodash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ProductBalance',
  components: { ProductTabs: _ProductTabs2.default, StatisticTable: _StatisticTable2.default, Filters: _Filters2.default },
  data: function data() {
    return {
      data: [],
      filtersScope: {
        monthFromFilter: true,
        countryFilter: true
      },
      Helper: _Helper2.default,
      Storage: Storage,
      date: new Date(),
      isActive: false,
      TypeColor: _TypeColor2.default,
      loading: false,
      oldValue: {},
      isShow: true,
      ChangeValue: String,
      title: this.$root.$t('pages.by_balance_currency'),
      rows: [],
      checked: false,
      footColumns: [],
      headColumns: [{ label: this.$root.$t(''), width: '4%' }, { label: this.$root.$t('statistic.project'), width: '27%' }, { label: this.$root.$t('statistic.balance_on_the_first_day_of_the_month'), field: 'processed', width: '27%' }, { label: this.$root.$t('statistic.price_for_one'), field: 'paidPercents', width: '15%' }, { label: this.$root.$t('statistic.total_money'), field: 'time_success_call', width: '27%' }]
    };
  },

  computed: {
    computedHeadColumns: function computedHeadColumns() {
      var _this = this;

      if (!this.columns) {
        return this.headColumns;
      } else {
        var headColumns = [];
        this.headColumns.map(function (d) {
          if (_this.columns[d.field]) {
            headColumns.push(d);
          }
        });
        return headColumns;
      }
    },
    computedRows: function computedRows() {
      var _this2 = this;

      if (!this.columns) {
        return this.rows;
      } else {
        var rows = [];
        this.rows.map(function (row) {
          var tmpRow = {};
          (0, _lodash.map)(row, function (d, i) {
            if (_this2.columns[i] || _this2.columns[i.replace('Percents', '')]) {
              tmpRow[i] = d;
            }
          });
          rows.push(tmpRow);
        });
        return rows;
      }
    },
    computedFootColumns: function computedFootColumns() {
      var _this3 = this;

      if (!this.columns) {
        return this.footColumns;
      } else {
        var footColumns = {};
        (0, _lodash.map)(this.footColumns, function (d, i) {
          if (_this3.columns[i] || i === 'label' || _this3.columns[i.replace('Percents', '')]) {
            footColumns[i] = d;
          }
        });
        return footColumns;
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    setTimeout(function () {
      _this4.getData();
    }, 500);
    this.getCountries();
    this.getGoods();
    this.$root.$on('filters_load_new_data', function () {
      _this4.getData();
    });
  },

  methods: {
    isCheckBox: function isCheckBox(e, row) {
      var elem = document.getElementById(row).getAttribute('id');
      if (row === parseInt(elem)) {
        this.isActive = !this.isActive;
      }
    },
    renderBackground: function renderBackground(cell, i, bc) {
      var style = !cell.style ? {} : cell.style;
      if (!cell || cell.bgg === undefined && !cell.dbgg) {
        style.backgroundColor = !cell.bgc ? this.TypeColor[i] : cell.bgc;
      } else {
        if (!cell.dbgg) {
          if (!cell.bgl) {
            style.background = 'linear-gradient(to right, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
          } else {
            style.background = 'linear-gradient(to left, ' + (!cell.bggc ? this.TypeColor[i] : cell.bggc) + ' ' + cell.bgg + '%, transparent 0%)';
            style.position = 'relative';
          }
        } else {
          style.background = 'linear-gradient(to right, ' + this.TypeColor[cell.dbgg[0].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + cell.dbgg[0].width + '%, ' + this.TypeColor[cell.dbgg[1].name] + ' ' + (cell.dbgg[0].width + cell.dbgg[1].width) + '%, transparent 0%)';
        }
      }
      if (bc.bc) {
        style.backgroundColor = '' + bc.bc;
        style.color = bc.c;
      }
      if (cell.bgColorTwo) {
        var summ = Math.abs(cell.bgColorTwo.max.value) + Math.abs(cell.bgColorTwo.min.value);
        var minPercent = (Math.abs(cell.bgColorTwo.min.value) / summ * 100).toFixed(0);
        var maxPercent = (Math.abs(cell.bgColorTwo.max.value) / summ * 100).toFixed(0);
        var percent = void 0;
        if (cell.bgColorTwo.value < 0) {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.min.value) * minPercent + parseInt(maxPercent);
          style.background = 'linear-gradient(to left, transparent 0%, transparent ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + maxPercent + '%, ' + cell.bgColorTwo.min.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        } else {
          percent = Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.max.value) * maxPercent + parseInt(minPercent);
          style.background = 'linear-gradient(to right, transparent 0%, transparent ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + minPercent + '%, ' + cell.bgColorTwo.max.color + ' ' + percent + '%, transparent ' + percent + '%, transparent 100%)';
        }
        style.position = 'relative';
      }
      return style;
    },
    getCountries: function getCountries() {
      var _this5 = this;

      _API2.default.getCountries().then(function (response) {
        Storage.countries = response.body;
      }).catch(function (response) {
        _this5.$notify({
          type: 'danger',
          title: _this5.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    getData: function getData() {
      var _this6 = this;

      this.$root.$emit('data_loading');
      this.loading = true;
      this.rows = [];
      _API2.default.getRemnantsBalance().then(function (response) {
        _this6.data = response.body;
        var allByDayFoot = {};
        (0, _lodash.map)(Storage.countries, function (country) {
          var arrGoods = [];
          var totalRemnants = null;
          var filteredGoods = [];
          var allTotalByDay = [];
          allByDayFoot[country.id] = {};
          var storageCountry = {
            country: null,
            id: null,
            goods: null,
            remnants: null,
            price: null,
            total: null
          };
          allTotalByDay = {
            countryId: parseInt(country.id),
            totalRemn: 0,
            totalPrice: 0
          };
          (0, _lodash.map)(Storage.goods, function (byGoods) {
            arrGoods.push({
              alias: byGoods.alias,
              name: {
                value: byGoods.name
              },
              country_id: byGoods.country_id,
              price: {
                value: 0,
                htmlValue: '',
                oldvalue: 0,
                name: '',
                notupdate: _this6.isShow
              },
              priceAll: {
                value: 0
              },
              remnants: {
                value: 0,
                oldvalue: 0
              },
              flag: null,
              hidden: null
            });
          });
          (0, _lodash.map)(_this6.data, function (d) {
            if (country.id === parseInt(d.country_id)) {
              arrGoods.map(function (i) {
                if (i.alias === d.alias && parseInt(i.country_id) === parseInt(d.country_id)) {
                  i.price.value = Number(d.price);
                  i.price.notupdate = _this6.isShow;
                  i.remnants.value = parseInt(d.remnants);
                  i.flag = 1;
                  i.priceAll.value = Number(d.price) * Number(d.remnants);
                  i.hidden = parseInt(d.hidden);
                }
              });
              filteredGoods = arrGoods.filter(function (good) {
                return good.flag;
              });
              storageCountry = {
                country: _Helper2.default.getCountryTitle(Storage.countries, parseInt(d.country_id)),
                id: parseInt(d.country_id),
                goods: filteredGoods,
                total: totalRemnants
              };
            }
          });
          filteredGoods.map(function (o) {
            if (allTotalByDay.countryId === o.country_id) {
              if (!o.remnants.value && !o.priceAll.value && parseInt(o.hidden) === 0) {
                allTotalByDay.totalRemn += 0;
                allTotalByDay.totalPrice += 0;
                allTotalByDay.flag = 1;
              } else if (!o.priceAll.value && parseInt(o.hidden) === 0) {
                allTotalByDay.totalRemn += o.remnants.value;
                allTotalByDay.totalPrice += 0;
                allTotalByDay.flag = 1;
              } else if (parseInt(o.hidden) === 0) {
                allTotalByDay.totalRemn += o.remnants.value;
                allTotalByDay.totalPrice += o.priceAll.value;
                allTotalByDay.flag = 1;
              }
            }
          });
          allByDayFoot[country.id] = {
            totalRemnants: {
              value: allTotalByDay.totalRemn
            },
            totalPrice: {
              value: allTotalByDay.totalPrice
            }
          };
          _this6.footColumns = allByDayFoot;

          _this6.rows.push(storageCountry);
          _this6.rows = _this6.rows.filter(function (i) {
            return i.country;
          });
        });
        _this6.loading = false;
        _this6.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this6.$notify({
          type: 'danger',
          title: _this6.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    changeElem: function changeElem(update, cell, value, alias, country) {
      if (!update) {
        this.isShow = false;
        this.oldValue = cell;
        this.ChangeValue = value;
        return false;
      }
    },
    getGoods: function getGoods() {
      var _this7 = this;

      this.$root.$emit('data_loading');
      this.loading = false;
      _API2.default.getGoods(-1).then(function (res) {
        _this7.loading = false;
        Storage.goods = res.body;
      }).catch(function (error) {
        console.log(error);
      });
    },

    checkForm: function checkForm(e) {
      var _this8 = this;

      var post = [];
      this.date = _Helper2.default.getDateRangeFrom();
      this.date = this.date.substring(11, 18);
      var remn = void 0;
      var idnum = void 0,
          country = void 0,
          idcheck = void 0,
          checkAttr = void 0;
      (0, _lodash.map)(e.target.elements, function (elem) {
        if (elem.className === 'input-remnants') {
          remn = elem.value;
        }
        if (elem.name) {
          idnum = elem.id.substring(1);
          country = elem.name.substring(1);
          idcheck = document.getElementById('check' + idnum + '-' + country);
          checkAttr = idcheck.getAttribute('ishidden');
          if (idcheck.checked === true && parseInt(checkAttr) === 0) {
            console.log('true -> 0');
            post.push({
              'country_id': country,
              'product_id': idnum,
              'price': elem.value,
              'stock_balance': remn,
              'month_stat': _this8.date,
              'hidden': 1
            });
          } else if (idcheck.checked === true && parseInt(checkAttr) === 1) {
            console.log('true -> 1');
            post.push({
              'country_id': country,
              'product_id': idnum,
              'price': elem.value,
              'stock_balance': remn,
              'month_stat': _this8.date,
              'hidden': 0
            });
          } else if (elem.value || remn) {
            post.push({
              'country_id': country,
              'product_id': idnum,
              'price': elem.value,
              'stock_balance': remn,
              'month_stat': _this8.date,
              'hidden': parseInt(checkAttr)
            });
          }
        }
      });
      this.loading = true;
      _API2.default.postRemnantsBalance(post).then(function (res) {
        _this8.getData();
        _this8.loading = false;
      }).catch(function (response) {
        _this8.$root.$emit('data_loaded');
        _this8.$notify({
          type: 'danger',
          title: _this8.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
      e.preventDefault();
    }
  }
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _ProductTabs = __webpack_require__(22);

var _ProductTabs2 = _interopRequireDefault(_ProductTabs);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ProductCountry',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    ProductTabs: _ProductTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true
      },
      form: {
        product: null,
        orders_count: null,
        price: null,
        provider: null,
        delivery_time: null,
        status: null,
        comment: null
      },
      title: this.$root.$t('pages.by_country'),
      isLoading: false,
      isBlock: false,
      Storage: _Storage2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.offer'), field: 'offer' }, { label: this.$root.$t('statistic.leads'), field: 'leads' }, { label: this.$root.$t('statistic.quantity'), field: 'quantity' }, { label: this.$root.$t('statistic.products'), field: 'products' }],
      footColumnsByDay: {},
      footColumnsAll: {},
      rows: [],
      rowsAll: []
    };
  },

  computed: {
    computedFootColumnsAll: function computedFootColumnsAll() {
      var _this = this;

      if (!this.columns) {
        return this.footColumnsAll;
      } else {
        var footColumns = {};
        (0, _lodash.map)(this.footColumnsAll, function (d, i) {
          if (_this.columns[i] || i === 'label' || _this.columns[i.replace('Percents', '')]) {
            footColumns[i] = d;
          }
        });
        return footColumns;
      }
    },
    computedFootColumns1: function computedFootColumns1() {
      var _this2 = this;

      if (!this.columns) {
        return this.footColumnsByDay;
      } else {
        var footColumns = {};
        (0, _lodash.map)(this.footColumnsByDay, function (d, i) {
          if (_this2.columns[i] || i === 'label' || _this2.columns[i.replace('Percents', '')]) {
            footColumns[i] = d;
          }
        });
        return footColumns;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.calculateRows();
    this.getGoodsById();
    this.$root.$on('filters_load_new_data', function () {
      _this3.calculateRows();
      _this3.getGoodsById();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this4 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.rowsAll = [];
      _API2.default.getRemnantsCountry().then(function (response) {
        if (response.status === 200) {
          (0, _lodash.map)(_Storage2.default.offers, function (offer) {
            var leads = null;
            var leadsTotal = null;
            var quantityTotal = null;
            var goodsTotal = null;
            var goodsByDayArr = [];
            var quantity = null;
            var goodsByDay = {};
            var allTotalByDay = [];
            var allTotalByDayGoods = [];
            var goodsQantity = [];
            var filterGoods = [];
            var storageOfferDay = {};
            var allByDayFoot = {};
            var storageOffer = {
              offer: null,
              quantity: null,
              lead: null
            };
            (0, _lodash.map)(_Storage2.default.goods, function (good) {
              goodsQantity.push({
                title: good.name,
                id: good.id,
                quantity: 0
              });
            });
            (0, _lodash.map)(response.body, function (offers, date) {
              allTotalByDay = {
                dateBy: date,
                leads: 0,
                quantity: 0
              };
              allTotalByDayGoods = {
                dateBy: date,
                goods: 0
              };
              goodsByDay = {};
              storageOfferDay[date] = [];
              allByDayFoot[date] = {};
              (0, _lodash.map)(offers, function (offerInner, offerId) {
                if (allTotalByDay.dateBy === date) {
                  allTotalByDay.quantity += parseInt(offerInner.quantity);
                  allTotalByDay.leads += parseInt(offerInner.count);
                }
                leadsTotal += parseInt(offerInner.count);
                quantityTotal += parseInt(offerInner.quantity);
                if (offer.id === parseInt(offerId)) {
                  quantity += parseInt(offerInner.quantity);
                  leads += parseInt(offerInner.count);
                }
                (0, _lodash.map)(offerInner.goods, function (goods, goodsId) {
                  if (allTotalByDayGoods.dateBy === date) {
                    allTotalByDayGoods.goods += parseInt(goods);
                  }
                  goodsByDay = {
                    title: _Helper2.default.getGoodNameById(_Storage2.default.goods, goodsId),
                    quantity: goods,
                    goodsByDayDate: date,
                    goodsByDayDateOfferId: parseInt(offerId)
                  };
                  goodsByDayArr.push(goodsByDay);
                  goodsTotal += parseInt(goods);
                  if (offer.id === parseInt(offerId)) {
                    goodsQantity.map(function (goodQuantity) {
                      if (goodQuantity.id === parseInt(goodsId)) {
                        goodQuantity.quantity += goods;
                      }
                    });
                    filterGoods = goodsQantity.filter(function (good) {
                      return good.quantity !== 0;
                    });
                    storageOffer = {
                      offer: _Helper2.default.getOfferTitle(_Storage2.default.offers, offerId),
                      quantity: quantity,
                      lead: leads,
                      goods: filterGoods
                    };
                  }
                });
                storageOfferDay[date].push({
                  offer: _Helper2.default.getOfferTitle(_Storage2.default.offers, offerId),
                  leads: offerInner.count,
                  quantity: offerInner.quantity,
                  goods: goodsByDayArr.filter(function (good) {
                    return good.goodsByDayDate === date && good.goodsByDayDateOfferId === parseInt(offerId);
                  })
                });
              });
              allByDayFoot[date] = {
                offer: {
                  value: ''
                },
                leads: {
                  value: allTotalByDay.leads
                },
                quantity: {
                  value: allTotalByDay.quantity
                },
                goods: {
                  value: allTotalByDayGoods.goods
                }
              };
            });
            _this4.footColumnsAll = {
              offer: {
                value: ''
              },
              leads: {
                value: leadsTotal
              },
              quantity: {
                value: quantityTotal
              },
              goods: {
                value: goodsTotal
              }
            };
            _this4.footColumnsByDay = allByDayFoot;
            _this4.rowsAll.push(storageOffer);
            _this4.rowsAll = _this4.rowsAll.filter(function (i) {
              return i.quantity;
            });
            _this4.rows = storageOfferDay;
          });
        }
        _this4.$root.$emit('data_loaded');
      });
    },
    getOffers: function getOffers() {
      return new Promise(function (resolve, reject) {
        _API2.default.getOffers(_Helper2.default.getCountryList()).then(function (res) {
          if (res.status === 200) {
            _Storage2.default.offers = res.body;
            resolve(true);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getGoodsById: function getGoodsById() {
      _API2.default.getRemnantsCountryById().then(function (res) {
        _Storage2.default.goods = res.body;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ProductTabs'
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _ProductTabs = __webpack_require__(22);

var _ProductTabs2 = _interopRequireDefault(_ProductTabs);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ProductTag',
  components: { ProductTabs: _ProductTabs2.default, StatisticTable: _StatisticTable2.default },
  data: function data() {
    return {
      data: [],
      allTags: {},
      statistic: {},
      countries: {},
      Helper: _Helper2.default,
      Storage: Storage,
      TypeColor: _TypeColor2.default,
      storageCountries: [],
      isLoading: false,
      headColumns: [{ label: this.$root.$t('statistic.country'), field: 'country', field_country: true, fix: true }, { label: this.$root.$t('statistic.adult'), field: 'adult', fix: true }, { label: this.$root.$t('statistic.slimming'), field: 'slimming', fix: true }, { label: this.$root.$t('statistic.beauty'), field: 'beauty', fix: true }, { label: this.$root.$t('statistic.health'), field: 'health', fix: true }, { label: this.$root.$t('statistic.economizers'), field: 'economizers', fix: true }, { label: this.$root.$t('statistic.lowPrice'), field: 'lowPrice', fix: true }, { label: this.$root.$t('statistic.hair'), field: 'hair', fix: true }, { label: this.$root.$t('statistic.sport'), field: 'sport', fix: true }, { label: this.$root.$t('statistic.other'), field: 'other', fix: true }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getTags();
    this.getCountries();
    this.$root.$on('filters_load_new_data', function () {
      _this.getTags();
    });
  },

  methods: {
    getCountries: function getCountries() {
      var _this2 = this;

      _API2.default.getCountries().then(function (response) {
        Storage.countries = response.body;
      }).catch(function (response) {
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    },
    getTags: function getTags() {
      var _this3 = this;

      this.$root.$emit('data_loading');
      var datat = void 0;
      this.storageCountries = [];
      _API2.default.getProductTags().then(function (response) {
        datat = response.body;
        _this3.statistic = response.body.statistic;
        _this3.allTags = datat.tags;
        _this3.$root.$emit('data_loaded');
        var totalAdult = [];
        var totalSlimming = [];
        var totalBeauty = [];
        var totalHealth = [];
        var totalEconomizers = [];
        var totallowPrice = [];
        var totalHair = [];
        var totalSport = [];
        var totalOther = [];
        for (var i in response.body.statistic) {
          for (var o in response.body.statistic[i]) {
            if (o === '1') {
              (0, _lodash.find)(response.body.statistic[i][1], function (i) {
                return totalAdult.push(i);
              });
            } else if (o === '2') {
              (0, _lodash.find)(response.body.statistic[i][2], function (i) {
                return totalSlimming.push(i);
              });
            } else if (o === '3') {
              (0, _lodash.find)(response.body.statistic[i][3], function (i) {
                return totalBeauty.push(i);
              });
            } else if (o === '4') {
              (0, _lodash.find)(response.body.statistic[i][4], function (i) {
                return totalHealth.push(i);
              });
            } else if (o === '5') {
              (0, _lodash.find)(response.body.statistic[i][5], function (i) {
                return totalEconomizers.push(i);
              });
            } else if (o === '6') {
              (0, _lodash.find)(response.body.statistic[i][6], function (i) {
                return totallowPrice.push(i);
              });
            } else if (o === '7') {
              (0, _lodash.find)(response.body.statistic[i][7], function (i) {
                return totalHair.push(i);
              });
            } else if (o === '8') {
              (0, _lodash.find)(response.body.statistic[i][8], function (i) {
                return totalSport.push(i);
              });
            } else if (o === '9') {
              (0, _lodash.find)(response.body.statistic[i][9], function (i) {
                return totalOther.push(i);
              });
            }
          }
        }
        (0, _lodash.map)(Object.keys(response.body.statistic), function (i) {
          var country = (0, _lodash.find)(Storage.countries, { id: parseInt(i) });
          if (country !== undefined) {
            var adult = response.body.statistic[country.id][1];
            var slimming = response.body.statistic[country.id][2];
            var beauty = response.body.statistic[country.id][3];
            var health = response.body.statistic[country.id][4];
            var economizers = response.body.statistic[country.id][5];
            var lowPrice = response.body.statistic[country.id][6];
            var hair = response.body.statistic[country.id][7];
            var sport = response.body.statistic[country.id][8];
            var other = response.body.statistic[country.id][9];
            _this3.storageCountries.push({
              country: {
                value: country.name,
                code: country.code
              },
              adult: {
                value: adult,
                bgg: parseInt(adult) / (0, _lodash.max)(totalAdult) * 100
              },
              slimming: {
                value: slimming,
                bgg: parseInt(slimming) / (0, _lodash.max)(totalSlimming) * 100
              },
              beauty: {
                value: beauty,
                bgg: parseInt(beauty) / (0, _lodash.max)(totalBeauty) * 100
              },
              health: {
                value: health,
                bgg: parseInt(health) / (0, _lodash.max)(totalHealth) * 100
              },
              economizers: {
                value: economizers,
                bgg: parseInt(economizers) / (0, _lodash.max)(totalEconomizers) * 100
              },
              lowPrice: {
                value: lowPrice,
                bgg: parseInt(lowPrice) / (0, _lodash.max)(totallowPrice) * 100
              },
              hair: {
                value: hair,
                bgg: parseInt(hair) / (0, _lodash.max)(totalHair) * 100
              },
              sport: {
                value: sport,
                bgg: parseInt(sport) / (0, _lodash.max)(totalSport) * 100
              },
              other: {
                value: other,
                bgg: parseInt(other) / (0, _lodash.max)(totalOther) * 100
              }
            });
          }
        });
        _this3.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this3.$root.$emit('data_loaded');
        _this3.$notify({
          type: 'danger',
          title: _this3.$root.$t('verbs.error'),
          text: !response.body ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _OrderTable = __webpack_require__(31);

var _OrderTable2 = _interopRequireDefault(_OrderTable);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Receipt',
  components: {
    Filters: _Filters2.default,
    OrderTable: _OrderTable2.default
  },
  props: {
    rowsReceipt: Array,
    loading: Boolean
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.country'), field: 'country_id' }, { label: this.$root.$t('statistic.product'), field: 'product_id' }, { label: this.$root.$t('statistic.ordered'), field: 'orders_count' }, { label: this.$root.$t('statistic.price'), field: 'price', input: { type: 'text' } }, { label: this.$root.$t('statistic.logistic'), field: 'logistic', input: { type: 'text' } }, { label: this.$root.$t('statistic.customs'), field: 'customs', input: { type: 'text' } }, { label: this.$root.$t('statistic.price_for_one'), field: 'price_for_one' }, { label: this.$root.$t('statistic.provider'), field: 'provider' }, { label: this.$root.$t('statistic.times'), field: 'delivery_time' }, { label: this.$root.$t('statistic.credit'), field: 'credit', input: { type: 'text' }, color: [{ value: 0, bg: '#53d3a2' }, { value: 'else', bg: '#ef9a9a' }] }, { label: this.$root.$t('statistic.comment'), field: 'comment', input: { type: 'text' } }, { label: this.$root.$t('statistic.expiration_date'), field: 'expiration_date' }],
      rows: [],
      footColumns: {}
    };
  },

  watch: {
    rowsReceipt: function rowsReceipt(newq, old) {
      if (!(0, _lodash.isEqual)(newq, old)) {
        this.calculateRows(newq);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows(_this.rowsReceipt);
    });
  },

  methods: {
    calculateRows: function calculateRows(rowsReceipt) {
      var _this2 = this;

      this.rows = [];
      (0, _lodash.map)(rowsReceipt, function (item, index) {
        var value = [];
        var sumByOne = null;
        if (!item.customs && !item.logistic) {
          sumByOne = Number(item.price);
        } else if (!item.logistic) {
          sumByOne = Number(item.price) + Number(item.customs);
        } else if (item.customs && item.logistic && item.price) {
          sumByOne = Number(item.price) + Number(item.customs) + Number(item.logistic);
        } else if (!item.customs) {
          sumByOne = Number(item.price) + Number(item.logistic);
        }
        var creditSum = Number((sumByOne * item.orders_count).toFixed(2));
        var auxvalue = void 0;
        (0, _lodash.forEach)(_this2.headColumns, function (headCol) {
          if (headCol.field === 'price' || headCol.field === 'price_for_one') {
            if (_Storage2.default.selectedCountry.id === -1) {
              if (item.country_id === 77 || item.country_id === 1535 || item.country_id === 1547) {
                auxvalue = '₽';
              } else {
                auxvalue = '$';
              }
            } else {
              if (_Storage2.default.selectedCountry.currency === 'RUB') {
                auxvalue = _Storage2.default.selectedCountry.currency_symbol;
              } else {
                auxvalue = '$';
              }
            }
          } else if (headCol.field === 'orders_count') {
            auxvalue = (0, _lodash.isEmpty)(auxvalue) ? 'шт.' : '';
          } else {
            auxvalue = null;
          }
          if (headCol.field === 'price') {
            value.push({
              key: headCol.field,
              input: headCol.input ? headCol.input : null,
              value: Number(item.price),
              color: headCol.color ? headCol.color : null,
              aux: auxvalue
            });
          } else if (headCol.field === 'price_for_one') {
            value.push({
              key: headCol.field,
              input: headCol.input ? headCol.input : null,
              value: sumByOne.toFixed(2),
              color: headCol.color ? headCol.color : null,
              aux: auxvalue
            });
          } else if (headCol.field === 'credit') {
            value.push({
              key: headCol.field,
              input: headCol.input ? headCol.input : null,
              value: creditSum,
              color: headCol.color ? headCol.color : null,
              aux: auxvalue
            });
          } else {
            value.push({
              key: headCol.field,
              input: headCol.input ? headCol.input : null,
              value: item[headCol.field],
              color: headCol.color ? headCol.color : null,
              aux: auxvalue
            });
          }
        });
        _this2.rows.push({
          key: item.id,
          value: value
        });
      });
      this.footColumns = {};
    },
    downloadPdfReceipt: function downloadPdfReceipt(id) {
      this.$emit('downloadPdfReceipt', id);
    },
    downloadAllReceipt: function downloadAllReceipt(row) {
      this.$emit('downloadAllReceipt', row.rows);
    },
    uploadImageReceipt: function uploadImageReceipt(id, files, name) {
      this.$emit('uploadImageReceipt', id, files, name);
    },
    changeValReciept: function changeValReciept(key, cell) {
      this.$emit('changeVal', { id: key, title: cell.key, value: cell.value });
    }
  }
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _OrderTable = __webpack_require__(31);

var _OrderTable2 = _interopRequireDefault(_OrderTable);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _vueStrap = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Remnants',
  components: {
    Filters: _Filters2.default,
    OrderTable: _OrderTable2.default,
    modal: _vueStrap.modal,
    StatisticTable: _StatisticTable2.default
  },
  props: {
    rowRemnants: [Array, Object],
    loading: Boolean
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true
      },
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.product'), field: 'product_id', width: '10%', widthTd: '10%' }, { label: this.$root.$t('statistic.balance'), field: 'stock_balance', input: { type: 'number' }, width: '16%', widthTd: '16%' }, { label: this.$root.$t('statistic.unloaded_leads'), field: 'count_lead', width: '10%', widthTd: '10%' }, { label: this.$root.$t('statistic.unloaded_product'), field: 'count_product', width: '10%', widthTd: '10%' }, { label: this.$root.$t('statistic.delays_leads'), field: 'count_stagnation_lead', color: [{ value: '>0', bg: '#ef9a9a' }], width: '10%', widthTd: '10%' }, { label: this.$root.$t('statistic.delays_product'), field: 'count_stagnation_product', color: [{ value: '>0', bg: '#ef9a9a' }], width: '10%', widthTd: '10%' }, { label: this.$root.$t('statistic.stock_product'), field: 'reserve', bg: { maxday: 45, colorBg: '#90caf9' }, width: '8%', widthTd: '8%' }, { label: this.$root.$t('statistic.ordered'), field: 'is_ordered', color: [{ value: 1, bg: '#53d3a2' }], width: '6%', widthTd: '6%' }, { label: this.$root.$t('statistic.expiration_date'), field: 'expiration_date', width: '10%', widthTd: '10%' }, { label: this.$root.$t('statistic.stagnation_date'), field: 'stagnation_date', width: '10%', widthTd: '10%' }],
      rows: [],
      footColumns: {},
      exportHistiryModal: false,
      exportHeadColumns: [{ label: this.$root.$t('statistic.user'), field: 'user' }, { label: this.$root.$t('statistic.offer'), field: 'offer' }, { label: this.$root.$t('statistic.date'), field: 'datetime' }, { label: this.$root.$t('statistic.fix_from'), field: 'fix_from' }, { label: this.$root.$t('statistic.fix_to'), field: 'fix_to' }],
      exportRows: [],
      exportFootColumns: {}
    };
  },

  watch: {
    rowRemnants: function rowRemnants(newq, old) {
      if (!(0, _lodash.isEqual)(newq, old)) {
        this.calculateRows(newq);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows(this.rowRemnants);
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows(_this.rowRemnants);
    });
  },

  methods: {
    changeVal: function changeVal(key, cell) {
      this.$emit('changeVal', { id: key, title: cell.key, value: cell.value });
    },
    calculateRows: function calculateRows(rowRemnants) {
      var _this2 = this;

      this.rows = [];
      (0, _lodash.map)(rowRemnants, function (item, index) {
        var value = [];
        (0, _lodash.forEach)(_this2.headColumns, function (headCol) {
          if (Number(item[headCol.field])) {
            item[headCol.field] = parseInt(item[headCol.field]);
          }
          var auxvalue = null;
          if (headCol.field === 'count_product' || headCol.field === 'count_stagnation_product' || headCol.field === 'stock_balance') {
            if (item[headCol.field]) {
              auxvalue = 'шт.';
            }
          }
          value.push({
            key: headCol.field,
            input: headCol.input ? headCol.input : null,
            value: item[headCol.field],
            color: headCol.color ? headCol.color : null,
            width: headCol.width ? headCol.width : null,
            widthTd: headCol.widthTd ? headCol.widthTd : null,
            aux: auxvalue,
            bg: headCol.bg ? headCol.bg : null
          });
        });
        _this2.rows.push({
          key: index,
          value: value
        });
      });
      this.footColumns = {};
    },
    toggleExportHistoryModal: function toggleExportHistoryModal() {
      var _this3 = this;

      if (!this.exportHistiryModal) {
        this.exportRows = [];
        _API2.default.getRemnandsChanges().then(function (response) {
          var orderedResponse = (0, _lodash.orderBy)(response.body, ['date'], ['ASC']);
          orderedResponse.map(function (d) {
            _this3.exportRows.push({
              user: { value: d.user, bg: true },
              offer: { value: _Helper2.default.getOfferTitle(_Storage2.default.offers, d.offer_id), bg: true },
              date: { value: d.datetime, bg: true },
              fix_from: { value: d.remnants_from, bg: true },
              fix_to: { value: d.remnants_to, bg: true }
            });
          });
          _this3.exportHistiryModal = true;
        }).catch(function (response) {
          _this3.$notify({
            type: 'danger',
            title: _this3.$root.$t('verbs.error'),
            text: response.body.message ? response.body.message : response.body,
            animationType: 'velocity'
          });
        });
      } else {
        this.exportHistiryModal = false;
      }
      return false;
    }
  }
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _RefundsTabs = __webpack_require__(23);

var _RefundsTabs2 = _interopRequireDefault(_RefundsTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Buyout',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    RefundsTabs: _RefundsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byWmFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.refunds_id'), field: 'refunds_id' }, { label: this.$root.$t('statistic.cancel_title'), field: 'cancel_title' }, { label: this.$root.$t('statistic.cancel_count'), field: 'cancel_count', colspan: 2 }],
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      _API2.default.getRefundsStatistic(1).then(function (response) {
        var reasons = {};
        var total = 0;
        (0, _lodash.map)(response.body, function (d) {
          if (!reasons[d.reason_id]) {
            reasons[d.reason_id] = d;
          } else {
            reasons[d.reason_id].count += d.count;
          }
          total += d.count;
        });
        (0, _lodash.map)(reasons, function (d) {
          _this2.rows.push({
            reason_id: { value: d.reason_id, style: { textAlign: 'left' } },
            reason: { value: d.reason_text, style: { textAlign: 'left' } },
            count: {
              value: d.count,
              bgg: _Helper2.default.renderGistPart(total, d.count),
              isCollspaned: true
            },
            countPercents: {
              value: _Helper2.default.percents(total, d.count),
              bgg: _Helper2.default.renderGistPart(total, d.count, true)
            }
          });
        });
        _this2.footColumns = {
          label_id: {
            value: _this2.$root.$t('')
          },
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          count: {
            value: total + ' (' + _Helper2.default.average(total, 1) + ')'
          },
          countPercents: {
            value: _Helper2.default.percents(total, total)
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _RefundsTabs = __webpack_require__(23);

var _RefundsTabs2 = _interopRequireDefault(_RefundsTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CancelByMonth',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    RefundsTabs: _RefundsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byWmFilter: true,
        byWebmasterFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.canceled'), field: 'refunds_id' }],
      rows: [],
      footColumns: {},
      EnMessage: [{ id: 0, text: 'Без причины' }, { id: 2, text: 'Дорого' }, { id: 3, text: 'Передумал' }, { id: 4, text: 'Не устраивает способ оплаты (карта/наличные)' }, { id: 9, text: 'Плохая репутация продукта/компании' }, { id: 10, text: 'Не нравится форма выпуска продукта (клиент выслушал оператора и ему не нравится форма выпуска)' }, { id: 11, text: 'Клиент хочет получить информацию о гарантиях и возврате денег' }, { id: 12, text: 'Медицинские противопоказания' }, { id: 14, text: 'Муж, жена, родственники не разрешают' }, { id: 16, text: 'Сделали заявку чтобы получить консультацию' }, { id: 23, text: 'Заказы не могут быть обработаны в данный момент. (зп в след месяце, клиент в другом городе)' }, { id: 24, text: 'Дорогая доставка' }, { id: 27, text: 'Не хочет платить налог' }, { id: 1, text: 'Не заказывал' }, { id: 5, text: 'Не успеваем доставить вовремя' }, { id: 6, text: 'Уже купил' }, { id: 7, text: 'Отвечает третье лицо, нет заказчика рядом' }, { id: 8, text: 'На сайте другая цена' }, { id: 15, text: 'Клиент думал что выиграл подарок (или бесплатную упаковку)' }, { id: 17, text: 'Языковой барьер' }, { id: 18, text: 'Не верный номер, не туда попали' }, { id: 19, text: 'Недозвон в течении долгого времени' }, { id: 20, text: 'Клиент скидывает звонок / не может быть подтвержден' }, { id: 21, text: 'Не идёт на контакт бросает трубку агрессивно реагирует' }, { id: 22, text: 'Клиенты молчат и не разговаривают' }, { id: 25, text: 'Нет покрытия' }, { id: 26, text: 'Клиент в черном списке' }, { id: 28, text: 'Клиент младше 18 лет' }, { id: 99, text: 'Другое' }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },


  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      this.headColumns = [{ label: this.$root.$t('statistic.refundsId'), field: 'refunds_id' }, { label: this.$root.$t('statistic.return'), field: 'refunds_id' }];
      var language = _Storage2.default.language;

      _API2.default.getReturnReasonStatisticByMonth(1).then(function (response) {
        var reasonsByMonth = [];
        var footColumn = {
          reason_id: {
            value: ''
          },
          reason: {
            value: ''
          }
        };

        (0, _lodash.map)(response.body, function (year) {
          (0, _lodash.map)(year, function (data, month) {
            _this2.headColumns.push({
              label: _this2.$root.$t('month.' + month) + ' ' + _Helper2.default.percents(data.orders_count, data.reasons_count), field: 'month' + month, colspan: 2, bg: true
            });

            footColumn['month.' + month] = {
              value: data.reasons_count + ' / ' + data.orders_count, colspan: 2
            };

            (0, _lodash.map)(data.reasons, function (reason, reasonsId) {
              if (reasonsByMonth[reasonsId] === undefined) reasonsByMonth[reasonsId] = {};

              reasonsByMonth[reasonsId]['m' + month] = reason;
              reasonsByMonth[reasonsId]['m' + month].reasons_count = data.reasons_count;
            });
          });
        });

        reasonsByMonth.forEach(function (reasonData, reasonId) {
          var row = {
            reason_id: { value: reasonId },
            reason: { value: reasonId, style: { textAlign: 'left' } }
          };

          (0, _lodash.map)(reasonData, function (monthData, monthId) {
            row.reason.value = language === 'ru' ? _Helper2.default.getCancelName(_this2.EnMessage, reasonId) : monthData.text;
            row['month_count_' + monthId] = {};
            row['month_persent_' + monthId] = {};
            row['month_count_' + monthId] = {
              value: monthData.count
            };

            row['month_persent_' + monthId] = {
              value: _Helper2.default.percents(monthData.reasons_count, monthData.count),
              bgg: parseFloat(parseFloat(monthData.count) / parseFloat(monthData.reasons_count) * 100).toFixed(1),
              bggc: '#90caf9'
            };
          });

          _this2.rows.push(row);
        });

        console.log(_this2.rows);

        var reasonsArr = [];

        if (_this2.rows.length) {
          _this2.EnMessage.forEach(function (reason) {
            var id = reason.id,
                text = reason.text;


            var relatedReason = _this2.rows.find(function (row) {
              return row.reason_id.value === id;
            });
            console.log(relatedReason);
            if (relatedReason) reasonsArr.push(relatedReason);
          });
        }

        _this2.rows = reasonsArr;

        _this2.footColumns = footColumn;
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        console.log('err');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _RefundsTabs = __webpack_require__(23);

var _RefundsTabs2 = _interopRequireDefault(_RefundsTabs);

var _lodash = __webpack_require__(5);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CancelOperators',
  components: {
    StatisticTable: _StatisticTable2.default,
    RefundsTabs: _RefundsTabs2.default,
    Filters: _Filters2.default
  },
  data: function data() {
    return {
      x: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byManualFilter: true
      },
      headColumns: [{ label: this.$root.$t('statistic.operator'), field: 'operator' }, { label: this.$root.$t('statistic.processed_all'), field: 'processed_all', width: '100px' }, { label: this.$root.$t('statistic.approve'), field: 'approve' }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', width: '100px' }, { label: this.$root.$t('statistic.total_cancel'), field: 'total_cancel', colspan: 3 }, { label: this.$root.$t('statistic.expensive'), field: 'expensive', id_reason: 2, colspan: 2 }, { label: this.$root.$t('statistic.changed_mind'), field: 'changed_mind', id_reason: 3, colspan: 2 }, { label: this.$root.$t('statistic.no_payment_method'), field: 'no_payment_method', id_reason: 4, colspan: 2 }, { label: this.$root.$t('statistic.bad_reputation'), field: 'bad_reputation', id_reason: 9, colspan: 2 }, { label: this.$root.$t('statistic.form_release'), field: 'form_release', id_reason: 10, colspan: 2 }, { label: this.$root.$t('statistic.want_guarantees'), field: 'want_guarantees', id_reason: 11, colspan: 2 }, { label: this.$root.$t('statistic.medical_contraindications'), field: 'medical_contraindications', id_reason: 12, colspan: 2 }, { label: this.$root.$t('statistic.not_allowed'), field: 'not_allowed', id_reason: 14, colspan: 2 }, { label: this.$root.$t('statistic.consultation'), field: 'consultation', id_reason: 16, colspan: 2 }, { label: this.$root.$t('statistic.not_processed'), field: 'not_processed', id_reason: 23, colspan: 2 }, { label: this.$root.$t('statistic.expensive_delivery'), field: 'expensive_delivery', id_reason: 24, colspan: 2 }, { label: this.$root.$t('statistic.no_pay_tax'), field: 'no_pay_tax', id_reason: 27, colspan: 2 }, { label: this.$root.$t('statistic.not_order'), field: 'not_order', id_reason: 1, colspan: 2 }, { label: this.$root.$t('statistic.not_delivery_time'), field: 'not_delivery_time', id_reason: 5, colspan: 2 }, { label: this.$root.$t('statistic.already_bought'), field: 'already_bought', id_reason: 6, colspan: 2 }, { label: this.$root.$t('statistic.no_nearby'), field: 'no_nearby', id_reason: 7, colspan: 2 }, { label: this.$root.$t('statistic.suite_different_price'), field: 'suite_different_price', id_reason: 8, colspan: 2 }, { label: this.$root.$t('statistic.won_gift'), field: 'won_gift', id_reason: 15, colspan: 2 }, { label: this.$root.$t('statistic.language_barrier'), field: 'language_barrier', id_reason: 17, colspan: 2 }, { label: this.$root.$t('statistic.wrong_data'), field: 'wrong_data', id_reason: 18, colspan: 2 }, { label: this.$root.$t('statistic.not_ringing_long_time'), field: 'not_ringing_long_time', id_reason: 19, colspan: 2 }, { label: this.$root.$t('statistic.drop_calls'), field: 'drop_calls', id_reason: 20, colspan: 2 }, { label: this.$root.$t('statistic.not_make_contact'), field: 'not_make_contact', id_reason: 21, colspan: 2 }, { label: this.$root.$t('statistic.silent'), field: 'silent', id_reason: 22, colspan: 2 }, { label: this.$root.$t('statistic.no_coverage'), field: 'no_coverage', id_reason: 25, colspan: 2 }, { label: this.$root.$t('statistic.blacklisted_customer'), field: 'blacklisted_customer', id_reason: 26, colspan: 2 }, { label: this.$root.$t('statistic.under_18'), field: 'under_18', id_reason: 28, colspan: 2 }, { label: this.$root.$t('statistic.any_reasons'), field: 'any_reasons', id_reason: 0, colspan: 2 }, { label: this.$root.$t('statistic.another'), field: 'another', id_reason: 99, colspan: 2 }],
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    isPopup: function isPopup(cell) {
      var el = document.createElement('textarea');
      el.value = cell.value.trim();
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Скопирован оператор ' + el.value);
    },
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      _API2.default.getOperators(_Helper2.default.getCountryList()).then(function (operators) {
        _API2.default.getRefundsCancelOperators().then(function (response) {
          _this2.rows = [];
          _this2.footColumns = {};
          (0, _lodash.map)(response.body, function (dataOperator, indexOperator) {
            var sumCanceled = 0;
            var sumProcessed = 0;
            var sumApproved = 0;
            var sumTotalPrice = 0.0;
            var expensiveCount = 0;
            var changedMindCount = 0;
            var badReputationCount = 0;
            var consultationCount = 0;
            var notAllowedCount = 0;
            var medicalContraindicationsCount = 0;
            var notOrderCount = 0;
            var notRingingLongTimeCount = 0;
            var notMakeContactCount = 0;
            var noCoverageCount = 0;
            var blacklistedCustomerCount = 0;
            var notDeliveryTimeCount = 0;
            var alreadyBoughtCount = 0;
            var suiteDifferentPriceCount = 0;

            var noPaymentMethodCount = 0;
            var formReleaseCount = 0;
            var guaranteesCount = 0;
            var noProcessedCount = 0;
            var expensiveDeliveryCount = 0;
            var noPayTaxCount = 0;
            var noClientNearbyCount = 0;
            var otherInformationCount = 0;
            var wonGiftCount = 0;
            var languageBarrierCount = 0;
            var wrongNumberCount = 0;
            var dropCallCount = 0;
            var silentCount = 0;
            var under18Count = 0;

            var anotherCount = 0;
            var anyReasonsCount = 0;
            var redCountCol = 0;
            var grayCountCol = 0;

            var percentCanceled = function percentCanceled(reasonCount) {
              return _Helper2.default.percents(sumCanceled, reasonCount);
            };

            (0, _lodash.map)(dataOperator, function (data) {
              sumProcessed += parseInt(data.processed);
              sumApproved += parseInt(data.approved);
              sumTotalPrice += parseFloat(data.total_bill_usd);
              sumCanceled += data.canceled;

              switch (data.cancel_reason) {
                case 0:
                  anyReasonsCount = data.canceled;
                  break;
                case 1:
                  notOrderCount = data.canceled;
                  break;
                case 2:
                  expensiveCount = data.canceled;
                  break;
                case 3:
                  changedMindCount = data.canceled;
                  break;
                case 4:
                  noPaymentMethodCount = data.canceled;
                  break;
                case 5:
                  notDeliveryTimeCount = data.canceled;
                  break;
                case 6:
                  alreadyBoughtCount = data.canceled;
                  break;
                case 7:
                  noClientNearbyCount = data.canceled;
                  break;
                case 8:
                  suiteDifferentPriceCount = data.canceled;
                  break;
                case 9:
                  badReputationCount = data.canceled;
                  break;
                case 10:
                  formReleaseCount = data.canceled;
                  break;
                case 11:
                  guaranteesCount = data.canceled;
                  break;
                case 12:
                  notAllowedCount = data.canceled;
                  break;
                case 13:
                  otherInformationCount = data.canceled;
                  break;
                case 14:
                  medicalContraindicationsCount = data.canceled;
                  break;
                case 15:
                  wonGiftCount = data.canceled;
                  break;
                case 16:
                  consultationCount = data.canceled;
                  break;
                case 17:
                  languageBarrierCount = data.canceled;
                  break;
                case 18:
                  wrongNumberCount = data.canceled;
                  break;
                case 19:
                  notRingingLongTimeCount = data.canceled;
                  break;
                case 20:
                  dropCallCount = data.canceled;
                  break;
                case 21:
                  notMakeContactCount = data.canceled;
                  break;
                case 22:
                  silentCount = data.canceled;
                  break;
                case 23:
                  noProcessedCount = data.canceled;
                  break;
                case 24:
                  expensiveDeliveryCount = data.canceled;
                  break;
                case 25:
                  noCoverageCount = data.canceled;
                  break;
                case 26:
                  blacklistedCustomerCount = data.canceled;
                  break;
                case 27:
                  noPayTaxCount = data.canceled;
                  break;
                case 28:
                  under18Count = data.canceled;
                  break;
                case 99:
                  anotherCount += data.canceled;
                  break;
                default:
                  anotherCount += data.canceled;
              }
            });

            redCountCol = (0, _lodash.sum)([expensiveCount, changedMindCount, badReputationCount, consultationCount, notAllowedCount, medicalContraindicationsCount, noPaymentMethodCount, formReleaseCount, guaranteesCount, noProcessedCount, expensiveDeliveryCount, noPayTaxCount]);

            grayCountCol = (0, _lodash.sum)([notOrderCount, notRingingLongTimeCount, notMakeContactCount, noCoverageCount, blacklistedCustomerCount, notDeliveryTimeCount, alreadyBoughtCount, suiteDifferentPriceCount, noClientNearbyCount, otherInformationCount, wonGiftCount, languageBarrierCount, wrongNumberCount, dropCallCount, silentCount, under18Count, anotherCount, anyReasonsCount]);

            _this2.rows.push({
              operator: {
                value: _Helper2.default.getOperatorLogin(operators.body, indexOperator) + ' ' + (_Storage2.default.developMode ? '(' + indexOperator + ')' : ''),
                popup: true
              },
              processed_all: {
                value: sumProcessed
              },
              approved: {
                value: _Helper2.default.percents(sumProcessed, sumApproved),
                approvedSum: sumApproved
              },
              averageBill: {
                value: sumApproved > 0 ? '$ ' + (sumTotalPrice / sumApproved).toFixed(2) : '$ 0.00',
                averageBillTotal: sumTotalPrice
              },
              total_cancel: {
                value: sumCanceled
              },
              total_cancel_red: {
                value: sumCanceled > 0 ? (redCountCol / sumCanceled * 100).toFixed(1) + '%' : '0 %'
              },
              total_cancel_gray: {
                value: sumCanceled > 0 ? (grayCountCol / sumCanceled * 100).toFixed(1) + '%' : '0 %'
              },

              expensive: {
                value: expensiveCount
              },
              expensivePercent: {
                value: percentCanceled(expensiveCount)
              },

              changed_mind: {
                value: changedMindCount
              },
              changed_mindPercent: {
                value: percentCanceled(changedMindCount)
              },

              no_payment_method: {
                value: noPaymentMethodCount
              },
              no_payment_methodPercent: {
                value: percentCanceled(noPaymentMethodCount)
              },

              bad_reputation: {
                value: badReputationCount
              },
              bad_reputationPercent: {
                value: percentCanceled(badReputationCount)
              },

              form_release: {
                value: formReleaseCount
              },
              form_releasePercent: {
                value: percentCanceled(formReleaseCount)
              },

              want_guarantees: {
                value: guaranteesCount
              },
              want_guaranteesPercent: {
                value: percentCanceled(guaranteesCount)
              },

              medical_contraindications: {
                value: medicalContraindicationsCount
              },
              medical_contraindicationsPercent: {
                value: percentCanceled(medicalContraindicationsCount)
              },

              not_allowed: {
                value: notAllowedCount
              },
              not_allowedPercent: {
                value: percentCanceled(notAllowedCount)
              },

              consultation: {
                value: consultationCount
              },
              consultationPercent: {
                value: percentCanceled(consultationCount)
              },

              not_processed: {
                value: noProcessedCount
              },
              not_processedPercent: {
                value: percentCanceled(noProcessedCount)
              },

              expensive_delivery: {
                value: expensiveDeliveryCount
              },
              expensive_deliveryPercent: {
                value: percentCanceled(expensiveDeliveryCount)
              },

              no_pay_tax: {
                value: noPayTaxCount
              },
              no_pay_taxPercent: {
                value: percentCanceled(noPayTaxCount)
              },

              not_order: {
                value: notOrderCount
              },
              not_orderPercent: {
                value: percentCanceled(notOrderCount)
              },

              not_delivery_time: {
                value: notDeliveryTimeCount
              },
              not_delivery_timePercent: {
                value: percentCanceled(notDeliveryTimeCount)
              },

              already_bought: {
                value: alreadyBoughtCount
              },
              already_boughtPercent: {
                value: percentCanceled(alreadyBoughtCount)
              },

              no_nearby: {
                value: noClientNearbyCount
              },
              no_nearbyPercent: {
                value: percentCanceled(noClientNearbyCount)
              },

              suite_different_price: {
                value: suiteDifferentPriceCount
              },
              suite_different_pricePercent: {
                value: percentCanceled(suiteDifferentPriceCount)
              },

              other_information: {
                value: otherInformationCount
              },
              other_informationPercent: {
                value: percentCanceled(otherInformationCount)
              },

              won_gift: {
                value: wonGiftCount
              },
              won_giftPercent: {
                value: percentCanceled(wonGiftCount)
              },

              language_barrier: {
                value: languageBarrierCount
              },
              language_barrierPercent: {
                value: percentCanceled(languageBarrierCount)
              },

              wrong_data: {
                value: wrongNumberCount
              },
              wrong_dataPercent: {
                value: percentCanceled(wrongNumberCount)
              },

              not_ringing_long_time: {
                value: notRingingLongTimeCount
              },
              not_ringing_long_timePercent: {
                value: percentCanceled(notRingingLongTimeCount)
              },

              drop_calls: {
                value: dropCallCount
              },
              drop_callsPercent: {
                value: percentCanceled(dropCallCount)
              },

              not_make_contact: {
                value: notMakeContactCount
              },
              not_make_contactPercent: {
                value: percentCanceled(notMakeContactCount)
              },

              silent: {
                value: silentCount
              },
              silentPercent: {
                value: percentCanceled(silentCount)
              },

              no_coverage: {
                value: noCoverageCount
              },
              no_coveragePercent: {
                value: percentCanceled(noCoverageCount)
              },

              blacklisted_customer: {
                value: blacklistedCustomerCount
              },
              blacklisted_customerPercent: {
                value: percentCanceled(blacklistedCustomerCount)
              },

              under_18: {
                value: under18Count
              },
              under_18Percent: {
                value: percentCanceled(under18Count)
              },

              any_reasons: {
                value: anyReasonsCount
              },
              any_reasonsPercent: {
                value: percentCanceled(anyReasonsCount)
              },
              another: {
                value: anotherCount
              },
              anotherPercent: {
                value: percentCanceled(anotherCount)
              }
            });
          });

          var totalProcessed = 0;
          var totalApproved = 0;
          var totalAverageBill = 0.0;
          var totalCancel = 0;
          var totalCancelRed = 0;
          var totalCancelGray = 0;
          var totalExpensive = 0;
          var totalChangedMind = 0;
          var totalBadReputation = 0;
          var totalConsultation = 0;
          var totalNotAllowed = 0;
          var totalMedicalContraindications = 0;
          var totalNotOrder = 0;
          var totalNotRingingLongTime = 0;
          var totalNotMakeContact = 0;
          var totalNoCoverage = 0;
          var totalBlacklistedCustomer = 0;
          var totalNotDeliveryTime = 0;
          var totalAlreadyBought = 0;
          var totalSuiteDifferentPrice = 0;

          var totalNoPaymentMethod = 0;
          var totalFormRelease = 0;
          var totalGuarantees = 0;
          var totalNoProcessed = 0;
          var totalExpensiveDelivery = 0;
          var totalNoPayTax = 0;
          var totalNoClientNearby = 0;
          var totalOtherInformation = 0;
          var totalWonGift = 0;
          var totalLanguageBarrier = 0;
          var totalWrongNumber = 0;
          var totalDropCall = 0;
          var totalSilent = 0;
          var totalUnder18 = 0;
          var totalAnyReasons = 0;
          var totalAnother = 0;

          var totalPercentCanceled = function totalPercentCanceled(reasonCount) {
            return _Helper2.default.percents(totalCancel, reasonCount);
          };

          _this2.rows.forEach(function (item) {
            totalProcessed += item.processed_all.value;
            totalApproved += parseInt(item.approved.approvedSum);
            totalAverageBill += parseFloat(item.averageBill.averageBillTotal);
            totalCancel += parseInt(item.total_cancel.value);
            totalExpensive += parseInt(item.expensive.value);
            totalChangedMind += parseInt(item.changed_mind.value);
            totalBadReputation += parseInt(item.bad_reputation.value);
            totalConsultation += parseInt(item.consultation.value);
            totalNotAllowed += parseInt(item.not_allowed.value);
            totalMedicalContraindications += parseInt(item.medical_contraindications.value);
            totalNotOrder += parseInt(item.not_order.value);
            totalNotRingingLongTime += parseInt(item.not_ringing_long_time.value);
            totalNotMakeContact += parseInt(item.not_make_contact.value);
            totalNoCoverage += parseInt(item.no_coverage.value);
            totalBlacklistedCustomer += parseInt(item.blacklisted_customer.value);
            totalNotDeliveryTime += parseInt(item.not_delivery_time.value);
            totalAlreadyBought += parseInt(item.already_bought.value);
            totalSuiteDifferentPrice += parseInt(item.suite_different_price.value);
            totalNoPaymentMethod += parseInt(item.no_payment_method.value);
            totalFormRelease += parseInt(item.form_release.value);
            totalGuarantees += parseInt(item.want_guarantees.value);
            totalNoProcessed += parseInt(item.not_processed.value);
            totalExpensiveDelivery += parseInt(item.expensive_delivery.value);
            totalNoPayTax += parseInt(item.no_pay_tax.value);
            totalNoClientNearby += parseInt(item.no_nearby.value);
            totalOtherInformation += parseInt(item.other_information.value);
            totalWonGift += parseInt(item.won_gift.value);
            totalLanguageBarrier += parseInt(item.language_barrier.value);
            totalWrongNumber += parseInt(item.wrong_data.value);
            totalDropCall += parseInt(item.drop_calls.value);
            totalSilent += parseInt(item.silent.value);
            totalUnder18 += parseInt(item.under_18.value);
            totalAnyReasons += parseInt(item.any_reasons.value);
            totalAnother += parseInt(item.another.value);

            totalCancelRed = (0, _lodash.sum)([totalExpensive, totalChangedMind, totalBadReputation, totalConsultation, totalNotAllowed, totalMedicalContraindications, totalNoPaymentMethod, totalFormRelease, totalGuarantees, totalNoProcessed, totalExpensiveDelivery, totalNoPayTax]);

            totalCancelGray = (0, _lodash.sum)([totalNotOrder, totalNotRingingLongTime, totalNotMakeContact, totalNoCoverage, totalBlacklistedCustomer, totalNotDeliveryTime, totalAlreadyBought, totalSuiteDifferentPrice, totalNoClientNearby, totalOtherInformation, totalWonGift, totalLanguageBarrier, totalWrongNumber, totalDropCall, totalSilent, totalUnder18, totalAnyReasons, totalAnother]);
          });

          _this2.footColumns = {
            label: {
              value: _this2.$root.$t('statistic.in_total')
            },
            total: {
              value: totalProcessed
            },
            approved: {
              value: _Helper2.default.percents(totalProcessed, totalApproved)
            },
            averageBill: {
              value: _Helper2.default.averageBillDayCount(totalAverageBill, totalApproved)
            },
            total_cancel: {
              value: totalCancel
            },
            total_cancel_red: {
              value: totalPercentCanceled(totalCancel)
            },
            total_cancel_gray: {
              value: totalPercentCanceled(totalCancelGray)
            },

            expensive: {
              value: totalExpensive
            },
            expensivePercent: {
              value: totalPercentCanceled(totalExpensive)
            },

            changed_mind: {
              value: totalChangedMind
            },
            changed_mindPercent: {
              value: totalPercentCanceled(totalChangedMind)
            },

            no_payment_method: {
              value: totalNoPaymentMethod
            },
            no_payment_methodPercent: {
              value: totalPercentCanceled(totalNoPaymentMethod)
            },

            bad_reputation: {
              value: totalBadReputation
            },
            bad_reputationPercent: {
              value: totalPercentCanceled(totalBadReputation)
            },

            form_release: {
              value: totalFormRelease
            },
            form_releasePercent: {
              value: totalPercentCanceled(totalFormRelease)
            },

            want_guarantees: {
              value: totalGuarantees
            },
            want_guaranteesPercent: {
              value: totalPercentCanceled(totalGuarantees)
            },

            medical_contraindications: {
              value: totalMedicalContraindications
            },
            medical_contraindicationsPercent: {
              value: totalPercentCanceled(totalMedicalContraindications)
            },

            not_allowed: {
              value: totalNotAllowed
            },
            not_allowedPercent: {
              value: totalPercentCanceled(totalNotAllowed)
            },

            consultation: {
              value: totalConsultation
            },
            consultationPercent: {
              value: totalPercentCanceled(totalConsultation)
            },

            not_processed: {
              value: totalNoProcessed
            },
            not_processedPercent: {
              value: totalPercentCanceled(totalNoProcessed)
            },

            expensive_delivery: {
              value: totalExpensiveDelivery
            },
            expensive_deliveryPercent: {
              value: totalPercentCanceled(totalExpensiveDelivery)
            },

            no_pay_tax: {
              value: totalNoPayTax
            },
            no_pay_taxPercent: {
              value: totalPercentCanceled(totalNoPayTax)
            },

            not_order: {
              value: totalNotOrder
            },
            not_orderPercent: {
              value: totalPercentCanceled(totalNotOrder)
            },

            not_delivery_time: {
              value: totalNotDeliveryTime
            },
            not_delivery_timePercent: {
              value: totalPercentCanceled(totalNotDeliveryTime)
            },

            already_bought: {
              value: totalAlreadyBought
            },
            already_boughtPercent: {
              value: totalPercentCanceled(totalAlreadyBought)
            },

            no_nearby: {
              value: totalNoClientNearby
            },
            no_nearbyPercent: {
              value: totalPercentCanceled(totalNoClientNearby)
            },

            suite_different_price: {
              value: totalSuiteDifferentPrice
            },
            suite_different_pricePercent: {
              value: totalPercentCanceled(totalSuiteDifferentPrice)
            },

            other_information: {
              value: totalOtherInformation
            },
            other_informationPercent: {
              value: totalPercentCanceled(totalOtherInformation)
            },

            won_gift: {
              value: totalWonGift
            },
            won_giftPercent: {
              value: totalPercentCanceled(totalWonGift)
            },

            language_barrier: {
              value: totalLanguageBarrier
            },
            language_barrierPercent: {
              value: totalPercentCanceled(totalLanguageBarrier)
            },

            wrong_data: {
              value: totalWrongNumber
            },
            wrong_dataPercent: {
              value: totalPercentCanceled(totalWrongNumber)
            },

            not_ringing_long_time: {
              value: totalNotRingingLongTime
            },
            not_ringing_long_timePercent: {
              value: totalPercentCanceled(totalNotRingingLongTime)
            },

            drop_calls: {
              value: totalDropCall
            },
            drop_callsPercent: {
              value: totalPercentCanceled(totalDropCall)
            },

            not_make_contact: {
              value: totalNotMakeContact
            },
            not_make_contactPercent: {
              value: totalPercentCanceled(totalNotMakeContact)
            },

            silent: {
              value: totalSilent
            },
            silentPercent: {
              value: totalPercentCanceled(totalSilent)
            },

            no_coverage: {
              value: totalNoCoverage
            },
            no_coveragePercent: {
              value: totalPercentCanceled(totalNoCoverage)
            },

            blacklisted_customer: {
              value: totalBlacklistedCustomer
            },
            blacklisted_customerPercent: {
              value: totalPercentCanceled(totalBlacklistedCustomer)
            },

            under_18: {
              value: totalUnder18
            },
            under_18Percent: {
              value: totalPercentCanceled(totalUnder18)
            },

            any_reasons: {
              value: totalAnyReasons
            },
            any_reasonsPercent: {
              value: _Helper2.default.percents(totalCancel, totalAnyReasons)
            },
            another: {
              value: totalAnother
            },
            anotherPercent: {
              value: _Helper2.default.percents(totalCancel, totalAnother)
            }
          };

          _this2.$root.$emit('data_loaded');
        }).catch(function (response) {
          _this2.$root.$emit('data_loaded');
          console.log('err');
          _this2.$notify({
            type: 'danger',
            title: _this2.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          });
        });
      });
    }
  }
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'RefundsTabs'
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _RefundsTabs = __webpack_require__(23);

var _RefundsTabs2 = _interopRequireDefault(_RefundsTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Buyout',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    RefundsTabs: _RefundsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byWmFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.refunds_id'), field: 'refunds_id' }, { label: this.$root.$t('statistic.return_title'), field: 'return_title' }, { label: this.$root.$t('statistic.return_count'), field: 'return_count', colspan: 2 }],
      rows: [],
      footColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      _API2.default.getRefundsStatistic(2).then(function (response) {
        var reasons = {};
        var total = 0;
        (0, _lodash.map)(response.body, function (d) {
          if (!reasons[d.reason_id]) {
            reasons[d.reason_id] = d;
          } else {
            reasons[d.reason_id].count += d.count;
          }
          total += d.count;
        });
        (0, _lodash.map)(reasons, function (d) {
          _this2.rows.push({
            reason_id: { value: d.reason_id, style: { textAlign: 'left' } },
            reason: { value: d.reason_text, style: { textAlign: 'left' } },
            count: {
              value: d.count,
              bgg: _Helper2.default.renderGistPart(total, d.count),
              isCollspaned: true
            },
            countPercents: {
              value: _Helper2.default.percents(total, d.count),
              bgg: _Helper2.default.renderGistPart(total, d.count, true)
            }
          });
        });
        _this2.footColumns = {
          label_id: {
            value: _this2.$root.$t('')
          },
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          count: {
            value: total + ' (' + _Helper2.default.average(total, 1) + ')'
          },
          countPercents: {
            value: _Helper2.default.percents(total, total)
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _RefundsTabs = __webpack_require__(23);

var _RefundsTabs2 = _interopRequireDefault(_RefundsTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ReturnByMonth',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    RefundsTabs: _RefundsTabs2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byWmFilter: true,
        byWebmasterFilter: true
      },
      isLoading: false,
      checked: [],
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      country: null,
      headColumns: [{ label: this.$root.$t('statistic.return'), field: 'refunds_id' }],
      rows: [],
      footColumns: {},
      EnMessage: [{ id: 0, text: 'Без причины' }, { id: 1, text: 'Дорого' }, { id: 2, text: 'Передумал' }, { id: 3, text: 'Доставка заняла слишком много времени' }, { id: 4, text: 'Не понравилось качество посылки' }, { id: 5, text: 'Курьер потребовал большую сумму' }, { id: 6, text: 'Курьерская служба не позвонила и я не знал, что моя посылка доставлена' }, { id: 7, text: 'Грубый курьер' }, { id: 8, text: 'Я не мог забрать посылку в первый раз, но курьер не доставил её повторно' }, { id: 9, text: 'Я нахожусь за городом' }, { id: 10, text: 'Курьер не пришел' }, { id: 11, text: 'Адрес/индекс неверный' }, { id: 12, text: 'Клиент недоступен' }, { id: 13, text: 'Проблемы с деньгами' }, { id: 14, text: 'Клиент сменил адрес' }, { id: 15, text: 'Не могу открыть посылку' }, { id: 16, text: 'Не могу оплатить кредиткой' }, { id: 17, text: 'Купил другой товар (в другом месте)' }, { id: 18, text: 'Медицинские противопоказания' }, { id: 19, text: 'Другое' }, { id: 24, text: 'Недозвон в течении долгого времени' }, { id: 25, text: 'Уже получил заказ' }, { id: 26, text: 'Множественные смены даты доставки' }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.checked = [];
      this.footColumns = {};
      this.headColumns = [{ label: this.$root.$t('statistic.refundsId'), field: 'refunds_id' }, { label: this.$root.$t('statistic.return'), field: 'refunds' }];
      var language = _Storage2.default.language;
      _API2.default.getReturnReasonStatisticByMonth(2).then(function (response) {
        var reasonsByMonth = [];
        var footColumn = {
          reason_id: {
            value: ''
          },
          reason: {
            value: ''
          }
        };
        (0, _lodash.map)(response.body, function (year) {
          (0, _lodash.map)(year, function (data, month) {
            _this2.headColumns.push({
              label: _this2.$root.$t('month.' + month) + ' ' + _Helper2.default.percents(data.orders_count, data.reasons_count), field: 'month' + month, colspan: 2, bg: true
            });

            footColumn['month.' + month] = {
              value: data.reasons_count
            };
            footColumn['orders_month.' + month] = {
              value: ''
            };
            (0, _lodash.map)(data.reasons, function (reason, reasonsId) {
              if (reasonsByMonth[reasonsId] === undefined) {
                reasonsByMonth[reasonsId] = {};
              }
              reasonsByMonth[reasonsId]['m' + month] = reason;
              reasonsByMonth[reasonsId]['m' + month].reasons_count = data.reasons_count;
            });
          });
        });
        reasonsByMonth.forEach(function (reasonData, reasonId) {
          var row = {
            id: { value: reasonId },
            reason: { value: reasonId, style: { textAlign: 'left' } }
          };
          var checkd = {
            id: reasonId,
            total: {}
          };
          (0, _lodash.map)(reasonData, function (monthData, monthId) {
            checkd.total['month.' + monthId.substring(1)] = {};
            checkd.total['month.' + monthId.substring(1)].count = monthData.count;
            row.reason.value = language === 'ru' ? _Helper2.default.getCancelName(_this2.EnMessage, reasonId) : monthData.text;
            row['month_count_' + monthId] = {};
            row['month_persent_' + monthId] = {};
            row['month_count_' + monthId] = {
              value: monthData.count
            };
            row['month_persent_' + monthId] = {
              value: _Helper2.default.percents(monthData.reasons_count, monthData.count),
              bgg: parseFloat(parseFloat(monthData.count) / parseFloat(monthData.reasons_count) * 100).toFixed(1)
            };
          });
          _this2.rows.push(row);
          _this2.checked.push(checkd);
        });
        _this2.footColumns = footColumn;
        _this2.$root.$emit('data_loaded');
      }).catch(function (response) {
        _this2.$root.$emit('data_loaded');
        _this2.$notify({
          type: 'danger',
          title: _this2.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        });
      });
    }
  }
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'ArrivalNewLeads',
  components: { StatisticTable: _StatisticTable2.default, Filters: _Filters2.default },
  data: function data() {
    return {
      contentVisible: false,
      title: 'Поступление новых лидов',
      filtersScope: {
        ParsePeriod: true,
        dateFilter: true,
        byWmFilterAll: true,
        offerFilter: true
      },
      footColumns: [],
      headColumns: [],
      rows: [],
      x: 0,
      monthIndex: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      isParse: 'day'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('handleChangeParse', function (isParsePeriod) {
      _this.isParse = isParsePeriod;
      _this.calculateRows();
    });
    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    getWeekDaysByWeekNumber: function getWeekDaysByWeekNumber(week) {
      var date = (0, _moment2.default)().isoWeek(week || 1).startOf('week'),
          weeklength = 7,
          result = [],
          month = '';
      while (weeklength--) {
        result.push(date.format('DD'));
        month = date.format('MM');
        date.add(1, 'day');
      }
      return '\u041D\u0435\u0434\u0435\u043B\u044F \u0441 ' + result[0] + ' - ' + result[6] + ' ' + this.monthIndex[month - 1];
    },
    linerGradient: function linerGradient(approved, total) {
      var count = total && approved > 0 ? (approved / total * 100).toFixed(1) : 0;
      return 'linear-gradient(to right, #90caf9 ' + count + '%, white 0%)';
    },
    findCountry: function findCountry(id) {
      var country = (0, _lodash.find)(_Storage2.default.countries, { id: parseInt(id) });
      return country.name;
    },
    findOffer: function findOffer(id) {
      var offer = _Helper2.default.getOfferTitle(_Storage2.default.offers, id);
      return offer;
    },
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    dateParse: function dateParse(data, parse) {
      var arr = [];
      (0, _lodash.map)(data, function (arrOffer) {
        (0, _lodash.map)(arrOffer, function (arrItems) {
          (0, _lodash.map)(arrItems, function (item) {
            if (parse === 'day') {
              arr.push(item.date);
            }
            if (parse === 'week') {
              arr.push(item.week);
            }
            if (parse === 'month') {
              arr.push(item.month);
            }
          });
        });
      });
      var filterArr = arr.filter(function (item, index) {
        return arr.indexOf(item) === index;
      });
      return filterArr;
    },
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.rows = [];
      this.footColumns = [];
      this.headColumns = [{ label: this.$root.$t('statistic.country'), field: 'country', color: '#e0e0e0', width: '200px' }];
      _API2.default.getArrivalNewLeads(this.isParse).then(function (response) {
        var data = response.body;
        var arrDateHead = _this2.dateParse(data, _this2.isParse);
        var dateHead = (0, _lodash.orderBy)(arrDateHead, [], ['desc']);
        if (_this2.isParse === 'day') {
          var dateDay = dateHead;
          dateDay.forEach(function (item) {
            _this2.headColumns.push({ label: item, color: '#90caf9' });
          });
          (0, _lodash.map)(data, function (offerCountry, indexCountry) {
            var sortForOffers = [];
            var totalCountryOffers = [];
            (0, _lodash.map)(offerCountry, function (arr) {
              for (var i = 0; i < dateHead.length; i++) {
                arr.push({
                  date: dateHead[i],
                  total: 0,
                  spam: 0,
                  approved: 0
                });
              }
            });
            (0, _lodash.map)(offerCountry, function (arr, indexOffer) {
              var unicByOffer = [];
              unicByOffer.push((0, _lodash.uniqBy)(arr, 'date'));
              var sortByOffer = [];
              (0, _lodash.map)(unicByOffer, function (arr) {
                sortByOffer.push((0, _lodash.orderBy)(arr, 'date', 'desc'));
              });
              sortForOffers.push(_defineProperty({}, indexOffer, sortByOffer.flat()));
            });
            var allItemsOffers = [];
            (0, _lodash.map)(sortForOffers, function (arr) {
              (0, _lodash.map)(arr, function (items) {
                (0, _lodash.map)(items, function (item) {
                  allItemsOffers.push(item);
                });
              });
            });
            for (var i = 0; i < dateDay.length; i++) {
              var row = [];
              for (var j = 0; j < allItemsOffers.length; j++) {
                if (dateDay[i] === allItemsOffers[j].date) {
                  row.push(allItemsOffers[j]);
                }
              }
              totalCountryOffers.push({
                date: dateDay[i],
                total: row.map(function (x) {
                  return x.total;
                }).reduce(function (a, b) {
                  return a + b;
                }),
                spam: row.map(function (x) {
                  return x.spam;
                }).reduce(function (a, b) {
                  return a + b;
                }),
                approved: row.map(function (x) {
                  return x.approved;
                }).reduce(function (a, b) {
                  return a + b;
                })
              });
            }
            _this2.rows.push(_defineProperty({}, indexCountry, {
              total: totalCountryOffers,
              offers: sortForOffers,
              visible: false
            }));
          });
          var allItemsTotal = [];
          _this2.rows.forEach(function (arr) {
            (0, _lodash.map)(arr, function (item) {
              (0, _lodash.map)(item.total, function (item) {
                allItemsTotal.push(item);
              });
            });
          });

          for (var i = 0; i < dateDay.length; i++) {
            var row = [];
            for (var j = 0; j < allItemsTotal.length; j++) {
              if (dateDay[i] === allItemsTotal[j].date) {
                row.push(allItemsTotal[j]);
              }
            }
            _this2.footColumns.push({
              day: dateDay[i],
              total: row.map(function (x) {
                return x.total;
              }).reduce(function (a, b) {
                return a + b;
              }),
              spam: row.map(function (x) {
                return x.spam;
              }).reduce(function (a, b) {
                return a + b;
              }),
              approved: row.map(function (x) {
                return x.approved;
              }).reduce(function (a, b) {
                return a + b;
              })
            });
          }
        }
        if (_this2.isParse === 'week') {
          dateHead.forEach(function (item) {
            _this2.headColumns.push({ label: _this2.getWeekDaysByWeekNumber(item), color: '#90caf9' });
          });
          (0, _lodash.map)(data, function (offerCountry, indexCountry) {
            var allItems = [];
            var idOffers = [];
            (0, _lodash.map)(offerCountry, function (offerItems) {
              offerItems.forEach(function (item) {
                allItems.push(item);
                idOffers.push(item.offer_id);
              });
            });
            var idOffersFilter = idOffers.filter(function (item, index) {
              return idOffers.indexOf(item) === index;
            });

            var sortForOffers = [];
            for (var _i = 0; _i < idOffersFilter.length; _i++) {
              var _row = [];
              for (var _j = 0; _j < allItems.length; _j++) {
                if (idOffersFilter[_i] === allItems[_j].offer_id) {
                  _row.push(allItems[_j]);
                }
              }
              var offer = '';
              var week = [];

              for (var _i2 = 0; _i2 < dateHead.length; _i2++) {
                var total = 0;
                var spam = 0;
                var approved = 0;
                for (var _j2 = 0; _j2 < _row.length; _j2++) {
                  if (dateHead[_i2] === _row[_j2].week) {
                    offer = _row[_j2].offer_id;
                    total += _row[_j2].total;
                    spam += _row[_j2].spam;
                    approved += _row[_j2].approved;
                  }
                }
                week.push({
                  week: dateHead[_i2],
                  total: total,
                  spam: spam,
                  approved: approved,
                  offer_id: offer
                });
              }
              sortForOffers.push(_defineProperty({}, offer, week));
            }

            var sortForTotal = [];
            for (var _i3 = 0; _i3 < dateHead.length; _i3++) {
              var _row2 = [];
              for (var _j3 = 0; _j3 < allItems.length; _j3++) {
                if (dateHead[_i3] === allItems[_j3].week) {
                  _row2.push(allItems[_j3]);
                }
              }

              sortForTotal.push({
                week: dateHead[_i3],
                total: _row2.map(function (x) {
                  return x.total;
                }).reduce(function (a, b) {
                  return a + b;
                }),
                spam: _row2.map(function (x) {
                  return x.spam;
                }).reduce(function (a, b) {
                  return a + b;
                }),
                approved: _row2.map(function (x) {
                  return x.approved;
                }).reduce(function (a, b) {
                  return a + b;
                })
              });
            }
            _this2.rows.push(_defineProperty({}, indexCountry, {
              total: sortForTotal,
              offers: sortForOffers,
              visible: false
            }));
          });
          var _allItemsTotal = [];
          _this2.rows.forEach(function (arr) {
            (0, _lodash.map)(arr, function (items) {
              (0, _lodash.map)(items.total, function (item) {
                _allItemsTotal.push(item);
              });
            });
          });

          for (var _i4 = 0; _i4 < dateHead.length; _i4++) {
            var _row3 = [];
            for (var _j4 = 0; _j4 < _allItemsTotal.length; _j4++) {
              if (dateHead[_i4] === _allItemsTotal[_j4].week) {
                _row3.push(_allItemsTotal[_j4]);
              }
            }
            _this2.footColumns.push({
              week: dateHead[_i4],
              total: _row3.map(function (x) {
                return x.total;
              }).reduce(function (a, b) {
                return a + b;
              }),
              spam: _row3.map(function (x) {
                return x.spam;
              }).reduce(function (a, b) {
                return a + b;
              }),
              approved: _row3.map(function (x) {
                return x.approved;
              }).reduce(function (a, b) {
                return a + b;
              })
            });
          }
        }
        if (_this2.isParse === 'month') {
          dateHead.forEach(function (item) {
            _this2.headColumns.push({ label: _this2.monthIndex[item - 1], color: '#90caf9' });
          });
          (0, _lodash.map)(data, function (offerCountry, indexCountry) {
            var allItems = [];
            var idOffers = [];
            (0, _lodash.map)(offerCountry, function (offerItems) {
              offerItems.forEach(function (item) {
                allItems.push(item);
                idOffers.push(item.offer_id);
              });
            });
            var idOffersFilter = idOffers.filter(function (item, index) {
              return idOffers.indexOf(item) === index;
            });

            var sortForOffers = [];
            for (var _i5 = 0; _i5 < idOffersFilter.length; _i5++) {
              var _row4 = [];
              for (var _j5 = 0; _j5 < allItems.length; _j5++) {
                if (idOffersFilter[_i5] === allItems[_j5].offer_id) {
                  _row4.push(allItems[_j5]);
                }
              }
              var offer = '';
              var month = [];

              for (var _i6 = 0; _i6 < dateHead.length; _i6++) {
                var total = 0;
                var spam = 0;
                var approved = 0;
                for (var _j6 = 0; _j6 < _row4.length; _j6++) {
                  if (dateHead[_i6] === _row4[_j6].month) {
                    offer = _row4[_j6].offer_id;
                    total += _row4[_j6].total;
                    spam += _row4[_j6].spam;
                    approved += _row4[_j6].approved;
                  }
                }
                month.push({
                  month: dateHead[_i6],
                  total: total,
                  spam: spam,
                  approved: approved,
                  offer_id: offer
                });
              }
              sortForOffers.push(_defineProperty({}, offer, month));
            }

            var sortForTotal = [];
            for (var _i7 = 0; _i7 < dateHead.length; _i7++) {
              var _row5 = [];
              for (var _j7 = 0; _j7 < allItems.length; _j7++) {
                if (dateHead[_i7] === allItems[_j7].month) {
                  _row5.push(allItems[_j7]);
                }
              }

              sortForTotal.push({
                month: dateHead[_i7],
                total: _row5.map(function (x) {
                  return x.total;
                }).reduce(function (a, b) {
                  return a + b;
                }),
                spam: _row5.map(function (x) {
                  return x.spam;
                }).reduce(function (a, b) {
                  return a + b;
                }),
                approved: _row5.map(function (x) {
                  return x.approved;
                }).reduce(function (a, b) {
                  return a + b;
                })
              });
            }
            _this2.rows.push(_defineProperty({}, indexCountry, {
              total: sortForTotal,
              offers: sortForOffers,
              visible: false
            }));
          });
          var _allItemsTotal2 = [];
          _this2.rows.forEach(function (arr) {
            (0, _lodash.map)(arr, function (items) {
              (0, _lodash.map)(items.total, function (item) {
                _allItemsTotal2.push(item);
              });
            });
          });

          for (var _i8 = 0; _i8 < dateHead.length; _i8++) {
            var _row6 = [];
            for (var _j8 = 0; _j8 < _allItemsTotal2.length; _j8++) {
              if (dateHead[_i8] === _allItemsTotal2[_j8].month) {
                _row6.push(_allItemsTotal2[_j8]);
              }
            }
            _this2.footColumns.push({
              week: dateHead[_i8],
              total: _row6.map(function (x) {
                return x.total;
              }).reduce(function (a, b) {
                return a + b;
              }),
              spam: _row6.map(function (x) {
                return x.spam;
              }).reduce(function (a, b) {
                return a + b;
              }),
              approved: _row6.map(function (x) {
                return x.approved;
              }).reduce(function (a, b) {
                return a + b;
              })
            });
          }
        }
      });
    }
  }
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _AlbhabetScroll = __webpack_require__(19);

var _AlbhabetScroll2 = _interopRequireDefault(_AlbhabetScroll);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Grid',
  components: {
    Filters: _Filters2.default,
    AlphabetScroll: _AlbhabetScroll2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byWmFilterAll: true
      },
      scrollPos: 0,
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      headColumns: [{ label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed' }, { label: this.$root.$t('statistic.accepted'), field: 'accepted' }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.approve'), field: 'approve', width: '50px' }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }],
      rows: [],
      footColumns: [],
      offers: [],
      web: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.getWeb();
    this.getOffers();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
      _this.getWeb();
      _this.getOffers();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.loading = true;
      this.offers = _Storage2.default.offers.slice(0);
      this.rows = [];
      this.footColumns = [];
      _API2.default.getGrid().then(function (response) {
        (0, _lodash.map)(response.body, function (d) {
          _this2.rows.push({
            offer: d.offer_id,
            rows: [{
              webmaster: {
                value: _Helper2.default.getWebLogin(_this2.web, d.wm_id)
              },
              total: {
                value: d.total
              },
              processed: {
                value: d.processed,
                bg: true
              },
              accepted: {
                value: d.approved,
                bg: true
              },
              canceled: {
                value: d.canceled,
                bgg: _Helper2.default.renderGistPart(d.total, d.canceled),
                isCollspaned: true
              },
              canceledPercents: {
                value: _Helper2.default.percents(d.total, d.canceled),
                bgg: _Helper2.default.renderGistPart(d.total, d.canceled, true)
              },
              error: {
                value: d.error,
                bgg: _Helper2.default.renderGistPart(d.total, d.error),
                isCollspaned: true
              },
              errorPercents: {
                value: _Helper2.default.percents(d.total, d.error),
                bgg: _Helper2.default.renderGistPart(d.total, d.error, true)
              },
              return: {
                value: d.return,
                bgg: _Helper2.default.renderGistPart(d.approved, d.return),
                isCollspaned: true
              },
              returnPercents: {
                value: _Helper2.default.percents(d.approved, d.return),
                bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
              },
              paid: {
                value: d.paid,
                bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
                isCollspaned: true
              },
              paidPercents: {
                value: _Helper2.default.percents(d.approved, d.paid),
                bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true)
              },
              averageBill: {
                value: '$ ' + d.average_bill_usd.toFixed(2),

                isCollspaned: true
              },
              averageBillLocal: {
                value: d.local_currency.split(',').length === 1 ? d.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
              },
              approve: {
                value: _Helper2.default.percents(d.total, d.approved),
                bgg: _Helper2.default.renderSingleGist(d.total, d.approved)
              },
              approvedFromValid: {
                value: d.approved_from_valid.toFixed(1) + '%'
              }
            }],
            foot: sum(d)
          });
        });

        function sum(data) {
          var sumTotal = 0;
          var sumProcessed = 0;
          var countProcessed = 0;
          var sumAccepted = 0;
          var countAccepted = 0;
          var sumCanceled = 0;
          var countCanceled = 0;
          var sumError = 0;
          var countError = 0;
          var sumReturn = 0;
          var countReturn = 0;
          var sumPaid = 0;
          var countPaid = 0;
          var sumAverageBillLocal = 0.0;
          var sumAverageBill = 0.0;
          sumTotal += data.total;
          if (data.processed > 0) {
            sumProcessed += data.processed;
            countProcessed++;
          }
          if (data.approved > 0) {
            sumAccepted += data.approved;
            countAccepted++;
            sumAverageBillLocal += parseFloat(data.average_bill_local) * data.approved;
            sumAverageBill += parseFloat(data.average_bill_usd) * data.approved;
          }
          if (data.canceled > 0) {
            sumCanceled += data.canceled;
            countCanceled++;
          }
          if (data.error > 0) {
            sumError += data.error;
            countError++;
          }
          if (data.return > 0) {
            sumReturn += data.return;
            countReturn++;
          }
          if (data.paid > 0) {
            sumPaid += data.paid;
            countPaid++;
          }
          var array = {
            label: {
              value: 'Итого'
            },
            total: {
              value: '' + sumTotal,
              graph: true
            },
            processed: {
              value: '' + sumProcessed,
              graph: true
            },
            accepted: {
              value: '' + sumAccepted,
              graph: true
            },
            canceled: {
              value: '' + sumCanceled,
              graph: true
            },
            canceledPercents: {
              value: _Helper2.default.percents(sumTotal, sumCanceled),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            error: {
              value: '' + sumError,
              graph: true
            },
            errorPercents: {
              value: _Helper2.default.percents(sumTotal, sumError),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            return: {
              value: '' + sumReturn,
              graph: true
            },
            returnPercents: {
              value: _Helper2.default.percents(sumAccepted, sumReturn),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            paid: {
              value: '' + sumPaid,
              graph: true
            },
            paidPercents: {
              value: _Helper2.default.percents(sumAccepted, sumPaid),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            averageBill: {
              value: _Helper2.default.averageBillDayCount(sumAverageBill, sumAccepted),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '$'
              }
            },
            averageBillLocal: {
              value: _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumAccepted, (0, _currencySymbolMap2.default)(data.local_currency)),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: _Storage2.default.selectedCountry.currency_symbol
              }
            },
            approve: {
              value: _Helper2.default.percents(sumTotal, sumAccepted),
              graph: {
                cb: function cb(value) {
                  return _Helper2.default.getRawNumber(value);
                },
                symbol: '%'
              }
            },
            approvedFromValid: {
              value: _Helper2.default.approvedFromValid(sumAccepted, sumTotal, sumError)
            }
          };
          return array;
        }
      });
    },
    getWeb: function getWeb() {
      var _this3 = this;

      this.web = null;
      _API2.default.getWebmastersAll(_Helper2.default.getCountryList()).then(function (res) {
        _this3.web = res.body;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getOffers: function getOffers() {
      _API2.default.getOffers(_Helper2.default.getCountryList()).then(function (res) {
        _Storage2.default.offers = res.body;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }

};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _lodash = __webpack_require__(5);

var _vueStrap = __webpack_require__(9);

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Landing',
  components: {
    modal: _vueStrap.modal,
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byWmFilter: true,
        byWebmasterFilter: true
      },
      chartModal: false,
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      webid: null,
      country: null,
      headColumns: [{ label: this.$root.$t('pages.sources'), field: 'webmaster' }, { label: this.$root.$t('statistic.proportion'), field: 'proportion' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2 }, { label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2 }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }],
      rows: [],
      footColumns: {},
      chart: {
        isBuilded: false,
        isHidden: false,
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          title: {
            text: null
          },
          tickInterval: 1
        }],
        tooltip: {
          valueSuffix: null
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m-%d}'
          }
        },
        series: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getWebmasterLandStatistic().then(function (response) {
        var sumTotal = 0;
        var count = Object(response.data).keys.length;

        (0, _lodash.map)(response.data, function (d) {
          sumTotal += parseInt(d.total);
        });
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });

        var sumProcessed = 0;
        var countProcessed = 0;
        var sumAccepted = 0;
        var countApproved = 0;
        var sumCanceled = 0;
        var countCanceled = 0;
        var sumError = 0;
        var countError = 0;
        var sumPaid = 0;
        var countPaid = 0;
        var sumReturn = 0;
        var countReturn = 0;
        var sumAverageBillLocal = 0.0;
        var sumAverageBill = 0.0;
        (0, _lodash.map)(response.data, function (d) {
          if (d.processed > 0) {
            sumProcessed += parseInt(d.processed);
            countProcessed++;
          }
          if (d.approved > 0) {
            sumAccepted += parseInt(d.approved);
            countApproved++;
            sumAverageBillLocal += parseFloat(d.average_bill_local) * d.approved;
            sumAverageBill += parseFloat(d.average_bill_usd) * d.approved;
            _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
          }
          if (d.canceled > 0) {
            sumCanceled += parseInt(d.canceled);
            countCanceled++;
          }
          if (d.error > 0) {
            sumError += parseInt(d.error);
            countError++;
          }
          if (d.paid > 0) {
            sumPaid += parseInt(d.paid);
            countPaid++;
          }
          if (d.return > 0) {
            sumReturn += parseInt(d.return);
            countReturn++;
          }
          _this2.rows.push({
            source: { isCollspaned: true, value: d.source },
            proportion: {
              value: _Helper2.default.percents(sumTotal, d.total),
              bgg: _Helper2.default.renderSingleGist(parseInt(d.total), parseInt(d.canceled)),
              ocb: function ocb(value) {
                return _Helper2.default.getRawNumber(value);
              }
            },
            total: {
              value: d.total,
              bg: true,
              webGraph: true,
              wb: d.source
            },
            processed: {
              value: d.processed,
              bgg: _Helper2.default.renderGistPart(d.total, d.processed),
              isCollspaned: true
            },
            processedPercents: {
              value: _Helper2.default.percents(d.total, d.processed),
              bgg: _Helper2.default.renderGistPart(d.total, d.processed, true)
            },
            accepted: {
              value: d.approved,
              bgg: _Helper2.default.renderGistPart(d.total, d.approved),
              isCollspaned: true
            },
            acceptedPercents: {
              value: _Helper2.default.percents(d.total, d.approved),
              bgg: _Helper2.default.renderGistPart(d.total, d.approved, true),
              webGraph: true,
              wb: d.source,
              webGraphSymbol: '%'
            },
            paid: {
              value: d.paid,
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
              isCollspaned: true
            },
            paidPercents: {
              value: _Helper2.default.percents(parseInt(d.approved), parseInt(d.paid)),
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true),
              webGraph: true,
              wb: d.source,
              webGraphSymbol: '%'
            },
            return: {
              value: d.return,
              bgg: _Helper2.default.renderGistPart(d.approved, d.return),
              isCollspaned: true
            },
            returnPercents: {
              value: _Helper2.default.percents(parseInt(d.approved), parseInt(d.return)),
              bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
            },
            averageBill: {
              value: '$ ' + d.average_bill_usd.toFixed(2),

              isCollspaned: true
            },
            averageBillLocal: {
              value: d.local_currency.split(',').length === 1 ? d.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
            },
            canceled: {
              value: d.canceled,
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled),
              isCollspaned: true
            },
            canceledPercents: {
              value: _Helper2.default.percents(parseInt(d.total), parseInt(d.canceled)),
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled, true)
            },
            error: {
              value: d.error,
              bgg: _Helper2.default.renderGistPart(d.total, d.error),
              isCollspaned: true
            },
            errorPercents: {
              value: _Helper2.default.percents(parseInt(d.total), parseInt(d.error)),
              bgg: _Helper2.default.renderGistPart(d.total, d.error, true)
            },
            approvedFromValid: {
              value: d.approved_from_valid.toFixed(1) + '%'
            }
          });
        });
        _this2.footColumns = {
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          proportion: {
            value: null
          },
          total: {
            value: sumTotal + ' (' + _Helper2.default.average(sumTotal, count) + ')'
          },
          processed: {
            value: sumProcessed + ' (' + _Helper2.default.average(sumProcessed, countProcessed) + ')'
          },
          processedPercents: {
            value: _Helper2.default.percents(sumTotal, sumProcessed)
          },
          accepted: {
            value: sumAccepted + ' (' + _Helper2.default.average(sumAccepted, countApproved) + ')'
          },
          acceptedPercents: {
            value: _Helper2.default.percents(sumTotal, sumAccepted)
          },
          paid: {
            value: sumPaid + ' (' + _Helper2.default.average(sumPaid, countPaid) + ')'
          },
          paidPercents: {
            value: _Helper2.default.percents(sumAccepted, sumPaid)
          },
          return: {
            value: sumReturn + ' (' + _Helper2.default.average(sumReturn, countReturn) + ')'
          },
          returnPercents: {
            value: _Helper2.default.percents(sumAccepted, sumReturn)
          },
          averageBill: {
            value: _Helper2.default.averageBillDayCount(sumAverageBill, sumAccepted),
            graph: {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: '$'
            }
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumAccepted, _this2.localCurrencySymbol) : '-',
            graph: filterCurrency.length === 1 ? {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: _this2.localCurrencySymbol
            } : false
          },
          canceled: {
            value: sumCanceled + ' (' + _Helper2.default.average(sumCanceled, countCanceled) + ')'
          },
          canceledPercents: {
            value: _Helper2.default.percents(sumTotal, sumCanceled)
          },
          error: {
            value: sumError + ' (' + _Helper2.default.average(sumError, countError) + ')'
          },
          errorPercents: {
            value: _Helper2.default.percents(sumTotal, sumError)
          },
          approvedFromValid: {
            value: _Helper2.default.approvedFromValid(sumAccepted, sumTotal, sumError)
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (error) {
        console.log(error);
      });
    },
    webGraph: function webGraph(cell, i) {
      var _this3 = this;

      var name = i === 'acceptedPercents' ? 'approved' : i === 'paidPercents' ? 'paid' : 'total';
      this.webid = cell.wb;
      var approvedAll = [];
      var acceptedPercentsName = this.$root.$t('statistic.approved');
      var totalPercentsTotal = this.$root.$t('statistic.total');
      var totals = this.$root.$t('verbs.total');
      _API2.default.getLandGraps(cell.wb).then(function (response) {
        var rows = (0, _lodash.orderBy)(response.body, [function (item) {
          return item.date.value;
        }], ['asc']);
        var series = [];
        (0, _lodash.map)(rows, function (row) {
          var value = i === 'acceptedPercents' ? _Helper2.default.percentsF(row['total'], row['approved']) : i === 'paidPercents' ? _Helper2.default.percentsF(row['approved'], row['paid']) : row['total'];
          approvedAll[Date.parse(row.date)] = row['approved'];
          series.push([Date.parse(row.date), value]);
        });
        if (cell.webGraphSymbol) {
          _this3.chart.tooltip.valueSuffix = cell.webGraphSymbol;
        } else {
          _this3.chart.tooltip.valueSuffix = null;
        }
        _this3.chart.title = _this3.$root.$t('statistic.' + name);
        _this3.chart.series[0] = {
          data: series,
          color: _TypeColor2.default[i],
          name: _this3.$root.$t('statistic.' + name)
        };
        _this3.chart.yAxis[0].min = 0;
        _this3.chart.yAxis[0].title.text = _this3.$root.$t('statistic.' + name);
        _this3.chart.tooltip.formatter = function () {
          if (this.series.name === acceptedPercentsName) {
            return this.series.name + ': <b>' + this.point.y + ' %</b><br>' + totals + ': <b>' + approvedAll[this.x] + '</b>';
          } else if (this.series.name === totalPercentsTotal) {
            return this.series.name + ': <b>' + this.point.y + ' </b>';
          } else {
            return this.series.name + ': <b>' + this.point.y + ' %</b>';
          }
        };
        _highcharts2.default.chart('chart-container-' + _this3.webid, _this3.chart);
        _this3.chartModal = true;
      });
    }
  }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _lodash = __webpack_require__(5);

var _vueStrap = __webpack_require__(9);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Payments',
  components: {
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default,
    modal: _vueStrap.modal
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true
      },
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      confirmModal: false,
      Helper: _Helper2.default,
      country: null,
      oldValue: {},
      ChangeValue: String,
      headColumns: [{ label: this.$root.$t('statistic.webmaster'), field: 'webmaster' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.payment_fix'), field: 'payment_fix' }, { label: this.$root.$t('statistic.last_payment'), field: 'last_payment' }, { label: this.$root.$t('statistic.average_payment'), field: 'average_payment' }, { label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }],
      rows: [],
      footColumns: {},
      exportHistiryModal: false,
      exportHeadColumns: [{ label: this.$root.$t('statistic.user'), field: 'user' }, { label: this.$root.$t('statistic.offer'), field: 'offer' }, { label: this.$root.$t('statistic.webmaster'), field: 'externalWebmaster' }, { label: this.$root.$t('statistic.date'), field: 'datetime' }, { label: this.$root.$t('statistic.fix_from'), field: 'fix_from' }, { label: this.$root.$t('statistic.fix_to'), field: 'fix_to' }],
      exportRows: [],
      exportFootColumns: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      _API2.default.getWebmasterPayments().then(function (response) {
        var statistic = {};
        var max = {
          average_payment: 0,
          last_payment: 0
        };
        var sumAveragePayment = 0;
        var countAveragePayment = 0;
        var sumBuyout = 0;
        var countBuyout = 0;
        var sumLastPayment = 0;
        var countLastPayment = 0;
        var sumPayment = 0;
        var countPayment = 0;
        var sumApproved = 0;
        var sumReturn = 0;
        var countReturn = 0;
        var sumTotal = 0;
        var countTotal = 0;
        (0, _lodash.map)(response.body, function (webmasterData, id) {
          if (parseInt(max.average_payment) < parseInt(webmasterData.average_payment)) {
            max.average_payment = webmasterData.average_payment;
          }
          if (parseInt(max.last_payment) < parseInt(webmasterData.last_payment)) {
            max.last_payment = webmasterData.last_payment;
          }
          statistic[id] = webmasterData;
          statistic[id].webmaster_id = webmasterData.externalWebmaster;
          statistic[id].average_payment = webmasterData.average_payment;
          statistic[id].buyout = webmasterData.buyout;
          statistic[id].last_payment = webmasterData.last_payment;
          statistic[id].payment = webmasterData.payment_fix;
          statistic[id].return = webmasterData.refunded;
          statistic[id].approved = webmasterData.approved;
          statistic[id].total = webmasterData.total;
        });
        var offersList = _Helper2.default.getOffersList();
        var disable = '';
        if (offersList === '') {
          disable = 'disabled';
        }
        (0, _lodash.map)(statistic, function (d) {
          sumTotal += parseInt(d.total);
          countTotal++;
          if (d.average_payment > 0) {
            sumAveragePayment += parseInt(d.average_payment);
            countAveragePayment++;
          }
          if (d.approved > 0) {
            sumApproved += parseInt(d.approved);
          }
          if (d.buyout > 0) {
            sumBuyout += parseInt(d.buyout);
            countBuyout++;
          }
          if (d.last_payment > 0) {
            sumLastPayment += parseInt(d.last_payment);
            countLastPayment++;
          }
          if (d.payment > 0) {
            sumPayment += parseInt(d.payment);
            countPayment++;
          }
          if (d.return > 0) {
            sumReturn += parseInt(d.return);
            countReturn++;
          }
          _this2.rows.push({
            webmaster: {
              value: d.webmaster_id
            },
            total: {
              value: d.total,
              bg: true
            },
            payment: {
              htmlValue: '<input class="cellInput" type="text" onchange="" ' + disable + ' value="' + d.payment + '" >',
              id: d.webmaster_id,
              oldvalue: d.payment
            },
            last_payment: {
              value: parseInt(d.last_payment),
              bgg: _Helper2.default.renderSingleGist(max.last_payment, d.last_payment)
            },
            average_payment: {
              value: parseInt(d.average_payment),
              bgg: _Helper2.default.renderSingleGist(max.average_payment, d.average_payment)
            },
            buyout: {
              value: parseInt(d.buyout),
              bgg: _Helper2.default.renderGistPart(d.approved, d.buyout),
              isCollspaned: true
            },
            buyoutPercents: {
              value: _Helper2.default.percents(d.approved, d.buyout),
              bgg: _Helper2.default.renderGistPart(d.approved, d.buyout, true)
            },
            return: {
              value: parseInt(d.return),
              bgg: _Helper2.default.renderGistPart(d.approved, d.return),
              isCollspaned: true
            },
            returnPercents: {
              value: _Helper2.default.percents(d.approved, d.return),
              bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
            }
          });
        });
        _this2.footColumns = {
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          total: {
            value: sumTotal + ' (' + _Helper2.default.average(sumTotal, countTotal) + ')'
          },
          payment: {
            value: '' + _Helper2.default.average(sumPayment, countPayment)
          },
          last_payment: {
            value: '' + _Helper2.default.average(sumLastPayment, countLastPayment)
          },
          average_payment: {
            value: '' + _Helper2.default.average(sumAveragePayment, countAveragePayment)
          },
          buyout: {
            value: sumBuyout + ' (' + _Helper2.default.average(sumBuyout, countBuyout) + ')'
          },
          buyoutPercents: {
            value: _Helper2.default.percents(sumApproved, sumBuyout)
          },
          return: {
            value: sumReturn + ' (' + _Helper2.default.average(sumReturn, countReturn) + ')'
          },
          returnPercents: {
            value: _Helper2.default.percents(sumApproved, sumReturn)
          }
        };
        _this2.$root.$emit('data_loaded');
      });
    },
    changeElem: function changeElem(cell, value) {
      this.confirmModal = true;
      this.oldValue = cell;
      this.ChangeValue = value;
    },
    confirmValue: function confirmValue(valueBool) {
      var _this3 = this;

      if (valueBool) {
        _API2.default.getWebmasterPaymentChange(this.oldValue.id, this.ChangeValue, this.oldValue.oldvalue).then(function (response) {
          _this3.calculateRows();
        });
      } else {
        this.calculateRows();
      }
      this.confirmModal = false;
    },
    toggleExportHistoryModal: function toggleExportHistoryModal() {
      var _this4 = this;

      if (!this.exportHistiryModal) {
        this.exportRows = [];
        _API2.default.getWebmasterPaymentHistory().then(function (response) {
          var orderedResponse = (0, _lodash.orderBy)(response.body, ['date'], ['ASC']);
          orderedResponse.map(function (d) {
            _this4.exportRows.push({
              user: { value: d.user, bg: true },
              offer: { value: _Helper2.default.getOfferTitle(_Storage2.default.offers, d.offer_id), bg: true },
              webmaster: { value: d.externalWebmaster, bg: true },
              date: { value: d.datetime, bg: true },
              fix_from: { value: d.fix_from, bg: true },
              fix_to: { value: d.fix_to, bg: true }
            });
          });
          _this4.exportHistiryModal = true;
        }).catch(function (response) {
          _this4.$notify({
            type: 'danger',
            title: _this4.$root.$t('verbs.error'),
            text: response.body.message ? response.body.message : response.body,
            animationType: 'velocity'
          });
        });
      } else {
        this.exportHistiryModal = false;
      }
      return false;
    },
    toggleBonusModal: function toggleBonusModal() {
      this.bonusModal = !this.bonusModal;
    }
  }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _TypeColor = __webpack_require__(8);

var _TypeColor2 = _interopRequireDefault(_TypeColor);

var _lodash = __webpack_require__(5);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _vueStrap = __webpack_require__(9);

var _highcharts = __webpack_require__(14);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Source',
  components: {
    modal: _vueStrap.modal,
    Filters: _Filters2.default,
    StatisticTable: _StatisticTable2.default
  },
  data: function data() {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byWmFilter: true,
        byWebmasterFilter: true
      },
      chartModal: false,
      isLoading: false,
      Storage: _Storage2.default,
      TypeColor: _TypeColor2.default,
      Helper: _Helper2.default,
      webid: null,
      country: null,
      headColumns: [{ label: this.$root.$t('pages.sources'), field: 'webmaster' }, { label: this.$root.$t('statistic.proportion'), field: 'proportion' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2 }, { label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2 }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2 }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2 }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2 }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2 }, { label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px' }],
      rows: [],
      footColumns: {},
      chart: {
        isBuilded: false,
        isHidden: false,
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          title: {
            text: null
          },
          tickInterval: 1
        }],
        tooltip: {
          valueSuffix: null
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m-%d}'
          }
        },
        series: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    calculateRows: function calculateRows() {
      var _this2 = this;

      this.$root.$emit('data_loading');
      this.rows = [];
      this.footColumns = {};
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getWebmasterSourceStatistic().then(function (response) {
        var sumTotal = 0;
        var count = Object(response.data).keys.length;

        (0, _lodash.map)(response.data, function (d) {
          sumTotal += parseInt(d.total);
        });
        (0, _lodash.map)(response.data, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });

        var sumProcessed = 0;
        var countProcessed = 0;
        var sumAccepted = 0;
        var countApproved = 0;
        var sumCanceled = 0;
        var countCanceled = 0;
        var sumError = 0;
        var countError = 0;
        var sumPaid = 0;
        var countPaid = 0;
        var sumReturn = 0;
        var countReturn = 0;
        var sumAverageBillLocal = 0.0;
        var sumAverageBill = 0.0;
        (0, _lodash.map)(response.data, function (d) {
          if (d.processed > 0) {
            sumProcessed += parseInt(d.processed);
            countProcessed++;
          }
          if (d.approved > 0) {
            sumAccepted += parseInt(d.approved);
            countApproved++;
            sumAverageBillLocal += parseFloat(d.average_bill_local) * d.approved;
            sumAverageBill += parseFloat(d.average_bill_usd) * d.approved;
            _this2.localCurrencySymbol = (0, _currencySymbolMap2.default)(d.local_currency);
          }
          if (d.canceled > 0) {
            sumCanceled += parseInt(d.canceled);
            countCanceled++;
          }
          if (d.error > 0) {
            sumError += parseInt(d.error);
            countError++;
          }
          if (d.paid > 0) {
            sumPaid += parseInt(d.paid);
            countPaid++;
          }
          if (d.return > 0) {
            sumReturn += parseInt(d.return);
            countReturn++;
          }
          _this2.rows.push({
            source: { isCollspaned: true, value: d.source },
            proportion: {
              value: _Helper2.default.percents(sumTotal, d.total),
              bgg: _Helper2.default.renderSingleGist(parseInt(d.total), parseInt(d.canceled)),
              ocb: function ocb(value) {
                return _Helper2.default.getRawNumber(value);
              }
            },
            total: {
              value: d.total,
              bg: true,
              webGraph: true,
              wb: d.source
            },
            processed: {
              value: d.processed,
              bgg: _Helper2.default.renderGistPart(d.total, d.processed),
              isCollspaned: true
            },
            processedPercents: {
              value: _Helper2.default.percents(d.total, d.processed),
              bgg: _Helper2.default.renderGistPart(d.total, d.processed, true)
            },
            accepted: {
              value: d.approved,
              bgg: _Helper2.default.renderGistPart(d.total, d.approved),
              isCollspaned: true
            },
            acceptedPercents: {
              value: _Helper2.default.percents(d.total, d.approved),
              bgg: _Helper2.default.renderGistPart(d.total, d.approved, true),
              webGraph: true,
              wb: d.source,
              webGraphSymbol: '%'
            },
            paid: {
              value: d.paid,
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid),
              isCollspaned: true
            },
            paidPercents: {
              value: _Helper2.default.percents(parseInt(d.approved), parseInt(d.paid)),
              bgg: _Helper2.default.renderGistPart(d.approved, d.paid, true),
              webGraph: true,
              wb: d.source,
              webGraphSymbol: '%'
            },
            return: {
              value: d.return,
              bgg: _Helper2.default.renderGistPart(d.approved, d.return),
              isCollspaned: true
            },
            returnPercents: {
              value: _Helper2.default.percents(parseInt(d.approved), parseInt(d.return)),
              bgg: _Helper2.default.renderGistPart(d.approved, d.return, true)
            },
            averageBill: {
              value: '$ ' + d.average_bill_usd.toFixed(2),

              isCollspaned: true
            },
            averageBillLocal: {
              value: d.local_currency.split(',').length === 1 ? d.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(d.local_currency) : '-'
            },
            canceled: {
              value: d.canceled,
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled),
              isCollspaned: true
            },
            canceledPercents: {
              value: _Helper2.default.percents(parseInt(d.total), parseInt(d.canceled)),
              bgg: _Helper2.default.renderGistPart(d.total, d.canceled, true)
            },
            error: {
              value: d.error,
              bgg: _Helper2.default.renderGistPart(d.total, d.error),
              isCollspaned: true
            },
            errorPercents: {
              value: _Helper2.default.percents(parseInt(d.total), parseInt(d.error)),
              bgg: _Helper2.default.renderGistPart(d.total, d.error, true)
            },
            approvedFromValid: {
              value: d.approved_from_valid.toFixed(1) + '%'
            }
          });
        });
        _this2.footColumns = {
          label: {
            value: _this2.$root.$t('statistic.in_total')
          },
          proportion: {
            value: null
          },
          total: {
            value: sumTotal + ' (' + _Helper2.default.average(sumTotal, count) + ')'
          },
          processed: {
            value: sumProcessed + ' (' + _Helper2.default.average(sumProcessed, countProcessed) + ')'
          },
          processedPercents: {
            value: _Helper2.default.percents(sumTotal, sumProcessed)
          },
          accepted: {
            value: sumAccepted + ' (' + _Helper2.default.average(sumAccepted, countApproved) + ')'
          },
          acceptedPercents: {
            value: _Helper2.default.percents(sumTotal, sumAccepted)
          },
          paid: {
            value: sumPaid + ' (' + _Helper2.default.average(sumPaid, countPaid) + ')'
          },
          paidPercents: {
            value: _Helper2.default.percents(sumAccepted, sumPaid)
          },
          return: {
            value: sumReturn + ' (' + _Helper2.default.average(sumReturn, countReturn) + ')'
          },
          returnPercents: {
            value: _Helper2.default.percents(sumAccepted, sumReturn)
          },
          averageBill: {
            value: _Helper2.default.averageBillDayCount(sumAverageBill, sumAccepted),
            graph: {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: '$'
            }
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(sumAverageBillLocal, sumAccepted, _this2.localCurrencySymbol) : '-',
            graph: filterCurrency.length === 1 ? {
              cb: function cb(value) {
                return _Helper2.default.getRawNumber(value);
              },
              symbol: _this2.localCurrencySymbol
            } : false
          },
          canceled: {
            value: sumCanceled + ' (' + _Helper2.default.average(sumCanceled, countCanceled) + ')'
          },
          canceledPercents: {
            value: _Helper2.default.percents(sumTotal, sumCanceled)
          },
          error: {
            value: sumError + ' (' + _Helper2.default.average(sumError, countError) + ')'
          },
          errorPercents: {
            value: _Helper2.default.percents(sumTotal, sumError)
          },
          approvedFromValid: {
            value: _Helper2.default.approvedFromValid(sumAccepted, sumTotal, sumError)
          }
        };
        _this2.$root.$emit('data_loaded');
      }).catch(function (error) {
        console.log(error);
      });
    },
    webGraph: function webGraph(cell, i) {
      var _this3 = this;

      var name = i === 'acceptedPercents' ? 'approved' : i === 'paidPercents' ? 'paid' : 'total';
      this.webid = cell.wb;
      var approvedAll = [];
      var acceptedPercentsName = this.$root.$t('statistic.approved');
      var totalPercentsTotal = this.$root.$t('statistic.total');
      var totals = this.$root.$t('verbs.total');
      _API2.default.getSourcesGraps(cell.wb).then(function (response) {
        var rows = (0, _lodash.orderBy)(response.body, [function (item) {
          return item.date.value;
        }], ['asc']);
        var series = [];
        (0, _lodash.map)(rows, function (row) {
          var value = i === 'acceptedPercents' ? _Helper2.default.percentsF(row['total'], row['approved']) : i === 'paidPercents' ? _Helper2.default.percentsF(row['approved'], row['paid']) : row['total'];
          approvedAll[Date.parse(row.date)] = row['approved'];
          series.push([Date.parse(row.date), value]);
        });
        if (cell.webGraphSymbol) {
          _this3.chart.tooltip.valueSuffix = cell.webGraphSymbol;
        } else {
          _this3.chart.tooltip.valueSuffix = null;
        }
        _this3.chart.title = _this3.$root.$t('statistic.' + name);
        _this3.chart.series[0] = {
          data: series,
          color: _TypeColor2.default[i],
          name: _this3.$root.$t('statistic.' + name)
        };
        _this3.chart.yAxis[0].min = 0;
        _this3.chart.yAxis[0].title.text = _this3.$root.$t('statistic.' + name);
        _this3.chart.tooltip.formatter = function () {
          if (this.series.name === acceptedPercentsName) {
            return this.series.name + ': <b>' + this.point.y + ' %</b><br>' + totals + ': <b>' + approvedAll[this.x] + '</b>';
          } else if (this.series.name === totalPercentsTotal) {
            return this.series.name + ': <b>' + this.point.y + ' </b>';
          } else {
            return this.series.name + ': <b>' + this.point.y + ' %</b>';
          }
        };
        _highcharts2.default.chart('chart-container-' + _this3.webid, _this3.chart);
        _this3.chartModal = true;
      });
    }
  }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _WebTabs = __webpack_require__(180);

var _WebTabs2 = _interopRequireDefault(_WebTabs);

var _StatisticTable = __webpack_require__(7);

var _StatisticTable2 = _interopRequireDefault(_StatisticTable);

var _API = __webpack_require__(3);

var _API2 = _interopRequireDefault(_API);

var _lodash = __webpack_require__(5);

var _Helper = __webpack_require__(4);

var _Helper2 = _interopRequireDefault(_Helper);

var _Storage = __webpack_require__(2);

var _Storage2 = _interopRequireDefault(_Storage);

var _fileSaver = __webpack_require__(17);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _currencySymbolMap = __webpack_require__(10);

var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Filters: _Filters2.default,
    WebTabs: _WebTabs2.default,
    StatisticTable: _StatisticTable2.default,
    Helper: _Helper2.default
  },
  data: function data() {
    return {
      isLoading: false,
      isActive: false,
      picked: 'aprove',
      isCopyNotify: false,
      filtersScope: {
        dateFilter: true,
        dateFilterSecond: true,
        offerFilter: true,
        byManualFilter: true
      },
      rows_first: [],
      rows_second: [],
      rows_difference: [],
      rows_last: [],
      rows_difference_web: [],
      rows_difference_aprove: [],
      rows_difference_web_aprove: [],
      firstFootColumns: {},
      differenceFootColumnsWeb: {},
      secondFootColumns: {},
      differenceFootColumns: {},
      lastFootColumns: {},
      headColumns: [{ label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px' }, { label: this.$root.$t('statistic.proportion'), field: 'proportion' }, { label: this.$root.$t('statistic.total'), field: 'total' }, { label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2 }, { label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2 }, { label: this.$root.$t('statistic.error'), field: 'error', colspan: 2, isActive: true }, { label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2, isActive: true }, { label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2, isActive: false }, { label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, isActive: false }],
      headColumnsDifference: [{ label: this.$root.$t('statistic.difference'), field: 'difference' }],
      headColumnsLst: [{ label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px' }, { label: this.$root.$t('statistic.proportion'), field: 'proportion' }, { label: this.$root.$t('statistic.total'), field: 'total' }],
      headColumnsLstWeb: [{ label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px' }, { label: this.$root.$t('statistic.difference'), field: 'difference' }],
      selectTask: '',
      percent: 0,
      x: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.calculateRows();
    this.$root.$on('filters_load_new_data', function () {
      _this.calculateRows();
    });
  },

  methods: {
    onSwipe: function onSwipe(e) {
      var offset = document.getElementById('swipe').offsetWidth;
      var scroll = document.getElementById('swipe').scrollWidth;
      var width = scroll - offset;
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10;
        } else {
          this.x -= e.distance / 10;
        }
        if (this.x > 0) {
          this.x = 0;
        }
        if (Math.abs(this.x) > width) {
          this.x = -width;
        }
      }
    },
    getPercent: function getPercent() {
      var _this2 = this;

      this.rows_first.forEach(function (item) {
        if (parseFloat(_this2.percent) > parseFloat(item.paidPercents.value.replace(',', '.'))) {
          item.webmaster.percentBg = true;
        } else {
          item.webmaster.percentBg = false;
        }
      });
      this.rows_second.forEach(function (item) {
        if (item.paidPercents.value && parseFloat(_this2.percent) > parseFloat(item.paidPercents.value.replace(',', '.'))) {
          item.webmaster.percentBg = true;
        } else {
          item.webmaster.percentBg = false;
        }
      });
    },
    reverseColumnsIsActive: function reverseColumnsIsActive(items) {
      items.forEach(function (item) {
        if (item.isActive === true) {
          item.isActive = false;
        } else if (item.isActive === false) {
          item.isActive = true;
        }
      });
    },
    reverseRowsIsActive: function reverseRowsIsActive(items) {
      items.forEach(function (item) {
        for (var i in item) {
          if (item[i].isActive === true) {
            item[i].isActive = false;
          } else if (item[i].isActive === false) {
            item[i].isActive = true;
          }
        }
      });
    },
    reverseFootIsActive: function reverseFootIsActive(items) {
      for (var i in items) {
        if (items[i].isActive === true) {
          items[i].isActive = false;
        } else if (items[i].isActive === false) {
          items[i].isActive = true;
        }
      }
    },
    reverseTableActive: function reverseTableActive() {
      var tableAprove = document.querySelector('.table_difference');
      var tablePaid = document.querySelector('.table_difference_aprove');
      if (!tableAprove.classList.contains('noActive')) {
        tableAprove.classList.add('noActive');
        tablePaid.classList.remove('noActive');
      } else {
        tableAprove.classList.remove('noActive');
        tablePaid.classList.add('noActive');
      }
      var tableWeb = document.querySelector('.table_difference_web');
      var tableWebAprove = document.querySelector('.table_difference_web_aprove');
      if (!tableWeb.classList.contains('noActive')) {
        tableWeb.classList.add('noActive');
        tableWebAprove.classList.remove('noActive');
      } else {
        tableWeb.classList.remove('noActive');
        tableWebAprove.classList.add('noActive');
      }
    },
    onChancgeSelect: function onChancgeSelect() {
      this.reverseRowsIsActive(this.rows_first);
      this.reverseColumnsIsActive(this.headColumns);
      this.reverseFootIsActive(this.firstFootColumns);
      this.reverseRowsIsActive(this.rows_second);
      this.reverseFootIsActive(this.secondFootColumns);
      this.reverseTableActive();
    },
    sortRows: function sortRows(arr, unsortArr, lastArr) {
      var firstPeriod = [];
      var secondPeriod = [];
      var lastPeriod = [];
      var existsValues = [];
      var existsValuesSecond = [];
      arr.sort(function (a, b) {
        if (parseInt(a.total_percent) > parseInt(b.total_percent)) {
          return -1;
        } else {
          return 1;
        }
      });
      for (var val in arr) {
        if (arr[val].total_percent >= 1) {
          firstPeriod.push(arr[val]);
        }
        if (arr[val].total_percent >= 1) {
          var arrValue = arr[val];
          existsValues.push(arrValue['wm_id']);
          var toPush = [];
          for (var unsortVal in unsortArr) {
            if (!unsortArr.hasOwnProperty(unsortVal)) {
              continue;
            }
            var unsortValue = unsortArr[unsortVal];
            if (unsortValue['wm_id'] === arrValue['wm_id']) {
              if (unsortValue.total_percent >= 1) {
                toPush = unsortValue;
                break;
              }
            }
          }
          secondPeriod.push(toPush);
        }
      }
      for (var _val in unsortArr) {
        if (!arr.hasOwnProperty(_val)) {
          continue;
        }
        if (unsortArr[_val].total_percent > 1) {
          var _unsortValue = unsortArr[_val];
          if (existsValues.indexOf(_unsortValue['wm_id']) === -1) {
            firstPeriod.push({});
            secondPeriod.push(_unsortValue);
          }
        }
      }
      var secondPeriod2 = [];
      for (var _val2 in secondPeriod) {
        var _arrValue = secondPeriod[_val2];
        existsValuesSecond.push(_arrValue['wm_id']);
        var _toPush = [];
        for (var _unsortVal in lastArr) {
          if (!lastArr.hasOwnProperty(_unsortVal)) {
            continue;
          }
          if (lastArr[_unsortVal].total_percent >= 1) {
            var _unsortValue2 = lastArr[_unsortVal];
            if (_unsortValue2['wm_id'] === _arrValue['wm_id']) {
              if (_unsortValue2.total_percent >= 1) {
                _toPush = _unsortValue2;
                break;
              }
            }
          }
        }
        secondPeriod2.push(secondPeriod[_val2]);
        lastPeriod.push(_toPush);
      }
      for (var _val3 in lastArr) {
        if (!secondPeriod2.hasOwnProperty(_val3)) {
          continue;
        }
        if (lastArr[_val3].total_percent >= 1) {
          var lastValue = lastArr[_val3];
          if (existsValuesSecond.indexOf(lastValue['wm_id']) === -1) {
            secondPeriod2.push({});
            lastPeriod.push(lastValue);
          }
        }
      }

      return [firstPeriod, secondPeriod, lastPeriod];
    },
    calculateRows: function calculateRows() {
      var _this3 = this;

      if (this.picked === 'buyout') {
        this.reverseColumnsIsActive(this.headColumns);
        this.picked = 'aprove';
      }
      document.querySelector('.table_difference_aprove').classList.add('noActive');
      document.querySelector('.table_difference').classList.remove('noActive');
      document.querySelector('.table_difference_web').classList.remove('noActive');
      document.querySelector('.table_difference_web_aprove').classList.add('noActive');
      this.$root.$emit('data_loading');
      this.rows_first = [];
      this.rows_second = [];
      this.rows_difference = [];
      this.rows_difference_aprove = [];
      this.rows_difference_web = [];
      this.rows_difference_web_aprove = [];
      this.rows_last = [];
      this.firstFootColumns = {};
      this.secondFootColumns = {};
      this.lastFootColumns = {};
      var firstPeriod = [];
      var secondPeriod = [];
      var lastPeriod = [];
      var oldArrCurrency = [];
      var newArrCurrency = [];
      _API2.default.getWebAnalysis().then(function (response) {
        var _sortRows = _this3.sortRows(response.data.first_period, response.data.second_period, response.data.last_week);

        var _sortRows2 = _slicedToArray(_sortRows, 3);

        firstPeriod = _sortRows2[0];
        secondPeriod = _sortRows2[1];
        lastPeriod = _sortRows2[2];

        var firstSumTotal = 0;
        var firstCountApproved = 0;
        var firstSumCanceled = 0;
        var firstCountCanceled = 0;
        var firstSumPaid = 0;
        var firstCountPaid = 0;
        var firstSumReturn = 0;
        var firstCountReturn = 0;
        var firstSumError = 0;
        var firstCountError = 0;
        var firstSumAverageBill = 0.0;
        var firstSumAverageBillLocal = 0.0;
        var firstSumApproved = 0;
        (0, _lodash.map)(response.data.first_period, function (d) {
          oldArrCurrency.push(d.local_currency.split(','));
          oldArrCurrency.forEach(function (array) {
            array.forEach(function (item) {
              newArrCurrency.push(item);
            });
          });
        });
        var filterCurrency = newArrCurrency.filter(function (item, index) {
          return newArrCurrency.indexOf(item) === index;
        });
        (0, _lodash.map)(response.data.first_period, function (data) {
          if (data.total > 0) {
            firstSumTotal += parseInt(data.total);
          }
          if (data.approved > 0) {
            firstSumApproved += parseInt(data.approved);
            firstSumApproved = firstSumApproved++;
            firstSumAverageBillLocal += data.average_bill_local * data.approved;
            firstSumAverageBill += data.average_bill_usd * data.approved;
            _this3.localCurrencySymbol = (0, _currencySymbolMap2.default)(data.local_currency);
          }
          if (data.canceled > 0) {
            firstSumCanceled += parseInt(data.canceled);
            firstCountCanceled++;
          }
          if (data.paid > 0) {
            firstSumPaid += parseInt(data.paid);
            firstCountPaid++;
          }
          if (data.return > 0) {
            firstSumReturn += parseInt(data.return);
            firstCountReturn++;
          }
          if (data.error > 0) {
            firstSumError += parseInt(data.error);
            firstCountError++;
          }
        });
        (0, _lodash.map)(firstPeriod, function (data) {
          _this3.rows_first.push({
            webmaster: {
              value: data.wm_id,
              percentBg: false
            },
            proportion: {
              value: data.total ? _Helper2.default.percents(firstSumTotal, data.total) : ''
            },
            total: {
              value: data.total
            },
            accepted: {
              value: data.approved,
              bgg: _Helper2.default.renderGistPart(data.total, data.approved),
              isCollspaned: true
            },
            acceptedPercents: {
              value: data.total && data.approved ? _Helper2.default.percents(data.total, data.approved) : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.approved, true)
            },
            canceled: {
              value: data.canceled ? data.canceled : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.canceled),
              isCollspaned: true
            },
            canceledPercents: {
              value: data.total && data.canceled ? _Helper2.default.percents(parseInt(data.total), parseInt(data.canceled)) : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.canceled, true)
            },
            error: {
              value: data.error ? data.error : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.error),
              isCollspaned: true,
              isActive: true
            },
            errorPercents: {
              value: data.total && data.error ? _Helper2.default.percents(parseInt(data.total), parseInt(data.error)) : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.error, true),
              isActive: true
            },
            averageBill: {
              value: data.average_bill_usd ? '$ ' + data.average_bill_usd.toFixed(2) : '-',

              isCollspaned: true,
              isActive: true
            },
            averageBillLocal: {
              value: data.local_currency && data.local_currency.split(',').length === 1 ? data.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(data.local_currency) : '-',

              isActive: true
            },
            paid: {
              value: data.paid ? data.paid : '',
              bgg: _Helper2.default.renderGistPart(data.approved, data.paid),
              isCollspaned: true,
              isActive: false
            },
            paidPercents: {
              value: data.approved && data.paid ? _Helper2.default.percents(parseInt(data.approved), parseInt(data.paid)) : '',
              bgg: _Helper2.default.renderGistPart(data.approved, data.paid, true),
              webGraph: true,
              wb: data.wm_id,
              webGraphSymbol: '%',
              isActive: false
            },
            return: {
              value: data.return ? data.return : '',
              bgg: _Helper2.default.renderGistPart(data.approved, data.return),
              isCollspaned: true,
              isActive: false
            },
            returnPercents: {
              value: data.approved && data.return ? _Helper2.default.percents(parseInt(data.approved), parseInt(data.return)) : '',
              bgg: _Helper2.default.renderGistPart(data.approved, data.return, true),
              isActive: false
            }
          });
        });
        _this3.firstFootColumns = {
          label: {
            value: _this3.$root.$t('statistic.in_total')
          },
          proportion: {
            value: null
          },
          total: {
            value: '' + firstSumTotal
          },
          accepted: {
            value: '' + firstSumApproved
          },
          acceptedPercents: {
            value: _Helper2.default.percents(firstSumTotal, firstSumApproved)
          },
          canceled: {
            value: '' + firstSumCanceled
          },
          canceledPercents: {
            value: _Helper2.default.percents(firstSumTotal, firstSumCanceled)
          },
          error: {
            value: '' + firstSumError,
            isActive: true
          },
          errorPercents: {
            value: _Helper2.default.percents(firstSumTotal, firstSumError),
            isActive: true
          },
          averageBill: {
            value: _Helper2.default.averageBillDayCount(firstSumAverageBill, firstSumApproved),
            isActive: true
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(firstSumAverageBillLocal, firstSumApproved, _this3.localCurrencySymbol) : '-',
            isActive: true
          },
          paid: {
            value: '' + firstSumPaid,
            isActive: false
          },
          paidPercents: {
            value: _Helper2.default.percents(firstSumApproved, firstSumPaid),
            isActive: false
          },
          return: {
            value: '' + firstSumReturn,
            isActive: false
          },
          returnPercents: {
            value: _Helper2.default.percents(firstSumApproved, firstSumReturn),
            isActive: false
          }
        };

        var secondSumTotal = 0;
        var secondCountApproved = 0;
        var secondSumProcessed = 0;
        var secondCountProcessed = 0;
        var secondSumCanceled = 0;
        var secondCountCanceled = 0;
        var secondSumPaid = 0;
        var secondCountPaid = 0;
        var secondSumReturn = 0;
        var secondCountReturn = 0;
        var secondSumError = 0;
        var secondCountError = 0;
        var secondSumAverageBill = 0.0;
        var secondSumAverageBillLocal = 0.0;
        var secondSumApproved = 0;
        var lastSumTotalBill = 0;
        (0, _lodash.map)(response.data.second_period, function (data) {
          if (data.total > 0) {
            secondSumTotal += parseInt(data.total);
          }
          if (data.approved > 0) {
            secondSumProcessed += parseInt(data.approved);
            secondCountProcessed = secondCountProcessed++;
          }
          if (data.canceled > 0) {
            secondSumCanceled += parseInt(data.canceled);
            secondCountCanceled++;
          }
          if (data.paid > 0) {
            secondSumPaid += parseInt(data.paid);
            secondCountPaid++;
          }
          if (data.return > 0) {
            secondSumReturn += parseInt(data.return);
            secondCountReturn++;
          }
          if (data.error > 0) {
            secondSumError += parseInt(data.error);
            secondCountError++;
          }
          if (data.approved > 0) {
            secondSumApproved += parseInt(data.approved);
            secondCountApproved++;
            secondSumAverageBillLocal += parseFloat(data.average_bill_local) * data.approved;
            secondSumAverageBill += parseFloat(data.average_bill_usd) * data.approved;
            _this3.localCurrencySymbol = (0, _currencySymbolMap2.default)(data.local_currency);
          }
        });
        (0, _lodash.map)(secondPeriod, function (data) {
          _this3.rows_second.push({
            webmaster: {
              value: data.wm_id,
              percentBg: false
            },
            proportion: {
              value: data.total ? _Helper2.default.percents(secondSumTotal, data.total) : null
            },
            total: {
              value: data.total
            },
            accepted: {
              value: data.approved ? data.approved : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.approved),
              isCollspaned: true
            },
            acceptedPercents: {
              value: data.total && data.approved ? _Helper2.default.percents(data.total, data.approved) : null,
              bgg: _Helper2.default.renderGistPart(data.total, data.approved, true)
            },
            canceled: {
              value: data.canceled ? data.canceled : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.canceled),
              isCollspaned: true
            },
            canceledPercents: {
              value: data.total && data.canceled ? _Helper2.default.percents(parseInt(data.total), parseInt(data.canceled)) : null,
              bgg: _Helper2.default.renderGistPart(data.total, data.canceled, true)
            },
            error: {
              value: data.error ? data.error : '',
              bgg: _Helper2.default.renderGistPart(data.total, data.error),
              isCollspaned: true,
              isActive: true
            },
            errorPercents: {
              value: data.total && data.error ? _Helper2.default.percents(parseInt(data.total), parseInt(data.error)) : null,
              bgg: _Helper2.default.renderGistPart(data.total, data.error, true),
              isActive: true
            },
            averageBill: {
              value: data.average_bill_usd ? '$ ' + data.average_bill_usd.toFixed(2) : '-',

              isCollspaned: true,
              isActive: true
            },
            averageBillLocal: {
              value: data.local_currency && data.local_currency.split(',').length === 1 ? data.average_bill_local.toFixed(0) + ' ' + (0, _currencySymbolMap2.default)(data.local_currency) : '-',

              isActive: true
            },
            paid: {
              value: data.paid ? data.paid : '',
              bgg: _Helper2.default.renderGistPart(data.approved, data.paid),
              isCollspaned: true,
              isActive: false
            },
            paidPercents: {
              value: data.approved && data.paid ? _Helper2.default.percents(parseInt(data.approved), parseInt(data.paid)) : null,
              bgg: _Helper2.default.renderGistPart(data.approved, data.paid, true),
              webGraph: true,
              wb: data.wm_id,
              webGraphSymbol: '%',
              isActive: false
            },
            return: {
              value: data.return ? data.return : '',
              bgg: _Helper2.default.renderGistPart(data.approved, data.return),
              isCollspaned: true,
              isActive: false
            },
            returnPercents: {
              value: data.approved && data.return ? _Helper2.default.percents(parseInt(data.approved), parseInt(data.return)) : null,
              bgg: _Helper2.default.renderGistPart(data.approved, data.return, true),
              isActive: false
            }
          });
        });
        _this3.secondFootColumns = {
          label: {
            value: _this3.$root.$t('statistic.in_total')
          },
          proportion: {
            value: null
          },
          total: {
            value: '' + secondSumTotal
          },
          accepted: {
            value: '' + secondSumProcessed
          },
          acceptedPercents: {
            value: _Helper2.default.percents(secondSumTotal, secondSumProcessed)
          },
          canceled: {
            value: '' + secondSumCanceled
          },
          canceledPercents: {
            value: _Helper2.default.percents(secondSumTotal, secondSumCanceled)
          },
          error: {
            value: '' + secondSumError,
            isActive: true
          },
          errorPercents: {
            value: _Helper2.default.percents(secondSumTotal, secondSumError),
            isActive: true
          },
          averageBill: {
            value: _Helper2.default.averageBillDayCount(secondSumAverageBill, secondSumApproved),
            isActive: true
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? _Helper2.default.newLocalAverageBill(secondSumAverageBillLocal, secondSumApproved, _this3.localCurrencySymbol) : '-',
            isActive: true
          },
          paid: {
            value: '' + secondSumPaid,
            isActive: false
          },
          paidPercents: {
            value: _Helper2.default.percents(secondSumProcessed, secondSumPaid),
            isActive: false
          },
          return: {
            value: '' + secondSumReturn,
            isActive: false
          },
          returnPercents: {
            value: _Helper2.default.percents(secondSumProcessed, secondSumReturn),
            isActive: false
          }
        };

        var value1 = (0, _lodash.map)(_this3.rows_first, function (item) {
          for (var val in item.paidPercents) {
            return parseFloat(item.paidPercents[val].replace(',', '.'));
          }
        });
        var value2 = (0, _lodash.map)(_this3.rows_second, function (item) {
          for (var val in item.paidPercents) {
            if (item.paidPercents[val]) {
              return parseFloat(item.paidPercents[val].replace(',', '.'));
            } else {
              return null;
            }
          }
        });
        var result = [];
        var Difference = function Difference(val1, val2, wm) {
          for (var i = 0; i < val2.length; i++) {
            if (val2[i]) {
              result.push({
                value: val2[i] && val1[i] ? val2[i] - val1[i] : '',
                webmaster: wm[i].wm_id
              });
            } else {
              result.push({
                value: val1[i] ? val1[i] : '',
                webmaster: wm[i].wm_id
              });
            }
          }
        };
        Difference(value1, value2, secondPeriod);
        (0, _lodash.map)(result, function (item) {
          _this3.rows_difference.push({
            difference: {
              value: item.value ? item.value.toFixed(2) + '%' : item.value,
              minusBg: item.value < 0
            }
          });
          if (item.value < 0) {
            _this3.rows_difference_web.push({
              webmaster: {
                value: item.webmaster
              },
              difference: {
                value: item.value ? item.value.toFixed(2) + '%' : item.value,
                minusBg: true
              }
            });
          }
        });

        var valueAprove1 = (0, _lodash.map)(_this3.rows_first, function (item) {
          for (var val in item.acceptedPercents) {
            return parseFloat(item.acceptedPercents[val].replace(',', '.'));
          }
        });
        var valueAprove2 = (0, _lodash.map)(_this3.rows_second, function (item) {
          for (var val in item.acceptedPercents) {
            if (item.acceptedPercents[val]) {
              return parseFloat(item.acceptedPercents[val].replace(',', '.'));
            }
          }
        });
        var resultAprove = [];
        var DefferenceAprove = function DefferenceAprove(val1, val2, wm) {
          for (var i = 0; i < val2.length; i++) {
            if (val2[i]) {
              resultAprove.push({
                value: val2[i] && val1[i] ? val2[i] - val1[i] : '',
                webmaster: wm[i].wm_id
              });
            } else {
              resultAprove.push({
                value: val1[i] ? val1[i] : '',
                webmaster: wm[i].wm_id
              });
            }
          }
        };
        DefferenceAprove(valueAprove1, valueAprove2, secondPeriod);
        (0, _lodash.map)(resultAprove, function (item) {
          _this3.rows_difference_aprove.push({
            difference: {
              value: item.value ? item.value.toFixed(2) + '%' : item.value,
              minusBg: item.value < 0
            }
          });
          if (item.value < 0) {
            _this3.rows_difference_web_aprove.push({
              webmaster: {
                value: item.webmaster
              },
              difference: {
                value: item.value ? item.value.toFixed(2) + '%' : item.value,
                minusBg: true
              }
            });
          }
        });

        (0, _lodash.map)(response.data.last_week, function (data) {
          if (data.total > 0) {
            lastSumTotalBill += parseInt(data.total);
          }
        });
        (0, _lodash.map)(lastPeriod, function (data) {
          _this3.rows_last.push({
            webmaster: {
              value: data.wm_id ? data.wm_id : ''
            },
            proportion: {
              value: data.total ? _Helper2.default.percents(lastSumTotalBill, data.total) : null
            },
            total: {
              value: data.total ? data.total : ''
            }
          });
        });
        _this3.$root.$emit('data_loaded');
      });
    },
    exportingAll: function exportingAll() {
      var classes = document.getElementsByClassName('excel');
      var doc = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>';
      (0, _lodash.map)(classes, function (cl, i) {
        doc += cl.innerHTML + '<br/>';
      });
      doc += '</body></html>';
      _fileSaver2.default.saveAs(new Blob([doc], {
        encoding: 'UTF-8',
        type: 'application/octet-stream'
      }), 'analytics-analysis.xls');
    },
    copyWebmasters: function copyWebmasters(dataArr) {
      var _this4 = this;

      var values = dataArr.map(function (obj) {
        return obj.webmaster.value;
      }).filter(Boolean).join(', ');

      navigator.clipboard.writeText(values).then(function () {
        _this4.isCopyNotify = true;

        setTimeout(function () {
          _this4.isCopyNotify = false;
        }, 3000);
      });
    }
  }
};

/***/ }),
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 41,
	"./af.js": 41,
	"./ar": 48,
	"./ar-dz": 42,
	"./ar-dz.js": 42,
	"./ar-kw": 43,
	"./ar-kw.js": 43,
	"./ar-ly": 44,
	"./ar-ly.js": 44,
	"./ar-ma": 45,
	"./ar-ma.js": 45,
	"./ar-sa": 46,
	"./ar-sa.js": 46,
	"./ar-tn": 47,
	"./ar-tn.js": 47,
	"./ar.js": 48,
	"./az": 49,
	"./az.js": 49,
	"./be": 50,
	"./be.js": 50,
	"./bg": 51,
	"./bg.js": 51,
	"./bm": 52,
	"./bm.js": 52,
	"./bn": 54,
	"./bn-bd": 53,
	"./bn-bd.js": 53,
	"./bn.js": 54,
	"./bo": 55,
	"./bo.js": 55,
	"./br": 56,
	"./br.js": 56,
	"./bs": 57,
	"./bs.js": 57,
	"./ca": 58,
	"./ca.js": 58,
	"./cs": 59,
	"./cs.js": 59,
	"./cv": 60,
	"./cv.js": 60,
	"./cy": 61,
	"./cy.js": 61,
	"./da": 62,
	"./da.js": 62,
	"./de": 65,
	"./de-at": 63,
	"./de-at.js": 63,
	"./de-ch": 64,
	"./de-ch.js": 64,
	"./de.js": 65,
	"./dv": 66,
	"./dv.js": 66,
	"./el": 67,
	"./el.js": 67,
	"./en-au": 68,
	"./en-au.js": 68,
	"./en-ca": 69,
	"./en-ca.js": 69,
	"./en-gb": 70,
	"./en-gb.js": 70,
	"./en-ie": 71,
	"./en-ie.js": 71,
	"./en-il": 72,
	"./en-il.js": 72,
	"./en-in": 73,
	"./en-in.js": 73,
	"./en-nz": 74,
	"./en-nz.js": 74,
	"./en-sg": 75,
	"./en-sg.js": 75,
	"./eo": 76,
	"./eo.js": 76,
	"./es": 80,
	"./es-do": 77,
	"./es-do.js": 77,
	"./es-mx": 78,
	"./es-mx.js": 78,
	"./es-us": 79,
	"./es-us.js": 79,
	"./es.js": 80,
	"./et": 81,
	"./et.js": 81,
	"./eu": 82,
	"./eu.js": 82,
	"./fa": 83,
	"./fa.js": 83,
	"./fi": 84,
	"./fi.js": 84,
	"./fil": 85,
	"./fil.js": 85,
	"./fo": 86,
	"./fo.js": 86,
	"./fr": 89,
	"./fr-ca": 87,
	"./fr-ca.js": 87,
	"./fr-ch": 88,
	"./fr-ch.js": 88,
	"./fr.js": 89,
	"./fy": 90,
	"./fy.js": 90,
	"./ga": 91,
	"./ga.js": 91,
	"./gd": 92,
	"./gd.js": 92,
	"./gl": 93,
	"./gl.js": 93,
	"./gom-deva": 94,
	"./gom-deva.js": 94,
	"./gom-latn": 95,
	"./gom-latn.js": 95,
	"./gu": 96,
	"./gu.js": 96,
	"./he": 97,
	"./he.js": 97,
	"./hi": 98,
	"./hi.js": 98,
	"./hr": 99,
	"./hr.js": 99,
	"./hu": 100,
	"./hu.js": 100,
	"./hy-am": 101,
	"./hy-am.js": 101,
	"./id": 102,
	"./id.js": 102,
	"./is": 103,
	"./is.js": 103,
	"./it": 105,
	"./it-ch": 104,
	"./it-ch.js": 104,
	"./it.js": 105,
	"./ja": 106,
	"./ja.js": 106,
	"./jv": 107,
	"./jv.js": 107,
	"./ka": 108,
	"./ka.js": 108,
	"./kk": 109,
	"./kk.js": 109,
	"./km": 110,
	"./km.js": 110,
	"./kn": 111,
	"./kn.js": 111,
	"./ko": 112,
	"./ko.js": 112,
	"./ku": 113,
	"./ku.js": 113,
	"./ky": 114,
	"./ky.js": 114,
	"./lb": 115,
	"./lb.js": 115,
	"./lo": 116,
	"./lo.js": 116,
	"./lt": 117,
	"./lt.js": 117,
	"./lv": 118,
	"./lv.js": 118,
	"./me": 119,
	"./me.js": 119,
	"./mi": 120,
	"./mi.js": 120,
	"./mk": 121,
	"./mk.js": 121,
	"./ml": 122,
	"./ml.js": 122,
	"./mn": 123,
	"./mn.js": 123,
	"./mr": 124,
	"./mr.js": 124,
	"./ms": 126,
	"./ms-my": 125,
	"./ms-my.js": 125,
	"./ms.js": 126,
	"./mt": 127,
	"./mt.js": 127,
	"./my": 128,
	"./my.js": 128,
	"./nb": 129,
	"./nb.js": 129,
	"./ne": 130,
	"./ne.js": 130,
	"./nl": 132,
	"./nl-be": 131,
	"./nl-be.js": 131,
	"./nl.js": 132,
	"./nn": 133,
	"./nn.js": 133,
	"./oc-lnc": 134,
	"./oc-lnc.js": 134,
	"./pa-in": 135,
	"./pa-in.js": 135,
	"./pl": 136,
	"./pl.js": 136,
	"./pt": 138,
	"./pt-br": 137,
	"./pt-br.js": 137,
	"./pt.js": 138,
	"./ro": 139,
	"./ro.js": 139,
	"./ru": 140,
	"./ru.js": 140,
	"./sd": 141,
	"./sd.js": 141,
	"./se": 142,
	"./se.js": 142,
	"./si": 143,
	"./si.js": 143,
	"./sk": 144,
	"./sk.js": 144,
	"./sl": 145,
	"./sl.js": 145,
	"./sq": 146,
	"./sq.js": 146,
	"./sr": 148,
	"./sr-cyrl": 147,
	"./sr-cyrl.js": 147,
	"./sr.js": 148,
	"./ss": 149,
	"./ss.js": 149,
	"./sv": 150,
	"./sv.js": 150,
	"./sw": 151,
	"./sw.js": 151,
	"./ta": 152,
	"./ta.js": 152,
	"./te": 153,
	"./te.js": 153,
	"./tet": 154,
	"./tet.js": 154,
	"./tg": 155,
	"./tg.js": 155,
	"./th": 156,
	"./th.js": 156,
	"./tk": 157,
	"./tk.js": 157,
	"./tl-ph": 158,
	"./tl-ph.js": 158,
	"./tlh": 159,
	"./tlh.js": 159,
	"./tr": 160,
	"./tr.js": 160,
	"./tzl": 161,
	"./tzl.js": 161,
	"./tzm": 163,
	"./tzm-latn": 162,
	"./tzm-latn.js": 162,
	"./tzm.js": 163,
	"./ug-cn": 164,
	"./ug-cn.js": 164,
	"./uk": 165,
	"./uk.js": 165,
	"./ur": 166,
	"./ur.js": 166,
	"./uz": 168,
	"./uz-latn": 167,
	"./uz-latn.js": 167,
	"./uz.js": 168,
	"./vi": 169,
	"./vi.js": 169,
	"./x-pseudo": 170,
	"./x-pseudo.js": 170,
	"./yo": 171,
	"./yo.js": 171,
	"./zh-cn": 172,
	"./zh-cn.js": 172,
	"./zh-hk": 173,
	"./zh-hk.js": 173,
	"./zh-mo": 174,
	"./zh-mo.js": 174,
	"./zh-tw": 175,
	"./zh-tw.js": 175
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(589),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(601),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(500),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(515),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e5082692",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(585),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(579),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72a8d37c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(563),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09129ecc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(568),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66c6b984",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(564),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(520),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d616976",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(602),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(572),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b2a8870",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(591),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30c3b954",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(533),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(514),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(570),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68f44d2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(573),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(542),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(551),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d4cd1a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(582),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(547),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(557),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(575),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e239866",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(574),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c9b8936",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(583),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36a3e937",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-042d8307",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(586),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(502),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2554792e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ceaee202",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(593),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f96d392",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(499),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0036ce6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2941f4f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(501),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01867062",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-052c7dbc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(581),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(571),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69c45af9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f9c56b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(578),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-729da737",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(503),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(548),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(577),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e0fb2a5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a664574a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-348aa62a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e3cb9ffc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(400)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(603),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34edc800",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn new_orders"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('operators-conversion-tabs'), _vm._v(" "), _c('div', {
    staticClass: "container__table",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, _vm._l((_vm.rows), function(dataWeek, indexWeek) {
    return _c('div', {
      staticClass: "statistic-wrap"
    }, [_c('div', {
      staticClass: "card statistic-table"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n              " + _vm._s(_vm.getWeekDaysByWeekNumber(indexWeek)) + "\n              "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [(_vm.headColumns) ? _c('tr', _vm._l((_vm.headColumns), function(col) {
      return _c('th', {
        style: ({
          background: col.color
        }),
        attrs: {
          "colspan": col.colspan
        }
      }, [_vm._v(_vm._s(col.label))])
    })) : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((dataWeek), function(row) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "background": "#e0e0e0"
        }
      }, [_vm._v(_vm._s(_vm.operatorsReturn(row.operator_id)))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#81c784"
        }
      }, [_vm._v(_vm._s(row.approved))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((row.total - row.paid) > 0 ? ((row.approved / (row.total - row.paid)) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#b9f6ca"
        }
      }, [_vm._v(_vm._s(row.paid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.approved > 0 ? ((row.paid / row.approved) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.total_buyout_usd > 0 ? '$ ' + (row.total_buyout_usd / row.paid).toFixed(2) : '$ 0.00'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.local_currency.split(',').length === 1 ? ((row.total_buyout_local) + " " + (_vm.localCurrency(row.local_currency))) : '-'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#ffd96a",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.approved > 0 ? '$ ' + ((row.total_buyout_usd * ((row.paid / row.approved) * 100)) / 100).toFixed(2) : '$ 0.00'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#60b3f6",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(row.total_buyout_usd > 0 ? '$ ' + (row.paid * (row.total_buyout_usd / row.paid)).toFixed(2) : '$ 0.00'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#8fbc8f",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s(_vm.approvedFromValid(row.approved, row.total, row.spam)))])])
    })), _vm._v(" "), _c('tfoot', _vm._l((dataWeek.total), function(row) {
      return _c('tr', [_c('th', {
        staticStyle: {
          "background": "#e0e0e0"
        }
      }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#81c784"
        }
      }, [_vm._v(_vm._s(row.approved))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.total > 0 ? ((row.approved / (row.total - row.paid)) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#b9f6ca"
        }
      }, [_vm._v(_vm._s(row.paid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.approved > 0 ? ((row.paid / row.approved) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff"
        }
      }, [_vm._v(_vm._s(row.total_bill))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#bae0ff"
        }
      }, [_vm._v(_vm._s(row.total_local))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#ffd96a"
        }
      }, [_vm._v(_vm._s('$ ' + row.total_revenue))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#60b3f6",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s('$ ' + row.total_all_average))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background": "#8fbc8f",
          "white-space": "nowrap"
        }
      }, [_vm._v(_vm._s('$ ' + row.approvedFromValid))])])
    }))], 1)])])])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-actions"
  }, [_c('button', {
    staticClass: "btn-close"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])])
}]}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'card card-inverse differency-card card-' + _vm.color
  }, [_c('div', {
    staticClass: "card-header",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    }
  }, [_c('i', {
    class: ' pull-left fa fa-' + _vm.icon,
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), (_vm.title === 'Средний чек') ? _c('span', {
    staticClass: "average_title",
    on: {
      "click": _vm.idPopupAllCountry
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    class: (_vm.$root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag',
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    }
  }, [(!_vm.calculate) ? _c('span', {
    class: (_vm.$root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag'
  }, [_vm._v(_vm._s(_vm.average) + _vm._s(_vm.symbol))]) : _vm._e(), _vm._v(" "), (_vm.calculate) ? _c('span', {
    class: (_vm.$root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag'
  }, [_vm._v(_vm._s(_vm.average) + _vm._s(_vm.symbol) + "\n            "), _c('span', {
    class: (_vm.$root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag'
  }, [_c('i', {
    style: (_vm.diffStyle(_vm.average))
  }, [_vm._v(_vm._s(_vm.diffSymbol(_vm.average)))])])]) : _vm._e()])]), _vm._v(" "), (_vm.isLeads) ? _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-6",
    staticStyle: {
      "margin": "0 6%"
    }
  }, [_c('table', {
    staticClass: "table d-none d-sm-block d-md-block d-lg-block",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "10px",
      "border": "none"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px",
      "border": "none"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "font-size": "10px",
      "border": "none",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.sort('limit')
      }
    }
  }, [_vm._v("Лимит"), _c('br'), _vm._v(" КЦ")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "font-size": "10px",
      "border": "none",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.sort('weekAverage')
      }
    }
  }, [_vm._v("Трафик "), _c('br'), _vm._v("за неделю")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "font-size": "10px",
      "border": "none",
      "vertical-align": "middle"
    },
    on: {
      "click": function($event) {
        _vm.sort('difference')
      }
    }
  }, [_vm._v("Разница")])])])])]), _vm._v(" "), _vm._l((_vm.preparedData), function(line) {
    return _c('div', {
      staticClass: "row differency-table",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "border-bottom": "1px solid rgba(0, 0, 0, 0.1)"
      }
    }, [_c('div', {
      staticClass: "col-6 backed",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "display": "block",
        "border-bottom": "none"
      }
    }, [_c('i', {
      staticClass: "flag",
      class: 'flag-' + line.country_code
    }), _vm._v(" "), _c('div', {
      staticClass: "country-name",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "float": "left"
      }
    }, [_vm._v(_vm._s(_vm.$t('country.' + line.country_id)))]), _vm._v(" "), _c('div', {
      staticClass: "leadsLimit d-none d-sm-block d-md-block d-lg-block",
      staticStyle: {
        "position": "absolute",
        "top": "5px",
        "left": "130px"
      }
    }, [_c('small', [_vm._v(_vm._s(line.limit))])]), _vm._v(" "), _c('div', {
      staticClass: "avarege d-none d-sm-block d-md-block d-lg-block",
      staticStyle: {
        "position": "absolute",
        "top": "5px",
        "left": "200px"
      }
    }, [_c('small', [_vm._v(_vm._s(line.weekAverage))])]), _vm._v(" "), _c('div', {
      staticClass: "different d-none d-sm-block d-md-block d-lg-block",
      staticStyle: {
        "position": "absolute",
        "top": "5px",
        "left": "272px"
      }
    }, [_c('small', [_vm._v(_vm._s(line.weekAverage - line.limit))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "pull-right gist",
      class: line.average ? 'i-spaced' : null,
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "display": "block",
        "max-width": "70px",
        "line-height": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "overflow": "hidden",
        "display": "block"
      }
    }, [_c('small', [_vm._v(_vm._s(line.diff) + _vm._s(_vm.symbol) + "\n                            "), _c('i', {
      style: (_vm.diffStyle(line.diff))
    }, [_vm._v(_vm._s(_vm.diffSymbol(line.diff)))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "overflow": "hidden",
        "display": "block"
      }
    }, [(line.average) ? _c('i', {
      style: (_vm.diffStyle(line.total - line.average))
    }, [_c('small', [_vm._v(_vm._s(line.total - line.average))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 gisted nobr",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "overflow": "hidden",
        "display": "block"
      },
      style: (_vm.renderGist(line))
    }, [_c('span', {
      staticClass: "pull-right gist total"
    }, [_c('small', [_c('strong', [_vm._v(_vm._s(line.total) + _vm._s(_vm.symbol))])])])])])
  })], 2) : _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap",
      "display": "block"
    }
  }, _vm._l((_vm.preparedData), function(line) {
    return _c('div', {
      staticClass: "row differency-table",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_c('div', {
      staticClass: "col-9 backed",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "display": "block"
      }
    }, [_c('i', {
      staticClass: "flag",
      class: 'flag-' + line.country_code
    }), _vm._v(" "), _c('div', {
      staticClass: "country-name",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "float": "left",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.isPopup(line.country_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('country.' + line.country_id )))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right gist",
      class: line.average ? 'i-spaced' : null,
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "display": "block"
      }
    }, [_c('div', {
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "overflow": "hidden",
        "display": "block"
      }
    }, [_c('small', [_vm._v(_vm._s(line.diff) + _vm._s(_vm.symbol) + " "), _c('i', {
      style: (_vm.diffStyle(line.diff))
    }, [_vm._v(_vm._s(_vm.diffSymbol(line.diff)))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "overflow": "hidden",
        "display": "block"
      }
    }, [(line.average) ? _c('i', {
      style: (_vm.diffStyle(line.total - line.average))
    }, [_c('small', [_vm._v(_vm._s(line.total - line.average))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 gisted nobr bl",
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap",
        "overflow": "hidden",
        "display": "block"
      },
      style: (_vm.renderGist(line))
    }, [_c('span', {
      staticClass: "pull-right gist total"
    }, [_c('small', [_c('strong', [_vm._v(_vm._s(line.total) + _vm._s(_vm.symbol))])])])])])
  })), _vm._v(" "), _c('modal', {
    attrs: {
      "large": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.chartModalDif),
      callback: function($$v) {
        _vm.chartModalDif = $$v
      },
      expression: "chartModalDif"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "color": "#000",
      "width": "100%",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.titleAverage) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    attrs: {
      "id": "dash-chart-traffic-dif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chartModalDif = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ringing-tabs'), _vm._v(" "), _c('form', {
    attrs: {
      "id": "formCall"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cel"
  }, [_c('strong', [_vm._v("Тариф смс: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sms),
      expression: "sms"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sms = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "cel"
  }, [_c('strong', [_vm._v("Стоимость 1 минуты: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call),
      expression: "call"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.call = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.sent_sms_template')))
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 apply-buttons"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("\n                  Сохранить\n                ")])])])])
}]}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('StatisticTable', {
    ref: "statisticTable",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.order')))
    },
    on: {
      "isPopup": _vm.isPopup
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('modal', {
    attrs: {
      "large": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.exportHistiryModal),
      callback: function($$v) {
        _vm.exportHistiryModal = $$v
      },
      expression: "exportHistiryModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.exportHeadColumns,
      "footColumns": _vm.exportFootColumns,
      "rows": _vm.exportRows,
      "title": ("" + (_vm.$t('statistic.payment_history')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportHistiryModal = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('verbs.close')) + "\n            ")])])], 1), _vm._v(" "), _c('OrderTable', {
    key: 'order-table-remnants',
    attrs: {
      "title": ("" + (_vm.$t('pages.remnants'))),
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "disableActionBTN": true,
      "isLoading": _vm.loading,
      "idElem": 'remnants'
    },
    on: {
      "changeVal": _vm.changeVal
    }
  }, [_c('template', {
    slot: "table-actions"
  }, [_c('button', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.toggleExportHistoryModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "logout-message",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                        "), _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _c('div', {
    staticClass: "card statistic-table"
  }, [(_vm.allCountry) ? _c('div', _vm._l((_vm.rowsAll), function(rowsDate, indexCountry) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "40px"
      }
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n                        " + _vm._s(_vm.Helper.findCountryName(indexCountry)) + "\n                    ")]), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Дата")]), _vm._v(" "), _vm._l((_vm.headColumnsAll), function(cell) {
      return (cell[indexCountry]) ? _c('th', {
        attrs: {
          "colspan": cell.colspan
        }
      }, [_vm._v(_vm._s(cell[indexCountry]))]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('tbody', _vm._l((rowsDate), function(row, i) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(i))]), _vm._v(" "), _vm._l((_vm.headColumnsAll), function(col) {
        return (col[indexCountry]) ? _c('td', [(row[col[indexCountry]]) ? _c('span', [_vm._v(_vm._s(row[col[indexCountry]]) + "%")]) : _c('span', [_vm._v(" - ")])]) : _vm._e()
      })], 2)
    }))])])
  })) : _c('div', [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('pages.approved_during_the_day')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block card-zz"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Дата")]), _vm._v(" "), _vm._l((_vm.headColumns), function(col) {
    return _c('th', {
      attrs: {
        "colspan": col.colspan
      }
    }, [_vm._v(_vm._s(col.label) + "ч.")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i))]), _vm._v(" "), _vm._l((_vm.headColumns), function(col) {
      return _c('td', {
        staticStyle: {
          "position": "relative"
        },
        on: {
          "mouseover": function($event) {
            _vm.mouseOver(row[col.label].approved, row[col.label].total, $event)
          },
          "mouseleave": function($event) {
            _vm.mouseleave(row[col.label].approved, row[col.label].total, $event)
          }
        }
      }, [(row[col.label]) ? _c('span', [_vm._v("\n                                " + _vm._s(row[col.label].data) + "%\n                                ")]) : _c('span', {
        staticClass: "no-tool"
      }, [_vm._v(" - ")]), _vm._v(" "), _c('span', {
        staticClass: "tool"
      }, [_vm._v("\n                                    " + _vm._s(this.approved) + "\n                                ")])])
    })], 2)
  })), _vm._v(" "), _c('tfoot')], 1)])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "small": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.confirmModal),
      callback: function($$v) {
        _vm.confirmModal = $$v
      },
      expression: "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.5em",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('verbs.edit')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmValue(true)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('verbs.apply')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmValue(false)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('verbs.close')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "formRent"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cel"
  }, [_c('strong', [_vm._v("КЦ")]), _vm._v(" " + _vm._s(_vm.reskc))]), _vm._v(" "), _c('td', {
    staticClass: "cel"
  }, [_c('strong', [_vm._v("Доставка")]), _vm._v(" " + _vm._s(_vm.resdoc))]), _vm._v(" "), _c('td', {
    staticClass: "cel"
  }, [_c('strong', [_vm._v("Возвраты")]), _vm._v(" " + _vm._s(_vm.resVozv))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('StatisticTable', {
    ref: "statisticTable",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.offer_rent')))
    },
    on: {
      "changeElem": _vm.changeElem
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 apply-buttons"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("\n                    Сохранить\n                  ")])])])])
}]}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "effect": "fade/zoom",
      "small": "",
      "title": ""
    },
    model: {
      value: (_vm.confirmModal),
      callback: function($$v) {
        _vm.confirmModal = $$v
      },
      expression: "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.5em",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.expiration_date')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "card card-default filters card-modal"
  }, [_c('div', {
    staticClass: "card-modal"
  }, [(_vm.errorsByOrder.length) ? _c('div', {
    staticClass: "error"
  }, [_c('b', [_vm._v("Пожалуйста исправьте указанные ошибки:")]), _vm._v(" "), _c('ul', _vm._l((_vm.errorsByOrder), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row date-filter"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.expiration_date'),
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.expiration),
      callback: function($$v) {
        _vm.expiration = $$v
      },
      expression: "expiration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 pad-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customs),
      expression: "customs"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.customs'),
      "name": "customs",
      "type": "text"
    },
    domProps: {
      "value": (_vm.customs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 pad-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logistics),
      expression: "logistics"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.logistic'),
      "name": "customs",
      "type": "text"
    },
    domProps: {
      "value": (_vm.logistics)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.logistics = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 filter-buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.addExpiration
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('verbs.save')) + "\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  })]), _vm._v(" "), _c('ProductTabs'), _vm._v(" "), _c('div', {
    staticClass: "card card-default filters",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.isLoad
    },
    on: {
      "click": function($event) {
        _vm.clickAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" " + _vm._s(_vm.$t('verbs.add_product')) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBlock),
      expression: "isBlock"
    }],
    staticClass: "card card-default filters"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.checkForm
    }
  }, [(_vm.errors.length) ? _c('div', {
    staticClass: "error"
  }, [_c('b', [_vm._v("Пожалуйста исправьте указанные ошибки:")]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.Storage.selectedCountry.id === -1) ? _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getGoodsAll]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.country')))]), _vm._v(" "), _vm._l((_vm.Storage.countries), function(c) {
    return (c.id !== -1) ? _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orders_count),
      expression: "form.orders_count"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.ordered'),
      "name": "orders_count",
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.orders_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.orders_count = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price),
      expression: "form.price"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.price'),
      "name": "price",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.provider),
      expression: "form.provider"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.provider'),
      "name": "provider",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.provider = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.time'),
      "format": "yyyy-MM-dd",
      "name": "delivery_time"
    },
    model: {
      value: (_vm.form.delivery_time),
      callback: function($$v) {
        _vm.form.delivery_time = $$v
      },
      expression: "form.delivery_time"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.status')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Заказан")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Отгружен")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.comment),
      expression: "form.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.comment'),
      "name": "comment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control input files",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFilesUpload($event.target.name, $event.target.files)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "clear-on-select": false,
      "close-on-select": false,
      "hide-selected": false,
      "multiple": false,
      "options": _vm.storageGoodsAll,
      "placeholder": _vm.$t('statistic.products'),
      "preserve-search": true,
      "searchable": true,
      "label": "name",
      "name": "product",
      "track-by": "name"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                                                    " + _vm._s(props.option.name) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.alias) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.form.product),
      callback: function($$v) {
        _vm.form.product = $$v
      },
      expression: "form.product"
    }
  })], 1)])]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "clear-on-select": false,
      "close-on-select": false,
      "hide-selected": false,
      "multiple": false,
      "options": _vm.Storage.goods,
      "placeholder": _vm.$t('statistic.products'),
      "preserve-search": true,
      "searchable": true,
      "label": "name",
      "name": "product",
      "track-by": "name"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                                                    " + _vm._s(props.option.name) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.alias) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.form.product),
      callback: function($$v) {
        _vm.form.product = $$v
      },
      expression: "form.product"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orders_count),
      expression: "form.orders_count"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.ordered'),
      "name": "orders_count",
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.orders_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.orders_count = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price),
      expression: "form.price"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.price'),
      "name": "price",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.provider),
      expression: "form.provider"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.provider'),
      "name": "provider",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.provider = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.time'),
      "format": "yyyy-MM-dd",
      "name": "delivery_time"
    },
    model: {
      value: (_vm.form.delivery_time),
      callback: function($$v) {
        _vm.form.delivery_time = $$v
      },
      expression: "form.delivery_time"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.status')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Заказан")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Отгружен")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.comment),
      expression: "form.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.comment'),
      "name": "comment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control input files",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFilesUpload($event.target.name, $event.target.files)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 pad-top"
  }, [_c('button', {
    staticClass: "btn btn-primary float-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Отправить")])])])])])]), _vm._v(" "), _c('ProductOrders', {
    attrs: {
      "loading": _vm.loadingProduct,
      "rowsOrder": _vm.rowsOrder
    },
    on: {
      "addReceipt": _vm.addReceipt,
      "changeVal": _vm.changeVal,
      "deleteChange": _vm.deleteChange,
      "download": _vm.download,
      "downloadAll": _vm.downloadAll,
      "uploadImage": _vm.uploadImageOrder
    }
  }), _vm._v(" "), _c('ReceiptOrders', {
    attrs: {
      "loading": _vm.loadingProduct,
      "rowsReceipt": _vm.rowsReceipt
    },
    on: {
      "changeVal": _vm.changeVal,
      "uploadImageReceipt": _vm.uploadImageReceipt,
      "downloadAllReceipt": _vm.downloadAllReceipt,
      "downloadPdfReceipt": _vm.downloadPdfReceipt
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary float-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Отправить")])])
}]}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center",
    attrs: {
      "id": "login-form"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: _vm.error ? 'input-group mb-3 has-danger has-feedback' : 'input-group mb-3'
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.code),
      expression: "credentials.code"
    }],
    class: _vm.error ? 'form-control form-control-danger' : 'form-control',
    attrs: {
      "type": "text",
      "placeholder": _vm.$t("auth.key"),
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                                        " + _vm._s(_vm.error) + "\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "button",
      "disabled": this.authLoading
    },
    on: {
      "click": function($event) {
        _vm.redirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("auth.login_action")) + " "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.authLoading),
      expression: "this.authLoading"
    }],
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('Language')], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
}]}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row webmaster-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "webmaster_hash",
      "options": _vm.Storage.webmasters,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('filter.webmaster'),
      "label": "webmaster_hash",
      "searchable": true,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n              " + _vm._s(props.option.webmaster_hash) + " (" + _vm._s(props.option.web_login) + ")\n           ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.selectedWebmaster),
      callback: function($$v) {
        _vm.Storage.selectedWebmaster = $$v
      },
      expression: "Storage.selectedWebmaster"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('label', [_vm._v("По дате прихода")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateReceiptFrom),
      callback: function($$v) {
        _vm.Storage.selectedDateReceiptFrom = $$v
      },
      expression: "Storage.selectedDateReceiptFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateReceiptTo),
      callback: function($$v) {
        _vm.Storage.selectedDateReceiptTo = $$v
      },
      expression: "Storage.selectedDateReceiptTo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info reset reset-receipt",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('dropdown', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('template', {
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('filters.period')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.yesterday
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.yesterday')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.week
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.week')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.thisMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.this_month')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.lastMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.last_month')))])])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds/return_by_month',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ref_return_by_month')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds/cancel_by_month',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ref_cancel_by_month')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds/cancel_operators',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ref_cancel_operators')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/dashboard'
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.dashboard')) + "\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('pages.statistic')) + "\n            ")]), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.CONVERSIONS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/country'
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.conversions')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS) || _vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS_PAYMENTS)) ? _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": '/statistic/webmasters',
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-internet-explorer"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.webmasters')) + "\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [(_vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.webmaster_statistic')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS_PAYMENTS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/payments',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.individual_rates')))])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/source',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.source_statistic')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/landing',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.landing_statistic')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/arrival_new_leads\n',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.arrival_new_leads')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/grid',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.grid_statistic')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OFFER_RENTABILITY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/offer'
    }
  }, [_c('i', {
    staticClass: "fa fa-percent"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.offer')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.RETURN_REASON)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds'
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.refunds')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.BUYOUT)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout'
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.buyout')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_EFFICIENCY) || _vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_ACTIVITY) || _vm.haveAccess(_vm.Config.STATISTICS.ORDER_PROCESSING)) ? _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": '/statistic/operators',
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.operators')) + "\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [(_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_EFFICIENCY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/efficiency',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.efficiency')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_ACTIVITY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/activity',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.activity')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.ORDER_PROCESSING)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/order',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.order')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_SUMMARY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/conversion',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.conversion')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OFFER_ACTIVITY_STATISTIC)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/schedule',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.approved_during_the_day')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.EXPENSE_EXPECTION)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/expenses_kc',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.expenses_by_kc')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.CALL_CENTER_TIMINGS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/timing_kc',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.timing_kc')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.EXPENSE_EXPECTION)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/ringing_sms',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ringing_sms')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/call_statistics',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.call_statistics')) + "\n                        ")])], 1), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.HOLD_CALLS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/ringing_holds',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ringing_holds')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/cross_sell',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.cross_sell')) + "\n                    ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product'
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.product')) + "\n                ")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('AlphabetScroll', {
    attrs: {
      "alphabet": _vm.alphabet,
      "context": this,
      "scrollPos": _vm.scrollPos
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "offer-scroll animated fadeIn"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "letter-block",
      attrs: {
        "id": ("letter-" + (letter.letter))
      }
    }, _vm._l((_vm.rows[letter.letter]), function(row) {
      return (_vm.Helper.getOfferTitle(_vm.offers, row.id)) ? _c('StatisticTable', {
        key: row.id,
        attrs: {
          "title": ((_vm.Helper.getOfferTitle(_vm.offers, row.id)) + " (" + (row.id) + ")"),
          "headColumns": _vm.headColumns,
          "footColumns": _vm.footColumns[row.id],
          "rows": row.cells
        }
      }) : _vm._e()
    }))
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.changelog')))]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('ul', {
    staticClass: "nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.selecteds == 1
    },
    on: {
      "click": function($event) {
        _vm.showlistclick(1)
      }
    }
  }, [_c('span', [_vm._v("Backend")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.selecteds == 2
    },
    on: {
      "click": function($event) {
        _vm.showlistclick(2)
      }
    }
  }, [_c('span', [_vm._v("Frontend")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-contents",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('table', {
    staticClass: "datatable"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', [_vm._v(_vm._s(log.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.by_user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.text))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": log.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(log.link))])])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Дата")]), _vm._v(" "), _c('th', [_vm._v("Кто сделал")]), _vm._v(" "), _c('th', [_vm._v("Текст")]), _vm._v(" "), _c('th', [_vm._v("Ссылка")])])])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('h1', {
    staticClass: "float-left display-3 mr-4"
  }, [_vm._v("404")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Ой! Вы потерялись =(")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Данная страницы нет, но есть "), _c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("главная")]), _vm._v(".")], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n        ☰\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto profile"
  }, [_c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": _vm.Auth.user.profile.photo_small,
      "alt": _vm.Auth.user.profile.email
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.Auth.user.profile.first_name) + " " + _vm._s(_vm.Auth.user.profile.last_name))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    slot: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('auth.account')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": '/account/profile'
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                            " + _vm._s(_vm.$t('auth.profile')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.$t('auth.logout')))])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center animated fadeIn",
    attrs: {
      "id": "login-form"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                                " + _vm._s(_vm.error) + "\n                            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "logout-message"
  }, [_vm._v(_vm._s(_vm.$t('message.loading')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "logout-message"
  }, [_vm._v(_vm._s(_vm.step) + "/" + _vm._s(_vm.total))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row date-filter date-filter-second pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateFromSecond),
      callback: function($$v) {
        _vm.Storage.selectedDateFromSecond = $$v
      },
      expression: "Storage.selectedDateFromSecond"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateToSecond),
      callback: function($$v) {
        _vm.Storage.selectedDateToSecond = $$v
      },
      expression: "Storage.selectedDateToSecond"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info reset",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('dropdown', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('template', {
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('filters.period')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.yesterday
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.yesterday')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.week
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.week')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.thisMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.this_month')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.lastMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.last_month')))])])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "name",
      "options": _vm.Storage.webNewFilter,
      "multiple": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('statistic.webmaster'),
      "label": "name",
      "searchable": true,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n           " + _vm._s(props.option.name) + "\n          ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.webNewSelectedFilter),
      callback: function($$v) {
        _vm.Storage.webNewSelectedFilter = $$v
      },
      expression: "Storage.webNewSelectedFilter"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    attrs: {
      "id": ("chart-container-" + _vm.id)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row operator-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "login",
      "options": _vm.Storage.operators,
      "multiple": true,
      "searchable": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('statistic.operators'),
      "label": "login",
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                       " + _vm._s(props.option.login) + " " + _vm._s(!props.option.name ? null : ("(" + (props.option.name) + ")")) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.id) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.Storage.selectedOperator),
      callback: function($$v) {
        _vm.Storage.selectedOperator = $$v
      },
      expression: "Storage.selectedOperator"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.selectAll
    }
  }, [_c('i', {
    staticClass: "fa fa-reply-all"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.select_all')) + "\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_vm._v("\n    © " + _vm._s(_vm.date) + " LeadGroup. \n    "), _c('span', {
    staticClass: "float-right",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('statistic.last_version')) + ":")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": '/pages/versions'
    }
  }, [_vm._v(_vm._s(_vm.lastVersion))])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('statistic.last_update')) + ":")]), _vm._v(" "), (_vm.Storage.developMode) ? _c('span', [_c('router-link', {
    attrs: {
      "to": '/pages/changelog'
    }
  }, [_vm._v(_vm._s(_vm.lastUpdate))])], 1) : _c('span', [_vm._v(_vm._s(_vm.lastUpdate))])])])
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/efficiency',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.efficiency')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/operators_analysis',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.operators_analysis')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-select"
  }, [_c('button', {
    staticClass: "flag flag-ru",
    on: {
      "click": function($event) {
        _vm.chooseLanguage('ru')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "flag flag-us",
    on: {
      "click": function($event) {
        _vm.chooseLanguage('en')
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn month"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_vm._l((_vm.totalAllColumns), function(indexMonth, indexYear) {
    return _c('div', {
      directives: [{
        name: "hammer",
        rawName: "v-hammer:pan",
        value: (_vm.onSwipe),
        expression: "onSwipe",
        arg: "pan"
      }],
      key: indexYear,
      staticStyle: {
        "display": "flex",
        "flex-wrap": "nowrap"
      },
      style: ({
        'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
      }),
      attrs: {
        "id": "swipe1"
      }
    }, _vm._l((indexMonth), function(rowsMonth, indexCourier, index) {
      return _c('div', {
        key: (indexYear + "_" + indexCourier),
        staticStyle: {
          "flex": "0 0 880px"
        }
      }, [_c('div', {
        staticClass: " statistic-table",
        staticStyle: {
          "margin-bottom": "0"
        }
      }, [_c('div', {
        staticClass: "card-header"
      }, [_vm._v("\n              " + _vm._s(_vm.month[indexCourier - 1]) + " " + _vm._s(indexYear) + " г."), _c('br')]), _vm._v(" "), _c('TemporaryTable', {
        attrs: {
          "className": (([indexYear]) + "-" + (_vm.month[indexCourier - 1])),
          "headColumns": _vm.headColumnsTotal,
          "rows": [],
          "footColumns": _vm.totalAllColumns[indexYear][indexCourier][0],
          "totalColumnsDd": _vm.totalCourier[indexYear][indexCourier],
          "title": ("" + (_vm.$t('statistic.in_total')))
        }
      })], 1)])
    }))
  }), _vm._v(" "), _vm._l((_vm.rows), function(rowsCourier, indexYear) {
    return _c('div', {
      directives: [{
        name: "hammer",
        rawName: "v-hammer:pan",
        value: (_vm.onSwipe),
        expression: "onSwipe",
        arg: "pan"
      }],
      key: indexYear,
      style: ({
        'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
      }),
      attrs: {
        "id": "swipe"
      }
    }, _vm._l((rowsCourier), function(rowsMonth, indexCourier, index) {
      return _c('div', {
        key: (indexYear + "_" + indexCourier),
        staticStyle: {
          "display": "flex",
          "flex-wrap": "nowrap"
        }
      }, _vm._l((rowsMonth), function(rowsData, indexMonth) {
        return _c('div', {
          key: (indexYear + "_" + indexCourier + "_" + indexMonth),
          staticStyle: {
            "flex": "0 0 880px"
          }
        }, [(rowsData.length !== 0) ? _c('div', [_c('div', {
          staticClass: " statistic-table",
          staticStyle: {
            "margin-bottom": "0"
          }
        }, [_c('StatisticTable', {
          attrs: {
            "className": (([indexYear]) + "-" + ([indexMonth])),
            "footColumns": _vm.footColumns[indexYear][indexCourier][indexMonth][0],
            "headColumns": _vm.headColumns,
            "rows": rowsData,
            "title": ("" + (_vm.Helper.getOfferTitle(_vm.Storage.offers, indexCourier)))
          }
        })], 1)]) : _vm._e()])
      }))
    }))
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn new_orders"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('operators-conversion-tabs'), _vm._v(" "), _c('div', {
    staticClass: "container__table excel",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('StatisticTable', {
    ref: "statisticTable",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.new_orders')))
    },
    on: {
      "isPopup": _vm.isPopup
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('RefundsTabs'), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.ref_return')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.changeversion')))]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('div', {
    staticClass: "tab-contents",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('table', {
    staticClass: "datatable"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', [_vm._v(_vm._s(log.version))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.htmlNow(log.description))
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.by_user))])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Версия")]), _vm._v(" "), _c('th', [_vm._v("Описание")]), _vm._v(" "), _c('th', [_vm._v("Дата")]), _vm._v(" "), _c('th', [_vm._v("Кто сделал")])])])
}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/country',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_country')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/offers',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_offers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/period',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_period')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/courier',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_couriers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/graph',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_graph')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/buyout',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_pieces')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/flypost',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.buyouts_flypost')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "minimumView": 'month',
      "maximumView": 'month',
      "format": _vm.DatePickerFormat,
      "disabled": _vm.disabledDates
    },
    model: {
      value: (_vm.Storage.selectedMonthFrom),
      callback: function($$v) {
        _vm.Storage.selectedMonthFrom = $$v
      },
      expression: "Storage.selectedMonthFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "minimumView": 'month',
      "maximumView": 'month',
      "format": _vm.DatePickerFormat,
      "disabled": _vm.disabledDates
    },
    model: {
      value: (_vm.Storage.selectedMonthTo),
      callback: function($$v) {
        _vm.Storage.selectedMonthTo = $$v
      },
      expression: "Storage.selectedMonthTo"
    }
  }, [_vm._v(">")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info reset",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('dropdown', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('template', {
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('filters.period')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.yesterday
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.yesterday')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.week
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.week')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.thisMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.this_month')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.lastMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.last_month')))])])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn ringingHolds"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Прозвон холдов")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.rows), function(row) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.date) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.total_processed) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.average_changes) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.average_calls) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_one_day_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_one_day_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_one_day_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_one_day_ago > 0 ? ((row.approved_one_day_ago / row.created_one_day_ago) * 100).toFixed(1) + '%' : '0%') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_two_days_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_two_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_two_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v(_vm._s(row.created_two_days_ago > 0 ? ((row.approved_two_days_ago / row.created_two_days_ago) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_three_days_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v(_vm._s(row.approved_three_days_ago > 0 ? ((row.approved_three_days_ago / row.created_three_days_ago) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_more_three_days_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_more_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_more_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v(_vm._s(row.created_more_three_days_ago > 0 ? ((row.approved_more_three_days_ago / row.created_more_three_days_ago) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(129, 199, 132)"
      }
    }, [_vm._v(_vm._s(row.total_approved))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(129, 199, 132)"
      }
    }, [_vm._v(_vm._s(((row.total_approved / row.total_processed) * 100).toFixed(1) + '%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(129, 199, 132)"
      }
    }, [_vm._v(_vm._s(_vm.approvedFromValid(row.total_approved, row.total_processed, row.total_spam)))])])])
  }), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((this.footColumns), function(item) {
    return _c('th', [_vm._v(_vm._s(item))])
  }))])], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)",
      "width": "100px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дата")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Отработано")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 1 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 1 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 2 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 2 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 3 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 3 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 4 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 4 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув")])]), _vm._v(" "), _c('tr', {
    staticClass: "th-level-2"
  }, [_c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    }
  }, [_vm._v("касаний")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    }
  }, [_vm._v("звонков")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    }
  }, [_vm._v("от валида")])])])
}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ringing-tabs'), _vm._v(" "), _c('form', {
    attrs: {
      "id": "formCall"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cel"
  }, [_c('strong', [_vm._v("Тариф смс: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sms),
      expression: "sms"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sms = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "cel"
  }, [_c('strong', [_vm._v("Стоимость 1 минуты: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call),
      expression: "call"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.call = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "title": ("" + (_vm.$t('pages.ringing_sms')))
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 apply-buttons"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("\n                                    Сохранить\n                                ")])])])])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [(_vm.title) ? _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('div', {
    staticClass: "card-actions"
  }, [_vm._t("table-actions"), _vm._v(" "), _c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.exporting
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), (_vm.title === ("" + (_vm.$t('pages.orders')))) ? _c('button', {
    staticClass: "btn-close",
    attrs: {
      "title": "pdf"
    },
    on: {
      "click": _vm.downloadAll
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  })]) : _vm._e(), _vm._v(" "), (_vm.title === ("" + (_vm.$t('pages.receipt')))) ? _c('button', {
    staticClass: "btn-close",
    attrs: {
      "title": "pdf"
    },
    on: {
      "click": _vm.downloadAllReceipt
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  })]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "table-loader",
    staticStyle: {
      "padding": "50px 0",
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x fa-fw"
  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    class: _vm.idElem
  }, [_c('table', {
    staticClass: "table table-responsive",
    attrs: {
      "id": _vm.idElem
    }
  }, [_c('thead', [(_vm.preheatColumns) ? _c('tr', _vm._l((_vm.preheatColumns), function(col) {
    return _c('th', {
      staticClass: "th-action",
      attrs: {
        "colspan": col.colspan,
        "width": col.width ? col.width : 'auto'
      }
    }, [_vm._v(_vm._s(col.label))])
  })) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.headColumns), function(col, index) {
    return _c('th', {
      staticClass: "th-action",
      attrs: {
        "colspan": col.colspan,
        "width": col.width ? col.width : 'auto'
      },
      on: {
        "click": function($event) {
          _vm.sort(col.field, index)
        }
      }
    }, [_vm._v(_vm._s(col.label) + "\n            ")])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      key: row.key
    }, [_vm._l((row.value), function(cell, i) {
      return _c('td', {
        key: cell.offer_id,
        style: (_vm.renderBackground(cell)),
        attrs: {
          "width": cell.widthTd ? cell.widthTd : 'auto'
        }
      }, [(cell.key === 'country_id') ? [_vm._v("\n                " + _vm._s(_vm.Helper.findCountryName(cell.value)) + "\n              ")] : _vm._e(), _vm._v(" "), (cell.key === 'offer_id' || cell.key === 'product_id') ? [_vm._v("\n                " + _vm._s(_vm.getOfferName(cell.value)) + "\n              ")] : (cell.key == 'credit') ? [(cell.value == 0) ? [(row.showInput == false) ? [_c('span', {
        on: {
          "click": function($event) {
            _vm.showClick(row)
          }
        }
      }, [_vm._v("Оплачено")])] : [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cell.value),
          expression: "cell.value"
        }],
        staticClass: "cellInput",
        attrs: {
          "type": "text",
          "placeholder": cell.input.placeholder ? cell.input.placeholder : ''
        },
        domProps: {
          "value": cell.value,
          "value": (cell.value)
        },
        on: {
          "change": function($event) {
            _vm.changeTableVal(row.key, cell)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            cell.value = $event.target.value
          }
        }
      })]] : [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cell.value),
          expression: "cell.value"
        }],
        staticClass: "cellInput",
        attrs: {
          "type": "text",
          "placeholder": cell.input.placeholder ? cell.input.placeholder : ''
        },
        domProps: {
          "value": cell.value,
          "value": (cell.value)
        },
        on: {
          "change": function($event) {
            _vm.changeTableVal(row.key, cell)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            cell.value = $event.target.value
          }
        }
      })]] : (cell.key === 'is_ordered') ? [(cell.value === 1) ? [_vm._v("\n                 Заказан\n               ")] : _vm._e()] : [(cell.input) ? [(cell.input.type === 'number') ? [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cell.value),
          expression: "cell.value"
        }],
        staticClass: "cellInput",
        attrs: {
          "type": "number",
          "placeholder": cell.input.placeholder ? cell.input.placeholder : ''
        },
        domProps: {
          "value": cell.value,
          "value": (cell.value)
        },
        on: {
          "change": function($event) {
            _vm.changeTableVal(row.key, cell)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            cell.value = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      })] : _vm._e(), _vm._v(" "), (cell.input.type === 'text') ? [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cell.value),
          expression: "cell.value"
        }],
        staticClass: "cellInput",
        attrs: {
          "type": "text",
          "placeholder": cell.input.placeholder ? cell.input.placeholder : ''
        },
        domProps: {
          "value": cell.value,
          "value": (cell.value)
        },
        on: {
          "change": function($event) {
            _vm.changeTableVal(row.key, cell)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            cell.value = $event.target.value
          }
        }
      })] : _vm._e(), _vm._v(" "), (cell.input.type === 'date') ? [_c('DatePicker', {
        attrs: {
          "wrapper-class": 'date',
          "input-class": 'cellInput',
          "language": _vm.Storage.language,
          "placeholder": cell.input.placeholder ? cell.input.placeholder : '',
          "format": "yyyy-MM-dd"
        },
        on: {
          "input": function($event) {
            _vm.changeTableVal(row.key, cell)
          }
        },
        model: {
          value: (cell.value),
          callback: function($$v) {
            cell.value = $$v
          },
          expression: "cell.value"
        }
      })] : _vm._e(), _vm._v(" "), (cell.input.type === 'selectStatus') ? [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cell.value),
          expression: "cell.value"
        }],
        staticClass: "cellInput",
        attrs: {
          "name": "status"
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            cell.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }, function($event) {
            _vm.changeTableVal(row.key, cell)
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "0"
        }
      }, [_vm._v("Заказан")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "1"
        }
      }, [_vm._v("Отгружен")])])] : _vm._e()] : (cell.key !== 'country_id') ? [_vm._v("\n                  " + _vm._s(cell.value) + "\n                ")] : _vm._e()], _vm._v(" "), (cell.aux) ? [_vm._v("\n                " + _vm._s(cell.aux) + "\n              ")] : _vm._e()], 2)
    }), _vm._v(" "), (!_vm.disableActionBTN) ? _c('td', {
      key: 'action-' + row.key
    }, [_vm._t("table-actions"), _vm._v(" "), _c('button', {
      staticClass: "btn-close",
      attrs: {
        "title": "Сохранить"
      },
      on: {
        "click": function($event) {
          _vm.saveChange(row.key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn-close",
      attrs: {
        "title": "Удалить"
      },
      on: {
        "click": function($event) {
          _vm.deleteChange(row.key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn-close",
      attrs: {
        "title": "PDF"
      },
      on: {
        "click": function($event) {
          _vm.download(row.key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn-close btn-file",
      attrs: {
        "title": "Image"
      }
    }, [_c('input', {
      ref: "file",
      refInFor: true,
      staticClass: "form-control input files",
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.uploadImage(row.key, $event.target.name, $event.target.files)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-picture-o"
    })])], 2) : _vm._e(), _vm._v(" "), (_vm.isActiveBtn) ? _c('td', {
      key: 'action-' + row.key
    }, [_vm._t("table-actions"), _vm._v(" "), _c('button', {
      staticClass: "btn-close btn-close-receipt",
      attrs: {
        "title": "PDF"
      },
      on: {
        "click": function($event) {
          _vm.downloadPdfReceipt(row.key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn-close btn-file btn-close-receipt",
      attrs: {
        "title": "Image"
      }
    }, [_c('input', {
      ref: "file",
      refInFor: true,
      staticClass: "form-control input files",
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.uploadImageReceipt(row.key, $event.target.name, $event.target.files)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-picture-o"
    })])], 2) : _vm._e()], 2)
  }))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn profile"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('profile.avatar')))]), _vm._v(" "), _c('div', {
    staticClass: "card-block avatar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": _vm.Auth.user.profile.photo_big,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('profile.gravatar_change_avatar')) + "\n                            "), _c('a', {
    attrs: {
      "href": "https://gravatar.com/",
      "target": "_blank"
    }
  }, [_vm._v("Gravatar.com")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.$t('profile.security')))]), _vm._v(" "), _c('div', {
    staticClass: "card-block security"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.security.oldPassword),
      expression: "security.oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('auth.old_password'),
      "disabled": _vm.security.isLoading
    },
    domProps: {
      "value": (_vm.security.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.security.oldPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.security.password),
      expression: "security.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('auth.password'),
      "disabled": _vm.security.isLoading
    },
    domProps: {
      "value": (_vm.security.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.security.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.security.passwordRepeat),
      expression: "security.passwordRepeat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('auth.password_repeat'),
      "disabled": _vm.security.isLoading
    },
    domProps: {
      "value": (_vm.security.passwordRepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.security.passwordRepeat = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.security.alert) ? _c('div', {
    staticClass: "form-group-row"
  }, [_c('div', {
    staticClass: "alert",
    class: ("alert-" + (_vm.security.alert.type ? _vm.security.alert.type : 'danger'))
  }, [_vm._v("\n                            " + _vm._s(_vm.security.alert.message) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.security.isLoading
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.change_password')) + " "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.security.isLoading),
      expression: "security.isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.$t('profile.personal_information')))]), _vm._v(" "), _c('div', {
    staticClass: "card-block personal-information"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "hf-login"
    }
  }, [_vm._v(_vm._s(_vm.$t('auth.login')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Auth.user.profile.username),
      expression: "Auth.user.profile.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "hf-login",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.Auth.user.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Auth.user.profile.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "hf-email"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.email')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.personal.email),
      expression: "personal.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "hf-email",
      "disabled": _vm.personal.isLoading
    },
    domProps: {
      "value": (_vm.personal.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.personal.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "hf-first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.first_name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.personal.firstName),
      expression: "personal.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "hf-first_name",
      "disabled": _vm.personal.isLoading
    },
    domProps: {
      "value": (_vm.personal.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.personal.firstName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "hf-last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.last_name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.personal.lastName),
      expression: "personal.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "hf-last_name",
      "disabled": _vm.personal.isLoading
    },
    domProps: {
      "value": (_vm.personal.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.personal.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.personal.alert) ? _c('div', {
    staticClass: "form-group-row"
  }, [_c('div', {
    staticClass: "alert",
    class: ("alert-" + (_vm.personal.alert.type ? _vm.personal.alert.type : 'danger'))
  }, [_vm._v("\n                            " + _vm._s(_vm.personal.alert.message) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.personal.isLoading
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v(_vm._s(_vm.$t('verbs.save')) + " "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personal.isLoading),
      expression: "personal.isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-language"
  }), _vm._v(" " + _vm._s(_vm.$t('profile.language')))]), _vm._v(" "), _c('div', {
    staticClass: "card-block language"
  }, [_c('div', {
    staticClass: "form-group-row"
  }, [_c('MultiSelect', {
    attrs: {
      "track-by": "value",
      "options": _vm.language.list,
      "searchable": false,
      "label": "label",
      "allowEmpty": false,
      "disabled": _vm.language.isLoading
    },
    model: {
      value: (_vm.language.selected),
      callback: function($$v) {
        _vm.language.selected = $$v
      },
      expression: "language.selected"
    }
  })], 1), _vm._v(" "), (_vm.language.alert) ? _c('div', {
    staticClass: "form-group-row"
  }, [_c('div', {
    staticClass: "alert",
    class: ("alert-" + (_vm.language.alert.type ? _vm.language.alert.type : 'danger'))
  }, [_vm._v("\n                            " + _vm._s(_vm.language.alert.message) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.language.isLoading
    },
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v(_vm._s(_vm.$t('verbs.save')) + " "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.language.isLoading),
      expression: "language.isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" " + _vm._s(_vm.$t('profile.for_developer')))]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "danger"
    },
    on: {
      "change": _vm.handleDevelopMode
    },
    model: {
      value: (_vm.developMode),
      callback: function($$v) {
        _vm.developMode = $$v
      },
      expression: "developMode"
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  })), _vm._v("\n                    " + _vm._s(_vm.$t('profile.developer_mode')) + "\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  })])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad"
  }, [_c('div', {
    staticClass: "col-md-12 padTop"
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.Storage.OldbyWmFilter),
      callback: function($$v) {
        _vm.Storage.OldbyWmFilter = $$v
      },
      expression: "Storage.OldbyWmFilter"
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  })), _vm._v("\n    " + _vm._s(_vm.$t('filters.by_wm')) + "\n  ")], 1)])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  })], 1), _vm._v(" "), _c('ProductTabs'), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', [(_vm.title) ? _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block card-zz"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.headColumns), function(col) {
    return _c('th', {
      attrs: {
        "colspan": col.colspan
      }
    }, [_vm._v(_vm._s(col.label))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsAll), function(col) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(col.offer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.lead))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.quantity))]), _vm._v(" "), _c('td', _vm._l((col.goods), function(i) {
      return _c('p', {
        staticClass: "goods"
      }, [_vm._v(_vm._s(i.title) + " -> " + _vm._s(i.quantity))])
    }))])
  })), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.computedFootColumnsAll), function(cell) {
    return _c('th', [_c('span', [_vm._v(_vm._s(cell.value))])])
  }))])], 1)]), _vm._v(" "), _vm._l((_vm.rows), function(rowsDate, indexDate) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "40px"
      }
    }, [(_vm.title) ? _c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n            " + _vm._s(indexDate) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', _vm._l((_vm.headColumns), function(col) {
      return _c('th', {
        attrs: {
          "colspan": col.colspan
        }
      }, [_vm._v(_vm._s(col.label))])
    }))]), _vm._v(" "), _c('tbody', _vm._l((rowsDate), function(col) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(col.offer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.leads))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.quantity))]), _vm._v(" "), _c('td', _vm._l((col.goods), function(i) {
        return _c('p', {
          staticClass: "goods"
        }, [_vm._v(_vm._s(i.title) + " -> " + _vm._s(i.quantity))])
      }))])
    })), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.computedFootColumns1[indexDate]), function(cell) {
      return _c('th', [_c('span', [_vm._v(_vm._s(cell.value))])])
    }))])], 1)])
  }), _vm._v(" "), _c('br')], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('DashCard', {
    attrs: {
      "value": _vm.trafficTotal,
      "label": _vm.$t('statistic.traffic'),
      "icon": "users"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('DashCard', {
    attrs: {
      "value": _vm.approvedTotal,
      "label": _vm.$t('statistic.approve'),
      "icon": "thumbs-o-up",
      "bg": "success"
    }
  }, [_c('template', {
    slot: "percents"
  }, [_c('small', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.approvedPercents))])])], 2)], 1), _vm._v(" "), (_vm.Auth.haveAccess('DASH_ADVERTISE_DEBIT')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('DashCard', {
    attrs: {
      "value": (_vm.adverticeDebit + "$"),
      "label": _vm.$t('statistic.debt'),
      "icon": "hand-lizard-o"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('TrafficChart', {
    attrs: {
      "chartData": _vm.trafficChart
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 col-md-6 col-xs-12 otherResponsive"
  }, [_c('DifferencyTable', {
    attrs: {
      "tableData": _vm.averageBillTable,
      "title": _vm.$t('statistic.averageBill'),
      "symbol": "$",
      "icon": "usd",
      "calculate": true,
      "withAverage": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 col-md-6 col-xs-12 otherResponsive"
  }, [_c('DifferencyTable', {
    attrs: {
      "tableData": _vm.approveTable,
      "title": _vm.$t('statistic.approve'),
      "symbol": "%",
      "color": "warning",
      "icon": "thumbs-o-up",
      "calculate": true,
      "withAverage": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 col-md-12 col-xs-12 leadsResponsive"
  }, [_c('DifferencyTable', {
    attrs: {
      "isLeads": true,
      "tableData": _vm.leadsForDash,
      "title": _vm.$t('statistic.leads'),
      "color": "success",
      "icon": "users",
      "calculate": true
    }
  }), _vm._v("`\n        ")], 1), _vm._v(" "), (_vm.Auth.haveAccess('DASH_ADVERTISE_DEBIT')) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 col-xs-12"
  }, [_c('DebitTable', {
    attrs: {
      "tableData": _vm.adverticeDbt,
      "title": _vm.$t('statistic.debt'),
      "color": "primary",
      "icon": "hand-lizard-o"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _vm._l((_vm.rows), function(rowsData) {
    return _c('div', [_c('div', {
      staticClass: "card-header"
    }, [_c('StatisticTable', {
      attrs: {
        "footColumns": rowsData.foot,
        "headColumns": _vm.headColumns,
        "rows": rowsData.rows,
        "title": ((_vm.Helper.getOfferTitle(_vm.offers, rowsData.offer)) + " (" + (rowsData.offer) + ")")
      }
    })], 1)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "footColumns": _vm.footColumns,
      "headColumns": _vm.headColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.sources')))
    },
    on: {
      "webGraph": _vm.webGraph
    }
  }), _vm._v(" "), (_vm.webid) ? _c('modal', {
    attrs: {
      "effect": "fade/zoom",
      "large": ""
    },
    model: {
      value: (_vm.chartModal),
      callback: function($$v) {
        _vm.chartModal = $$v
      },
      expression: "chartModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.chart.title))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ("chart-container-" + _vm.webid)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chartModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flypost"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('form', {
    attrs: {
      "id": "formRent"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "logout-message",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                      "), _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _c('div', {
    staticClass: "exelAll",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_vm._l((_vm.totalAllColumns), function(indexMonth, indexYear) {
    return _c('div', {
      directives: [{
        name: "hammer",
        rawName: "v-hammer:pan",
        value: (_vm.onSwipe),
        expression: "onSwipe",
        arg: "pan"
      }],
      key: indexYear,
      staticStyle: {
        "display": "flex",
        "flex-wrap": "nowrap"
      },
      style: ({
        'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
      }),
      attrs: {
        "id": "swipe1"
      }
    }, _vm._l((indexMonth), function(rowsMonth, indexCourier, index) {
      return _c('div', {
        key: (indexYear + "_" + indexCourier),
        staticStyle: {
          "flex": "0 0 880px"
        }
      }, [_c('div', {
        staticClass: " statistic-table",
        staticStyle: {
          "margin-bottom": "0"
        }
      }, [_c('div', {
        staticClass: "card-header"
      }, [_vm._v("\n                          " + _vm._s(_vm.month[indexCourier - 1]) + " " + _vm._s(indexYear) + " г."), _c('br')]), _vm._v(" "), _c('StatisticTable', {
        attrs: {
          "className": (([indexYear]) + "-" + (_vm.month[indexCourier - 1])),
          "classes": (([indexYear]) + "-" + ([_vm.month[indexCourier - 1]])),
          "footColumns": _vm.totalAllColumns[indexYear][indexCourier][0],
          "isFlypost": true,
          "isExelAll": true,
          "headColumns": _vm.headColumnsFlyPost,
          "rows": [],
          "isFlypostModal": true,
          "totalColumnsDd": _vm.totalCourier[indexYear][indexCourier],
          "title": ("" + (_vm.$t('statistic.in_total')))
        },
        on: {
          "isPopupFlyPost": _vm.isPopupFlyPost,
          "exportingAll": _vm.exportingAll
        }
      })], 1)])
    }))
  }), _vm._v(" "), _vm._l((_vm.rows), function(rowsCourier, indexYear) {
    return _c('div', {
      directives: [{
        name: "hammer",
        rawName: "v-hammer:pan",
        value: (_vm.onSwipe),
        expression: "onSwipe",
        arg: "pan"
      }],
      key: indexYear,
      style: ({
        'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
      }),
      attrs: {
        "id": "swipe"
      }
    }, _vm._l((rowsCourier), function(rowsMonth, indexCourier, index) {
      return _c('div', {
        key: (indexYear + "_" + indexCourier),
        staticStyle: {
          "display": "flex",
          "flex-wrap": "nowrap"
        }
      }, _vm._l((rowsMonth), function(rowsData, indexMonth) {
        return _c('div', {
          key: (indexYear + "_" + indexCourier + "_" + indexMonth),
          staticStyle: {
            "flex": "0 0 880px"
          }
        }, [(rowsData.length !== 0) ? _c('div', [_c('div', {
          staticClass: " statistic-table",
          staticStyle: {
            "margin-bottom": "0"
          }
        }, [_c('StatisticTable', {
          attrs: {
            "className": (([indexYear]) + "-" + ([indexMonth])),
            "footColumns": _vm.footColumns[indexYear][indexCourier][indexMonth][0],
            "headColumns": _vm.headColumns,
            "rows": rowsData,
            "isFlypostModal": true,
            "title": ("" + (_vm.Helper.getOfferTitle(_vm.Storage.offers, indexCourier)))
          },
          on: {
            "isPopup": _vm.isPopup
          }
        })], 1)]) : _vm._e()])
      }))
    }))
  })], 2)])]), _vm._v(" "), _c('modal', {
    attrs: {
      "large": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.branchStatistics),
      callback: function($$v) {
        _vm.branchStatistics = $$v
      },
      expression: "branchStatistics"
    }
  }, [_c('div', {
    staticClass: "modal-header modal-header_popup",
    slot: "modal-header"
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumnsPopup,
      "rows": _vm.rowsDataPopup,
      "footColumns": _vm.footColumnsPopup,
      "title": this.popupTitle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.branchStatistics = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-header-title"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-check",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("\n                      Сохранить\n                  ")])])])])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "title",
      "options": _vm.Storage.couriers,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('statistic.couriers'),
      "label": "title",
      "searchable": true,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_c('span', [_vm._v(_vm._s(props.option.title) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.id) + ")")]) : _vm._e()])])])]
      }
    }]),
    model: {
      value: (_vm.Storage.selectedCouriers),
      callback: function($$v) {
        _vm.Storage.selectedCouriers = $$v
      },
      expression: "Storage.selectedCouriers"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.selectAll
    }
  }, [_c('i', {
    staticClass: "fa fa-reply-all"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.select_all')) + "\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', [(_vm.loading) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "logout-message",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                            "), _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _c('form', {
    attrs: {
      "id": "formRent"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.title) ? _c('div', {
    staticClass: "card-header-title"
  }, [_vm._v("\n                            " + _vm._s(_vm.title) + "\n                            "), _c('button', {
    staticClass: "btn btn-success btn-lg btn-check",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("\n                                Сохранить\n                            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [(_vm.allCountry) ? _c('div', [_c('div', {
    staticClass: "card statistic-table statistic-table-balance"
  }, _vm._l((_vm.rowsAll), function(rowsDate, indexCountry) {
    return _c('div', [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n                                    " + _vm._s(_vm.Helper.findCountryName(indexCountry)) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "card-block card-zz"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', _vm._l((_vm.computedHeadColumns), function(col) {
      return _c('th', {
        style: (_vm.renderBackground(false, col.field, false)),
        attrs: {
          "colspan": col.colspan,
          "width": col.width ? col.width : 'auto'
        }
      }, [_vm._v(_vm._s(col.label))])
    }))]), _vm._v(" "), _c('tbody', _vm._l((rowsDate), function(row, i) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(row.month))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        }
      }, [_vm._v(_vm._s(row.leads))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#b9f6ca"
        }
      }, [_vm._v(_vm._s((row.approved_percent * 100).toFixed(2)) + "%")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#c8e6c9"
        }
      }, [_vm._v(_vm._s(row.approved))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(_vm._s(row.expenses_by_kc))]), _vm._v(" "), (_vm.date === row.dateByRows && row.isChanged) ? _c('td', {
        staticStyle: {
          "background-color": "#90caf9"
        },
        on: {
          "change": function($event) {
            _vm.changeElem()
          }
        }
      }, [_c('input', {
        staticClass: "input-price",
        attrs: {
          "id": 'm' + row.dateByRows,
          "name": 'c' + row.country_id,
          "value": "-",
          "type": "text"
        }
      })]) : _c('td', {
        staticStyle: {
          "background-color": "#90caf9"
        },
        on: {
          "change": function($event) {
            _vm.changeElem()
          }
        }
      }, [_c('input', {
        staticClass: "input-price",
        attrs: {
          "id": 'm' + row.dateByRows,
          "name": 'c' + row.country_id,
          "type": "text"
        },
        domProps: {
          "value": row.expenses_by_lead
        }
      })]), _vm._v(" "), (_vm.date === row.dateByRows && row.country_id !== 77) ? _c('td', {
        staticStyle: {
          "background-color": "#e0e0e0"
        }
      }, [_vm._v("$ " + _vm._s(row.expected_lead_increase))]) : (_vm.date === row.dateByRows && row.country_id === 77) ? _c('td', {
        staticStyle: {
          "background-color": "#e0e0e0"
        }
      }, [_vm._v("₽ " + _vm._s(row.expected_lead_increase))]) : _c('td', {
        staticStyle: {
          "background-color": "#e0e0e0"
        }
      }, [_vm._v(" - ")]), _vm._v(" "), (_vm.date !== row.dateByRows) ? _c('td', {
        staticStyle: {
          "background-color": "#ef9a9a"
        }
      }, [_vm._v(_vm._s(row.cost_change_other_month) + "%")]) : (_vm.date === row.dateByRows) ? _c('td', {
        staticStyle: {
          "background-color": "#ef9a9a"
        }
      }, [_vm._v(_vm._s(row.cost_change_current_month) + "%")]) : _vm._e()])
    })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', [_vm._v("Итого:")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_vm._v(_vm._s(_vm.footAll[indexCountry].total))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#b9f6ca"
      }
    }, [_vm._v(_vm._s(_vm.footAll[indexCountry].totalApprovedPercent) + "%")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#c8e6c9"
      }
    }, [_vm._v(_vm._s(_vm.footAll[indexCountry].totalApproved))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#c8cce6"
      }
    }, [_vm._v(_vm._s(_vm.footAll[indexCountry].totalKc))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#90caf9"
      }
    }, [_c('span')]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#e0e0e0"
      }
    }, [_c('span')]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#ef9a9a"
      }
    }, [_c('span')])])])], 1)])])
  }))]) : _c('div', {
    staticClass: "card statistic-table statistic-table-balance"
  }, [(_vm.title) ? _c('div', {
    staticClass: "card-header"
  }, _vm._l((_vm.countryTitle), function(name) {
    return _c('span', [_vm._v(_vm._s(name))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block card-zz"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.computedHeadColumns), function(col) {
    return _c('th', {
      style: (_vm.renderBackground(false, col.field, false)),
      attrs: {
        "colspan": col.colspan,
        "width": col.width ? col.width : 'auto'
      }
    }, [_vm._v(_vm._s(col.label))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(cell) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(cell.month))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_vm._v(_vm._s(cell.leads))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#b9f6ca"
      }
    }, [_vm._v(_vm._s((cell.approved_percent * 100).toFixed(2)) + "%")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c8e6c9"
      }
    }, [_vm._v(_vm._s(cell.approved))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c8cce6"
      }
    }, [_vm._v(_vm._s(cell.expenses_by_kc))]), _vm._v(" "), (_vm.date === cell.dateByRows && cell.isChanged) ? _c('td', {
      staticStyle: {
        "background-color": "#90caf9"
      },
      on: {
        "change": function($event) {
          _vm.changeElem()
        }
      }
    }, [_c('input', {
      staticClass: "input-price",
      attrs: {
        "id": 'm' + cell.dateByRows,
        "name": 'c' + cell.country_id,
        "value": "-",
        "type": "text"
      }
    })]) : _c('td', {
      staticStyle: {
        "background-color": "#90caf9"
      },
      on: {
        "change": function($event) {
          _vm.changeElem()
        }
      }
    }, [_c('input', {
      staticClass: "input-price",
      attrs: {
        "id": 'm' + cell.dateByRows,
        "name": 'c' + cell.country_id,
        "type": "text"
      },
      domProps: {
        "value": cell.expenses_by_lead
      }
    })]), _vm._v(" "), (_vm.date === cell.dateByRows && cell.country_id !== 77) ? _c('td', {
      staticStyle: {
        "background-color": "#e0e0e0"
      }
    }, [_vm._v("$ " + _vm._s(cell.expected_lead_increase))]) : (_vm.date === cell.dateByRows && cell.country_id === 77) ? _c('td', {
      staticStyle: {
        "background-color": "#e0e0e0"
      }
    }, [_vm._v("₽ " + _vm._s(cell.expected_lead_increase))]) : _c('td', {
      staticStyle: {
        "background-color": "#e0e0e0"
      }
    }, [_vm._v(" - ")]), _vm._v(" "), (_vm.date !== cell.dateByRows) ? _c('td', {
      staticStyle: {
        "background-color": "#ef9a9a"
      }
    }, [_vm._v(_vm._s(cell.cost_change_other_month) + "%")]) : (_vm.date === cell.dateByRows) ? _c('td', {
      staticStyle: {
        "background-color": "#ef9a9a"
      }
    }, [_vm._v(_vm._s(cell.cost_change_current_month) + "%")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#8fbc8f"
      }
    }, [_vm._v(_vm._s(cell.approvedFromValid))])])
  })), _vm._v(" "), _c('tfoot', _vm._l((_vm.footColumns), function(col) {
    return _c('tr', [_c('th', [_vm._v("Итого:")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_c('span', [_vm._v(_vm._s(col.total))])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#b9f6ca"
      }
    }, [_vm._v(_vm._s((col.totalApprovedPercent * 100).toFixed(2)) + "%")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#c8e6c9"
      }
    }, [_c('span', [_vm._v(_vm._s(col.totalApproved))])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#c8cce6"
      }
    }, [_c('span', [_vm._v(_vm._s(col.totalKc))])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#90caf9"
      }
    }, [_c('span')]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#e0e0e0"
      }
    }, [_c('span')]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#ef9a9a"
      }
    }, [_c('span')]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#8fbc8f"
      }
    }, [_vm._v(_vm._s(col.approvedFromValid))])])
  }))], 1)])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('AlphabetScroll', {
    attrs: {
      "alphabet": _vm.alphabet,
      "context": this,
      "scrollPos": _vm.scrollPos
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "offer-scroll"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "letter-block",
      attrs: {
        "id": ("letter-" + (letter.letter))
      }
    }, _vm._l((_vm.rows[letter.letter]), function(row) {
      return (_vm.Helper.getCourierTitle(_vm.couriers, row.id)) ? _c('StatisticTable', {
        key: row.id,
        attrs: {
          "footColumns": _vm.footColumns[row.id],
          "headColumns": _vm.headColumns,
          "rows": row.cells,
          "title": ((_vm.Helper.getCourierTitle(_vm.couriers, row.id)) + " " + (_vm.Storage.developMode ? ("(" + (row.id) + ")") : ''))
        }
      }) : _vm._e()
    }))
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('StatisticTable', {
    staticClass: "animated fadeIn",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.conversions')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    attrs: {
      "options": _vm.options,
      "show-labels": false,
      "track-by": "title",
      "label": "title",
      "placeholder": "Выбрать период"
    },
    on: {
      "select": _vm.handleChangeParse
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn webAnalysis"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filters__atalytics"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "filters__atalytics--content"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "aprove"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "id": "aprove",
      "value": "aprove"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "aprove")
    },
    on: {
      "change": _vm.onChancgeSelect,
      "__c": function($event) {
        _vm.picked = "aprove"
      }
    }
  }), _vm._v("\n                    По выкупам")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "buyout"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "id": "buyout",
      "value": "buyout"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "buyout")
    },
    on: {
      "change": _vm.onChancgeSelect,
      "__c": function($event) {
        _vm.picked = "buyout"
      }
    }
  }), _vm._v("\n                    По апрувам")])]), _vm._v(" "), _c('div', {
    staticClass: "content__percent"
  }, [_c('label', {
    attrs: {
      "for": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percent),
      expression: "percent"
    }],
    attrs: {
      "type": "number",
      "id": "percent"
    },
    domProps: {
      "value": (_vm.percent)
    },
    on: {
      "change": _vm.getPercent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.percent = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n                    Процентное значение: " + _vm._s(_vm.percent) + "%")])])])]), _vm._v(" "), _c('WebTabs'), _vm._v(" "), _c('div', {
    staticClass: "container__table excel",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('StatisticTable', {
    attrs: {
      "footColumns": _vm.firstFootColumns,
      "headColumns": _vm.headColumns,
      "rows": _vm.rows_first,
      "title": "Первый период",
      "isExelAll": true,
      "isFlypostModal": true,
      "copy-icon": 'webmaster'
    },
    on: {
      "copy": function($event) {
        _vm.copyWebmasters(_vm.rows_first)
      },
      "exportingAll": _vm.exportingAll
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "footColumns": _vm.secondFootColumns,
      "headColumns": _vm.headColumns,
      "isFlypostModal": true,
      "rows": _vm.rows_second,
      "copy-icon": 'webmaster',
      "title": "Второй период"
    },
    on: {
      "copy": function($event) {
        _vm.copyWebmasters(_vm.rows_second)
      }
    }
  }), _vm._v(" "), _c('StatisticTable', {
    staticClass: "table_difference",
    attrs: {
      "footColumns": _vm.differenceFootColumns,
      "headColumns": _vm.headColumnsDifference,
      "rows": _vm.rows_difference,
      "isFlypostModal": true,
      "copy-icon": 'webmaster',
      "title": "Разница",
      "id": "table_difference"
    },
    on: {
      "copy": function($event) {
        _vm.copyWebmasters(_vm.rows_difference)
      }
    }
  }), _vm._v(" "), _c('StatisticTable', {
    staticClass: "table_difference_aprove noActive",
    attrs: {
      "footColumns": _vm.differenceFootColumns,
      "headColumns": _vm.headColumnsDifference,
      "rows": _vm.rows_difference_aprove,
      "isFlypostModal": true,
      "copy-icon": 'webmaster',
      "title": "Разница по апрувам",
      "id": "table_difference_aprove"
    },
    on: {
      "copy": function($event) {
        _vm.copyWebmasters(_vm.rows_difference_aprove)
      }
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "footColumns": _vm.lastFootColumns,
      "headColumns": _vm.headColumnsLst,
      "isFlypostModal": true,
      "rows": _vm.rows_last,
      "copy-icon": 'webmaster',
      "title": "Последняя неделя"
    },
    on: {
      "copy": function($event) {
        _vm.copyWebmasters(_vm.rows_last)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content__table_difference_web excel"
  }, [_c('StatisticTable', {
    staticClass: "table_difference_web",
    attrs: {
      "footColumns": _vm.differenceFootColumnsWeb,
      "headColumns": _vm.headColumnsLstWeb,
      "rows": _vm.rows_difference_web,
      "isFlypostModal": true,
      "copy-icon": 'webmaster',
      "title": "Вебмастера имеющие -% по выкупам",
      "id": "table_difference_web"
    },
    on: {
      "copy": function($event) {
        _vm.copyWebmasters(_vm.rows_difference_web)
      }
    }
  }), _vm._v(" "), _c('StatisticTable', {
    staticClass: "table_difference_web table_difference_web_aprove noActive",
    attrs: {
      "footColumns": _vm.differenceFootColumnsWeb,
      "headColumns": _vm.headColumnsLstWeb,
      "isFlypostModal": true,
      "rows": _vm.rows_difference_web_aprove,
      "copy-icon": 'webmaster',
      "title": "Вебмастера имеющие -% по апрувам",
      "id": "table_difference_web_aprove"
    },
    on: {
      "copy": function($event) {
        _vm.copyWebmasters(_vm.rows_difference_web_aprove)
      }
    }
  })], 1), _vm._v(" "), (_vm.isCopyNotify) ? _c('div', {
    staticClass: "copy-notify"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('pages.webmasters_notify')) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters__atalytics--title card-header"
  }, [_c('i', {
    staticClass: "fa fa-filter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            Фильтры по анализу\n        ")])
}]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('AlphabetScroll', {
    attrs: {
      "alphabet": _vm.alphabet,
      "context": this,
      "scrollPos": _vm.scrollPos
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "offer-scroll"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "letter-block",
      attrs: {
        "id": ("letter-" + (letter.letter))
      }
    }, _vm._l((_vm.rows[letter.letter]), function(row) {
      return (_vm.Helper.getOfferTitle(_vm.offers, row.id)) ? _c('StatisticTable', {
        key: row.id,
        attrs: {
          "title": ((_vm.Helper.getOfferTitle(_vm.offers, row.id)) + " " + (_vm.Storage.developMode ? ("(" + (row.id) + ")") : '')),
          "headColumns": _vm.headColumns,
          "footColumns": _vm.footColumns[row.id],
          "rows": row.cells
        }
      }) : _vm._e()
    }))
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('div', {
    staticClass: "row animated fadeIn"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('statistic.by_graph')) + "\n              ")]), _vm._v(" "), _vm._m(0)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    attrs: {
      "id": "chart-conversion"
    }
  })])
}]}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('RefundsTabs'), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.ref_cancel')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-default filters"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-filter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('statistic.filters')) + "\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('CopyButton', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.scope.dateFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('DateFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.dateFilterSecond) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('DateFilterSecond', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.dateFilterCreated) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('DateCreated', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.dateFilterReceipt) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('DateReceipt', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.monthFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('MonthFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.offerFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('OfferFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.operatorFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('OperatorFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.courierFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('CourierFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.monthFromFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('MonthFromFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.scope.countryFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('CountryFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.oneCountryFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('OneCountryFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.byWmFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('ByWmFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.byManualFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('ByManualFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.byWmFilterAll) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('ByWmFilterAll', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.oldWmFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('OldWmFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.newWmFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('NewWmFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.webmasterFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('WebmasterFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.filterWebCountry) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('CountryFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  }), _vm._v(" "), _c('ByManualFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.byWebmasterFilter) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('byWebmasterFilter', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 apply-buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.load()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('filters.apply')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.resetAll
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.scope.WorkShifts) ? _c('div', {
    staticClass: "col-md-2 new_filter"
  }, [_c('WorkShifts', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scope.ParsePeriod) ? _c('div', {
    staticClass: "col-md-2 new_filter"
  }, [_c('ParsePeriod', {
    attrs: {
      "disabled": _vm.isLoading
    }
  })], 1) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/offer',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_offers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/country',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_country')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/tag',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_category_product')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/balance',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_balance_currency')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product/orders_receipt',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.orders_receipt')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('AlphabetScroll', {
    attrs: {
      "alphabet": _vm.alphabet,
      "context": this,
      "scrollPos": _vm.scrollPos
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "offer-scroll"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "letter-block",
      attrs: {
        "id": ("letter-" + (letter.letter))
      }
    }, _vm._l((_vm.rows[letter.letter]), function(row) {
      return (_vm.Helper.getCourierTitle(_vm.couriers, row.id)) ? _c('StatisticTable', {
        key: row.id,
        attrs: {
          "title": ((_vm.Helper.getCourierTitle(_vm.couriers, row.id)) + " " + (_vm.Storage.developMode ? ("(" + (row.id) + ")") : '')),
          "headColumns": _vm.headColumns,
          "footColumns": _vm.footColumns[row.id],
          "rows": row.cells
        }
      }) : _vm._e()
    }))
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('RefundsTabs'), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "checkbox": true,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "checked": _vm.checked,
      "title": ("" + (_vm.$t('pages.ref_return_by_month')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('RefundsTabs'), _vm._v(" "), _c('div', {
    staticClass: "container__table excel",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%",
      "z-index": "-10"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%",
      "z-index": "-10"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.ref_cancel_operators')))
    },
    on: {
      "isPopup": _vm.isPopup
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "disabled": _vm.disabled,
      "hide-selected": false,
      "multiple": true,
      "options": _vm.Storage.webFilter,
      "placeholder": _vm.$t('filter.webmaster_grid'),
      "preserve-search": true,
      "searchable": true,
      "label": "login",
      "track-by": "login"
    },
    on: {
      "input": _vm.dispatchInputAction
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n         " + _vm._s(props.option.login) + "\n        ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.webSelectedFilter),
      callback: function($$v) {
        _vm.Storage.webSelectedFilter = $$v
      },
      expression: "Storage.webSelectedFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-left": "25px",
      "padding-top": "0.24rem"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "disabled": _vm.disabled,
      "type": "icon",
      "variant": "info"
    },
    model: {
      value: (_vm.Storage.byManualFilter),
      callback: function($$v) {
        _vm.Storage.byManualFilter = $$v
      },
      expression: "Storage.byManualFilter"
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  })), _vm._v("\n        " + _vm._s(_vm.$t('filters.by_manual')) + "\n    ")], 1)])
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center",
    attrs: {
      "id": "login-form"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: _vm.error ? 'input-group mb-3 has-danger has-feedback' : 'input-group mb-3'
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    class: _vm.error ? 'form-control form-control-danger' : 'form-control',
    attrs: {
      "type": "text",
      "placeholder": _vm.$t("auth.login"),
      "disabled": this.authLoading,
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.error ? 'input-group mb-3 has-danger has-feedback' : 'input-group mb-3'
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    class: _vm.error ? 'form-control form-control-danger' : 'form-control',
    attrs: {
      "type": "password",
      "placeholder": _vm.$t("auth.password"),
      "disabled": this.authLoading,
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                                        " + _vm._s(_vm.error) + "\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "button",
      "disabled": this.authLoading
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("auth.login_action")) + " "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.authLoading),
      expression: "this.authLoading"
    }],
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('Language')], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', {
    class: _vm.className
  }, [(_vm.title) ? _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), _c('div', {
    staticClass: "card-actions"
  }, [_vm._t("table-actions"), _vm._v(" "), _c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.exporting
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), (_vm.isExelAll) ? _c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.exportingAll
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    class: {
      cardFixed: _vm.isFixed
    },
    attrs: {
      "id": _vm.id
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [(_vm.preheatColumns) ? _c('tr', _vm._l((_vm.preheatColumns), function(col) {
    return _c('th', {
      attrs: {
        "colspan": col.colspan
      }
    }, [_vm._v("\n                      " + _vm._s(col.label) + "\n                    ")])
  })) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.checkbox) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status.all),
      expression: "status.all"
    }],
    staticClass: "checkall",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.status.all,
      "checked": Array.isArray(_vm.status.all) ? _vm._i(_vm.status.all, _vm.status.all) > -1 : (_vm.status.all)
    },
    on: {
      "change": function($event) {
        _vm.check('all')
      },
      "__c": function($event) {
        var $$a = _vm.status.all,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.status.all,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.status.all = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.status.all = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.status.all = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedHeadColumns), function(col) {
    return _c('th', {
      staticClass: "th-action",
      class: {
        isFix: col.fix, bgCountry: col.field_country, noActive: col.isActive ? 'noActive' : '', 'th-splitter': col.splitter
      },
      style: (_vm.renderBackground(false, col.field, false)),
      attrs: {
        "colspan": col.colspan,
        "width": col.width ? col.width : 'auto'
      },
      on: {
        "click": function($event) {
          !col.splitter ? _vm.sort(col) : function () { return false; }
        }
      }
    }, [(col.splitter) ? _c('div', {
      staticClass: "th-split-left",
      on: {
        "click": function($event) {
          _vm.sort(col)
        }
      }
    }) : _vm._e(), _vm._v(" "), (col.splitter) ? _c('div', {
      staticClass: "th-split-right",
      on: {
        "click": function($event) {
          _vm.sort(col, false)
        }
      }
    }) : _vm._e(), _vm._v("\n                      " + _vm._s(col.label) + "\n                      "), (_vm.rows.length && col.field === _vm.copyIcon) ? _c('i', {
      staticClass: "fa fa-lg fa-copy copy-icon",
      on: {
        "click": _vm.copyIconClick
      }
    }) : _vm._e()])
  })], 2)]), _vm._v(" "), (!_vm.isLoading) ? _c('tbody', _vm._l((_vm.computedRows), function(row) {
    return _c('tr', [(_vm.checkbox) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.status[row.id.value]),
        expression: "status[row.id.value]"
      }],
      class: 'check_' + row.id.value,
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": _vm.status[row.id.value],
        "checked": Array.isArray(_vm.status[row.id.value]) ? _vm._i(_vm.status[row.id.value], _vm.status[row.id.value]) > -1 : (_vm.status[row.id.value])
      },
      on: {
        "change": function($event) {
          _vm.check(row.id.value)
        },
        "__c": function($event) {
          var $$a = _vm.status[row.id.value],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.status[row.id.value],
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.status[row.id.value] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.status[row.id.value] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            var $$exp = _vm.status,
              $$idx = row.id.value;
            if (!Array.isArray($$exp)) {
              _vm.status[row.id.value] = $$c
            } else {
              $$exp.splice($$idx, 1, $$c)
            }
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((row), function(cell, i) {
      return (!cell.code) ? _c('td', {
        class: _vm.getCellClasses(cell),
        style: (_vm.renderBackground(cell, i, false)),
        attrs: {
          "colspan": cell.colspan
        },
        domProps: {
          "innerHTML": _vm._s(!cell.htmlValue ? cell.value : cell.htmlValue)
        },
        on: {
          "change": function($event) {
            _vm.updates(cell, $event.target.value)
          },
          "click": function($event) {
            cell.webGraph ? _vm.webGraph(cell, i) : (cell.popup) ? _vm.isPopup(cell, i) : null
          }
        }
      }) : _c('td', {
        staticClass: "col-md-2"
      }, [_c('div', {
        staticClass: "col-md-8",
        staticStyle: {
          "display": "inline-block"
        }
      }, [_vm._v(_vm._s(cell.value))]), _c('div', {
        staticClass: "col-md-4",
        staticStyle: {
          "float": "right"
        }
      }, [_c('i', {
        staticClass: "option__image flag",
        class: 'flag-' + cell.code.toLowerCase(),
        staticStyle: {
          "margin": "-5px 0 -10px 0"
        }
      })])])
    })], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "table-loader",
    staticStyle: {
      "padding": "50px 0",
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x fa-fw"
  })]) : _vm._e(), _vm._v(" "), _c('tfoot', [_vm._l((_vm.computedFootCourier), function(cell, i) {
    return _c('tr', {
      staticClass: "normal-text tr_courier"
    }, [_c('th', {
      staticClass: "flypost_corier_name"
    }, [_vm._v(_vm._s(cell.courier_name))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#e0e0e0"
      }
    }, [_vm._v(_vm._s(cell.total))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(parseFloat((cell.total / cell.totalPercents) * 100).toFixed(2)) + "%")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#90caf9"
      }
    }, [_vm._v(_vm._s(cell.delivered))]), _vm._v(" "), _c('th', {
      staticClass: "averageBuyback",
      staticStyle: {
        "background-color": "#bae0ff",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(cell.paid > 0 ? '$ ' + (cell.average_buyout / cell.paid).toFixed(2) : '$ 0.00'))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#ce93d8",
        "font-weight": "normal"
      }
    }, [_vm._v(_vm._s(cell.refunded))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(cell.returnPercents))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_vm._v(_vm._s(cell.shipped))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background": "#b9f6ca"
      }
    }, [_vm._v(_vm._s(cell.buyout))]), _vm._v(" "), (_vm.isFlypost) ? _c('th', {
      staticStyle: {
        "background": "rgba(156,255,112,0.56)"
      }
    }, [_vm._v(_vm._s(cell.cost))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(cell.buyout))])])
  }), _vm._v(" "), _vm._l((_vm.computedFootCourier), function(cell, i) {
    return _c('tr', {
      staticClass: "normal-text tr_flypost"
    }, [_c('th', {
      staticClass: "flypost_corier_name",
      on: {
        "click": function($event) {
          _vm.isPopupFlyPost(cell)
        }
      }
    }, [_vm._v(_vm._s(cell.courier_name))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#e0e0e0"
      }
    }, [_vm._v(_vm._s(cell.total))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(parseFloat((cell.total / cell.totalPercents) * 100).toFixed(2)) + "%")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#90caf9"
      }
    }, [_vm._v(_vm._s(cell.delivered))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#ce93d8",
        "font-weight": "normal"
      }
    }, [_vm._v(_vm._s(cell.refunded))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(cell.returnPercents))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_vm._v(_vm._s(cell.shipped))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background": "#b9f6ca"
      }
    }, [_vm._v(_vm._s(cell.buyout))]), _vm._v(" "), (_vm.isFlypost) ? _c('th', {
      staticStyle: {
        "background": "rgba(156,255,112,0.56)"
      }
    }, [_vm._v(_vm._s(cell.cost))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(cell.buyout))])])
  }), _vm._v(" "), _c('tr', [(_vm.checkbox) ? _c('th') : _vm._e(), _vm._v(" "), _vm._l((_vm.computedFootColumns), function(cell, i) {
    return _c('th', {
      class: cell.graph ? 'th-action' : null || cell.isActive ? 'noActive' : '',
      style: (_vm.renderBackground(false, i, cell)),
      attrs: {
        "colspan": cell.colspan,
        "width": cell.width ? cell.width : 'auto'
      },
      on: {
        "click": function($event) {
          cell.graph ? _vm.renderChart(cell, i) : (cell.popup) ? _vm.isPopup(cell, i) : null
        }
      }
    }, [_c('span', [_vm._v(_vm._s(cell.value))])])
  })], 2)], 2)], 1)])]), _vm._v(" "), (_vm.id && !_vm.isFlypostModal) ? _c('modal', {
    attrs: {
      "effect": "fade/zoom",
      "large": ""
    },
    model: {
      value: (_vm.chartModal),
      callback: function($$v) {
        _vm.chartModal = $$v
      },
      expression: "chartModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.chart.title))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ("chart-container-" + _vm.id)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chartModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')) + "\n                ")])])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('StatisticTable', {
    staticClass: "animated fadeIn",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.conversions')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "login",
      "options": _vm.Storage.webFilter,
      "multiple": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('filter.webmaster_grid'),
      "label": "login",
      "searchable": true,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.dispatchInputAction
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n         " + _vm._s(props.option.login) + "\n        ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.webSelectedFilter),
      callback: function($$v) {
        _vm.Storage.webSelectedFilter = $$v
      },
      expression: "Storage.webSelectedFilter"
    }
  })], 1), _vm._v(" "), (_vm.manual_filter) ? _c('div', [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-left": "25px",
      "padding-top": "0.24rem"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.Storage.byManualFilter),
      callback: function($$v) {
        _vm.Storage.byManualFilter = $$v
      },
      expression: "Storage.byManualFilter"
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  })), _vm._v("\n            " + _vm._s(_vm.$t('filters.by_manual')) + "\n        ")], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/conversion',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.conversion')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/new_orders',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.new_orders')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/new_orders_week',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.new_orders_week')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row country-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "CountryFilter",
    attrs: {
      "track-by": "name",
      "options": _vm.Storage.countries,
      "searchable": true,
      "allowEmpty": false,
      "custom-label": _vm.customLabel,
      "show-labels": false,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.dispatchInputAction
    },
    scopedSlots: _vm._u([{
      key: "loading",
      fn: function(props) {
        return [_c('div', {
          staticClass: "country-selected-flag"
        }, [(_vm.$refs.CountryFilter && !_vm.$refs.CountryFilter.isOpen) ? _c('i', {
          staticClass: "option__image flag",
          class: 'flag-' + _vm.Storage.selectedCountry.code.toLowerCase()
        }) : _vm._e()])]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__singleTitle"
        }, [_vm._v(_vm._s(_vm.$t('country.' + props.option.id)))])]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_c('i', {
          staticClass: "option__image flag",
          class: 'flag-' + props.option.code.toLowerCase()
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('country.' + props.option.id)) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.id) + ")")]) : _vm._e()])])])]
      }
    }]),
    model: {
      value: (_vm.Storage.selectedCountry),
      callback: function($$v) {
        _vm.Storage.selectedCountry = $$v
      },
      expression: "Storage.selectedCountry"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/ringing_sms',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ringing_sms')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/sent_sms_template',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.sent_sms_template')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('StatisticTable', {
    staticClass: "animated fadeIn",
    attrs: {
      "footColumns": _vm.footColumns,
      "headColumns": _vm.headColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.conversions')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateFrom),
      callback: function($$v) {
        _vm.Storage.selectedDateFrom = $$v
      },
      expression: "Storage.selectedDateFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateTo),
      callback: function($$v) {
        _vm.Storage.selectedDateTo = $$v
      },
      expression: "Storage.selectedDateTo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info reset",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('dropdown', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('template', {
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('filters.period')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.yesterday
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.yesterday')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.week
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.week')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.thisMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.this_month')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.lastMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.last_month')))])])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "name",
      "options": _vm.Storage.offers,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('statistic.offers'),
      "label": "name",
      "searchable": true,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                       " + _vm._s(props.option.title) + " (" + _vm._s(props.option.name) + ") "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.id) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.Storage.selectedOffer),
      callback: function($$v) {
        _vm.Storage.selectedOffer = $$v
      },
      expression: "Storage.selectedOffer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.selectAll
    }
  }, [_c('i', {
    staticClass: "fa fa-reply-all"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.select_all')) + "\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/country',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_country')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/offers',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_offers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/couriers',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_couriers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/weeks',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_weeks')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/days',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_days')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/month',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_month')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row country-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "CountryFilter",
    attrs: {
      "track-by": "name",
      "options": _vm.Storage.countries,
      "searchable": "",
      "allowEmpty": false,
      "multiple": "",
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": "",
      "custom-label": _vm.customLabel,
      "show-labels": false,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.dispatchInputActionCountry
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__singleTitle"
        }, [_vm._v(_vm._s(_vm.$t('country.' + props.option.id)))])]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_c('i', {
          staticClass: "option__image flag",
          class: 'flag-' + props.option.code.toLowerCase()
        }), _vm._v(" "), _c('span', [_vm._v("\n                        " + _vm._s(_vm.$t('country.' + props.option.id)) + "\n                        "), _vm._v(" "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.id) + ")")]) : _vm._e()])])])]
      }
    }]),
    model: {
      value: (_vm.Storage.selectedCountry),
      callback: function($$v) {
        _vm.Storage.selectedCountry = $$v
      },
      expression: "Storage.selectedCountry"
    }
  }, [_c('template', {
    slot: "loading"
  }, [_c('div', {
    staticClass: "country-selected-flag"
  }, [(_vm.$refs.CountryFilter && !_vm.$refs.CountryFilter.isOpen) ? _c('i', {
    staticClass: "option__image"
  }) : _vm._e()])])], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.webmasters')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/analysis',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.web_analysis')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-12 action"
  }, [_c('DatePicker', {
    attrs: {
      "disabled": _vm.disabledDates,
      "format": _vm.DatePickerFormat,
      "language": _vm.Storage.language,
      "maximumView": 'month',
      "minimumView": 'month'
    },
    model: {
      value: (_vm.Storage.selectedMonthFrom),
      callback: function($$v) {
        _vm.Storage.selectedMonthFrom = $$v
      },
      expression: "Storage.selectedMonthFrom"
    }
  }, [_vm._v(">")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-12 action"
  }, [_c('button', {
    staticClass: "btn btn-info reset",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('OrderTable', {
    key: 'order-table-orders',
    attrs: {
      "title": ("" + (_vm.$t('pages.orders'))),
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "disableActionBTN": false,
      "isLoading": _vm.loading
    },
    on: {
      "addReceipt": _vm.addReceipt,
      "changeVal": _vm.changeVal,
      "download": _vm.download,
      "downloadAll": _vm.downloadAll,
      "deleteChange": _vm.deleteChange,
      "uploadImage": _vm.uploadImage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('WebTabs'), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.webmasters')))
    },
    on: {
      "webGraph": _vm.webGraph,
      "isPopup": _vm.isPopup
    }
  }, [_c('template', {
    slot: "table-actions"
  }, [_c('button', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.toggleExportHistoryModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])])], 2), _vm._v(" "), _c('modal', {
    attrs: {
      "large": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.exportHistiryModal),
      callback: function($$v) {
        _vm.exportHistiryModal = $$v
      },
      expression: "exportHistiryModal"
    }
  }, [_c('div', {
    staticClass: "card-header",
    staticStyle: {
      "text-align": "center"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("История изменений")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block statistic-table"
  }, [_c('table', {
    staticClass: "table table-modal"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Пользователь")]), _vm._v(" "), _c('th', [_vm._v("Оффер")]), _vm._v(" "), _c('th', [_vm._v("Вебмастер")]), _vm._v(" "), _c('th', [_vm._v("Дата")]), _vm._v(" "), _c('th', [_vm._v("Статус был")]), _vm._v(" "), _c('th', [_vm._v("Статус стал")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.exportRows), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.offer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.webmasters))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.date))]), _vm._v(" "), _c('td', {
      class: _vm.getClassesModal(row.fix_from.status)
    }, [_vm._v(_vm._s(row.fix_from.text))]), _vm._v(" "), _c('td', {
      class: _vm.getClassesModal(row.fix_to.status)
    }, [_vm._v(_vm._s(row.fix_to.text))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportHistiryModal = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('verbs.close')) + "\n            ")])])]), _vm._v(" "), (_vm.webid) ? _c('modal', {
    attrs: {
      "large": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.chartModal),
      callback: function($$v) {
        _vm.chartModal = $$v
      },
      expression: "chartModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.chart.title))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ("chart-container-" + _vm.webid)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chartModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "large": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.webModal),
      callback: function($$v) {
        _vm.webModal = $$v
      },
      expression: "webModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Веб-мастер: " + _vm._s(_vm.webid_modal))])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Страны вебмастера")]), _vm._v(" "), _c('th', [_vm._v("Проекты вебмастера")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsReason), function(row) {
    return _c('tr', {
      class: _vm.getClasses(row),
      on: {
        "click": function($event) {
          _vm.getWebmastersRow(row)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(row.country.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.offer.name))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.statusWebmasterFilter(_vm.statusFilter)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.statusFilter')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.statusWebmasterStop(_vm.statusStop)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.statusStop')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.webModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('ProductTabs'), _vm._v(" "), _c('form', {
    attrs: {
      "id": "formRent"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.title) ? _c('div', {
    staticClass: "card-header-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.title) + "\n                        "), _vm._m(0)]) : _vm._e()])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "logout-message",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                                "), _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]) : _vm._l((_vm.rows), function(row) {
    return _c('div', {
      staticClass: "statistic-wrap"
    }, [(_vm.loading) ? _c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "logout-message",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                                "), _c('i', {
      staticClass: "fa fa-spinner fa-spin",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card statistic-table statistic-table-balance"
    }, [(_vm.title) ? _c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n                        " + _vm._s(row.country) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-block card-zz"
    }, [_c('table', {
      staticClass: "table",
      attrs: {
        "id": row.id
      }
    }, [_c('thead', [_c('tr', _vm._l((_vm.computedHeadColumns), function(col) {
      return _c('th', {
        style: (_vm.renderBackground(false, col.field, false)),
        attrs: {
          "colspan": col.colspan,
          "width": col.width ? col.width : 'auto'
        }
      }, [_vm._v(_vm._s(col.label))])
    }))]), _vm._v(" "), _c('tbody', [_vm._l((row.goods), function(cell) {
      return (cell.hidden === 0) ? _c('tr', [_c('td', [_c('input', {
        staticClass: "input-check",
        attrs: {
          "id": 'check' + cell.alias + '-' + cell.country_id,
          "ishidden": cell.hidden,
          "type": "checkbox"
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cell.name.value))]), _vm._v(" "), (cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(cell.price.update, cell.remnants.value, $event.target.value, cell.alias, cell.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + cell.alias,
          "type": "text"
        },
        domProps: {
          "value": cell.remnants.value
        }
      })]) : (!cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(cell.price.update, cell.remnants.value, $event.target.value, cell.alias, cell.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + cell.alias,
          "type": "text",
          "value": "-"
        }
      })]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#b9f6ca"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(cell.price.update, cell.price.value, $event.target.value, cell.alias, cell.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-price",
        attrs: {
          "id": 'g' + cell.alias,
          "name": 'c' + cell.country_id,
          "type": "text"
        },
        domProps: {
          "value": cell.price.value
        }
      })]), _vm._v(" "), (cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(_vm._s(cell.priceAll.value.toFixed(2)))]) : (!cell.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(" - ")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _c('tr', {
      on: {
        "click": function($event) {
          _vm.isCheckBox($event, row.id)
        }
      }
    }, [_c('td'), _vm._v(" "), (_vm.isActive === false) ? _c('td', [_c('span', {
      staticClass: "badge badge-success badge-hidden",
      staticStyle: {
        "color": "#263238"
      }
    }, [_vm._v("Скрытые офферы"), _c('i', {
      staticClass: "fa fa-arrow-down",
      staticStyle: {
        "margin": "0 5px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isActive === true) ? _c('td', [_c('span', {
      staticClass: "badge badge-success badge-hidden",
      staticStyle: {
        "color": "#263238"
      }
    }, [_vm._v("Скрытые офферы"), _c('i', {
      staticClass: "fa fa-arrow-up",
      staticStyle: {
        "margin": "0 5px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((row.goods), function(ce) {
      return (_vm.isActive && ce.hidden === 1) ? _c('tr', [_c('td', [_c('input', {
        staticClass: "input-check",
        attrs: {
          "id": 'check' + ce.alias + '-' + ce.country_id,
          "ishidden": ce.hidden,
          "type": "checkbox"
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ce.name.value))]), _vm._v(" "), (ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(ce.price.update, ce.remnants.value, $event.target.value, ce.alias, ce.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + ce.alias,
          "type": "text"
        },
        domProps: {
          "value": ce.remnants.value
        }
      })]) : (!ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(ce.price.update, ce.remnants.value, $event.target.value, ce.alias, ce.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-remnants",
        attrs: {
          "id": 'g' + ce.alias,
          "type": "text",
          "value": "-"
        }
      })]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#b9f6ca"
        },
        on: {
          "change": function($event) {
            _vm.changeElem(ce.price.update, ce.price.value, $event.target.value, ce.alias, ce.country_id)
          }
        }
      }, [_c('input', {
        staticClass: "input-price",
        attrs: {
          "id": 'g' + ce.alias,
          "name": 'c' + ce.country_id,
          "type": "text"
        },
        domProps: {
          "value": ce.price.value
        }
      })]), _vm._v(" "), (ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(_vm._s(ce.priceAll.value.toFixed(2)))]) : (!ce.remnants.value) ? _c('td', {
        staticStyle: {
          "background-color": "#c8cce6"
        }
      }, [_vm._v(" - ")]) : _vm._e()]) : _vm._e()
    })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', [_vm._v("Итого:")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.footColumns[row.id].totalRemnants.value))])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#b9f6ca"
      }
    }), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#c8cce6"
      }
    }, [_c('span', [_vm._v("$ " + _vm._s((_vm.footColumns[row.id].totalPrice.value).toFixed(2)))])])])])], 1)])])])
  })], 2)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-lg btn-check",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("\n                            Сохранить\n                        ")])
}]}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "options": _vm.options,
      "show-labels": false,
      "track-by": "title",
      "label": "title",
      "placeholder": "Выбрать смену"
    },
    on: {
      "select": _vm.handleChangeClose
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('AlphabetScroll', {
    attrs: {
      "alphabet": _vm.alphabet,
      "context": this,
      "scrollPos": _vm.scrollPos
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "offer-scroll"
  }, _vm._l((_vm.alphabet), function(letter) {
    return _c('div', {
      staticClass: "letter-block",
      attrs: {
        "id": ("letter-" + (letter.letter))
      }
    }, _vm._l((_vm.rows[letter.letter]), function(row) {
      return (_vm.Helper.getCourierTitle(_vm.couriers, row.id)) ? _c('StatisticTable', {
        key: row.id,
        attrs: {
          "title": ((_vm.Helper.getCourierTitle(_vm.couriers, row.id)) + " " + (_vm.Storage.developMode ? ("(" + (row.id) + ")") : '')),
          "headColumns": _vm.headColumns,
          "footColumns": _vm.footColumns[row.id],
          "rows": row.cells
        }
      }) : _vm._e()
    }))
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "width": "100%",
      "z-index": "-10"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%",
      "z-index": "-10"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n              " + _vm._s(("" + (_vm.$t('pages.cross_sell')))) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "#e0e0e0"
    }
  }, [_vm._v("Операторы")]), _vm._v(" "), _vm._l((_vm.headColumns), function(col) {
    return _c('th', {
      staticStyle: {
        "white-space": "nowrap",
        "cursor": "pointer"
      },
      style: ({
        background: col.isMain ? '#ffd96a' : col.color
      }),
      attrs: {
        "colspan": "2"
      },
      on: {
        "click": function($event) {
          _vm.isPopup(col)
        }
      }
    }, [_vm._v(_vm._s(col.label))])
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#81c784"
    }
  }, [_vm._v("Одобрено")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#fff9c4"
    }
  }, [_vm._v("Общее кол-во")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#90caf9"
    }
  }, [_vm._v("Средний чек")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#8fbc8f"
    }
  }, [_vm._v("Апрув от валида")])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(rowItems) {
    return _vm._l((rowItems), function(row, operator) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "background-color": "#e0e0e0"
        }
      }, [_vm._v(_vm._s(_vm.findOperator(operator)))]), _vm._v(" "), _vm._l((row), function(item) {
        return [_c('td', {
          staticStyle: {
            "background-color": "#fff9c4"
          }
        }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "background-color": "#90caf9"
          }
        }, [_vm._v(_vm._s(item.quantity > 0 ? '$ ' + (item.total_bill / item.quantity).toFixed(2) : 0))])]
      }), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#81c784"
        }
      }, [_vm._v(_vm._s(row.Approved))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        }
      }, [_vm._v(_vm._s(row.Quantity))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#90caf9"
        }
      }, [_vm._v(_vm._s(row.AverageBill))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#8fbc8f"
        }
      }, [_vm._v(_vm._s(_vm.approvedFromValid(row.Approved, row.Total, row.Spam)))])], 2)
    })
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "#e0e0e0"
    }
  }, [_vm._v("Итого:")]), _vm._v(" "), _vm._l((_vm.footColumns), function(row) {
    return [_c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_vm._v(_vm._s(row.footQuantity))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#90caf9"
      }
    }, [_vm._v(_vm._s(row.footQuantity > 0 ? '$ ' + (row.footTotal / row.footQuantity).toFixed(2) : 0))])]
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#81c784"
    }
  }, [_vm._v(_vm._s(_vm.footColumns.footSumApproved))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#fff9c4"
    }
  }, [_vm._v(_vm._s(_vm.footColumns.footSumQuantity))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#90caf9"
    }
  }, [_vm._v(_vm._s(_vm.footColumns.footSumAverageBill))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#8fbc8f"
    }
  }, [_vm._v(_vm._s(_vm.approvedFromValid(_vm.footColumns.footSumApproved, _vm.footColumns.footSumTotal, _vm.footColumns.footSumSpam)))])], 2)])], 1)])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.crossSellModal),
      callback: function($$v) {
        _vm.crossSellModal = $$v
      },
      expression: "crossSellModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.titleModal))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "search_offers"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Поиск оффера..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "offers"
  }, _vm._l((this.filterRowsModal), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "offers_items",
      class: _vm.getClasses(item),
      on: {
        "click": function($event) {
          _vm.selectedOffers(item)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(item.offerName))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.crossSellApply()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.save')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.crossSellModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn activity-chart"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x fa-fw"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.chartsData), function(chart, i) {
    return _c('OperatorActivityChart', {
      key: i,
      attrs: {
        "title": _vm.Helper.getOperatorLogin(_vm.operators, i),
        "statistic": chart,
        "id": i
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn call_statistics"
  }, [_c('filters', {
    staticClass: "filter-call_statistics",
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": _vm.title
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('RefundsTabs'), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.ref_return_by_month')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ProductTabs'), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "title": ("" + (_vm.$t('pages.by_category_product'))),
      "rows": _vm.storageCountries,
      "isFixed": true
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('label', [_vm._v("По дате создания")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateCreatedFrom),
      callback: function($$v) {
        _vm.Storage.selectedDateCreatedFrom = $$v
      },
      expression: "Storage.selectedDateCreatedFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('DatePicker', {
    attrs: {
      "language": _vm.Storage.language,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.Storage.selectedDateCreatedTo),
      callback: function($$v) {
        _vm.Storage.selectedDateCreatedTo = $$v
      },
      expression: "Storage.selectedDateCreatedTo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6 action"
  }, [_c('button', {
    staticClass: "btn btn-info reset reset-receipt",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": this.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('filters.reset')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 action"
  }, [_c('dropdown', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('template', {
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('filters.period')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "disabled": _vm.disabled
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.yesterday
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.yesterday')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.week
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.week')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.thisMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.this_month')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.lastMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('filters.last_month')))])])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.filterURL()),
      expression: "filterURL()",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.showCopySuccess),
      expression: "showCopySuccess",
      arg: "success"
    }],
    staticClass: "btn-close",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('div', {
    class: {
      disabledbutton: _vm.loadingRemnants
    }
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "effect": "fade/zoom",
      "small": "",
      "title": ""
    },
    model: {
      value: (_vm.confirmModal),
      callback: function($$v) {
        _vm.confirmModal = $$v
      },
      expression: "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.5em",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.expiration_date')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "card card-default filters card-modal"
  }, [_c('div', {
    staticClass: "card-modal"
  }, [(_vm.errorsByOrder.length) ? _c('div', {
    staticClass: "error"
  }, [_c('b', [_vm._v("Пожалуйста исправьте указанные ошибки:")]), _vm._v(" "), _c('ul', _vm._l((_vm.errorsByOrder), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row date-filter"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.expiration_date'),
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.expiration),
      callback: function($$v) {
        _vm.expiration = $$v
      },
      expression: "expiration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 pad-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customs),
      expression: "customs"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.customs'),
      "name": "customs",
      "type": "text"
    },
    domProps: {
      "value": (_vm.customs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 pad-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logistics),
      expression: "logistics"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.logistic'),
      "name": "customs",
      "type": "text"
    },
    domProps: {
      "value": (_vm.logistics)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.logistics = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 filter-buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.addExpiration
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('verbs.save')) + "\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  })]), _vm._v(" "), _c('ProductTabs'), _vm._v(" "), _c('RemnantsOrders', {
    attrs: {
      "rowRemnants": _vm.rowRemnants,
      "loading": _vm.loadingRemnants
    },
    on: {
      "changeVal": _vm.changeValRemnants
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card card-default filters",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.isLoad
    },
    on: {
      "click": function($event) {
        _vm.clickAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" " + _vm._s(_vm.$t('verbs.add_product')) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBlock),
      expression: "isBlock"
    }],
    staticClass: "card card-default filters"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.checkForm
    }
  }, [(_vm.errors.length) ? _c('div', {
    staticClass: "error"
  }, [_c('b', [_vm._v("Пожалуйста исправьте указанные ошибки:")]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.Storage.selectedCountry.id === -1) ? _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getGoodsAll]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.country')))]), _vm._v(" "), _vm._l((_vm.Storage.countries), function(c) {
    return (c.id !== -1) ? _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orders_count),
      expression: "form.orders_count"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.ordered'),
      "name": "orders_count",
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.orders_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.orders_count = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price),
      expression: "form.price"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.price'),
      "name": "price",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.provider),
      expression: "form.provider"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.provider'),
      "name": "provider",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.provider = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.time'),
      "format": "yyyy-MM-dd",
      "name": "delivery_time"
    },
    model: {
      value: (_vm.form.delivery_time),
      callback: function($$v) {
        _vm.form.delivery_time = $$v
      },
      expression: "form.delivery_time"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.status')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Заказан")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Отгружен")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.comment),
      expression: "form.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.comment'),
      "name": "comment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control input files",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFilesUpload($event.target.name, $event.target.files)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "clear-on-select": false,
      "close-on-select": false,
      "hide-selected": false,
      "multiple": false,
      "options": _vm.storageGoodsAll,
      "placeholder": _vm.$t('statistic.products'),
      "preserve-search": true,
      "searchable": true,
      "label": "name",
      "name": "product",
      "track-by": "name"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                                                    " + _vm._s(props.option.name) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.alias) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.form.product),
      callback: function($$v) {
        _vm.form.product = $$v
      },
      expression: "form.product"
    }
  })], 1)])]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "clear-on-select": false,
      "close-on-select": false,
      "hide-selected": false,
      "multiple": false,
      "options": _vm.Storage.goods,
      "placeholder": _vm.$t('statistic.products'),
      "preserve-search": true,
      "searchable": true,
      "label": "name",
      "name": "product",
      "track-by": "name"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                                                    " + _vm._s(props.option.name) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.alias) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.form.product),
      callback: function($$v) {
        _vm.form.product = $$v
      },
      expression: "form.product"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orders_count),
      expression: "form.orders_count"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.ordered'),
      "name": "orders_count",
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.orders_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.orders_count = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price),
      expression: "form.price"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.price'),
      "name": "price",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.provider),
      expression: "form.provider"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.provider'),
      "name": "provider",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.provider = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.time'),
      "format": "yyyy-MM-dd",
      "name": "delivery_time"
    },
    model: {
      value: (_vm.form.delivery_time),
      callback: function($$v) {
        _vm.form.delivery_time = $$v
      },
      expression: "form.delivery_time"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.status')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Заказан")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Отгружен")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.comment),
      expression: "form.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.comment'),
      "name": "comment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control input files",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFilesUpload($event.target.name, $event.target.files)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 pad-top"
  }, [_c('button', {
    staticClass: "btn btn-primary float-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Отправить")])])])])])]), _vm._v(" "), _c('ProductOrders', {
    attrs: {
      "loading": _vm.loadingProduct,
      "rowsOrder": _vm.rowsOrder
    },
    on: {
      "addReceipt": _vm.addReceipt,
      "changeVal": _vm.changeVal,
      "deleteChange": _vm.deleteChange,
      "download": _vm.download,
      "downloadAll": _vm.downloadAll,
      "uploadImage": _vm.uploadImageOrder
    }
  }), _vm._v(" "), _c('ReceiptOrders', {
    attrs: {
      "loading": _vm.loadingProduct,
      "rowsReceipt": _vm.rowsReceipt
    },
    on: {
      "changeVal": _vm.changeVal,
      "downloadAllReceipt": _vm.downloadAllReceipt,
      "uploadImageReceipt": _vm.uploadImageReceipt,
      "downloadPdfReceipt": _vm.downloadPdfReceipt
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary float-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Отправить")])])
}]}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn courier"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "logout-message",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loading')) + "\n                      "), _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "exelAll",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_vm._l((_vm.totalAllColumns), function(indexMonth, indexYear) {
    return _c('div', {
      directives: [{
        name: "hammer",
        rawName: "v-hammer:pan",
        value: (_vm.onSwipe),
        expression: "onSwipe",
        arg: "pan"
      }],
      key: indexYear,
      staticStyle: {
        "display": "flex",
        "flex-wrap": "nowrap"
      },
      style: ({
        'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
      }),
      attrs: {
        "id": "swipe1"
      }
    }, _vm._l((indexMonth), function(rowsMonth, indexCourier, index) {
      return _c('div', {
        key: (indexYear + "_" + indexCourier),
        staticStyle: {
          "flex": "0 0 750px"
        }
      }, [_c('div', {
        staticClass: " statistic-table",
        staticStyle: {
          "margin-bottom": "0"
        }
      }, [_c('div', {
        staticClass: "card-header"
      }, [_vm._v("\n                          " + _vm._s(_vm.month[indexCourier - 1]) + " " + _vm._s(indexYear) + " г."), _c('br')]), _vm._v(" "), _c('StatisticTable', {
        attrs: {
          "headColumns": _vm.headColumns,
          "footColumns": _vm.totalAllColumns[indexYear][indexCourier][0],
          "totalColumnsDd": _vm.totalCourier[indexYear][indexCourier],
          "rows": [],
          "isExelAll": true,
          "isFlypostModal": true,
          "classes": (([indexYear]) + "-" + ([indexMonth])),
          "className": (([indexYear]) + "-" + ([indexMonth])),
          "title": ("" + (_vm.$t('statistic.in_total')))
        },
        on: {
          "exportingAll": _vm.exportingAll
        }
      })], 1)])
    }))
  }), _vm._v(" "), _vm._l((_vm.rows), function(rowsCourier, indexYear) {
    return _c('div', {
      directives: [{
        name: "hammer",
        rawName: "v-hammer:pan",
        value: (_vm.onSwipe),
        expression: "onSwipe",
        arg: "pan"
      }],
      key: indexYear,
      style: ({
        'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
      }),
      attrs: {
        "id": "swipe"
      }
    }, _vm._l((rowsCourier), function(rowsMonth, indexCourier, index) {
      return _c('div', {
        key: (indexYear + "_" + indexCourier),
        staticStyle: {
          "display": "flex",
          "flex-wrap": "nowrap"
        }
      }, _vm._l((rowsMonth), function(rowsData, indexMonth) {
        return _c('div', {
          key: (indexYear + "_" + indexCourier + "_" + indexMonth),
          staticStyle: {
            "flex": "0 0 750px"
          }
        }, [(rowsData.length !== 0) ? _c('div', [_c('div', {
          staticClass: " statistic-table",
          staticStyle: {
            "margin-bottom": "0"
          }
        }, [_c('StatisticTable', {
          attrs: {
            "headColumns": _vm.headColumns,
            "className": (([indexYear]) + "-" + ([indexMonth])),
            "footColumns": _vm.footColumns[indexYear][indexCourier][indexMonth][0],
            "rows": rowsData,
            "isFlypostModal": true,
            "title": ("" + (_vm.Helper.getOfferTitle(_vm.Storage.offers, indexCourier)))
          }
        })], 1)]) : _vm._e()])
      }))
    }))
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('OperatorsTab'), _vm._v(" "), _c('modal', {
    attrs: {
      "small": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.bonusModal),
      callback: function($$v) {
        _vm.bonusModal = $$v
      },
      expression: "bonusModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('statistic.bonus_system')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.$t('statistic.old_bonus')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldBonusRate),
      expression: "oldBonusRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.oldBonusRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldBonusRate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.$t('statistic.new_bonus')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBonusRate),
      expression: "newBonusRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.newBonusRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newBonusRate = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.error) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.bonusModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.applyBonus()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('verbs.apply')) + "\n            ")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "large": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.exportHistiryModal),
      callback: function($$v) {
        _vm.exportHistiryModal = $$v
      },
      expression: "exportHistiryModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.exportHeadColumns,
      "footColumns": {},
      "rows": _vm.exportRows,
      "title": ("" + (_vm.$t('statistic.exporting_history')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportHistiryModal = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('verbs.close')) + "\n            ")])])], 1), _vm._v(" "), _c('StatisticTable', {
    ref: "statisticTable",
    staticClass: "exelAll",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "isExelAll": true,
      "isFlypostModal": true,
      "title": ("" + (_vm.$t('pages.efficiency')))
    },
    on: {
      "isPopup": _vm.isPopup,
      "exportingAll": _vm.exportingAll
    }
  }, [_c('template', {
    slot: "table-actions"
  }, [_c('button', {
    staticClass: "btn-close btn-exp",
    on: {
      "click": function($event) {
        _vm.exportBonus(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.old_bonus')))]), _vm._v(" "), _c('button', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.toggleExportHistoryModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.toggleBonusModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  })])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.buyout')))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "login",
      "options": _vm.Storage.webFilter,
      "multiple": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('filter.webmaster_grid'),
      "label": "login",
      "searchable": true,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.dispatchInputAction
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n           " + _vm._s(props.option.login) + "\n          ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.webSelectedFilter),
      callback: function($$v) {
        _vm.Storage.webSelectedFilter = $$v
      },
      expression: "Storage.webSelectedFilter"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn operatorsAnalysis"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('OperatorsTab'), _vm._v(" "), _c('div', {
    staticClass: "filters__atalytics"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "filters__atalytics--content"
  }, [_c('div', {
    staticClass: "content__percent"
  }, [_c('label', {
    staticClass: "percent-label",
    attrs: {
      "for": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percent),
      expression: "percent"
    }],
    attrs: {
      "type": "number",
      "id": "percent"
    },
    domProps: {
      "value": (_vm.percent)
    },
    on: {
      "change": _vm.getPercent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.percent = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n                    Значение: < " + _vm._s(_vm.percent) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container__table excel",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('StatisticTable', {
    staticClass: "first-period",
    attrs: {
      "footColumns": _vm.firstFootColumns,
      "headColumns": _vm.headColumns,
      "rows": _vm.rows_first,
      "title": "Первый период"
    },
    on: {
      "isPopup": _vm.isPopup
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "footColumns": _vm.secondFootColumns,
      "headColumns": _vm.headColumns,
      "rows": _vm.rows_second,
      "title": "Второй период"
    },
    on: {
      "isPopup": _vm.isPopup
    }
  }), _vm._v(" "), _c('StatisticTable', {
    staticClass: "table_difference",
    attrs: {
      "footColumns": _vm.differenceFootColumns,
      "headColumns": _vm.headColumnsDifference,
      "rows": _vm.rows_difference,
      "title": "Разница"
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "footColumns": _vm.lastFootColumns,
      "headColumns": _vm.headColumnsLst,
      "rows": _vm.rows_last,
      "title": "Последняя неделя"
    },
    on: {
      "isPopup": _vm.isPopup
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters__atalytics--title card-header"
  }, [_c('i', {
    staticClass: "fa fa-filter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            Фильтры по анализу\n        ")])
}]}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('statistic.traffic')) + "\n                ")]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    attrs: {
      "id": "dash-chart-traffic"
    }
  })])
}]}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "alphabet-scroll"
  }, _vm._l((_vm.alphabet), function(letter, i) {
    return _c('li', {
      staticClass: "letter",
      style: ({
        marginBottom: _vm.margin(letter, i)
      }),
      on: {
        "click": function($event) {
          _vm.context.$scrollTo(i)
        }
      }
    }, [_vm._v("\n        " + _vm._s(letter.letter) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-inverse",
    class: ("card-" + _vm.bg)
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-xs-right m-b-2 pull-right"
  }, [_vm._t("percents"), _vm._v(" "), (_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: ("fa-" + _vm.icon)
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "h4 m-b-0"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container__table excel",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n              " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.headColumns), function(col) {
    return _c('th', {
      staticStyle: {
        "white-space": "nowrap"
      },
      style: ({
        background: col.color,
        width: col.width
      })
    }, [_vm._v(_vm._s(col.label))])
  }))]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(data) {
    return [_vm._l((data), function(countryData, indexCountry) {
      return [_c('tr', {
        on: {
          "click": function($event) {
            countryData.visible = !countryData.visible
          }
        }
      }, [_c('td', {
        staticStyle: {
          "background-color": "#e0e0e0",
          "cursor": "pointer"
        }
      }, [_vm._v(_vm._s(_vm.findCountry(indexCountry)))]), _vm._v(" "), _vm._l((countryData.total), function(row) {
        return _c('td', {
          staticStyle: {
            "white-space": "nowrap"
          },
          style: ({
            background: _vm.linerGradient(row.approved, row.total)
          })
        }, [_c('span', {
          staticStyle: {
            "display": "inline-block",
            "width": "50px"
          }
        }, [_vm._v(_vm._s(row.total))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "display": "inline-block",
            "width": "50px"
          }
        }, [_vm._v(_vm._s(row.total && row.approved > 0 ? ((row.approved / row.total) * 100).toFixed(1) : 0) + "%")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "display": "inline-block",
            "width": "50px",
            "color": "red"
          }
        }, [_vm._v(_vm._s(row.total && row.spam > 0 ? ((row.spam / row.total) * 100).toFixed(1) : 0) + "%")])])
      })], 2), _vm._v(" "), _vm._l((countryData.offers), function(dataOffer) {
        return (countryData.visible) ? _vm._l((dataOffer), function(rowData, index) {
          return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.findOffer(index)))]), _vm._v(" "), _vm._l((rowData), function(row) {
            return _c('td', [_c('span', {
              staticStyle: {
                "display": "inline-block",
                "width": "50px"
              }
            }, [_vm._v(_vm._s(row.total))]), _vm._v(" "), _c('span', {
              staticStyle: {
                "display": "inline-block",
                "width": "50px"
              }
            }, [_vm._v(_vm._s(row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) : 0) + "%")]), _vm._v(" "), _c('span', {
              staticStyle: {
                "display": "inline-block",
                "width": "50px",
                "color": "red"
              }
            }, [_vm._v(_vm._s(row.total > 0 ? ((row.spam / row.total) * 100).toFixed(1) : 0) + "%")])])
          })], 2)
        }) : _vm._e()
      })]
    })]
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "#e0e0e0"
    }
  }, [_vm._v("Итого:")]), _vm._v(" "), _vm._l((this.footColumns), function(row) {
    return _c('th', {
      staticStyle: {
        "background-color": "#90caf9"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "50px"
      }
    }, [_vm._v(_vm._s(row.total))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "50px"
      }
    }, [_vm._v(_vm._s(row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) : 0) + "%")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "50px",
        "color": "red"
      }
    }, [_vm._v(_vm._s(row.total && row.spam > 0 ? ((row.spam / row.total) * 100).toFixed(1) : 0) + "%")])])
  })], 2)])], 1)])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authenticated) ? _c('div', {
    staticClass: "app"
  }, [_c('notifications'), _vm._v(" "), _c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('AppFooter')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn conversion"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('operators-conversion-tabs'), _vm._v(" "), _c('StatisticTable', {
    ref: "statisticTable",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.operator_conversions')))
    },
    on: {
      "isPopup": _vm.isPopup
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn timing_kc"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), (this.checkForking.length > 0) ? _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', _vm._l((_vm.data), function(rows, i) {
    return _c('div', {
      staticClass: "card-block"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('div', {
      staticClass: "wrapper-title"
    }, [_c('tr', {
      staticClass: "main-tr"
    }, [_c('th', [_vm._v("Дата"), _c('br'), _vm._v(_vm._s(rows.date))])]), _vm._v(" "), _vm._m(0, true)])]), _vm._v(" "), _c('tbody', _vm._l((rows.data), function(row) {
      return _c('tr', {
        staticClass: "tr-data",
        style: (rows.time.indexOf(parseInt(row.local_period)) !== -1 ? 'background-color: rgb(200, 230, 201);' : '')
      }, [_c('td', {
        class: _vm.getClasses(row),
        style: (_vm.renderBackground(row))
      }, [_vm._v("\n                                        " + _vm._s(row.local_period) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.moscow_period) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.total) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s((row.total_percent).toFixed(1)) + " %\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.approved) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s((row.approved_percent).toFixed(1)) + " %\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s((row.approved_accumulated_percent).toFixed(1)) + " %\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.approvedFromValid(row.approved, row.total, row.spam)) + "\n                                    ")])])
    })), _vm._v(" "), _c('tfoot', {
      staticClass: "table-footer"
    }, [_c('tr', [_c('th', [_vm._v("Итого")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(rows.data.total_per_day))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s((rows.data.working_percent).toFixed(1)) + " %")])])])], 1)])
  }))])]) : _c('div', [_vm._v("Смены для этой страны не выставлены...")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titles"
  }, [_c('tr', [_c('th', [_vm._v("Часы(местное время)")]), _vm._v(" "), _c('th', [_vm._v("Часы (мск)")]), _vm._v(" "), _c('th', [_vm._v("Лиды")]), _vm._v(" "), _c('th', [_vm._v("% от общего")]), _vm._v(" "), _c('th', [_vm._v("Апрув лиды")]), _vm._v(" "), _c('th', [_vm._v("Апрув за час")]), _vm._v(" "), _c('th', [_vm._v("Апрув"), _c('br'), _vm._v("накопительный")]), _vm._v(" "), _c('th', [_vm._v("Апрув от валида")])])])
}]}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('OrderTable', {
    key: 'order-table-receipt',
    attrs: {
      "title": ("" + (_vm.$t('pages.receipt'))),
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "disableActionBTN": true,
      "isActiveBtn": true,
      "isLoading": _vm.loading
    },
    on: {
      "downloadPdfReceipt": _vm.downloadPdfReceipt,
      "uploadImageReceipt": _vm.uploadImageReceipt,
      "downloadAllReceipt": _vm.downloadAllReceipt,
      "changeVal": _vm.changeValReciept
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "footColumns": _vm.footColumns,
      "headColumns": _vm.headColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.landing')))
    },
    on: {
      "webGraph": _vm.webGraph
    }
  }), _vm._v(" "), (_vm.webid) ? _c('modal', {
    attrs: {
      "effect": "fade/zoom",
      "large": ""
    },
    model: {
      value: (_vm.chartModal),
      callback: function($$v) {
        _vm.chartModal = $$v
      },
      expression: "chartModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.chart.title))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ("chart-container-" + _vm.webid)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chartModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', {
    class: _vm.className
  }, [(_vm.title) ? _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_vm._t("table-actions"), _vm._v(" "), _c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.exporting
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), (_vm.isExelAll) ? _c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.exportingAll
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    class: {
      cardFixed: _vm.isFixed
    },
    attrs: {
      "id": _vm.id
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [(_vm.preheatColumns) ? _c('tr', _vm._l((_vm.preheatColumns), function(col) {
    return _c('th', {
      attrs: {
        "colspan": col.colspan
      }
    }, [_vm._v(_vm._s(col.label))])
  })) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.checkbox) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status.all),
      expression: "status.all"
    }],
    staticClass: "checkall",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.status.all,
      "checked": Array.isArray(_vm.status.all) ? _vm._i(_vm.status.all, _vm.status.all) > -1 : (_vm.status.all)
    },
    on: {
      "change": function($event) {
        _vm.check('all')
      },
      "__c": function($event) {
        var $$a = _vm.status.all,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.status.all,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.status.all = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.status.all = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.status.all = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedHeadColumns), function(col) {
    return _c('th', {
      staticClass: "th-action",
      class: {
        isFix: col.fix, bgCountry: col.field_country, noActive: col.isActive ? 'noActive' : ''
      },
      style: (_vm.renderBackground(false, col.field, false)),
      attrs: {
        "colspan": col.colspan,
        "width": col.width ? col.width : 'auto'
      },
      on: {
        "click": function($event) {
          _vm.sort(col.field)
        }
      }
    }, [_vm._v(_vm._s(col.label) + "\n            ")])
  })], 2)]), _vm._v(" "), (!_vm.isLoading) ? _c('tbody', _vm._l((_vm.computedRows), function(row) {
    return _c('tr', [(_vm.checkbox) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.status[row.id.value]),
        expression: "status[row.id.value]"
      }],
      class: 'check_' + row.id.value,
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": _vm.status[row.id.value],
        "checked": Array.isArray(_vm.status[row.id.value]) ? _vm._i(_vm.status[row.id.value], _vm.status[row.id.value]) > -1 : (_vm.status[row.id.value])
      },
      on: {
        "change": function($event) {
          _vm.check(row.id.value)
        },
        "__c": function($event) {
          var $$a = _vm.status[row.id.value],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.status[row.id.value],
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.status[row.id.value] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.status[row.id.value] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            var $$exp = _vm.status,
              $$idx = row.id.value;
            if (!Array.isArray($$exp)) {
              _vm.status[row.id.value] = $$c
            } else {
              $$exp.splice($$idx, 1, $$c)
            }
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((row), function(cell, i) {
      return (!cell.code) ? _c('td', {
        class: _vm.getCellClasses(cell),
        style: (_vm.renderBackground(cell, i, false)),
        attrs: {
          "colspan": cell.colspan
        },
        domProps: {
          "innerHTML": _vm._s(!cell.htmlValue ? cell.value : cell.htmlValue)
        },
        on: {
          "change": function($event) {
            _vm.updates(cell, $event.target.value)
          },
          "click": function($event) {
            cell.webGraph ? _vm.webGraph(cell, i) : (cell.popup) ? _vm.isPopup(cell, i) : null
          }
        }
      }) : _c('td', {
        staticClass: "col-md-2"
      }, [_c('div', {
        staticClass: "col-md-8",
        staticStyle: {
          "display": "inline-block"
        }
      }, [_vm._v(_vm._s(cell.value))]), _c('div', {
        staticClass: "col-md-4",
        staticStyle: {
          "float": "right"
        }
      }, [_c('i', {
        staticClass: "option__image flag",
        class: 'flag-' + cell.code.toLowerCase(),
        staticStyle: {
          "margin": "-5px 0 -10px 0"
        }
      })])])
    })], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "table-loader",
    staticStyle: {
      "padding": "50px 0",
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x fa-fw"
  })]) : _vm._e(), _vm._v(" "), _c('tfoot', [_vm._l((_vm.computedFootCourier), function(cell, i) {
    return _c('tr', {
      staticClass: "normal-text tr_courier"
    }, [_c('th', [_vm._v(_vm._s(cell.courier_name))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v(_vm._s(cell.shipped))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(144, 202, 249)"
      }
    }, [_vm._v(_vm._s(cell.delivered))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(255, 193, 7)"
      }
    }, [_vm._v(_vm._s(cell.transit))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(255, 193, 7)"
      }
    }, [_vm._v(_vm._s(cell.transitPercent))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(206, 147, 216)"
      }
    }, [_vm._v(_vm._s(cell.return))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(206, 147, 216)"
      }
    }, [_vm._v(_vm._s(cell.returnPercent))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(185, 246, 202)"
      }
    }, [_vm._v(_vm._s(cell.buyout))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(144, 202, 249)"
      }
    }, [_vm._v(_vm._s(cell.approved > 0 ? ("$ " + ((cell.totalBill / cell.approved).toFixed(2))) : '$ 0.0'))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "rgb(144, 202, 249)"
      }
    }, [_vm._v(_vm._s(cell.totalLocal))])])
  }), _vm._v(" "), _c('tr', [(_vm.checkbox) ? _c('th') : _vm._e(), _vm._v(" "), _vm._l((_vm.computedFootColumns), function(cell, i) {
    return _c('th', {
      class: cell.graph ? 'th-action' : null || cell.isActive ? 'noActive' : '',
      style: (_vm.renderBackground(false, i, cell)),
      attrs: {
        "colspan": cell.colspan,
        "width": cell.width ? cell.width : 'auto'
      },
      on: {
        "click": function($event) {
          cell.graph ? _vm.renderChart(cell, i) : (cell.popup) ? _vm.isPopup(cell, i) : null
        }
      }
    }, [_c('span', [_vm._v(_vm._s(cell.value))])])
  })], 2)], 2)], 1)])]), _vm._v(" "), (_vm.id && !_vm.isFlypostModal) ? _c('modal', {
    attrs: {
      "effect": "fade/zoom",
      "large": ""
    },
    model: {
      value: (_vm.chartModal),
      callback: function($$v) {
        _vm.chartModal = $$v
      },
      expression: "chartModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.chart.title))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ("chart-container-" + _vm.id)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chartModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')) + "\n        ")])])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.classList
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), (_vm.isOn) ? [_c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": _vm.on,
      "data-off": _vm.off
    }
  })] : [_c('span', {
    staticClass: "switch-label"
  })], _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'nobr card card-inverse differency-card card-' + _vm.color
  }, [_c('div', {
    staticClass: "card-header nobr",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    }
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    }
  }, [_c('i', {
    class: 'pull-left fa fa-' + _vm.icon
  }), _vm._v(" " + _vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.average) + "$")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block nobr",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('table', {
    staticClass: "table table-bordered debit-table table-striped table-sm table-responsive table-hover nobr"
  }, [_c('thead', {
    staticClass: "thead-default",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    }
  }, [_c('tr', {
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    }
  }, [_c('th', {
    staticClass: "th-action",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.sortData('countryId', function(e) {
          var country = _vm.$t(("country." + e))
          return country[0]
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('statistic.country')) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.sortData('balance')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('statistic.debt')) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.sortData('balance')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('statistic.delay_debt')) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.sortData('todaySum')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('statistic.to_pay_for_today')) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.sortData('weekSum')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('statistic.payout_for_the_week')) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.sortData('lastPaymentSum')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('statistic.last_payout')) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "th-action",
    staticStyle: {
      "word-wrap": "normal",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.sortData('lastPaymentDate', function(e) {
          return e
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('statistic.date')) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preparedData), function(country) {
    return _c('tr', {
      staticStyle: {
        "height": "8px",
        "line-height": "8px",
        "text-align": "center",
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_c('th', {
      staticStyle: {
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_c('i', {
      staticClass: "flag",
      class: 'flag-' + country.code
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "vertical-align": "100%"
      }
    }, [_vm._v(_vm._s(_vm.$t('country.' + country.countryId)))])]), _vm._v(" "), _c('td', {
      style: (("padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(129, 208, 234) " + (country.balance / _vm.totalBalance * 100) + "%, transparent 0%);"))
    }, [_c('table', {
      staticClass: "table table-sm table-cell",
      staticStyle: {
        "width": "100%",
        "margin": "0px",
        "padding": "0px",
        "border": "0px"
      },
      attrs: {
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "45%",
        "vertical-align": "middle",
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(country.balance) + " $")])])])]), _vm._v(" "), _c('td', {
      style: (("padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(129, 208, 234) " + (country.balance / _vm.totalBalance * 100) + "%, transparent 0%);"))
    }, [_c('table', {
      staticClass: "table table-sm table-cell",
      staticStyle: {
        "width": "100%",
        "margin": "0px",
        "padding": "0px",
        "border": "0px"
      },
      attrs: {
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "45%",
        "vertical-align": "middle",
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(country.delay_debt) + " $")])])])]), _vm._v(" "), _c('td', {
      style: (("padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(186, 192, 242) " + (country.todaySum / _vm.totalTodaySum * 100) + "%, transparent 0%);"))
    }, [_c('table', {
      staticClass: "table table-sm table-cell",
      staticStyle: {
        "width": "100%",
        "margin": "0px",
        "padding": "0px",
        "border": "0px",
        "word-wrap": "normal",
        "white-space": "nowrap"
      },
      attrs: {
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "45%",
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(country.todaySum) + " $")])])])]), _vm._v(" "), _c('td', {
      style: (("padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(196, 182, 234) " + (country.weekSum / _vm.totalWeekSum * 100) + "%, transparent 0%);"))
    }, [_c('table', {
      staticClass: "table table-sm table-cell",
      staticStyle: {
        "width": "100%",
        "margin": "0px",
        "padding": "0px",
        "border": "0px",
        "word-wrap": "normal",
        "white-space": "nowrap"
      },
      attrs: {
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "45%",
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(country.weekSum) + " $")])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-top": "13px",
        "text-align": "center",
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_c('table', {
      staticClass: "table table-sm table-cell",
      staticStyle: {
        "width": "100%",
        "margin": "0px",
        "padding": "0px",
        "border": "0px",
        "word-wrap": "normal",
        "white-space": "nowrap"
      },
      attrs: {
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "45%",
        "vertical-align": "middle",
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(country.lastPaymentSum) + " $")])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-top": "13px",
        "text-align": "center",
        "word-wrap": "normal",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("moment")(country.lastPaymentDate, "D MMM YYYY")) + "\n                        ")])])
  })), _vm._v(" "), _c('tfoot', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('statistic.in_total')))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalBalance) + " "), _c('span', {
    staticStyle: {
      "color": "darkolivegreen"
    }
  }, [_vm._v("$")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalDelayDebt) + " "), _c('span', {
    staticStyle: {
      "color": "darkolivegreen"
    }
  }, [_vm._v("$")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalTodaySum) + " "), _c('span', {
    staticStyle: {
      "color": "darkolivegreen"
    }
  }, [_vm._v("$")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalWeekSum) + " "), _c('span', {
    staticStyle: {
      "color": "darkolivegreen"
    }
  }, [_vm._v("$")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalLastPaymentSum) + " "), _c('span', {
    staticStyle: {
      "color": "darkolivegreen"
    }
  }, [_vm._v("$")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "name",
      "multiple": true,
      "placeholder": _vm.$t('statistic.webmaster'),
      "label": "name",
      "disabled": _vm.disabled,
      "options": _vm.options,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.Storage.webAddTagFilter),
      callback: function($$v) {
        _vm.Storage.webAddTagFilter = $$v
      },
      expression: "Storage.webAddTagFilter"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "small": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.confirmModal),
      callback: function($$v) {
        _vm.confirmModal = $$v
      },
      expression: "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.5em",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('verbs.edit')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmValue(true)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('verbs.apply')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmValue(false)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('verbs.close')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  })]), _vm._v(" "), _c('modal', {
    attrs: {
      "large": "",
      "title": "",
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.exportHistiryModal),
      callback: function($$v) {
        _vm.exportHistiryModal = $$v
      },
      expression: "exportHistiryModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.exportHeadColumns,
      "footColumns": _vm.exportFootColumns,
      "rows": _vm.exportRows,
      "title": ("" + (_vm.$t('statistic.payment_history')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportHistiryModal = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('verbs.close')) + "\n            ")])])], 1), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.webmaster_individual_rates')))
    },
    on: {
      "changeElem": _vm.changeElem
    }
  }, [_c('template', {
    slot: "table-actions"
  }, [_c('button', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.toggleExportHistoryModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[200]);


// WEBPACK FOOTER //
// static/js/app.f74f4bc6917872b99757.js